import NotFound from "assets/images/classes/generic/notfound.png";

import AFathersDevotion from "assets/images/items/A Father's Devotion.jpg"
import AFathersPledge from "assets/images/items/A Father's Pledge.jpg"
import AFathersWill from "assets/images/items/A Father's Will.jpg"
import AFathersWrath from "assets/images/items/A Father's Wrath.jpg"
import AbyssalCapeoftheFallenEmpire from "assets/images/items/Abyssal Cape of the Fallen Empire.jpg"
import AbyssalCloakofCrimsonSlaughter from "assets/images/items/Abyssal Cloak of Crimson Slaughter.jpg"
import AbyssalCloakoftheDeathMaster from "assets/images/items/Abyssal Cloak of the Death Master.jpg"
import AbyssalCloakoftheHellWalker from "assets/images/items/Abyssal Cloak of the Hell Walker.jpg"
import AbyssalDemonPendantofAssault from "assets/images/items/Abyssal Demon Pendant of Assault.jpg"
import AbyssalDemonPendantofConstitution from "assets/images/items/Abyssal Demon Pendant of Constitution.jpg"
import AbyssalDemonPendantofDexterity from "assets/images/items/Abyssal Demon Pendant of Dexterity.jpg"
import AbyssalDemonPendantofIntelligence from "assets/images/items/Abyssal Demon Pendant of Intelligence.jpg"
import AbyssalDemonPendantofStrength from "assets/images/items/Abyssal Demon Pendant of Strength.jpg"
import AbyssalDemonPendantofWisdom from "assets/images/items/Abyssal Demon Pendant of Wisdom.jpg"
import AbyssalDemonRingofAssault from "assets/images/items/Abyssal Demon Ring of Assault.jpg"
import AbyssalDemonRingofConstitution from "assets/images/items/Abyssal Demon Ring of Constitution.jpg"
import AbyssalDemonRingofDexterity from "assets/images/items/Abyssal Demon Ring of Dexterity.jpg"
import AbyssalDemonRingofIntelligence from "assets/images/items/Abyssal Demon Ring of Intelligence.jpg"
import AbyssalDemonRingofStrength from "assets/images/items/Abyssal Demon Ring of Strength.jpg"
import AbyssalDemonRingofWisdom from "assets/images/items/Abyssal Demon Ring of Wisdom.jpg"
import AbyssalGale from "assets/images/items/Abyssal Gale.jpg"
import AbyssalHammer from "assets/images/items/Abyssal Hammer.jpg"
import AbyssalShroud from "assets/images/items/Abyssal Shroud.jpg"
import AbyssalSlicer from "assets/images/items/Abyssal Slicer.jpg"
import AbyssalSting from "assets/images/items/Abyssal Sting.jpg"
import Accensus from "assets/images/items/Accensus.jpg"
import AchitonofCelestialRadiance from "assets/images/items/Achiton of Celestial Radiance.jpg"
import AchitonofEffulgentDevotion from "assets/images/items/Achiton of Effulgent Devotion.jpg"
import AchitonofIlluminantConviction from "assets/images/items/Achiton of Illuminant Conviction.jpg"
import AchitonoftheAscension from "assets/images/items/Achiton of the Ascension.jpg"
import AcolytesArmstrapsofBalance from "assets/images/items/Acolyte's Arm-straps of Balance.jpg"
import AcolytesArmbandsoftheSpillingBlood from "assets/images/items/Acolyte's Armbands of the Spilling Blood.jpg"
import AcolytesBeltofSacrifice from "assets/images/items/Acolyte's Belt of Sacrifice.jpg"
import AcolytesBeltoftheHallowWorlds from "assets/images/items/Acolyte's Belt of the Hallow Worlds.jpg"
import AcolytesBeltoftheLimitlessCipher from "assets/images/items/Acolyte's Belt of the Limitless Cipher.jpg"
import AcolytesBootsoftheAbyss from "assets/images/items/Acolyte's Boots of the Abyss.jpg"
import AcolytesBootsoftheEighteenPits from "assets/images/items/Acolyte's Boots of the Eighteen Pits.jpg"
import AcolytesBootsoftheNineSprings from "assets/images/items/Acolyte's Boots of the Nine Springs.jpg"
import AcolytesBootsoftheUnderworld from "assets/images/items/Acolyte's Boots of the Underworld.jpg"
import AcolytesGauntletsoftheEarthenPrison from "assets/images/items/Acolyte's Gauntlets of the Earthen Prison.jpg"
import AcolytesGirdleoftheEarthenPrison from "assets/images/items/Acolyte's Girdle of the Earthen Prison.jpg"
import AcolytesGlovesofSacrifice from "assets/images/items/Acolyte's Gloves of Sacrifice.jpg"
import AcolytesGlovesoftheHallowWorlds from "assets/images/items/Acolyte's Gloves of the Hallow Worlds.jpg"
import AcolytesGlovesoftheLimitlessCipher from "assets/images/items/Acolyte's Gloves of the Limitless Cipher.jpg"
import AcolytesHarnessoftheEighteenPits from "assets/images/items/Acolyte's Harness of the Eighteen Pits.jpg"
import AcolytesHelmoftheAbyss from "assets/images/items/Acolyte's Helm of the Abyss.jpg"
import AcolytesHoodoftheUnderworld from "assets/images/items/Acolyte's Hood of the Underworld.jpg"
import AcolytesJerkinoftheAbyss from "assets/images/items/Acolyte's Jerkin of the Abyss.jpg"
import AcolytesLeggingsoftheBlackThread from "assets/images/items/Acolyte's Leggings of the Black Thread.jpg"
import AcolytesLeggingsoftheSpillingBlood from "assets/images/items/Acolyte's Leggings of the Spilling Blood.jpg"
import AcolytesLegguardsoftheSacredMountain from "assets/images/items/Acolyte's Legguards of the Sacred Mountain.jpg"
import AcolytesMaskoftheNineSprings from "assets/images/items/Acolyte's Mask of the Nine Springs.jpg"
import AcolytesRobesoftheUnderworld from "assets/images/items/Acolyte's Robes of the Underworld.jpg"
import AcolytesStrapsoftheBlackThread from "assets/images/items/Acolyte's Straps of the Black Thread.jpg"
import AcolytesStrapsoftheSacredMountain from "assets/images/items/Acolyte's Straps of the Sacred Mountain.jpg"
import AcolytesThreadsofBalance from "assets/images/items/Acolyte's Threads of Balance.jpg"
import Acutus from "assets/images/items/Acutus.jpg"
import AdventurersPackBag from "assets/images/items/Adventurer's Pack-Bag.jpg"
import AdvocacyoftheAugustOnes from "assets/images/items/Advocacy of the August Ones.jpg"
import AegisofDhurkanBlackblade from "assets/images/items/Aegis of Dhurkan Blackblade.jpg"
import AegisofFiveMercies from "assets/images/items/Aegis of Five Mercies.jpg"
import AegisofKhan from "assets/images/items/Aegis of Khan.jpg"
import AegisoftheBloodGod from "assets/images/items/Aegis of the Blood God.jpg"
import AegisoftheJackal from "assets/images/items/Aegis of the Jackal.jpg"
import AegisoftheWarlord from "assets/images/items/Aegis of the Warlord.jpg"
import AegrusMal from "assets/images/items/Aegrus Mal.jpg"
import AelfrithsGrace from "assets/images/items/Aelfrith's Grace.jpg"
import AelfrithsGratitude from "assets/images/items/Aelfrith's Gratitude.jpg"
import AelfrithsHonour from "assets/images/items/Aelfrith's Honour.jpg"
import AelfrithsTribute from "assets/images/items/Aelfrith's Tribute.jpg"
import AgedBoneFlute from "assets/images/items/Aged Bone Flute.jpg"
import Agilis from "assets/images/items/Agilis.jpg"
import AgonizingBludgeon from "assets/images/items/Agonizing Bludgeon.jpg"
import Ahnefet from "assets/images/items/Ahnefet.jpg"
import AkinakesoftheRuinousMiasma from "assets/images/items/Akinakes of the Ruinous Miasma.jpg"
import Akivneteh from "assets/images/items/Akivneteh.jpg"
import AlchemistsPendant from "assets/images/items/Alchemist's Pendant.jpg"
import AllSeeingEyeofMysticalSupremacy from "assets/images/items/All-Seeing-Eye of Mystical Supremacy.jpg"
import AlphaHoundFang from "assets/images/items/Alpha Hound Fang.jpg"
import AlphaSkullHelm from "assets/images/items/Alpha Skull Helm.jpg"
import AlvazarsGloves from "assets/images/items/Alvazar's Gloves.jpg"
import AlvazarsVest from "assets/images/items/Alvazar's Vest.jpg"
import AmethystRingofWisdom from "assets/images/items/Amethyst Ring of Wisdom.jpg"
import AmrasPride from "assets/images/items/Amra's Pride.jpg"
import Amtah from "assets/images/items/Amtah.jpg"
import AmuletofAncientPython from "assets/images/items/Amulet of Ancient Python.jpg"
import AmuletofCrimsonSlaughter from "assets/images/items/Amulet of Crimson Slaughter.jpg"
import AmuletofFinesse from "assets/images/items/Amulet of Finesse.jpg"
import AmuletofGoodFortune from "assets/images/items/Amulet of Good Fortune.jpg"
import AmuletofOrastes from "assets/images/items/Amulet of Orastes.jpg"
import AmuletofPureIce from "assets/images/items/Amulet of Pure Ice.jpg"
import AmuletofSouls from "assets/images/items/Amulet of Souls.jpg"
import AmuletoftheAsshuri from "assets/images/items/Amulet of the Asshuri.jpg"
import AmuletoftheEsotericPendulum from "assets/images/items/Amulet of the Esoteric Pendulum.jpg"
import AmuletoftheHellWalker from "assets/images/items/Amulet of the Hell Walker.jpg"
import AmuletofZarallo from "assets/images/items/Amulet of Zarallo.jpg"
import AncientArbalest from "assets/images/items/Ancient Arbalest.jpg"
import AncientBlade from "assets/images/items/Ancient Blade.jpg"
import AncientBoneFlute from "assets/images/items/Ancient Bone Flute.jpg"
import AncientKukri from "assets/images/items/Ancient Kukri.jpg"
import AncientMace from "assets/images/items/Ancient Mace.jpg"
import AncientScroll from "assets/images/items/Ancient Scroll.jpg"
import AncientSerpentStaff from "assets/images/items/Ancient Serpent Staff.jpg"
import AncientShield from "assets/images/items/Ancient Shield.jpg"
import AncientSpear from "assets/images/items/Ancient Spear.jpg"
import AncientWarScythe from "assets/images/items/Ancient War Scythe.jpg"
import AncientWarhammer from "assets/images/items/Ancient Warhammer.jpg"
import AngerwakeHelm from "assets/images/items/Angerwake Helm.jpg"
import AnktarLongshot from "assets/images/items/Anktar Longshot.jpg"
import AntillianBoots from "assets/images/items/Antillian Boots.jpg"
import AntillianJerkin from "assets/images/items/Antillian Jerkin.jpg"
import AntillianLeggings from "assets/images/items/Antillian Leggings.jpg"
import AntlersofBoneandHorn from "assets/images/items/Antlers of Bone and Horn.jpg"
import Anvilrage from "assets/images/items/Anvilrage.jpg"
import Anvilstrike from "assets/images/items/Anvilstrike.jpg"
import ApotheosisofHate from "assets/images/items/Apotheosis of Hate.jpg"
import ApotheosisofPain from "assets/images/items/Apotheosis of Pain.jpg"
import ArakhoftheArchaeologian from "assets/images/items/Arakh of the Archaeologian.jpg"
import ArcofEternalWinter from "assets/images/items/Arc of Eternal Winter.jpg"
import ArcaofJaggtaNoga from "assets/images/items/Arca of Jaggta-Noga.jpg"
import ArcaneShield from "assets/images/items/Arcane Shield.jpg"
import ArcfireOpus from "assets/images/items/Arcfire Opus.jpg"
import ArchdeaconsArmbandsoftheEighteenPits from "assets/images/items/Archdeacon's Armbands of the Eighteen Pits.jpg"
import ArchdeaconsBeltoftheAbyss from "assets/images/items/Archdeacon's Belt of the Abyss.jpg"
import ArchdeaconsBootsoftheSacredMountain from "assets/images/items/Archdeacon's Boots of the Sacred Mountain.jpg"
import ArchdeaconsBootsoftheSpillingBlood from "assets/images/items/Archdeacon's Boots of the Spilling Blood.jpg"
import ArchdeaconsBracersoftheSacredMountain from "assets/images/items/Archdeacon's Bracers of the Sacred Mountain.jpg"
import ArchdeaconsBracersoftheSpillingBlood from "assets/images/items/Archdeacon's Bracers of the Spilling Blood.jpg"
import ArchdeaconsGauntletsoftheEighteenPits from "assets/images/items/Archdeacon's Gauntlets of the Eighteen Pits.jpg"
import ArchdeaconsGirdleoftheEighteenPits from "assets/images/items/Archdeacon's Girdle of the Eighteen Pits.jpg"
import ArchdeaconsGlovesoftheAbyss from "assets/images/items/Archdeacon's Gloves of the Abyss.jpg"
import ArchdeaconsHarnessoftheEarthenPrison from "assets/images/items/Archdeacon's Harness of the Earthen Prison.jpg"
import ArchdeaconsHelmoftheEarthenPrison from "assets/images/items/Archdeacon's Helm of the Earthen Prison.jpg"
import ArchdeaconsHelmoftheHallowWorlds from "assets/images/items/Archdeacon's Helm of the Hallow Worlds.jpg"
import ArchdeaconsJerkinoftheHallowWorlds from "assets/images/items/Archdeacon's Jerkin of the Hallow Worlds.jpg"
import ArchdeaconsLeggingsoftheEighteenPits from "assets/images/items/Archdeacon's Leggings of the Eighteen Pits.jpg"
import ArchdeaconsLegguardsoftheAbyss from "assets/images/items/Archdeacon's Legguards of the Abyss.jpg"
import ArchdeaconsStrapsoftheAbyss from "assets/images/items/Archdeacon's Straps of the Abyss.jpg"
import ArchersSerpentweave from "assets/images/items/Archer's Serpentweave.jpg"
import ArchpriestsBeltoftheNineSprings from "assets/images/items/Archpriest's Belt of the Nine Springs.jpg"
import ArchpriestsBootsofBalance from "assets/images/items/Archpriest's Boots of Balance.jpg"
import ArchpriestsBootsoftheBlackThread from "assets/images/items/Archpriest's Boots of the Black Thread.jpg"
import ArchpriestsBracersoftheBlackThread from "assets/images/items/Archpriest's Bracers of the Black Thread.jpg"
import ArchpriestsCoilsoftheUnderworld from "assets/images/items/Archpriest's Coils of the Underworld.jpg"
import ArchpriestsCordoftheUnderworld from "assets/images/items/Archpriest's Cord of the Underworld.jpg"
import ArchpriestsCrestofSacrifice from "assets/images/items/Archpriest's Crest of Sacrifice.jpg"
import ArchpriestsFauldoftheNineSprings from "assets/images/items/Archpriest's Fauld of the Nine Springs.jpg"
import ArchpriestsGlovesoftheNineSprings from "assets/images/items/Archpriest's Gloves of the Nine Springs.jpg"
import ArchpriestsGlovesoftheUnderworld from "assets/images/items/Archpriest's Gloves of the Underworld.jpg"
import ArchpriestsRaimentofSacrifice from "assets/images/items/Archpriest's Raiment of Sacrifice.jpg"
import ArchpriestsStrapsofBalance from "assets/images/items/Archpriest's Straps of Balance.jpg"
import ArchpriestsStrapsoftheNineSprings from "assets/images/items/Archpriest's Straps of the Nine Springs.jpg"
import ArchpriestsThreadsoftheUnderworld from "assets/images/items/Archpriest's Threads of the Underworld.jpg"
import ArchpriestsTunicoftheLimitlessCipher from "assets/images/items/Archpriest's Tunic of the Limitless Cipher.jpg"
import ArchpriestsVisageoftheLimitlessCipher from "assets/images/items/Archpriest's Visage of the Limitless Cipher.jpg"
import ArdentAtlanteanRelic from "assets/images/items/Ardent Atlantean Relic.jpg"
import ZealousAtlanteanRelic from "assets/images/items/Zealous Atlantean Relic.jpg"
import MysticAtlanteanRelic from "assets/images/items/Mystic Atlantean Relic.jpg"
import HolyAtlanteanRelic from "assets/images/items/Holy Atlantean Relic.jpg"
import FerventAtlanteanRelic from "assets/images/items/Fervent Atlantean Relic.jpg"
import HasteningAtlanteanRelic from "assets/images/items/Hastening Atlantean Relic.jpg"
import ArmBandoftheAmaranthineDrums from "assets/images/items/Arm Band of the Amaranthine Drums.jpg"
import ArmBandsoftheGhostoftheVeldt from "assets/images/items/Arm Bands of the Ghost of the Veldt.jpg"
import ArmBandsoftheMasqueroftheSands from "assets/images/items/Arm Bands of the Masquer of the Sands.jpg"
import ArmBindingoftheEarthMother from "assets/images/items/Arm Binding of the Earth Mother.jpg"
import ArmGuardoftheWardedBrute from "assets/images/items/Arm Guard of the Warded Brute.jpg"
import ArmGuardsoftheEarthMother from "assets/images/items/Arm Guards of the Earth Mother.jpg"
import ArmGuardsoftheEndlessSands from "assets/images/items/Arm Guards of the Endless Sands.jpg"
import ArmoftheGreatBear from "assets/images/items/Arm of the Great Bear.jpg"
import ArmStrapsoftheWardedBrute from "assets/images/items/Arm Straps of the Warded Brute.jpg"
import ArmbandsoftheBloodhunternm from "assets/images/items/Arm-bands of the Bloodhunter (nm).jpg"
import ArmbandsoftheBloodhunter from "assets/images/items/Arm-bands of the Bloodhunter.jpg"
import ArmbandsoftheDarkMessenger from "assets/images/items/Arm-bands of the Dark Messenger.jpg"
import ArmbandsoftheHellWalkernm from "assets/images/items/Arm-bands of the Hell Walker (nm).jpg"
import ArmbandsoftheHellWalker from "assets/images/items/Arm-bands of the Hell Walker.jpg"
import ArmstrapsofBedlam from "assets/images/items/Arm-straps of Bedlam.jpg"
import ArmstrapsofBlackWhispers from "assets/images/items/Arm-straps of Black Whispers.jpg"
import ArmstrapsofCrimsonSlaughternm from "assets/images/items/Arm-straps of Crimson Slaughter (nm).jpg"
import ArmstrapsofCrimsonSlaughter from "assets/images/items/Arm-straps of Crimson Slaughter.jpg"
import ArmstrapsofDarkMalice from "assets/images/items/Arm-straps of Dark Malice.jpg"
import ArmstrapsofDeadlyGuile from "assets/images/items/Arm-straps of Deadly Guile.jpg"
import ArmstrapsoftheBloodGodnm from "assets/images/items/Arm-straps of the Blood God (nm).jpg"
import ArmstrapsoftheBloodGod from "assets/images/items/Arm-straps of the Blood God.jpg"
import ArmstrapsoftheCrawlingChaos from "assets/images/items/Arm-straps of the Crawling Chaos.jpg"
import ArmstrapsoftheFacelessChaos from "assets/images/items/Arm-straps of the Faceless Chaos.jpg"
import ArmstrapsoftheFacelessSphinx from "assets/images/items/Arm-straps of the Faceless Sphinx.jpg"
import ArmstrapsoftheLector from "assets/images/items/Arm-straps of the Lector.jpg"
import ArmstrapsoftheOxmal from "assets/images/items/Arm-straps of the Oxmal.jpg"
import ArmstrapsoftheScatteredGods from "assets/images/items/Arm-straps of the Scattered Gods.jpg"
import ArmstrapsoftheSepulcher from "assets/images/items/Arm-straps of the Sepulcher.jpg"
import ArmstrapsoftheShiveringStars from "assets/images/items/Arm-straps of the Shivering Stars.jpg"
import ArmstrapsoftheSilentSlayer from "assets/images/items/Arm-straps of the Silent Slayer.jpg"
import ArmstrapsoftheSpheres from "assets/images/items/Arm-straps of the Spheres.jpg"
import ArmstrapsoftheUbahKan from "assets/images/items/Arm-straps of the Ubah Kan.jpg"
import ArmstrapsoftheUnutterable from "assets/images/items/Arm-straps of the Unutterable.jpg"
import ArmwrapsoftheCrawlingChaos from "assets/images/items/Arm-wraps of the Crawling Chaos.jpg"
import ArmbandofArdentFire from "assets/images/items/Armband of Ardent Fire.jpg"
import ArmbandofBrutalCarnage from "assets/images/items/Armband of Brutal Carnage.jpg"
import ArmbandofConflagrantFlame from "assets/images/items/Armband of Conflagrant Flame.jpg"
import ArmbandofInfernalZeal from "assets/images/items/Armband of Infernal Zeal.jpg"
import ArmbandoftheSavageSlaughter from "assets/images/items/Armband of the Savage Slaughter.jpg"
import ArmbandsofBestialRage from "assets/images/items/Armbands of Bestial Rage.jpg"
import ArmbandsofBlackOblivion from "assets/images/items/Armbands of Black Oblivion.jpg"
import ArmbandsofBristlingIre from "assets/images/items/Armbands of Bristling Ire.jpg"
import ArmbandsofCelestialRadiance from "assets/images/items/Armbands of Celestial Radiance.jpg"
import ArmbandsofClawingMight from "assets/images/items/Armbands of Clawing Might.jpg"
import ArmbandsofConcealingShadows from "assets/images/items/Armbands of Concealing Shadows.jpg"
import ArmbandsofDarkTerror from "assets/images/items/Armbands of Dark Terror.jpg"
import ArmbandsofEffulgentDevotion from "assets/images/items/Armbands of Effulgent Devotion.jpg"
import ArmbandsofErlik from "assets/images/items/Armbands of Erlik.jpg"
import ArmbandsofFerineAnger from "assets/images/items/Armbands of Ferine Anger.jpg"
import ArmbandsofIlluminantConviction from "assets/images/items/Armbands of Illuminant Conviction.jpg"
import ArmbandsofInsanity from "assets/images/items/Armbands of Insanity.jpg"
import ArmbandsofJaggedBarbs from "assets/images/items/Armbands of Jagged Barbs.jpg"
import ArmbandsofNecroticDread from "assets/images/items/Armbands of Necrotic Dread.jpg"
import ArmbandsofPandemonium from "assets/images/items/Armbands of Pandemonium.jpg"
import ArmbandsofQuilledDarts from "assets/images/items/Armbands of Quilled Darts.jpg"
import ArmbandsofRapturousBattle from "assets/images/items/Armbands of Rapturous Battle.jpg"
import ArmbandsofRighteousSmiting from "assets/images/items/Armbands of Righteous Smiting.jpg"
import ArmbandsofSwiftstriking from "assets/images/items/Armbands of Swiftstriking.jpg"
import ArmbandsoftheAscension from "assets/images/items/Armbands of the Ascension.jpg"
import ArmbandsoftheBerserkersFury from "assets/images/items/Armbands of the Berserker's Fury.jpg"
import ArmbandsoftheBloodmoon from "assets/images/items/Armbands of the Bloodmoon.jpg"
import ArmbandsoftheClay from "assets/images/items/Armbands of the Clay.jpg"
import ArmbandsoftheCloudcleaver from "assets/images/items/Armbands of the Cloudcleaver.jpg"
import ArmbandsoftheDeathGod from "assets/images/items/Armbands of the Death God.jpg"
import ArmbandsoftheDeathstalker from "assets/images/items/Armbands of the Deathstalker.jpg"
import ArmbandsoftheEcliptic from "assets/images/items/Armbands of the Ecliptic.jpg"
import ArmbandsoftheEternalBlaze from "assets/images/items/Armbands of the Eternal Blaze.jpg"
import ArmbandsoftheExorcist from "assets/images/items/Armbands of the Exorcist.jpg"
import ArmbandsoftheFarseeker from "assets/images/items/Armbands of the Farseeker.jpg"
import ArmbandsoftheFirstCircle from "assets/images/items/Armbands of the First Circle.jpg"
import ArmbandsoftheFuriousSwipe from "assets/images/items/Armbands of the Furious Swipe.jpg"
import ArmbandsoftheHaunterintheDark from "assets/images/items/Armbands of the Haunter in the Dark.jpg"
import ArmbandsoftheHowlingGiant from "assets/images/items/Armbands of the Howling Giant.jpg"
import ArmbandsoftheHuntmaster from "assets/images/items/Armbands of the Huntmaster.jpg"
import ArmbandsoftheIchorous from "assets/images/items/Armbands of the Ichorous.jpg"
import ArmbandsoftheInconceivable from "assets/images/items/Armbands of the Inconceivable.jpg"
import ArmbandsoftheJudgmentBolt from "assets/images/items/Armbands of the Judgment Bolt.jpg"
import ArmbandsoftheKozakSlayer from "assets/images/items/Armbands of the Kozak Slayer.jpg"
import ArmbandsoftheLivingTarim from "assets/images/items/Armbands of the Living Tarim.jpg"
import ArmbandsoftheMembranous from "assets/images/items/Armbands of the Membranous.jpg"
import ArmbandsoftheMerciless from "assets/images/items/Armbands of the Merciless.jpg"
import ArmbandsoftheOxmal from "assets/images/items/Armbands of the Oxmal.jpg"
import ArmbandsoftheRavenflight from "assets/images/items/Armbands of the Ravenflight.jpg"
import ArmbandsoftheRefectory from "assets/images/items/Armbands of the Refectory.jpg"
import ArmbandsoftheRenegade from "assets/images/items/Armbands of the Renegade.jpg"
import ArmbandsoftheRevelationsofTarim from "assets/images/items/Armbands of the Revelations of Tarim.jpg"
import ArmbandsoftheRiftcaller from "assets/images/items/Armbands of the Riftcaller.jpg"
import ArmbandsoftheSavageFang from "assets/images/items/Armbands of the Savage Fang.jpg"
import ArmbandsoftheShiveringStars from "assets/images/items/Armbands of the Shivering Stars.jpg"
import ArmbandsoftheStormbringer from "assets/images/items/Armbands of the Stormbringer.jpg"
import ArmbandsoftheStrangeBeyond from "assets/images/items/Armbands of the Strange Beyond.jpg"
import ArmbandsoftheSunderedSkies from "assets/images/items/Armbands of the Sundered Skies.jpg"
import ArmbandsoftheSwiftTalon from "assets/images/items/Armbands of the Swift Talon.jpg"
import ArmbandsoftheUbahKan from "assets/images/items/Armbands of the Ubah Kan.jpg"
import ArmbandsoftheUnholyCommunion from "assets/images/items/Armbands of the Unholy Communion.jpg"
import ArmbandsoftheUsurper from "assets/images/items/Armbands of the Usurper.jpg"
import ArmbandsoftheWhisperingBlade from "assets/images/items/Armbands of the Whispering Blade.jpg"
import ArmbandsofTribulation from "assets/images/items/Armbands of Tribulation.jpg"
import ArmbandsofUntamedViolence from "assets/images/items/Armbands of Untamed Violence.jpg"
import ArmbandsofVehementThunder from "assets/images/items/Armbands of Vehement Thunder.jpg"
import ArmbandsofVengefulZeal from "assets/images/items/Armbands of Vengeful Zeal.jpg"
import ArmbandsofVernantFury from "assets/images/items/Armbands of Vernant Fury.jpg"
import ArmbandsofVindictiveMalice from "assets/images/items/Armbands of Vindictive Malice.jpg"
import ArmbandsofViolentRage from "assets/images/items/Armbands of Violent Rage.jpg"
import ArmbandsofWrithing from "assets/images/items/Armbands of Writhing.jpg"
import ArmguardsofBalefulBlood from "assets/images/items/Armguards of Baleful Blood.jpg"
import ArmguardsofBlackSpite from "assets/images/items/Armguards of Black Spite.jpg"
import ArmguardsofCourageousSouls from "assets/images/items/Armguards of Courageous Souls.jpg"
import ArmguardsofFearlessSouls from "assets/images/items/Armguards of Fearless Souls.jpg"
import ArmguardsofHeroicSoul from "assets/images/items/Armguards of Heroic Soul.jpg"
import ArmguardsofIndomitableSouls from "assets/images/items/Armguards of Indomitable Souls.jpg"
import ArmguardsofRecklessChallenge from "assets/images/items/Armguards of Reckless Challenge.jpg"
import ArmguardsofRobustness from "assets/images/items/Armguards of Robustness.jpg"
import ArmguardsoftheAssailant from "assets/images/items/Armguards of the Assailant.jpg"
import ArmguardsoftheAtlantean from "assets/images/items/Armguards of the Atlantean.jpg"
import ArmguardsoftheBeyond from "assets/images/items/Armguards of the Beyond.jpg"
import ArmguardsoftheBlackDragon from "assets/images/items/Armguards of the Black Dragon.jpg"
import ArmguardsoftheBlackPharaoh from "assets/images/items/Armguards of the Black Pharaoh.jpg"
import ArmguardsoftheBlackWarden from "assets/images/items/Armguards of the Black Warden.jpg"
import ArmguardsoftheChaosAgent from "assets/images/items/Armguards of the Chaos Agent.jpg"
import ArmguardsoftheCrimsonFort from "assets/images/items/Armguards of the Crimson Fort.jpg"
import ArmguardsoftheDarkMessenger from "assets/images/items/Armguards of the Dark Messenger.jpg"
import ArmguardsoftheDauntless from "assets/images/items/Armguards of the Dauntless.jpg"
import ArmguardsoftheDefiant from "assets/images/items/Armguards of the Defiant.jpg"
import ArmguardsoftheHaunterintheDark from "assets/images/items/Armguards of the Haunter in the Dark.jpg"
import ArmguardsoftheHowlingGiant from "assets/images/items/Armguards of the Howling Giant.jpg"
import ArmguardsoftheInvincible from "assets/images/items/Armguards of the Invincible.jpg"
import ArmguardsoftheMartialParagon from "assets/images/items/Armguards of the Martial Paragon.jpg"
import ArmguardsoftheMilitesTempli from "assets/images/items/Armguards of the Milites Templi.jpg"
import ArmguardsoftheOstiary from "assets/images/items/Armguards of the Ostiary.jpg"
import ArmguardsofthePainlegion from "assets/images/items/Armguards of the Painlegion.jpg"
import ArmguardsoftheProvenChampion from "assets/images/items/Armguards of the Proven Champion.jpg"
import ArmguardsoftheTirelessDefender from "assets/images/items/Armguards of the Tireless Defender.jpg"
import ArmguardsoftheTormentor from "assets/images/items/Armguards of the Tormentor.jpg"
import ArmguardsoftheTriumphant from "assets/images/items/Armguards of the Triumphant.jpg"
import ArmguardsoftheUsurper from "assets/images/items/Armguards of the Usurper.jpg"
import ArmguardsoftheValiant from "assets/images/items/Armguards of the Valiant.jpg"
import ArmguardsoftheVanguard from "assets/images/items/Armguards of the Vanguard.jpg"
import ArmguardsoftheVictoriousElite from "assets/images/items/Armguards of the Victorious Elite.jpg"
import ArmguardsoftheWicked from "assets/images/items/Armguards of the Wicked.jpg"
import ArmstrapsofLunacy from "assets/images/items/Armstraps of Lunacy.jpg"
import ArmstrapsoftheNebulous from "assets/images/items/Armstraps of the Nebulous.jpg"
import ArmstrapsoftheWellsofNight from "assets/images/items/Armstraps of the Wells of Night.jpg"
import ArmwrapofIntricateSpite from "assets/images/items/Armwrap of Intricate Spite.jpg"
import ArmwrapoftheFirebrand from "assets/images/items/Armwrap of the Firebrand.jpg"
import ArmwrapsofFiendishInvocation from "assets/images/items/Armwraps of Fiendish Invocation.jpg"
import ArmwrapsoftheDarkwretch from "assets/images/items/Armwraps of the Darkwretch.jpg"
import ArmwrapsoftheDoomsayer from "assets/images/items/Armwraps of the Doomsayer.jpg"
import ArmwrapsoftheForsaken from "assets/images/items/Armwraps of the Forsaken.jpg"
import ArmwrapsoftheHarbinger from "assets/images/items/Armwraps of the Harbinger.jpg"
import ArmwrapsofthePrecursor from "assets/images/items/Armwraps of the Precursor.jpg"
import ArmwrapsoftheReanimator from "assets/images/items/Armwraps of the Reanimator.jpg"
import ArrowsoftheBastion from "assets/images/items/Arrows of the Bastion.jpg"
import ArrowsoftheHaunterintheDark from "assets/images/items/Arrows of the Haunter in the Dark.jpg"
import ArtefactoftheFacelessSphinx from "assets/images/items/Artefact of the Faceless Sphinx.jpg"
import ArtisansTunic from "assets/images/items/Artisan's Tunic.jpg"
import AshMantleoftheLivingLegend from "assets/images/items/Ash Mantle of the Living Legend.jpg"
import AspofMysticalSupremacy from "assets/images/items/Asp of Mystical Supremacy.jpg"
import Aspfang from "assets/images/items/Aspfang.jpg"
import AstralHandguards from "assets/images/items/Astral Handguards.jpg"
import Astrum from "assets/images/items/Astrum.jpg"
import AvalancheBand from "assets/images/items/Avalanche Band.jpg"
import AxeofRedRuin from "assets/images/items/Axe of Red Ruin.jpg"
import AxeoftheArchaeologian from "assets/images/items/Axe of the Archaeologian.jpg"
import AxeoftheRedTide from "assets/images/items/Axe of the Red Tide.jpg"
import AxisofSickeningDreams from "assets/images/items/Axis of Sickening Dreams.jpg"
import AxisofTartarus from "assets/images/items/Axis of Tartarus.jpg"
import BagofEngulfment from "assets/images/items/Bag of Engulfment.jpg"
import BagirwaTotem from "assets/images/items/Bagirwa Totem.jpg"
import BalthussBuckskinChaps from "assets/images/items/Balthus's Buckskin Chaps.jpg"
import BalthussBuckskinJerkin from "assets/images/items/Balthus's Buckskin Jerkin.jpg"
import BalthussWolfBow from "assets/images/items/Balthus's Wolf Bow.jpg"
import BalthussWolfCrossbow from "assets/images/items/Balthus's Wolf Crossbow.jpg"
import BalthussWoodlandHelm from "assets/images/items/Balthus's Woodland Helm.jpg"
import BalthussWoodsmanBelt from "assets/images/items/Balthus's Woodsman Belt.jpg"
import BalthussWoodsmanBoots from "assets/images/items/Balthus's Woodsman Boots.jpg"
import BalthussWoodsmanBracers from "assets/images/items/Balthus's Woodsman Bracers.jpg"
import BalthussWoodsmanBrassards from "assets/images/items/Balthus's Woodsman Brassards.jpg"
import BalthussWoodsmanGloves from "assets/images/items/Balthus's Woodsman Gloves.jpg"
import BambooJavelin from "assets/images/items/Bamboo Javelin.jpg"
import BandofBloodthirst from "assets/images/items/Band of Bloodthirst.jpg"
import BandofForce from "assets/images/items/Band of Force.jpg"
import BandofKhan from "assets/images/items/Band of Khan.jpg"
import BandofPower from "assets/images/items/Band of Power.jpg"
import BandoftheCelestialBureaucracy from "assets/images/items/Band of the Celestial Bureaucracy.jpg"
import BandoftheImmortals from "assets/images/items/Band of the Immortals.jpg"
import BandoftheRampaging from "assets/images/items/Band of the Rampaging.jpg"
import BandoftheSanguineDisciple from "assets/images/items/Band of the Sanguine Disciple.jpg"
import BandoftheTwiceConquered from "assets/images/items/Band of the Twice-Conquered.jpg"
import BandoftheWallGuardian from "assets/images/items/Band of the Wall Guardian.jpg"
import BanditsArmbandsofaHundredEyes from "assets/images/items/Bandit's Armbands of a Hundred Eyes.jpg"
import BanditsArmbandsoftheGraspingWild from "assets/images/items/Bandit's Armbands of the Grasping Wild.jpg"
import BanditsArmbandsoftheHowlingWind from "assets/images/items/Bandit's Armbands of the Howling Wind.jpg"
import BanditsArmguardsoftheHowlingMoon from "assets/images/items/Bandit's Armguards of the Howling Moon.jpg"
import BanditsBeltoftheBloodyFang from "assets/images/items/Bandit's Belt of the Bloody Fang.jpg"
import BanditsBeltoftheKhan from "assets/images/items/Bandit's Belt of the Khan.jpg"
import BanditsBeltoftheRitualFlame from "assets/images/items/Bandit's Belt of the Ritual Flame.jpg"
import BanditsBeltofWovenClouds from "assets/images/items/Bandit's Belt of Woven Clouds.jpg"
import BanditsBootsoftheCovertTrail from "assets/images/items/Bandit's Boots of the Covert Trail.jpg"
import BanditsBootsoftheGrasslands from "assets/images/items/Bandit's Boots of the Grasslands.jpg"
import BanditsBootsofWorldsEdge from "assets/images/items/Bandit's Boots of World's Edge.jpg"
import BanditsChestguardoftheGrasslands from "assets/images/items/Bandit's Chestguard of the Grasslands.jpg"
import BanditsGauntletsoftheGrasslands from "assets/images/items/Bandit's Gauntlets of the Grasslands.jpg"
import BanditsGlovesoftheCovertTrail from "assets/images/items/Bandit's Gloves of the Covert Trail.jpg"
import BanditsGlovesoftheWickedHearth from "assets/images/items/Bandit's Gloves of the Wicked Hearth.jpg"
import BanditsGlovesofWorldsEdge from "assets/images/items/Bandit's Gloves of World's Edge.jpg"
import BanditsHelmoftheKhan from "assets/images/items/Bandit's Helm of the Khan.jpg"
import BanditsHoodoftheRitualFlame from "assets/images/items/Bandit's Hood of the Ritual Flame.jpg"
import BanditsHoodofWovenClouds from "assets/images/items/Bandit's Hood of Woven Clouds.jpg"
import BanditsJerkinofWorldsEdge from "assets/images/items/Bandit's Jerkin of World's Edge.jpg"
import BanditsLeggingsofaHundredEyes from "assets/images/items/Bandit's Leggings of a Hundred Eyes.jpg"
import BanditsLeggingsoftheGraspingWild from "assets/images/items/Bandit's Leggings of the Grasping Wild.jpg"
import BanditsLeggingsoftheHowlingWind from "assets/images/items/Bandit's Leggings of the Howling Wind.jpg"
import BanditsLegguardsoftheHowlingMoon from "assets/images/items/Bandit's Legguards of the Howling Moon.jpg"
import BanditsMaskoftheBloodyFang from "assets/images/items/Bandit's Mask of the Bloody Fang.jpg"
import BanditsStrapsofWorldsEdge from "assets/images/items/Bandit's Straps of World's Edge.jpg"
import BanditsTunicoftheCovertTrail from "assets/images/items/Bandit's Tunic of the Covert Trail.jpg"
import BanditsVambracesoftheGrasslands from "assets/images/items/Bandit's Vambraces of the Grasslands.jpg"
import BanditsWristbandsoftheCovertTrail from "assets/images/items/Bandit's Wristbands of the Covert Trail.jpg"
import BandsoftheOuterDark from "assets/images/items/Bands of the Outer Dark.jpg"
import BangleoftheGhostoftheVeldt from "assets/images/items/Bangle of the Ghost of the Veldt.jpg"
import BangleofthePrimalSpirit from "assets/images/items/Bangle of the Primal Spirit.jpg"
import BanglesoftheFacelessChaos from "assets/images/items/Bangles of the Faceless Chaos.jpg"
import BanglesoftheFacelessSphinx from "assets/images/items/Bangles of the Faceless Sphinx.jpg"
import BarbarousLoincloth from "assets/images/items/Barbarous Loincloth.jpg"
import BarbsofPersuasion from "assets/images/items/Barbs of Persuasion.jpg"
import BarbsoftheBloodDrinker from "assets/images/items/Barbs of the Blood Drinker.jpg"
import BarbsoftheMasqueroftheSands from "assets/images/items/Barbs of the Masquer of the Sands.jpg"
import BarrierofCloudedFrost from "assets/images/items/Barrier of Clouded Frost.jpg"
import BattleblessedOpus from "assets/images/items/Battleblessed Opus.jpg"
import Battlebrace from "assets/images/items/Battlebrace.jpg"
import BattlegraceBoots from "assets/images/items/Battlegrace Boots.jpg"
import BattlestanceBoots from "assets/images/items/Battlestance Boots.jpg"
import Battlewarden from "assets/images/items/Battlewarden.jpg"
import BearClawsofDivineMight from "assets/images/items/Bear Claws of Divine Might.jpg"
import BeastHuntersBarbs from "assets/images/items/Beast Hunter's Barbs.jpg"
import BeastHuntersMaliceBreaker from "assets/images/items/Beast Hunter's Malice Breaker.jpg"
import BeastHuntersMantleoftheLivingLegend from "assets/images/items/Beast Hunter's Mantle of the Living Legend.jpg"
import BeastHuntersReaperCrossbow from "assets/images/items/Beast Hunter's Reaper Crossbow.jpg"
import BeastMantleofBoneandHorn from "assets/images/items/Beast Mantle of Bone and Horn.jpg"
import Beastclaw from "assets/images/items/Beastclaw.jpg"
import BeastmastersBevor from "assets/images/items/Beastmaster's Bevor.jpg"
import BeastmastersCordedClaw from "assets/images/items/Beastmaster's Corded Claw.jpg"
import BeastmastersHereticalEye from "assets/images/items/Beastmaster's Heretical Eye.jpg"
import BeastmastersIconofFaith from "assets/images/items/Beastmaster's Icon of Faith.jpg"
import BeastmastersRuggedChoker from "assets/images/items/Beastmaster's Rugged Choker.jpg"
import BeastmastersStrandofBones from "assets/images/items/Beastmaster's Strand of Bones.jpg"
import BeastmastersTannedChoker from "assets/images/items/Beastmaster's Tanned Choker.jpg"
import BelieversArmbandsoftheCrumblingTower from "assets/images/items/Believer's Armbands of the Crumbling Tower.jpg"
import BelieversBandsoftheAureate from "assets/images/items/Believer's Bands of the Aureate.jpg"
import BelieversBeltoftheAureate from "assets/images/items/Believer's Belt of the Aureate.jpg"
import BelieversBeltoftheEldritch from "assets/images/items/Believer's Belt of the Eldritch.jpg"
import BelieversBeltofthePurpleSun from "assets/images/items/Believer's Belt of the Purple Sun.jpg"
import BelieversBootsoftheGreenOnes from "assets/images/items/Believer's Boots of the Green Ones.jpg"
import BelieversBootsoftheSoaringHeart from "assets/images/items/Believer's Boots of the Soaring Heart.jpg"
import BelieversBracersoftheGreenOnes from "assets/images/items/Believer's Bracers of the Green Ones.jpg"
import BelieversBracersoftheSoaringHeart from "assets/images/items/Believer's Bracers of the Soaring Heart.jpg"
import BelieversBraidoftheEldritch from "assets/images/items/Believer's Braid of the Eldritch.jpg"
import BelieversClothoftheEldritch from "assets/images/items/Believer's Cloth of the Eldritch.jpg"
import BelieversGauntletsoftheBloodyStone from "assets/images/items/Believer's Gauntlets of the Bloody Stone.jpg"
import BelieversGlovesoftheSoaringGod from "assets/images/items/Believer's Gloves of the Soaring God.jpg"
import BelieversGlovesofYag from "assets/images/items/Believer's Gloves of Yag.jpg"
import BelieversHarnessoftheBloodyStone from "assets/images/items/Believer's Harness of the Bloody Stone.jpg"
import BelieversHelmofthePurpleSun from "assets/images/items/Believer's Helm of the Purple Sun.jpg"
import BelieversHoodoftheEldritch from "assets/images/items/Believer's Hood of the Eldritch.jpg"
import BelieversJerkinoftheExaltedSpirit from "assets/images/items/Believer's Jerkin of the Exalted Spirit.jpg"
import BelieversJerkinoftheSoaringGod from "assets/images/items/Believer's Jerkin of the Soaring God.jpg"
import BelieversLeggingsoftheAureate from "assets/images/items/Believer's Leggings of the Aureate.jpg"
import BelieversLeggingsoftheCrumblingTower from "assets/images/items/Believer's Leggings of the Crumbling Tower.jpg"
import BelieversLegguardsofthePurpleSun from "assets/images/items/Believer's Legguards of the Purple Sun.jpg"
import BelieversRobesofYag from "assets/images/items/Believer's Robes of Yag.jpg"
import BelieversSandalsofShimmeringLight from "assets/images/items/Believer's Sandals of Shimmering Light.jpg"
import BelieversShoesoftheThreeClarities from "assets/images/items/Believer's Shoes of the Three Clarities.jpg"
import BelieversStrapsofthePurpleSun from "assets/images/items/Believer's Straps of the Purple Sun.jpg"
import BelieversStrapsoftheThreeClarities from "assets/images/items/Believer's Straps of the Three Clarities.jpg"
import BelieversWrapsoftheExaltedSpirit from "assets/images/items/Believer's Wraps of the Exalted Spirit.jpg"
import BelieversWriststrapsofShimmeringLight from "assets/images/items/Believer's Wrist-straps of Shimmering Light.jpg"
import BeltofArdentFire from "assets/images/items/Belt of Ardent Fire.jpg"
import BeltofBedlam from "assets/images/items/Belt of Bedlam.jpg"
import BeltofBenMorgh from "assets/images/items/Belt of Ben Morgh.jpg"
import BeltofBestialRage from "assets/images/items/Belt of Bestial Rage.jpg"
import BeltofBlackOblivion from "assets/images/items/Belt of Black Oblivion.jpg"
import BeltofBlackWhispers from "assets/images/items/Belt of Black Whispers.jpg"
import BeltofBloodlust from "assets/images/items/Belt of Bloodlust.jpg"
import BeltofBristlingIre from "assets/images/items/Belt of Bristling Ire.jpg"
import BeltofClarity from "assets/images/items/Belt of Clarity.jpg"
import BeltofConcealingShadows from "assets/images/items/Belt of Concealing Shadows.jpg"
import BeltofConflagrantFlame from "assets/images/items/Belt of Conflagrant Flame.jpg"
import BeltofCourageousSouls from "assets/images/items/Belt of Courageous Souls.jpg"
import BeltofCrimsonSlaughternm from "assets/images/items/Belt of Crimson Slaughter (nm).jpg"
import BeltofCrimsonSlaughter from "assets/images/items/Belt of Crimson Slaughter.jpg"
import BeltofDarkMalice from "assets/images/items/Belt of Dark Malice.jpg"
import BeltofDarkTerror from "assets/images/items/Belt of Dark Terror.jpg"
import BeltofDeadlyGuile from "assets/images/items/Belt of Deadly Guile.jpg"
import BeltofFearlessSouls from "assets/images/items/Belt of Fearless Souls.jpg"
import BeltofFerineAnger from "assets/images/items/Belt of Ferine Anger.jpg"
import BeltofFiendishInvocation from "assets/images/items/Belt of Fiendish Invocation.jpg"
import BeltofHaloga from "assets/images/items/Belt of Haloga.jpg"
import BeltofInfernalZeal from "assets/images/items/Belt of Infernal Zeal.jpg"
import BeltofIntricateSpite from "assets/images/items/Belt of Intricate Spite.jpg"
import BeltofLunacy from "assets/images/items/Belt of Lunacy.jpg"
import BeltofNecroticDread from "assets/images/items/Belt of Necrotic Dread.jpg"
import BeltofRapturousBattle from "assets/images/items/Belt of Rapturous Battle.jpg"
import BeltofRecklessChallenge from "assets/images/items/Belt of Reckless Challenge.jpg"
import BeltofRedRuinnm from "assets/images/items/Belt of Red Ruin (nm).jpg"
import BeltofRedRuin from "assets/images/items/Belt of Red Ruin.jpg"
import BeltofRighteousSmiting from "assets/images/items/Belt of Righteous Smiting.jpg"
import BeltofSwiftstriking from "assets/images/items/Belt of Swiftstriking.jpg"
import BeltoftheAssailant from "assets/images/items/Belt of the Assailant.jpg"
import BeltoftheAtlantean from "assets/images/items/Belt of the Atlantean.jpg"
import BeltoftheBeyond from "assets/images/items/Belt of the Beyond.jpg"
import BeltoftheBlackDragon from "assets/images/items/Belt of the Black Dragon.jpg"
import BeltoftheBlackPharaoh from "assets/images/items/Belt of the Black Pharaoh.jpg"
import BeltoftheBlackWarden from "assets/images/items/Belt of the Black Warden.jpg"
import BeltoftheBloodDrinkernm from "assets/images/items/Belt of the Blood Drinker (nm).jpg"
import BeltoftheBloodDrinker from "assets/images/items/Belt of the Blood Drinker.jpg"
import BeltoftheClay from "assets/images/items/Belt of the Clay.jpg"
import BeltoftheCrawlingChaos from "assets/images/items/Belt of the Crawling Chaos.jpg"
import BeltoftheCrimsonFort from "assets/images/items/Belt of the Crimson Fort.jpg"
import BeltoftheDarkMessenger from "assets/images/items/Belt of the Dark Messenger.jpg"
import BeltoftheDarkwretch from "assets/images/items/Belt of the Darkwretch.jpg"
import BeltoftheDauntless from "assets/images/items/Belt of the Dauntless.jpg"
import BeltoftheDeathGod from "assets/images/items/Belt of the Death God.jpg"
import BeltoftheDeathMasternm from "assets/images/items/Belt of the Death Master (nm).jpg"
import BeltoftheDeathMaster from "assets/images/items/Belt of the Death Master.jpg"
import BeltoftheDefiant from "assets/images/items/Belt of the Defiant.jpg"
import BeltoftheDoomsayer from "assets/images/items/Belt of the Doomsayer.jpg"
import BeltoftheEternalBlaze from "assets/images/items/Belt of the Eternal Blaze.jpg"
import BeltoftheExorcist from "assets/images/items/Belt of the Exorcist.jpg"
import BeltoftheFacelessChaos from "assets/images/items/Belt of the Faceless Chaos.jpg"
import BeltoftheFacelessSphinx from "assets/images/items/Belt of the Faceless Sphinx.jpg"
import BeltoftheFallenEmpirenm from "assets/images/items/Belt of the Fallen Empire (nm).jpg"
import BeltoftheFallenEmpire from "assets/images/items/Belt of the Fallen Empire.jpg"
import BeltoftheFarseeker from "assets/images/items/Belt of the Farseeker.jpg"
import BeltoftheFirebrand from "assets/images/items/Belt of the Firebrand.jpg"
import BeltoftheForsaken from "assets/images/items/Belt of the Forsaken.jpg"
import BeltoftheGhostoftheVeldt from "assets/images/items/Belt of the Ghost of the Veldt.jpg"
import BeltoftheGreatImpi from "assets/images/items/Belt of the Great Impi.jpg"
import BeltoftheHarbinger from "assets/images/items/Belt of the Harbinger.jpg"
import BeltoftheHuntmaster from "assets/images/items/Belt of the Huntmaster.jpg"
import BeltoftheLector from "assets/images/items/Belt of the Lector.jpg"
import BeltoftheMilitesTempli from "assets/images/items/Belt of the Milites Templi.jpg"
import BeltoftheNebulous from "assets/images/items/Belt of the Nebulous.jpg"
import BeltoftheOstiary from "assets/images/items/Belt of the Ostiary.jpg"
import BeltoftheOuterDark from "assets/images/items/Belt of the Outer Dark.jpg"
import BeltofthePrecursor from "assets/images/items/Belt of the Precursor.jpg"
import BeltofthePrimalSpirit from "assets/images/items/Belt of the Primal Spirit.jpg"
import BeltofthePutrescent from "assets/images/items/Belt of the Putrescent.jpg"
import BeltoftheRagereaver from "assets/images/items/Belt of the Ragereaver.jpg"
import BeltoftheReanimator from "assets/images/items/Belt of the Reanimator.jpg"
import BeltoftheRipplingLake from "assets/images/items/Belt of the Rippling Lake.jpg"
import BeltoftheSanguineDisciplenm from "assets/images/items/Belt of the Sanguine Disciple (nm).jpg"
import BeltoftheSanguineDisciple from "assets/images/items/Belt of the Sanguine Disciple.jpg"
import BeltoftheScatteredGods from "assets/images/items/Belt of the Scattered Gods.jpg"
import BeltoftheSepulcher from "assets/images/items/Belt of the Sepulcher.jpg"
import BeltoftheSilentSlayer from "assets/images/items/Belt of the Silent Slayer.jpg"
import BeltoftheSpheres from "assets/images/items/Belt of the Spheres.jpg"
import BeltoftheStillPond from "assets/images/items/Belt of the Still Pond.jpg"
import BeltoftheStormbringer from "assets/images/items/Belt of the Stormbringer.jpg"
import BeltoftheStrangeBeyond from "assets/images/items/Belt of the Strange Beyond.jpg"
import BeltoftheTormentor from "assets/images/items/Belt of the Tormentor.jpg"
import BeltoftheUbahKan from "assets/images/items/Belt of the Ubah Kan.jpg"
import BeltoftheUnholyCommunion from "assets/images/items/Belt of the Unholy Communion.jpg"
import BeltoftheUnslaked from "assets/images/items/Belt of the Unslaked.jpg"
import BeltoftheUnutterable from "assets/images/items/Belt of the Unutterable.jpg"
import BeltoftheUsurper from "assets/images/items/Belt of the Usurper.jpg"
import BeltoftheVanguard from "assets/images/items/Belt of the Vanguard.jpg"
import BeltoftheWardedBrute from "assets/images/items/Belt of the Warded Brute.jpg"
import BeltoftheWellsofNight from "assets/images/items/Belt of the Wells of Night.jpg"
import BeltoftheWhisperingBlade from "assets/images/items/Belt of the Whispering Blade.jpg"
import BeltoftheWicked from "assets/images/items/Belt of the Wicked.jpg"
import BeltofTranquility from "assets/images/items/Belt of Tranquility.jpg"
import BeltofTribulation from "assets/images/items/Belt of Tribulation.jpg"
import BeltofVehementThunder from "assets/images/items/Belt of Vehement Thunder.jpg"
import BeltofVengefulZeal from "assets/images/items/Belt of Vengeful Zeal.jpg"
import BeltofViciousFrenzy from "assets/images/items/Belt of Vicious Frenzy.jpg"
import BeltofVindictiveMalice from "assets/images/items/Belt of Vindictive Malice.jpg"
import BeltofWildFuror from "assets/images/items/Belt of Wild Furor.jpg"
import BindingoftheEndlessSands from "assets/images/items/Binding of the Endless Sands.jpg"
import BindingoftheEnslavingOpiate from "assets/images/items/Binding of the Enslaving Opiate.jpg"
import BindingoftheVoid from "assets/images/items/Binding of the Void.jpg"
import BindingsofArdentFire from "assets/images/items/Bindings of Ardent Fire.jpg"
import BindingsofBlackOblivion from "assets/images/items/Bindings of Black Oblivion.jpg"
import BindingsofConflagrantFlame from "assets/images/items/Bindings of Conflagrant Flame.jpg"
import BindingsofDarkTerror from "assets/images/items/Bindings of Dark Terror.jpg"
import BindingsofInfernalZeal from "assets/images/items/Bindings of Infernal Zeal.jpg"
import BindingsofNecroticDread from "assets/images/items/Bindings of Necrotic Dread.jpg"
import BindingsoftheDarkwretch from "assets/images/items/Bindings of the Darkwretch.jpg"
import BindingsoftheEternalBlaze from "assets/images/items/Bindings of the Eternal Blaze.jpg"
import BindingsoftheForsaken from "assets/images/items/Bindings of the Forsaken.jpg"
import BindingsoftheReanimator from "assets/images/items/Bindings of the Reanimator.jpg"
import BindingsoftheUnholyCommunion from "assets/images/items/Bindings of the Unholy Communion.jpg"
import BindingsoftheWhisperingBlade from "assets/images/items/Bindings of the Whispering Blade.jpg"
import BiteoftheWinterSun from "assets/images/items/Bite of the Winter Sun.jpg"
import BitterSteelBand from "assets/images/items/Bitter-Steel Band.jpg"
import Bitterfrost from "assets/images/items/Bitterfrost.jpg"
import BlackDragonClaw from "assets/images/items/Black Dragon Claw.jpg"
import BlackDragonCloak from "assets/images/items/Black Dragon Cloak.jpg"
import BlackDragonScale from "assets/images/items/Black Dragon Scale.jpg"
import BlackDragonTail from "assets/images/items/Black Dragon Tail.jpg"
import BlackDragonTongue from "assets/images/items/Black Dragon Tongue.jpg"
import BlackDragonTooth from "assets/images/items/Black Dragon Tooth.jpg"
import BlackPharaohsSoulBlade from "assets/images/items/Black Pharaoh's Soul Blade.jpg"
import BlackVash from "assets/images/items/Black Vash.jpg"
import Blackfang from "assets/images/items/Blackfang.jpg"
import Blackfist from "assets/images/items/Blackfist.jpg"
import Blackgrasp from "assets/images/items/Blackgrasp.jpg"
import BlackiceBand from "assets/images/items/Blackice Band.jpg"
import BlackmarrowBoots from "assets/images/items/Blackmarrow Boots.jpg"
import BlackmarrowChest from "assets/images/items/Blackmarrow Chest.jpg"
import BlackmarrowHelm from "assets/images/items/Blackmarrow Helm.jpg"
import BlackmarrowLeggings from "assets/images/items/Blackmarrow Leggings.jpg"
import BlackrainArbalest from "assets/images/items/Blackrain Arbalest.jpg"
import Blackruin from "assets/images/items/Blackruin.jpg"
import Blackshard from "assets/images/items/Blackshard.jpg"
import Blacksorrow from "assets/images/items/Blacksorrow.jpg"
import Blacksting from "assets/images/items/Blacksting.jpg"
import BlacksulphurArmbands from "assets/images/items/Blacksulphur Armbands.jpg"
import BlacksulphurCowl from "assets/images/items/Blacksulphur Cowl.jpg"
import BlacksulphurGloves from "assets/images/items/Blacksulphur Gloves.jpg"
import BlacksulphurPants from "assets/images/items/Blacksulphur Pants.jpg"
import BlacksulphurRobe from "assets/images/items/Blacksulphur Robe.jpg"
import BlacksulphurSash from "assets/images/items/Blacksulphur Sash.jpg"
import BlacksulphurSlippers from "assets/images/items/Blacksulphur Slippers.jpg"
import BlacksulphurWristbands from "assets/images/items/Blacksulphur Wristbands.jpg"
import BlackwatchArmguards from "assets/images/items/Blackwatch Armguards.jpg"
import BladeofEndlessNight from "assets/images/items/Blade of Endless Night.jpg"
import BladeofKhan from "assets/images/items/Blade of Khan.jpg"
import BladeofMarredSpirits from "assets/images/items/Blade of Marred Spirits.jpg"
import BladeofRefectory from "assets/images/items/Blade of Refectory.jpg"
import BladeofResilience from "assets/images/items/Blade of Resilience.jpg"
import BladeoftheAncientSands from "assets/images/items/Blade of the Ancient Sands.jpg"
import BladeoftheBlackPharaoh from "assets/images/items/Blade of the Black Pharaoh.jpg"
import BladeoftheBloodhunter from "assets/images/items/Blade of the Bloodhunter.jpg"
import BladeoftheCrownedSerpent from "assets/images/items/Blade of the Crowned Serpent.jpg"
import BladeoftheDarkSun from "assets/images/items/Blade of the Dark Sun.jpg"
import BladeoftheEnslavingOpiate from "assets/images/items/Blade of the Enslaving Opiate.jpg"
import BladeoftheFallenKing from "assets/images/items/Blade of the Fallen King.jpg"
import BladeoftheManicHaze from "assets/images/items/Blade of the Manic Haze.jpg"
import BladeofthePillars from "assets/images/items/Blade of the Pillars.jpg"
import BladeoftheTuranianArmy from "assets/images/items/Blade of the Turanian Army.jpg"
import BladeoftheVoid from "assets/images/items/Blade of the Void.jpg"
import BladesArmstrapsofCharredEarth from "assets/images/items/Blade's Arm-straps of Charred Earth.jpg"
import BladesArmbandsoftheHiddenTomb from "assets/images/items/Blade's Armbands of the Hidden Tomb.jpg"
import BladesBeltofCharredEarth from "assets/images/items/Blade's Belt of Charred Earth.jpg"
import BladesBeltoftheGrimCabal from "assets/images/items/Blade's Belt of the Grim Cabal.jpg"
import BladesBeltoftheHiddenTomb from "assets/images/items/Blade's Belt of the Hidden Tomb.jpg"
import BladesBootsofCreepingDeath from "assets/images/items/Blade's Boots of Creeping Death.jpg"
import BladesBootsofShatteredSouls from "assets/images/items/Blade's Boots of Shattered Souls.jpg"
import BladesBootsoftheBlackArts from "assets/images/items/Blade's Boots of the Black Arts.jpg"
import BladesBootsoftheFirebringer from "assets/images/items/Blade's Boots of the Firebringer.jpg"
import BladesBracersofShatteredSouls from "assets/images/items/Blade's Bracers of Shattered Souls.jpg"
import BladesBracersoftheBlackArts from "assets/images/items/Blade's Bracers of the Black Arts.jpg"
import BladesBracersoftheFirebringer from "assets/images/items/Blade's Bracers of the Firebringer.jpg"
import BladesBreechesoftheGrimCabal from "assets/images/items/Blade's Breeches of the Grim Cabal.jpg"
import BladesCordofWaningDusk from "assets/images/items/Blade's Cord of Waning Dusk.jpg"
import BladesDeathmaskofMalice from "assets/images/items/Blade's Deathmask of Malice.jpg"
import BladesFauldofWaningDusk from "assets/images/items/Blade's Fauld of Waning Dusk.jpg"
import BladesGlovesofCharredEarth from "assets/images/items/Blade's Gloves of Charred Earth.jpg"
import BladesGlovesoftheHiddenTomb from "assets/images/items/Blade's Gloves of the Hidden Tomb.jpg"
import BladesGripsoftheGrimCabal from "assets/images/items/Blade's Grips of the Grim Cabal.jpg"
import BladesGripsofWaningDusk from "assets/images/items/Blade's Grips of Waning Dusk.jpg"
import BladesJerkinofMalice from "assets/images/items/Blade's Jerkin of Malice.jpg"
import BladesLeggingsofCharredEarth from "assets/images/items/Blade's Leggings of Charred Earth.jpg"
import BladesLeggingsoftheHiddenTomb from "assets/images/items/Blade's Leggings of the Hidden Tomb.jpg"
import BladesMaskoftheBattlethrall from "assets/images/items/Blade's Mask of the Battlethrall.jpg"
import BladesMaskoftheSilentKill from "assets/images/items/Blade's Mask of the Silent Kill.jpg"
import BladesSpauldofWaningDusk from "assets/images/items/Blade's Spauld of Waning Dusk.jpg"
import BladesStrapsoftheGrimCabal from "assets/images/items/Blade's Straps of the Grim Cabal.jpg"
import BladesTunicofArcaneDeath from "assets/images/items/Blade's Tunic of Arcane Death.jpg"
import BladesTunicoftheBattlethrall from "assets/images/items/Blade's Tunic of the Battlethrall.jpg"
import BladesTunicoftheSilentKill from "assets/images/items/Blade's Tunic of the Silent Kill.jpg"
import BladesVeilofArcaneDeath from "assets/images/items/Blade's Veil of Arcane Death.jpg"
import BladesWristbandsofCreepingDeath from "assets/images/items/Blade's Wristbands of Creeping Death.jpg"
import BladebarrierGirdle from "assets/images/items/Bladebarrier Girdle.jpg"
import BladefeintSabatons from "assets/images/items/Bladefeint Sabatons.jpg"
import BladekissedCloakoftheFinalGoodnight from "assets/images/items/Bladekissed Cloak of the Final Goodnight.jpg"
import BlanchedVambraces from "assets/images/items/Blanched Vambraces.jpg"
import BlessedDoKki from "assets/images/items/Blessed Do Kki.jpg"
import BlessedGem from "assets/images/items/Blessed Gem.jpg"
import BlessedSignet from "assets/images/items/Blessed Signet.jpg"
import BlesswarBracers from "assets/images/items/Blesswar Bracers.jpg"
import Blight from "assets/images/items/Blight.jpg"
import BlightedHalberd from "assets/images/items/Blighted Halberd.jpg"
import BloodChoker from "assets/images/items/Blood Choker.jpg"
import BloodoftheDamned from "assets/images/items/Blood of the Damned.jpg"
import BloodScriptureofXotli from "assets/images/items/Blood Scripture of Xotli.jpg"
import BloodSummoner from "assets/images/items/Blood Summoner.jpg"
import BloodritualBoots from "assets/images/items/Blood-ritual Boots.jpg"
import Bloodbane from "assets/images/items/Bloodbane.jpg"
import Bloodbarbs from "assets/images/items/Bloodbarbs.jpg"
import Bloodbeak from "assets/images/items/Bloodbeak.jpg"
import BloodbeggarBolts from "assets/images/items/Bloodbeggar Bolts.jpg"
import BloodbeggarShafts from "assets/images/items/Bloodbeggar Shafts.jpg"
import BloodbruteChestguard from "assets/images/items/Bloodbrute Chestguard.jpg"
import BloodbruteLegguards from "assets/images/items/Bloodbrute Legguards.jpg"
import Bloodcarve from "assets/images/items/Bloodcarve.jpg"
import BloodedArmstrapsoftheMound from "assets/images/items/Blooded Arm-straps of the Mound.jpg"
import BloodedArmbandsoftheFourWinds from "assets/images/items/Blooded Armbands of the Four Winds.jpg"
import BloodedBeltoftheFarHorizon from "assets/images/items/Blooded Belt of the Far Horizon.jpg"
import BloodedBeltoftheMound from "assets/images/items/Blooded Belt of the Mound.jpg"
import BloodedBeltofthePlains from "assets/images/items/Blooded Belt of the Plains.jpg"
import BloodedBootsofPassingSpirits from "assets/images/items/Blooded Boots of Passing Spirits.jpg"
import BloodedBootsoftheClans from "assets/images/items/Blooded Boots of the Clans.jpg"
import BloodedBootsoftheEverlastingSky from "assets/images/items/Blooded Boots of the Everlasting Sky.jpg"
import BloodedBootsoftheTribes from "assets/images/items/Blooded Boots of the Tribes.jpg"
import BloodedBracersofPassingSpirits from "assets/images/items/Blooded Bracers of Passing Spirits.jpg"
import BloodedBracersoftheClans from "assets/images/items/Blooded Bracers of the Clans.jpg"
import BloodedBracersoftheEverlastingSky from "assets/images/items/Blooded Bracers of the Everlasting Sky.jpg"
import BloodedFauldoftheMound from "assets/images/items/Blooded Fauld of the Mound.jpg"
import BloodedGauntletsoftheGreensward from "assets/images/items/Blooded Gauntlets of the Greensward.jpg"
import BloodedGirdleoftheFourWinds from "assets/images/items/Blooded Girdle of the Four Winds.jpg"
import BloodedGlovesoftheAncestors from "assets/images/items/Blooded Gloves of the Ancestors.jpg"
import BloodedGlovesoftheGoldenHorde from "assets/images/items/Blooded Gloves of the Golden Horde.jpg"
import BloodedGlovesoftheSevenSuns from "assets/images/items/Blooded Gloves of the Seven Suns.jpg"
import BloodedHarnessoftheGreensward from "assets/images/items/Blooded Harness of the Greensward.jpg"
import BloodedHelmoftheFourWinds from "assets/images/items/Blooded Helm of the Four Winds.jpg"
import BloodedHelmoftheMound from "assets/images/items/Blooded Helm of the Mound.jpg"
import BloodedHelmofthePlains from "assets/images/items/Blooded Helm of the Plains.jpg"
import BloodedJerkinoftheGoldenHorde from "assets/images/items/Blooded Jerkin of the Golden Horde.jpg"
import BloodedJerkinoftheSevenSuns from "assets/images/items/Blooded Jerkin of the Seven Suns.jpg"
import BloodedLegguardsofthePlains from "assets/images/items/Blooded Legguards of the Plains.jpg"
import BloodedStrapsoftheFarHorizon from "assets/images/items/Blooded Straps of the Far Horizon.jpg"
import BloodedStrapsofthePlains from "assets/images/items/Blooded Straps of the Plains.jpg"
import BloodedTunicoftheAncestors from "assets/images/items/Blooded Tunic of the Ancestors.jpg"
import BloodedVambracesoftheTribes from "assets/images/items/Blooded Vambraces of the Tribes.jpg"
import Bloodedge from "assets/images/items/Bloodedge.jpg"
import BloodfenMitts from "assets/images/items/Bloodfen Mitts.jpg"
import Bloodguard from "assets/images/items/Bloodguard.jpg"
import Bloodhammer from "assets/images/items/Bloodhammer.jpg"
import BloodmireGauntlets from "assets/images/items/Bloodmire Gauntlets.jpg"
import Bloodnail from "assets/images/items/Bloodnail.jpg"
import BloodregentClaymore from "assets/images/items/Bloodregent Claymore.jpg"
import Bloodsap from "assets/images/items/Bloodsap.jpg"
import BloodscytheGauntlets from "assets/images/items/Bloodscythe Gauntlets.jpg"
import BloodseekerBlade from "assets/images/items/Bloodseeker Blade.jpg"
import BloodseekerClaymore from "assets/images/items/Bloodseeker Claymore.jpg"
import BloodseersArmbands from "assets/images/items/Bloodseer's Armbands.jpg"
import BloodseersBoots from "assets/images/items/Bloodseer's Boots.jpg"
import BloodseersCowl from "assets/images/items/Bloodseer's Cowl.jpg"
import BloodseersGloves from "assets/images/items/Bloodseer's Gloves.jpg"
import BloodseersRobe from "assets/images/items/Bloodseer's Robe.jpg"
import BloodseersSash from "assets/images/items/Bloodseer's Sash.jpg"
import BloodseersTasset from "assets/images/items/Bloodseer's Tasset.jpg"
import BloodseersWristbands from "assets/images/items/Bloodseer's Wristbands.jpg"
import BloodseraphsArmguards from "assets/images/items/Bloodseraph's Armguards.jpg"
import BloodseraphsBoots from "assets/images/items/Bloodseraph's Boots.jpg"
import BloodseraphsChestguard from "assets/images/items/Bloodseraph's Chestguard.jpg"
import BloodseraphsGauntlets from "assets/images/items/Bloodseraph's Gauntlets.jpg"
import BloodseraphsGirdle from "assets/images/items/Bloodseraph's Girdle.jpg"
import BloodseraphsHelm from "assets/images/items/Bloodseraph's Helm.jpg"
import BloodseraphsLegguards from "assets/images/items/Bloodseraph's Legguards.jpg"
import BloodseraphsVambraces from "assets/images/items/Bloodseraph's Vambraces.jpg"
import Bloodsinger from "assets/images/items/Bloodsinger.jpg"
import BloodsireBoots from "assets/images/items/Bloodsire Boots.jpg"
import BloodsireHarness from "assets/images/items/Bloodsire Harness.jpg"
import BloodsireHelm from "assets/images/items/Bloodsire Helm.jpg"
import BloodsireTasset from "assets/images/items/Bloodsire Tasset.jpg"
import Bloodskew from "assets/images/items/Bloodskew.jpg"
import BloodsnareGloves from "assets/images/items/Bloodsnare Gloves.jpg"
import Bloodstreak from "assets/images/items/Bloodstreak.jpg"
import BloodtaintedBand from "assets/images/items/Bloodtainted Band.jpg"
import BloodtaintedHoop from "assets/images/items/Bloodtainted Hoop.jpg"
import BloodthirstRecurve from "assets/images/items/Bloodthirst Recurve.jpg"
import BloodtrailSabatons from "assets/images/items/Bloodtrail Sabatons.jpg"
import BloodvaliantGauntlets from "assets/images/items/Bloodvaliant Gauntlets.jpg"
import BloodweaselBoots from "assets/images/items/Bloodweasel Boots.jpg"
import BlossomingDeath from "assets/images/items/Blossoming Death.jpg"
import BludgeonoftheIcyTomb from "assets/images/items/Bludgeon of the Icy Tomb.jpg"
import BluefuryWarWolf from "assets/images/items/Bluefury War Wolf.jpg"
import BodyBag from "assets/images/items/Body Bag.jpg"
import BoltsofBlackSorrow from "assets/images/items/Bolts of Black Sorrow.jpg"
import BoltsofConflagration from "assets/images/items/Bolts of Conflagration.jpg"
import BoltsofRakedFlesh from "assets/images/items/Bolts of Raked Flesh.jpg"
import BoltsoftheArmsmaster from "assets/images/items/Bolts of the Armsmaster.jpg"
import BoltsoftheHaunterintheDark from "assets/images/items/Bolts of the Haunter in the Dark.jpg"
import BoltsofWintersBreath from "assets/images/items/Bolts of Winter's Breath.jpg"
import BondofAnarchy from "assets/images/items/Bond of Anarchy.jpg"
import BondoftheChampionofCimmeria from "assets/images/items/Bond of the Champion of Cimmeria.jpg"
import BoneLoop from "assets/images/items/Bone Loop.jpg"
import BonepickersBelt from "assets/images/items/Bone-picker's Belt.jpg"
import BonepickersHelm from "assets/images/items/Bone-picker's Helm.jpg"
import Bonebiter from "assets/images/items/Bonebiter.jpg"
import BonechillTalisman from "assets/images/items/Bonechill Talisman.jpg"
import Bonecleave from "assets/images/items/Bonecleave.jpg"
import Boneharbor from "assets/images/items/Boneharbor.jpg"
import Bonesever from "assets/images/items/Bonesever.jpg"
import BoneshadowMask from "assets/images/items/Boneshadow Mask.jpg"
import Boneshard from "assets/images/items/Boneshard.jpg"
import BoneshredGloves from "assets/images/items/Boneshred Gloves.jpg"
import BootsofaThousandBlossoms from "assets/images/items/Boots of a Thousand Blossoms.jpg"
import BootsofArdentFire from "assets/images/items/Boots of Ardent Fire.jpg"
import BootsofBalefulBlood from "assets/images/items/Boots of Baleful Blood.jpg"
import BootsofBedlam from "assets/images/items/Boots of Bedlam.jpg"
import BootsofBenMorgh from "assets/images/items/Boots of Ben Morgh.jpg"
import BootsofBerserkersFury from "assets/images/items/Boots of Berserker's Fury.jpg"
import BootsofBestialRage from "assets/images/items/Boots of Bestial Rage.jpg"
import BootsofBlackOblivion from "assets/images/items/Boots of Black Oblivion.jpg"
import BootsofBlackSpite from "assets/images/items/Boots of Black Spite.jpg"
import BootsofBloodlust from "assets/images/items/Boots of Bloodlust.jpg"
import BootsofBoneandHorn from "assets/images/items/Boots of Bone and Horn.jpg"
import BootsofBristlingIre from "assets/images/items/Boots of Bristling Ire.jpg"
import BootsofBrutalCarnage from "assets/images/items/Boots of Brutal Carnage.jpg"
import BootsofCelestialRadiance from "assets/images/items/Boots of Celestial Radiance.jpg"
import BootsofClarity from "assets/images/items/Boots of Clarity.jpg"
import BootsofClawingMight from "assets/images/items/Boots of Clawing Might.jpg"
import BootsofConcealingShadows from "assets/images/items/Boots of Concealing Shadows.jpg"
import BootsofConflagrantFlame from "assets/images/items/Boots of Conflagrant Flame.jpg"
import BootsofCourageousSouls from "assets/images/items/Boots of Courageous Souls.jpg"
import BootsofCrimsonSlaughternm from "assets/images/items/Boots of Crimson Slaughter (nm).jpg"
import BootsofCrimsonSlaughter from "assets/images/items/Boots of Crimson Slaughter.jpg"
import BootsofDarkTerror from "assets/images/items/Boots of Dark Terror.jpg"
import BootsofEffulgentDevotion from "assets/images/items/Boots of Effulgent Devotion.jpg"
import BootsofErlik from "assets/images/items/Boots of Erlik.jpg"
import BootsofFearlessSouls from "assets/images/items/Boots of Fearless Souls.jpg"
import BootsofFerineAnger from "assets/images/items/Boots of Ferine Anger.jpg"
import BootsofFiendishInvocation from "assets/images/items/Boots of Fiendish Invocation.jpg"
import BootsofFlowingWater from "assets/images/items/Boots of Flowing Water.jpg"
import BootsofHeroicSoul from "assets/images/items/Boots of Heroic Soul.jpg"
import BootsofIlluminantConviction from "assets/images/items/Boots of Illuminant Conviction.jpg"
import BootsofInfernalZeal from "assets/images/items/Boots of Infernal Zeal.jpg"
import BootsofInsanity from "assets/images/items/Boots of Insanity.jpg"
import BootsofIntricateSpite from "assets/images/items/Boots of Intricate Spite.jpg"
import BootsofJaggedBarbs from "assets/images/items/Boots of Jagged Barbs.jpg"
import BootsofLunacy from "assets/images/items/Boots of Lunacy.jpg"
import BootsofNecroticDread from "assets/images/items/Boots of Necrotic Dread.jpg"
import BootsofPandemonium from "assets/images/items/Boots of Pandemonium.jpg"
import BootsofQuilledDarts from "assets/images/items/Boots of Quilled Darts.jpg"
import BootsofRapturousBattle from "assets/images/items/Boots of Rapturous Battle.jpg"
import BootsofRecklessChallenge from "assets/images/items/Boots of Reckless Challenge.jpg"
import BootsofRighteousSmiting from "assets/images/items/Boots of Righteous Smiting.jpg"
import BootsofSwiftstriking from "assets/images/items/Boots of Swiftstriking.jpg"
import BootsoftheAmaranthineDrums from "assets/images/items/Boots of the Amaranthine Drums.jpg"
import BootsoftheAscension from "assets/images/items/Boots of the Ascension.jpg"
import BootsoftheAssailant from "assets/images/items/Boots of the Assailant.jpg"
import BootsoftheAtlantean from "assets/images/items/Boots of the Atlantean.jpg"
import BootsoftheBeyond from "assets/images/items/Boots of the Beyond.jpg"
import BootsoftheBlackDragon from "assets/images/items/Boots of the Black Dragon.jpg"
import BootsoftheBlackPharaoh from "assets/images/items/Boots of the Black Pharaoh.jpg"
import BootsoftheBlackWarden from "assets/images/items/Boots of the Black Warden.jpg"
import BootsoftheBloodDrinkernm from "assets/images/items/Boots of the Blood Drinker (nm).jpg"
import BootsoftheBloodDrinker from "assets/images/items/Boots of the Blood Drinker.jpg"
import BootsoftheBloodhunternm from "assets/images/items/Boots of the Bloodhunter (nm).jpg"
import BootsoftheBloodhunter from "assets/images/items/Boots of the Bloodhunter.jpg"
import BootsoftheBloodmoon from "assets/images/items/Boots of the Bloodmoon.jpg"
import BootsoftheChaosAgent from "assets/images/items/Boots of the Chaos Agent.jpg"
import BootsoftheClay from "assets/images/items/Boots of the Clay.jpg"
import BootsoftheCloudcleaver from "assets/images/items/Boots of the Cloudcleaver.jpg"
import BootsoftheCrawlingChaos from "assets/images/items/Boots of the Crawling Chaos.jpg"
import BootsoftheCrimsonFort from "assets/images/items/Boots of the Crimson Fort.jpg"
import BootsoftheDarkMessenger from "assets/images/items/Boots of the Dark Messenger.jpg"
import BootsoftheDauntless from "assets/images/items/Boots of the Dauntless.jpg"
import BootsoftheDeathGod from "assets/images/items/Boots of the Death God.jpg"
import BootsoftheDeathstalker from "assets/images/items/Boots of the Deathstalker.jpg"
import BootsoftheDefiant from "assets/images/items/Boots of the Defiant.jpg"
import BootsoftheDoomsayer from "assets/images/items/Boots of the Doomsayer.jpg"
import BootsoftheDragonKing from "assets/images/items/Boots of the Dragon King.jpg"
import BootsoftheEcliptic from "assets/images/items/Boots of the Ecliptic.jpg"
import BootsoftheEternalBlaze from "assets/images/items/Boots of the Eternal Blaze.jpg"
import BootsoftheExorcist from "assets/images/items/Boots of the Exorcist.jpg"
import BootsoftheFacelessChaos from "assets/images/items/Boots of the Faceless Chaos.jpg"
import BootsoftheFacelessSphinx from "assets/images/items/Boots of the Faceless Sphinx.jpg"
import BootsoftheFarseeker from "assets/images/items/Boots of the Farseeker.jpg"
import BootsoftheFirebrand from "assets/images/items/Boots of the Firebrand.jpg"
import BootsoftheFirstCircle from "assets/images/items/Boots of the First Circle.jpg"
import BootsoftheFuriousSwipe from "assets/images/items/Boots of the Furious Swipe.jpg"
import BootsoftheGrandMonarch from "assets/images/items/Boots of the Grand Monarch.jpg"
import BootsoftheGreatImpi from "assets/images/items/Boots of the Great Impi.jpg"
import BootsoftheHaunterintheDark from "assets/images/items/Boots of the Haunter in the Dark.jpg"
import BootsoftheHellWalkernm from "assets/images/items/Boots of the Hell Walker (nm).jpg"
import BootsoftheHellWalker from "assets/images/items/Boots of the Hell Walker.jpg"
import BootsoftheHowlingGiant from "assets/images/items/Boots of the Howling Giant.jpg"
import BootsoftheHuntmaster from "assets/images/items/Boots of the Huntmaster.jpg"
import BootsoftheIchorous from "assets/images/items/Boots of the Ichorous.jpg"
import BootsoftheInconceivable from "assets/images/items/Boots of the Inconceivable.jpg"
import BootsoftheInvincible from "assets/images/items/Boots of the Invincible.jpg"
import BootsoftheJudgmentBolt from "assets/images/items/Boots of the Judgment Bolt.jpg"
import BootsoftheKozakSlayer from "assets/images/items/Boots of the Kozak Slayer.jpg"
import BootsoftheLector from "assets/images/items/Boots of the Lector.jpg"
import BootsoftheLivingTarim from "assets/images/items/Boots of the Living Tarim.jpg"
import BootsoftheMartialParagon from "assets/images/items/Boots of the Martial Paragon.jpg"
import BootsoftheMasqueroftheSands from "assets/images/items/Boots of the Masquer of the Sands.jpg"
import BootsoftheMembranous from "assets/images/items/Boots of the Membranous.jpg"
import BootsoftheMilitesTempli from "assets/images/items/Boots of the Milites Templi.jpg"
import BootsoftheOstiary from "assets/images/items/Boots of the Ostiary.jpg"
import BootsoftheOxmal from "assets/images/items/Boots of the Oxmal.jpg"
import BootsofthePainlegion from "assets/images/items/Boots of the Painlegion.jpg"
import BootsoftheProvenChampion from "assets/images/items/Boots of the Proven Champion.jpg"
import BootsofthePutrescent from "assets/images/items/Boots of the Putrescent.jpg"
import BootsoftheRagereaver from "assets/images/items/Boots of the Ragereaver.jpg"
import BootsoftheRavenflight from "assets/images/items/Boots of the Ravenflight.jpg"
import BootsoftheRefectory from "assets/images/items/Boots of the Refectory.jpg"
import BootsoftheRenegade from "assets/images/items/Boots of the Renegade.jpg"
import BootsoftheRevelationsofTarim from "assets/images/items/Boots of the Revelations of Tarim.jpg"
import BootsoftheRevelations from "assets/images/items/Boots of the Revelations.jpg"
import BootsoftheRiftcaller from "assets/images/items/Boots of the Riftcaller.jpg"
import BootsoftheRipplingLake from "assets/images/items/Boots of the Rippling Lake.jpg"
import BootsoftheSanguineDisciplenm from "assets/images/items/Boots of the Sanguine Disciple (nm).jpg"
import BootsoftheSanguineDisciple from "assets/images/items/Boots of the Sanguine Disciple.jpg"
import BootsoftheSavageFang from "assets/images/items/Boots of the Savage Fang.jpg"
import BootsoftheSavageSlaughter from "assets/images/items/Boots of the Savage Slaughter.jpg"
import BootsoftheScatteredGods from "assets/images/items/Boots of the Scattered Gods.jpg"
import BootsoftheSepulcher from "assets/images/items/Boots of the Sepulcher.jpg"
import BootsoftheShiveringStars from "assets/images/items/Boots of the Shivering Stars.jpg"
import BootsoftheSpheres from "assets/images/items/Boots of the Spheres.jpg"
import BootsoftheSteelBehemoth from "assets/images/items/Boots of the Steel Behemoth.jpg"
import BootsoftheStillPond from "assets/images/items/Boots of the Still Pond.jpg"
import BootsoftheStormbringer from "assets/images/items/Boots of the Stormbringer.jpg"
import BootsoftheStrangeBeyond from "assets/images/items/Boots of the Strange Beyond.jpg"
import BootsoftheSunderedSkies from "assets/images/items/Boots of the Sundered Skies.jpg"
import BootsoftheSwiftTalon from "assets/images/items/Boots of the Swift Talon.jpg"
import BootsoftheTirelessDefender from "assets/images/items/Boots of the Tireless Defender.jpg"
import BootsoftheTormentor from "assets/images/items/Boots of the Tormentor.jpg"
import BootsoftheTriumphant from "assets/images/items/Boots of the Triumphant.jpg"
import BootsoftheUbahKan from "assets/images/items/Boots of the Ubah Kan.jpg"
import BootsoftheUnholyCommunion from "assets/images/items/Boots of the Unholy Communion.jpg"
import BootsoftheUnutterable from "assets/images/items/Boots of the Unutterable.jpg"
import BootsoftheUsurper from "assets/images/items/Boots of the Usurper.jpg"
import BootsoftheValiant from "assets/images/items/Boots of the Valiant.jpg"
import BootsoftheVanguard from "assets/images/items/Boots of the Vanguard.jpg"
import BootsoftheVictoriousElite from "assets/images/items/Boots of the Victorious Elite.jpg"
import BootsoftheWellsofNight from "assets/images/items/Boots of the Wells of Night.jpg"
import BootsoftheWhisperingBlade from "assets/images/items/Boots of the Whispering Blade.jpg"
import BootsoftheWicked from "assets/images/items/Boots of the Wicked.jpg"
import BootsoftheEarthMother from "assets/images/items/Boots of theEarth Mother.jpg"
import BootsofTribulation from "assets/images/items/Boots of Tribulation.jpg"
import BootsofUnrest from "assets/images/items/Boots of Unrest.jpg"
import BootsofUntamedViolence from "assets/images/items/Boots of Untamed Violence.jpg"
import BootsofVehementThunder from "assets/images/items/Boots of Vehement Thunder.jpg"
import BootsofVengefulZeal from "assets/images/items/Boots of Vengeful Zeal.jpg"
import BootsofVernantFury from "assets/images/items/Boots of Vernant Fury.jpg"
import BootsofViciousFrenzy from "assets/images/items/Boots of Vicious Frenzy.jpg"
import BootsofVindictiveMalice from "assets/images/items/Boots of Vindictive Malice.jpg"
import BootsofViolentRage from "assets/images/items/Boots of Violent Rage.jpg"
import BootsofWildFuror from "assets/images/items/Boots of Wild Furor.jpg"
import BootsofWrithing from "assets/images/items/Boots of Writhing.jpg"
import BorderKingdomCap from "assets/images/items/Border Kingdom Cap.jpg"
import BorderKingdomHeaddress from "assets/images/items/Border Kingdom Headdress.jpg"
import BorderKingdomHeadgear from "assets/images/items/Border Kingdom Headgear.jpg"
import BorderKingdomHelm from "assets/images/items/Border Kingdom Helm.jpg"
import BorderKingdomHelmet from "assets/images/items/Border Kingdom Helmet.jpg"
import BossonianBascinet from "assets/images/items/Bossonian Bascinet.jpg"
import BossonianCharm from "assets/images/items/Bossonian Charm.jpg"
import BossonianSovereignRing from "assets/images/items/Bossonian Sovereign Ring.jpg"
import BountyHuntersCrossbow from "assets/images/items/Bounty Hunter's Crossbow.jpg"
import BountyHuntersDirk from "assets/images/items/Bounty Hunter's Dirk.jpg"
import BowoftheClay from "assets/images/items/Bow of the Clay.jpg"
import BowoftheHaunterintheDark from "assets/images/items/Bow of the Haunter in the Dark.jpg"
import BowoftheMaskedHunter from "assets/images/items/Bow of the Masked Hunter.jpg"
import BowoftheRhinoRider from "assets/images/items/Bow of the Rhino Rider.jpg"
import BowoftheUnseen from "assets/images/items/Bow of the Unseen.jpg"
import BraceofKuthchemes from "assets/images/items/Brace of Kuthchemes.jpg"
import BraceletsofthePrimalSpirit from "assets/images/items/Bracelets of the Primal Spirit.jpg"
import BraceroftheKatari from "assets/images/items/Bracer of the Katari.jpg"
import BracersofArdentFire from "assets/images/items/Bracers of Ardent Fire.jpg"
import BracersofBedlam from "assets/images/items/Bracers of Bedlam.jpg"
import BracersofBestialRage from "assets/images/items/Bracers of Bestial Rage.jpg"
import BracersofBlackOblivion from "assets/images/items/Bracers of Black Oblivion.jpg"
import BracersofBlackWhispers from "assets/images/items/Bracers of Black Whispers.jpg"
import BracersofBristlingIre from "assets/images/items/Bracers of Bristling Ire.jpg"
import BracersofBrutalCarnage from "assets/images/items/Bracers of Brutal Carnage.jpg"
import BracersofCelestialRadiance from "assets/images/items/Bracers of Celestial Radiance.jpg"
import BracersofClawingMight from "assets/images/items/Bracers of Clawing Might.jpg"
import BracersofConflagrantFlame from "assets/images/items/Bracers of Conflagrant Flame.jpg"
import BracersofCourageousSouls from "assets/images/items/Bracers of Courageous Souls.jpg"
import BracersofDarkMalice from "assets/images/items/Bracers of Dark Malice.jpg"
import BracersofDarkTerror from "assets/images/items/Bracers of Dark Terror.jpg"
import BracersofDeadlyGuile from "assets/images/items/Bracers of Deadly Guile.jpg"
import BracersofEffulgentDevotion from "assets/images/items/Bracers of Effulgent Devotion.jpg"
import BracersofErlik from "assets/images/items/Bracers of Erlik.jpg"
import BracersofFearlessSouls from "assets/images/items/Bracers of Fearless Souls.jpg"
import BracersofFerineAnger from "assets/images/items/Bracers of Ferine Anger.jpg"
import BracersofHaloga from "assets/images/items/Bracers of Haloga.jpg"
import BracersofIlluminantConviction from "assets/images/items/Bracers of Illuminant Conviction.jpg"
import BracersofInfernalZeal from "assets/images/items/Bracers of Infernal Zeal.jpg"
import BracersofInsanity from "assets/images/items/Bracers of Insanity.jpg"
import BracersofJaggedBarbs from "assets/images/items/Bracers of Jagged Barbs.jpg"
import BracersofLunacy from "assets/images/items/Bracers of Lunacy.jpg"
import BracersofNecroticDread from "assets/images/items/Bracers of Necrotic Dread.jpg"
import BracersofPandemonium from "assets/images/items/Bracers of Pandemonium.jpg"
import BracersofQuilledDarts from "assets/images/items/Bracers of Quilled Darts.jpg"
import BracersofRapturousBattle from "assets/images/items/Bracers of Rapturous Battle.jpg"
import BracersofRecklessness from "assets/images/items/Bracers of Recklessness.jpg"
import BracersofRighteousSmiting from "assets/images/items/Bracers of Righteous Smiting.jpg"
import BracersofSwiftstriking from "assets/images/items/Bracers of Swiftstriking.jpg"
import BracersoftheAscension from "assets/images/items/Bracers of the Ascension.jpg"
import BracersoftheBerserkersFury from "assets/images/items/Bracers of the Berserker's Fury.jpg"
import BracersoftheBloodmoon from "assets/images/items/Bracers of the Bloodmoon.jpg"
import BracersoftheClay from "assets/images/items/Bracers of the Clay.jpg"
import BracersoftheCloudcleaver from "assets/images/items/Bracers of the Cloudcleaver.jpg"
import BracersoftheDeathGod from "assets/images/items/Bracers of the Death God.jpg"
import BracersoftheDeathstalker from "assets/images/items/Bracers of the Deathstalker.jpg"
import BracersoftheDragonKing from "assets/images/items/Bracers of the Dragon King.jpg"
import BracersoftheEcliptic from "assets/images/items/Bracers of the Ecliptic.jpg"
import BracersoftheEternalBlaze from "assets/images/items/Bracers of the Eternal Blaze.jpg"
import BracersoftheExorcist from "assets/images/items/Bracers of the Exorcist.jpg"
import BracersoftheFarseeker from "assets/images/items/Bracers of the Farseeker.jpg"
import BracersoftheFirstCircle from "assets/images/items/Bracers of the First Circle.jpg"
import BracersoftheFuriousSwipe from "assets/images/items/Bracers of the Furious Swipe.jpg"
import BracersoftheGrandMonarch from "assets/images/items/Bracers of the Grand Monarch.jpg"
import BracersoftheHaunterintheDark from "assets/images/items/Bracers of the Haunter in the Dark.jpg"
import BracersoftheHowlingGiant from "assets/images/items/Bracers of the Howling Giant.jpg"
import BracersoftheHuntmaster from "assets/images/items/Bracers of the Huntmaster.jpg"
import BracersoftheIchorous from "assets/images/items/Bracers of the Ichorous.jpg"
import BracersoftheInconceivable from "assets/images/items/Bracers of the Inconceivable.jpg"
import BracersoftheJudgmentBolt from "assets/images/items/Bracers of the Judgment Bolt.jpg"
import BracersoftheKozakSlayer from "assets/images/items/Bracers of the Kozak Slayer.jpg"
import BracersoftheLector from "assets/images/items/Bracers of the Lector.jpg"
import BracersoftheLivingTarim from "assets/images/items/Bracers of the Living Tarim.jpg"
import BracersoftheMembranous from "assets/images/items/Bracers of the Membranous.jpg"
import BracersoftheMerciless from "assets/images/items/Bracers of the Merciless.jpg"
import BracersoftheOuterDark from "assets/images/items/Bracers of the Outer Dark.jpg"
import BracersoftheOxmal from "assets/images/items/Bracers of the Oxmal.jpg"
import BracersofthePutrescent from "assets/images/items/Bracers of the Putrescent.jpg"
import BracersoftheRagereaver from "assets/images/items/Bracers of the Ragereaver.jpg"
import BracersoftheRavenflight from "assets/images/items/Bracers of the Ravenflight.jpg"
import BracersoftheRefectory from "assets/images/items/Bracers of the Refectory.jpg"
import BracersoftheRenegade from "assets/images/items/Bracers of the Renegade.jpg"
import BracersoftheRevelationsofTarim from "assets/images/items/Bracers of the Revelations of Tarim.jpg"
import BracersoftheRevelations from "assets/images/items/Bracers of the Revelations.jpg"
import BracersoftheRiftcaller from "assets/images/items/Bracers of the Riftcaller.jpg"
import BracersoftheSavageFang from "assets/images/items/Bracers of the Savage Fang.jpg"
import BracersoftheSavageSlaughter from "assets/images/items/Bracers of the Savage Slaughter.jpg"
import BracersoftheSilentSlayer from "assets/images/items/Bracers of the Silent Slayer.jpg"
import BracersoftheStormbringer from "assets/images/items/Bracers of the Stormbringer.jpg"
import BracersoftheStrangeBeyond from "assets/images/items/Bracers of the Strange Beyond.jpg"
import BracersoftheSunderedSkies from "assets/images/items/Bracers of the Sundered Skies.jpg"
import BracersoftheSwiftTalon from "assets/images/items/Bracers of the Swift Talon.jpg"
import BracersoftheUbahKan from "assets/images/items/Bracers of the Ubah Kan.jpg"
import BracersoftheUnholyCommunion from "assets/images/items/Bracers of the Unholy Communion.jpg"
import BracersoftheUsurper from "assets/images/items/Bracers of the Usurper.jpg"
import BracersoftheWellsofNight from "assets/images/items/Bracers of the Wells of Night.jpg"
import BracersofTribulation from "assets/images/items/Bracers of Tribulation.jpg"
import BracersofUntamedViolence from "assets/images/items/Bracers of Untamed Violence.jpg"
import BracersofVehementThunder from "assets/images/items/Bracers of Vehement Thunder.jpg"
import BracersofVengefulZeal from "assets/images/items/Bracers of Vengeful Zeal.jpg"
import BracersofVernantFury from "assets/images/items/Bracers of Vernant Fury.jpg"
import BracersofViciousFrenzy from "assets/images/items/Bracers of Vicious Frenzy.jpg"
import BracersofViolentRage from "assets/images/items/Bracers of Violent Rage.jpg"
import BracersofWildFuror from "assets/images/items/Bracers of Wild Furor.jpg"
import BracersofWrithing from "assets/images/items/Bracers of Writhing.jpg"
import BranchoftheGreatTree from "assets/images/items/Branch of the Great Tree.jpg"
import BrandofAshur from "assets/images/items/Brand of Ashur.jpg"
import BrandofShaulun from "assets/images/items/Brand of Shaulun.jpg"
import BrandoftheBlackPharaoh from "assets/images/items/Brand of the Black Pharaoh.jpg"
import BrassardofBenMorgh from "assets/images/items/Brassard of Ben Morgh.jpg"
import BrassardoftheKatari from "assets/images/items/Brassard of the Katari.jpg"
import BrassartofViciousFrenzy from "assets/images/items/Brassart of Vicious Frenzy.jpg"
import BrassartsoftheRagereaver from "assets/images/items/Brassarts of the Ragereaver.jpg"
import BrassartsofWildFuror from "assets/images/items/Brassarts of Wild Furor.jpg"
import BrawlersCloak from "assets/images/items/Brawler's Cloak.jpg"
import BreastoftheWardedBrute from "assets/images/items/Breast of the Warded Brute.jpg"
import BreastplateofRedRuinnm from "assets/images/items/Breastplate of Red Ruin (nm).jpg"
import BreastplateofRedRuin from "assets/images/items/Breastplate of Red Ruin.jpg"
import BreastplateoftheLivingTarim from "assets/images/items/Breastplate of the Living Tarim.jpg"
import BreastplateoftheRenegade from "assets/images/items/Breastplate of the Renegade.jpg"
import BreastplateoftheRevelationsofTarim from "assets/images/items/Breastplate of the Revelations of Tarim.jpg"
import BreastplateoftheScatteredGods from "assets/images/items/Breastplate of the Scattered Gods.jpg"
import BreathoftheNorth from "assets/images/items/Breath of the North.jpg"
import BreechesofHaloga from "assets/images/items/Breeches of Haloga.jpg"
import BreechesofNebthu from "assets/images/items/Breeches of Nebthu.jpg"
import BreechesoftheBlackPharaoh from "assets/images/items/Breeches of the Black Pharaoh.jpg"
import BreechesoftheCrawlingChaos from "assets/images/items/Breeches of the Crawling Chaos.jpg"
import BreechesoftheDarkMessenger from "assets/images/items/Breeches of the Dark Messenger.jpg"
import BreechesoftheFacelessChaos from "assets/images/items/Breeches of the Faceless Chaos.jpg"
import BreechesoftheFacelessSphinx from "assets/images/items/Breeches of the Faceless Sphinx.jpg"
import BreechesoftheGreatImpi from "assets/images/items/Breeches of the Great Impi.jpg"
import BreechesoftheHaunterintheDark from "assets/images/items/Breeches of the Haunter in the Dark.jpg"
import BreechesoftheHowlingGiant from "assets/images/items/Breeches of the Howling Giant.jpg"
import BreechesoftheMasqueroftheSands from "assets/images/items/Breeches of the Masquer of the Sands.jpg"
import BreechesoftheOxmal from "assets/images/items/Breeches of the Oxmal.jpg"
import BreechesoftheShiveringStars from "assets/images/items/Breeches of the Shivering Stars.jpg"
import BreechesoftheUbahKan from "assets/images/items/Breeches of the Ubah Kan.jpg"
import BrigandsArmbandsoftheBloodyFang from "assets/images/items/Brigand's Armbands of the Bloody Fang.jpg"
import BrigandsArmbandsoftheRitualFlame from "assets/images/items/Brigand's Armbands of the Ritual Flame.jpg"
import BrigandsArmbandsofWovenClouds from "assets/images/items/Brigand's Armbands of Woven Clouds.jpg"
import BrigandsArmguardsoftheKhan from "assets/images/items/Brigand's Armguards of the Khan.jpg"
import BrigandsBeltofaHundredEyes from "assets/images/items/Brigand's Belt of a Hundred Eyes.jpg"
import BrigandsBeltoftheGraspingWild from "assets/images/items/Brigand's Belt of the Grasping Wild.jpg"
import BrigandsBeltoftheHowlingMoon from "assets/images/items/Brigand's Belt of the Howling Moon.jpg"
import BrigandsBeltoftheHowlingWind from "assets/images/items/Brigand's Belt of the Howling Wind.jpg"
import BrigandsBootsoftheGrasslands from "assets/images/items/Brigand's Boots of the Grasslands.jpg"
import BrigandsGauntletsoftheHowlingMoon from "assets/images/items/Brigand's Gauntlets of the Howling Moon.jpg"
import BrigandsGlovesofaHundredEyes from "assets/images/items/Brigand's Gloves of a Hundred Eyes.jpg"
import BrigandsGlovesoftheGraspingWild from "assets/images/items/Brigand's Gloves of the Grasping Wild.jpg"
import BrigandsGlovesoftheHowlingWind from "assets/images/items/Brigand's Gloves of the Howling Wind.jpg"
import BrigandsHoodoftheWickedHearth from "assets/images/items/Brigand's Hood of the Wicked Hearth.jpg"
import BrigandsLeggingsoftheBloodyFang from "assets/images/items/Brigand's Leggings of the Bloody Fang.jpg"
import BrigandsLeggingsoftheRitualFlame from "assets/images/items/Brigand's Leggings of the Ritual Flame.jpg"
import BrigandsLeggingsofWovenClouds from "assets/images/items/Brigand's Leggings of Woven Clouds.jpg"
import BrigandsLegguardsoftheKhan from "assets/images/items/Brigand's Legguards of the Khan.jpg"
import BrigandsStrapsoftheWickedHearth from "assets/images/items/Brigand's Straps of the Wicked Hearth.jpg"
import BrigandsStrapsofWorldsEdge from "assets/images/items/Brigand's Straps of World's Edge.jpg"
import BrigandsWristbandsoftheCovertTrail from "assets/images/items/Brigand's Wristbands of the Covert Trail.jpg"
import BrittleBladeHonormask from "assets/images/items/Brittle Blade Honormask.jpg"
import BroadswordofOkeanos from "assets/images/items/Broadsword of Okeanos.jpg"
import BronzefuryWarWolf from "assets/images/items/Bronzefury War Wolf.jpg"
import BuckleroftheBloodGod from "assets/images/items/Buckler of the Blood God.jpg"
import BullmightBand from "assets/images/items/Bullmight Band.jpg"
import BurnedBandofSmokingCinders from "assets/images/items/Burned Band of Smoking Cinders.jpg"
import CadaverousBite from "assets/images/items/Cadaverous Bite.jpg"
import CadaverousVambraces from "assets/images/items/Cadaverous Vambraces.jpg"
import CageoftheCacklingMarionette from "assets/images/items/Cage of the Cackling Marionette.jpg"
import CaligaTergus from "assets/images/items/Caliga Tergus.jpg"
import CaliginousGridle from "assets/images/items/Caliginous Gridle.jpg"
import Callidus from "assets/images/items/Callidus.jpg"
import CanachBattleBelt from "assets/images/items/Canach Battle Belt.jpg"
import CanachBattleHood from "assets/images/items/Canach Battle Hood.jpg"
import CanachBrassards from "assets/images/items/Canach Brassards.jpg"
import CanachBreeches from "assets/images/items/Canach Breeches.jpg"
import CanachScales from "assets/images/items/Canach Scales.jpg"
import CaneofDecay from "assets/images/items/Cane of Decay.jpg"
import CangJeisAssortedNasties from "assets/images/items/Cang Jei's Assorted Nasties.jpg"
import CangJeisElevenSacredObscenities from "assets/images/items/Cang Jei's Eleven Sacred Obscenities.jpg"
import CangJeisSerratedGibe from "assets/images/items/Cang Jei's Serrated Gibe.jpg"
import CangJeisGrin from "assets/images/items/Cang-Jei's Grin.jpg"
import CangJeisLaugh from "assets/images/items/Cang-Jei's Laugh.jpg"
import CangJeisSmile from "assets/images/items/Cang-Jei's Smile.jpg"
import CangJeisWhisper from "assets/images/items/Cang-Jei's Whisper.jpg"
import CanvasPack from "assets/images/items/Canvas Pack.jpg"
import CapofaThousandBlossoms from "assets/images/items/Cap of a Thousand Blossoms.jpg"
import CapoftheStillPond from "assets/images/items/Cap of the Still Pond.jpg"
import CapoftheUnslaked from "assets/images/items/Cap of the Unslaked.jpg"
import CapeofAtlantis from "assets/images/items/Cape of Atlantis.jpg"
import CapeofElevenFallenHeroes from "assets/images/items/Cape of Eleven Fallen Heroes.jpg"
import CapeofIllusions from "assets/images/items/Cape of Illusions.jpg"
import CapeofReprisal from "assets/images/items/Cape of Reprisal.jpg"
import CapeoftheImperium from "assets/images/items/Cape of the Imperium.jpg"
import CaptainsArmguardsofHeavensPass from "assets/images/items/Captain's Armguards of Heaven's Pass.jpg"
import CaptainsArmguardsoftheBattlements from "assets/images/items/Captain's Armguards of the Battlements.jpg"
import CaptainsArmguardsoftheWatchtowers from "assets/images/items/Captain's Armguards of the Watchtowers.jpg"
import CaptainsBeltofHeavensPass from "assets/images/items/Captain's Belt of Heaven's Pass.jpg"
import CaptainsBeltoftheBattlements from "assets/images/items/Captain's Belt of the Battlements.jpg"
import CaptainsBeltoftheWatchtowers from "assets/images/items/Captain's Belt of the Watchtowers.jpg"
import CaptainsBootsoftheEasternSun from "assets/images/items/Captain's Boots of the Eastern Sun.jpg"
import CaptainsBootsoftheGoldenSun from "assets/images/items/Captain's Boots of the Golden Sun.jpg"
import CaptainsBootsoftheShiningSun from "assets/images/items/Captain's Boots of the Shining Sun.jpg"
import CaptainsChestguardoftheWarringStates from "assets/images/items/Captain's Chestguard of the Warring States.jpg"
import CaptainsChestplateofDynasticRule from "assets/images/items/Captain's Chestplate of Dynastic Rule.jpg"
import CaptainsChestplateoftheAscendingKingdom from "assets/images/items/Captain's Chestplate of the Ascending Kingdom.jpg"
import CaptainsGauntletsofDynasticRule from "assets/images/items/Captain's Gauntlets of Dynastic Rule.jpg"
import CaptainsGauntletsoftheAscendingKingdom from "assets/images/items/Captain's Gauntlets of the Ascending Kingdom.jpg"
import CaptainsGauntletsoftheWarringStates from "assets/images/items/Captain's Gauntlets of the Warring States.jpg"
import CaptainsHelmofHeavensPass from "assets/images/items/Captain's Helm of Heaven's Pass.jpg"
import CaptainsLegguardsofHeavensPass from "assets/images/items/Captain's Legguards of Heaven's Pass.jpg"
import CaptainsLegguardsoftheBattlements from "assets/images/items/Captain's Legguards of the Battlements.jpg"
import CaptainsLegguardsoftheWatchtowers from "assets/images/items/Captain's Legguards of the Watchtowers.jpg"
import CaptainsVambracesoftheEasternSun from "assets/images/items/Captain's Vambraces of the Eastern Sun.jpg"
import CaptainsVambracesoftheGoldenSun from "assets/images/items/Captain's Vambraces of the Golden Sun.jpg"
import CaptainsVambracesoftheShiningSun from "assets/images/items/Captain's Vambraces of the Shining Sun.jpg"
import CaravanMastersNecklace from "assets/images/items/Caravan Master's Necklace.jpg"
import CarbasaCingulum from "assets/images/items/Carbasa Cingulum.jpg"
import CatsEyeRing from "assets/images/items/Cat's Eye Ring.jpg"
import CatacombGauntlets from "assets/images/items/Catacomb Gauntlets.jpg"
import CatacombGloves from "assets/images/items/Catacomb Gloves.jpg"
import CatacombLegguards from "assets/images/items/Catacomb Legguards.jpg"
import CatacombTunic from "assets/images/items/Catacomb Tunic.jpg"
import CenserofThoseWhoWaitBelow from "assets/images/items/Censer of Those Who Wait Below.jpg"
import ChainofAkkaria from "assets/images/items/Chain of Akkaria.jpg"
import ChainofTartaros from "assets/images/items/Chain of Tartaros.jpg"
import ChainofUnbreakableLinks from "assets/images/items/Chain of Unbreakable Links.jpg"
import ChaldeanCloak from "assets/images/items/Chaldean Cloak.jpg"
import ChancellorCloak from "assets/images/items/Chancellor Cloak.jpg"
import Chang from "assets/images/items/Chang.jpg"
import Chaosreaver from "assets/images/items/Chaosreaver.jpg"
import CharmoftheLaughingShadows from "assets/images/items/Charm of the Laughing Shadows.jpg"
import CharmersTunic from "assets/images/items/Charmer's Tunic.jpg"
import ChengHoBattleBlade from "assets/images/items/Cheng-Ho Battle Blade.jpg"
import ChengHoBattleDagger from "assets/images/items/Cheng-Ho Battle Dagger.jpg"
import ChengHoBattleKrys from "assets/images/items/Cheng-Ho Battle Krys.jpg"
import ChengHoBattleMark from "assets/images/items/Cheng-Ho Battle Mark.jpg"
import ChengHoBattleStaff from "assets/images/items/Cheng-Ho Battle Staff.jpg"
import ChengHoBattleStave from "assets/images/items/Cheng-Ho Battle Stave.jpg"
import ChengHoBattleSword from "assets/images/items/Cheng-Ho Battle Sword.jpg"
import ChengHoBattleTalisman from "assets/images/items/Cheng-Ho Battle Talisman.jpg"
import ChestguardofBalefulBlood from "assets/images/items/Chestguard of Baleful Blood.jpg"
import ChestguardofBlackSpite from "assets/images/items/Chestguard of Black Spite.jpg"
import ChestguardofHeroicSoul from "assets/images/items/Chestguard of Heroic Soul.jpg"
import ChestguardofIndomitableSouls from "assets/images/items/Chestguard of Indomitable Souls.jpg"
import ChestguardofRecklessChallenge from "assets/images/items/Chestguard of Reckless Challenge.jpg"
import ChestguardoftheAssailant from "assets/images/items/Chestguard of the Assailant.jpg"
import ChestguardoftheBlackDragon from "assets/images/items/Chestguard of the Black Dragon.jpg"
import ChestguardoftheBlackWarden from "assets/images/items/Chestguard of the Black Warden.jpg"
import ChestguardoftheChaosAgent from "assets/images/items/Chestguard of the Chaos Agent.jpg"
import ChestguardoftheDauntless from "assets/images/items/Chestguard of the Dauntless.jpg"
import ChestguardoftheDefiant from "assets/images/items/Chestguard of the Defiant.jpg"
import ChestguardoftheInvincible from "assets/images/items/Chestguard of the Invincible.jpg"
import ChestguardoftheMartialParagon from "assets/images/items/Chestguard of the Martial Paragon.jpg"
import ChestguardofthePainlegion from "assets/images/items/Chestguard of the Painlegion.jpg"
import ChestguardoftheProvenChampion from "assets/images/items/Chestguard of the Proven Champion.jpg"
import ChestguardoftheTirelessDefender from "assets/images/items/Chestguard of the Tireless Defender.jpg"
import ChestguardoftheTormentor from "assets/images/items/Chestguard of the Tormentor.jpg"
import ChestguardoftheTriumphant from "assets/images/items/Chestguard of the Triumphant.jpg"
import ChestguardoftheUsurper from "assets/images/items/Chestguard of the Usurper.jpg"
import ChestguardoftheValiant from "assets/images/items/Chestguard of the Valiant.jpg"
import ChestguardoftheVanguard from "assets/images/items/Chestguard of the Vanguard.jpg"
import ChestguardoftheVictoriousElite from "assets/images/items/Chestguard of the Victorious Elite.jpg"
import ChestguardoftheWicked from "assets/images/items/Chestguard of the Wicked.jpg"
import ChestplateofBloodlust from "assets/images/items/Chestplate of Bloodlust.jpg"
import ChestplateofCourageousSouls from "assets/images/items/Chestplate of Courageous Souls.jpg"
import ChestplateofFearlessSouls from "assets/images/items/Chestplate of Fearless Souls.jpg"
import ChestplateoftheAtlantean from "assets/images/items/Chestplate of the Atlantean.jpg"
import ChestplateoftheBeyond from "assets/images/items/Chestplate of the Beyond.jpg"
import ChestplateoftheBlackPharaoh from "assets/images/items/Chestplate of the Black Pharaoh.jpg"
import ChestplateoftheCrimsonFort from "assets/images/items/Chestplate of the Crimson Fort.jpg"
import ChestplateoftheMilitesTempli from "assets/images/items/Chestplate of the Milites Templi.jpg"
import ChestplateoftheOstiary from "assets/images/items/Chestplate of the Ostiary.jpg"
import ChillofWintersBreathdexterity from "assets/images/items/Chill of Winter's Breath (dexterity).jpg"
import ChillofWintersBreath from "assets/images/items/Chill of Winter's Breath.jpg"
import ChimesoftheBlackWind from "assets/images/items/Chimes of the Black Wind.jpg"
import ChronicleoftheAncestors from "assets/images/items/Chronicle of the Ancestors.jpg"
import ChulainnsGift from "assets/images/items/Chulainn's Gift.jpg"
import CircletofaThousandBlossoms from "assets/images/items/Circlet of a Thousand Blossoms.jpg"
import CircletoftheNebulous from "assets/images/items/Circlet of the Nebulous.jpg"
import CircletoftheSepulcher from "assets/images/items/Circlet of the Sepulcher.jpg"
import CircletoftheSpheres from "assets/images/items/Circlet of the Spheres.jpg"
import CircletoftheUnutterable from "assets/images/items/Circlet of the Unutterable.jpg"
import CircuitoftheVoid from "assets/images/items/Circuit of the Void.jpg"
import ClanBoudBootsoftheFourWinds from "assets/images/items/Clan Boud Boots of the Four Winds.jpg"
import ClanBoundArmbandsoftheEverlastingSky from "assets/images/items/Clan Bound Armbands of the Everlasting Sky.jpg"
import ClanBoundBeltoftheAncestors from "assets/images/items/Clan Bound Belt of the Ancestors.jpg"
import ClanBoundBeltoftheGoldenHorde from "assets/images/items/Clan Bound Belt of the Golden Horde.jpg"
import ClanBoundBeltoftheSevenSuns from "assets/images/items/Clan Bound Belt of the Seven Suns.jpg"
import ClanBoundBootsoftheMound from "assets/images/items/Clan Bound Boots of the Mound.jpg"
import ClanBoundBootsofthePlains from "assets/images/items/Clan Bound Boots of the Plains.jpg"
import ClanBoundBracersoftheFarHorizon from "assets/images/items/Clan Bound Bracers of the Far Horizon.jpg"
import ClanBoundBracersoftheFourWinds from "assets/images/items/Clan Bound Bracers of the Four Winds.jpg"
import ClanBoundBracersofthePlains from "assets/images/items/Clan Bound Bracers of the Plains.jpg"
import ClanBoundFauldofPassingSpirits from "assets/images/items/Clan Bound Fauld of Passing Spirits.jpg"
import ClanBoundFauldoftheTribes from "assets/images/items/Clan Bound Fauld of the Tribes.jpg"
import ClanBoundGirdleoftheGreensward from "assets/images/items/Clan Bound Girdle of the Greensward.jpg"
import ClanBoundGlovesoftheFarHorizon from "assets/images/items/Clan Bound Gloves of the Far Horizon.jpg"
import ClanBoundGlovesoftheMound from "assets/images/items/Clan Bound Gloves of the Mound.jpg"
import ClanBoundGlovesofthePlains from "assets/images/items/Clan Bound Gloves of the Plains.jpg"
import ClanBoundGreavesoftheFarHorizon from "assets/images/items/Clan Bound Greaves of the Far Horizon.jpg"
import ClanBoundHarnessoftheFourWinds from "assets/images/items/Clan Bound Harness of the Four Winds.jpg"
import ClanBoundHauberkoftheFarHorizon from "assets/images/items/Clan Bound Hauberk of the Far Horizon.jpg"
import ClanBoundHelmoftheAncestors from "assets/images/items/Clan Bound Helm of the Ancestors.jpg"
import ClanBoundHelmoftheGoldenHorde from "assets/images/items/Clan Bound Helm of the Golden Horde.jpg"
import ClanBoundHelmoftheGreensward from "assets/images/items/Clan Bound Helm of the Greensward.jpg"
import ClanBoundHelmoftheSevenSuns from "assets/images/items/Clan Bound Helm of the Seven Suns.jpg"
import ClanBoundLeggingsoftheEverlastingSky from "assets/images/items/Clan Bound Leggings of the Everlasting Sky.jpg"
import ClanBoundLegguardsoftheClans from "assets/images/items/Clan Bound Legguards of the Clans.jpg"
import ClanBoundStrapsofPassingSpirits from "assets/images/items/Clan Bound Straps of Passing Spirits.jpg"
import ClanBoundStrapsoftheClans from "assets/images/items/Clan Bound Straps of the Clans.jpg"
import ClanBoundStrapsoftheTribes from "assets/images/items/Clan Bound Straps of the Tribes.jpg"
import ClanBoundVambracesoftheMound from "assets/images/items/Clan Bound Vambraces of the Mound.jpg"
import ClandestineHelm from "assets/images/items/Clandestine Helm.jpg"
import ClandestinusDarkhood from "assets/images/items/Clandestinus Darkhood.jpg"
import ClaspofaThousandBlossoms from "assets/images/items/Clasp of a Thousand Blossoms.jpg"
import ClaspofRevival from "assets/images/items/Clasp of Revival.jpg"
import ClaspoftheAmaranthineDrums from "assets/images/items/Clasp of the Amaranthine Drums.jpg"
import ClaspoftheFallenEmpire from "assets/images/items/Clasp of the Fallen Empire.jpg"
import ClaspoftheHaunterintheDark from "assets/images/items/Clasp of the Haunter in the Dark.jpg"
import ClaspoftheHowlingGiant from "assets/images/items/Clasp of the Howling Giant.jpg"
import ClaspoftheSteelBehemoth from "assets/images/items/Clasp of the Steel Behemoth.jpg"
import ClawofKhan from "assets/images/items/Claw of Khan.jpg"
import ClawoftheDeathMaster from "assets/images/items/Claw of the Death Master.jpg"
import ClawoftheVaaghasan from "assets/images/items/Claw of the Vaaghasan.jpg"
import ClawsoftheCacklingMarionette from "assets/images/items/Claws of the Cackling Marionette.jpg"
import ClaymoreoftheArchaeologian from "assets/images/items/Claymore of the Archaeologian.jpg"
import ClaymoreoftheCrownedSerpent from "assets/images/items/Claymore of the Crowned Serpent.jpg"
import ClaymoreoftheDeathMaster from "assets/images/items/Claymore of the Death Master.jpg"
import ClaymoreoftheRagingEarth from "assets/images/items/Claymore of the Raging Earth.jpg"
import CleaveoftheNorthernWastes from "assets/images/items/Cleave of the Northern Wastes.jpg"
import CloakofChampions from "assets/images/items/Cloak of Champions.jpg"
import CloakofEquivalence from "assets/images/items/Cloak of Equivalence.jpg"
import CloakofFuror from "assets/images/items/Cloak of Furor.jpg"
import CloakofHugin from "assets/images/items/Cloak of Hugin.jpg"
import CloakofIbis from "assets/images/items/Cloak of Ibis.jpg"
import CloakofInsight from "assets/images/items/Cloak of Insight.jpg"
import CloakofMunin from "assets/images/items/Cloak of Munin.jpg"
import CloakoftheBattleHardened from "assets/images/items/Cloak of the Battle Hardened.jpg"
import CloakoftheBlackPharaoh from "assets/images/items/Cloak of the Black Pharaoh.jpg"
import CloakoftheCrawlingChaos from "assets/images/items/Cloak of the Crawling Chaos.jpg"
import CloakoftheFacelessSphinx from "assets/images/items/Cloak of the Faceless Sphinx.jpg"
import CloakoftheFortifiedMind from "assets/images/items/Cloak of the Fortified Mind.jpg"
import CloakoftheGarrison from "assets/images/items/Cloak of the Garrison.jpg"
import CloakoftheShiveringStars from "assets/images/items/Cloak of the Shivering Stars.jpg"
import CloakoftheUbahKan from "assets/images/items/Cloak of the Ubah Kan.jpg"
import CloakofWakeningNightmares from "assets/images/items/Cloak of Wakening Nightmares.jpg"
import Cloudspire from "assets/images/items/Cloudspire.jpg"
import ClubofLarsha from "assets/images/items/Club of Larsha.jpg"
import CluboftheUbahKan from "assets/images/items/Club of the Ubah Kan.jpg"
import CluboftheWolfRider from "assets/images/items/Club of the Wolf Rider.jpg"
import ClutchofBlackTerrors from "assets/images/items/Clutch of Black Terrors.jpg"
import ClutchoftheDragonKing from "assets/images/items/Clutch of the Dragon King.jpg"
import CobrastrikeBand from "assets/images/items/Cobrastrike Band.jpg"
import CoiloftheAsp from "assets/images/items/Coil of the Asp.jpg"
import CoiloftheBoa from "assets/images/items/Coil of the Boa.jpg"
import CoiloftheCobra from "assets/images/items/Coil of the Cobra.jpg"
import CoiloftheJiangShi from "assets/images/items/Coil of the Jiang Shi.jpg"
import CoilofthePython from "assets/images/items/Coil of the Python.jpg"
import CoiloftheViper from "assets/images/items/Coil of the Viper.jpg"
import CoilofTiandal from "assets/images/items/Coil of Tiandal.jpg"
import CoiledSerpentRing from "assets/images/items/Coiled Serpent Ring.jpg"
import CoilsoftheBrood from "assets/images/items/Coils of the Brood.jpg"
import CoilsoftheDragonKing from "assets/images/items/Coils of the Dragon King.jpg"
import CollarofEndurance from "assets/images/items/Collar of Endurance.jpg"
import CollarofHavoc from "assets/images/items/Collar of Havoc.jpg"
import CollarofVigor from "assets/images/items/Collar of Vigor.jpg"
import CollectorofBlood from "assets/images/items/Collector of Blood.jpg"
import CommandersArmguardsoftheEasternSun from "assets/images/items/Commander's Armguards of the Eastern Sun.jpg"
import CommandersArmguardsoftheGoldenSun from "assets/images/items/Commander's Armguards of the Golden Sun.jpg"
import CommandersArmguardsoftheShiningSun from "assets/images/items/Commander's Armguards of the Shining Sun.jpg"
import CommandersBeltofDynasticRule from "assets/images/items/Commander's Belt of Dynastic Rule.jpg"
import CommandersBeltoftheAscendingKingdom from "assets/images/items/Commander's Belt of the Ascending Kingdom.jpg"
import CommandersBeltoftheWarringStates from "assets/images/items/Commander's Belt of the Warring States.jpg"
import CommandersBootsofHeavensPass from "assets/images/items/Commander's Boots of Heaven's Pass.jpg"
import CommandersBootsoftheBattlements from "assets/images/items/Commander's Boots of the Battlements.jpg"
import CommandersBootsoftheWatchtowers from "assets/images/items/Commander's Boots of the Watchtowers.jpg"
import CommandersChestguardoftheWatchtowers from "assets/images/items/Commander's Chestguard of the Watchtowers.jpg"
import CommandersChestplateofHeavensPass from "assets/images/items/Commander's Chestplate of Heaven's Pass.jpg"
import CommandersChestplateoftheBattlements from "assets/images/items/Commander's Chestplate of the Battlements.jpg"
import CommandersGauntletsofHeavensPass from "assets/images/items/Commander's Gauntlets of Heaven's Pass.jpg"
import CommandersGauntletsoftheBattlements from "assets/images/items/Commander's Gauntlets of the Battlements.jpg"
import CommandersGauntletsoftheWatchtowers from "assets/images/items/Commander's Gauntlets of the Watchtowers.jpg"
import CommandersHaversack from "assets/images/items/Commander's Haversack.jpg"
import CommandersHelmofDynasticRule from "assets/images/items/Commander's Helm of Dynastic Rule.jpg"
import CommandersHelmoftheAscendingKingdom from "assets/images/items/Commander's Helm of the Ascending Kingdom.jpg"
import CommandersHelmoftheWarringStates from "assets/images/items/Commander's Helm of the Warring States.jpg"
import CommandersLegguardsoftheEasternSun from "assets/images/items/Commander's Legguards of the Eastern Sun.jpg"
import CommandersLegguardsoftheGoldenSun from "assets/images/items/Commander's Legguards of the Golden Sun.jpg"
import CommandersLegguardsoftheShiningSun from "assets/images/items/Commander's Legguards of the Shining Sun.jpg"
import CommandersVambracesofHeavensPass from "assets/images/items/Commander's Vambraces of Heaven's Pass.jpg"
import CommandersVambracesoftheBattlements from "assets/images/items/Commander's Vambraces of the Battlements.jpg"
import CommandersVambracesoftheWatchtowers from "assets/images/items/Commander's Vambraces of the Watchtowers.jpg"
import CompositeBowoftheBloodDrinker from "assets/images/items/Composite Bow of the Blood Drinker.jpg"
import Concussor from "assets/images/items/Concussor.jpg"
import ConscriptsArmguardsofDynasticRule from "assets/images/items/Conscript's Armguards of Dynastic Rule.jpg"
import ConscriptsArmguardsoftheAscendingKingdom from "assets/images/items/Conscript's Armguards of the Ascending Kingdom.jpg"
import ConscriptsArmguardsoftheWarringStates from "assets/images/items/Conscript's Armguards of the Warring States.jpg"
import ConscriptsBeltoftheEasternSun from "assets/images/items/Conscript's Belt of the Eastern Sun.jpg"
import ConscriptsBeltoftheGoldenSun from "assets/images/items/Conscript's Belt of the Golden Sun.jpg"
import ConscriptsBeltoftheShiningSun from "assets/images/items/Conscript's Belt of the Shining Sun.jpg"
import ConscriptsBootsofHeavensPass from "assets/images/items/Conscript's Boots of Heaven's Pass.jpg"
import ConscriptsBootsoftheWatchtowers from "assets/images/items/Conscript's Boots of the Watchtowers.jpg"
import ConscriptsChestguardoftheWatchtowers from "assets/images/items/Conscript's Chestguard of the Watchtowers.jpg"
import ConscriptsChestplateofHeavensPass from "assets/images/items/Conscript's Chestplate of Heaven's Pass.jpg"
import ConscriptsChestplateoftheBattlements from "assets/images/items/Conscript's Chestplate of the Battlements.jpg"
import ConscriptsGauntletsoftheEasternSun from "assets/images/items/Conscript's Gauntlets of the Eastern Sun.jpg"
import ConscriptsGauntletsoftheGoldenSun from "assets/images/items/Conscript's Gauntlets of the Golden Sun.jpg"
import ConscriptsGauntletsoftheShiningSun from "assets/images/items/Conscript's Gauntlets of the Shining Sun.jpg"
import ConscriptsHelmofHeavensPass from "assets/images/items/Conscript's Helm of Heaven's Pass.jpg"
import ConscriptsHelmoftheWatchtowers from "assets/images/items/Conscript's Helm of the Watchtowers.jpg"
import ConscriptsLegguardsofDynasticRule from "assets/images/items/Conscript's Legguards of Dynastic Rule.jpg"
import ConscriptsLegguardsoftheAscendingKingdom from "assets/images/items/Conscript's Legguards of the Ascending Kingdom.jpg"
import ConscriptsLegguardsoftheWarringStates from "assets/images/items/Conscript's Legguards of the Warring States.jpg"
import ConscriptsVambracesofHeavensPass from "assets/images/items/Conscript's Vambraces of Heaven's Pass.jpg"
import ConscriptsVambracesoftheBattlements from "assets/images/items/Conscript's Vambraces of the Battlements.jpg"
import ConsecratedDoKki from "assets/images/items/Consecrated Do Kki.jpg"
import ConsecratedLibram from "assets/images/items/Consecrated Libram.jpg"
import ConsecratedMace from "assets/images/items/Consecrated Mace.jpg"
import ContemplativeHelm from "assets/images/items/Contemplative Helm.jpg"
import ConversantMantleoftheLivingLegend from "assets/images/items/Conversant Mantle of the Living Legend.jpg"
import CordoftheCacklingMarionette from "assets/images/items/Cord of the Cackling Marionette.jpg"
import CoronalBoots from "assets/images/items/Coronal Boots.jpg"
import CoronalHelm from "assets/images/items/Coronal Helm.jpg"
import CoronalJerkin from "assets/images/items/Coronal Jerkin.jpg"
import CoronalLeggings from "assets/images/items/Coronal Leggings.jpg"
import CorpseWakersBand from "assets/images/items/Corpse-Waker's Band.jpg"
import CorpusAilette from "assets/images/items/Corpus Ailette.jpg"
import CorpusBelt from "assets/images/items/Corpus Belt.jpg"
import CorpusSandals from "assets/images/items/Corpus Sandals.jpg"
import CorruptorsTasset from "assets/images/items/Corruptor's Tasset.jpg"
import CoruscantWardofMaahes from "assets/images/items/Coruscant Ward of Maahes.jpg"
import CoveringsofPurification from "assets/images/items/Coverings of Purification.jpg"
import CoveringsoftheGrandMonarch from "assets/images/items/Coverings of the Grand Monarch.jpg"
import CoveringsoftheRevelations from "assets/images/items/Coverings of the Revelations.jpg"
import CovertLeggings from "assets/images/items/Covert Leggings.jpg"
import CraftsmansMitts from "assets/images/items/Craftsman's Mitts.jpg"
import CrimsonDeath from "assets/images/items/Crimson Death.jpg"
import CrocodileClawRing from "assets/images/items/Crocodile Claw Ring.jpg"
import CrossbowofArdashirGarrison from "assets/images/items/Crossbow of Ardashir Garrison.jpg"
import CrossbowoftheArchaeologian from "assets/images/items/Crossbow of the Archaeologian.jpg"
import CrossbowoftheBloodDrinker from "assets/images/items/Crossbow of the Blood Drinker.jpg"
import CrossbowoftheHaunterintheDark from "assets/images/items/Crossbow of the Haunter in the Dark.jpg"
import CrossbowoftheUndefeated from "assets/images/items/Crossbow of the Undefeated.jpg"
import CrossbowoftheUnderworld from "assets/images/items/Crossbow of the Underworld.jpg"
import CrowShadowArmbands from "assets/images/items/Crow Shadow Armbands.jpg"
import CrowShadowGauntlets from "assets/images/items/Crow Shadow Gauntlets.jpg"
import CrowShadowSash from "assets/images/items/Crow Shadow Sash.jpg"
import CrowShadowTasset from "assets/images/items/Crow Shadow Tasset.jpg"
import CrowcackleGauntlets from "assets/images/items/Crowcackle Gauntlets.jpg"
import CrowcackleLeggings from "assets/images/items/Crowcackle Leggings.jpg"
import Crowfire from "assets/images/items/Crowfire.jpg"
import CrownoftheDragonKing from "assets/images/items/Crown of the Dragon King.jpg"
import Cruciatus from "assets/images/items/Cruciatus.jpg"
import Crusher from "assets/images/items/Crusher.jpg"
import CryforWar from "assets/images/items/Cry for War.jpg"
import Cryptguard from "assets/images/items/Cryptguard.jpg"
import Crystallite from "assets/images/items/Crystallite.jpg"
import CudgeloftheEarthMother from "assets/images/items/Cudgel of the Earth Mother.jpg"
import CuirassofConajohara from "assets/images/items/Cuirass of Conajohara.jpg"
import CuirassofFaith from "assets/images/items/Cuirass of Faith.jpg"
import CuirassoftheFallenEmpirenm from "assets/images/items/Cuirass of the Fallen Empire (nm).jpg"
import CuirassoftheFallenEmpire from "assets/images/items/Cuirass of the Fallen Empire.jpg"
import CuirassoftheSanguineDisciplenm from "assets/images/items/Cuirass of the Sanguine Disciple (nm).jpg"
import CuirassoftheSanguineDisciple from "assets/images/items/Cuirass of the Sanguine Disciple.jpg"
import CuisseoftheBloodDrinkernm from "assets/images/items/Cuisse of the Blood Drinker (nm).jpg"
import CuisseoftheBloodDrinker from "assets/images/items/Cuisse of the Blood Drinker.jpg"
import CuisseoftheDeathMasternm from "assets/images/items/Cuisse of the Death Master (nm).jpg"
import CuisseoftheDeathMaster from "assets/images/items/Cuisse of the Death Master.jpg"
import CuisseoftheSanguineDisciplenm from "assets/images/items/Cuisse of the Sanguine Disciple (nm).jpg"
import CuisseoftheSanguineDisciple from "assets/images/items/Cuisse of the Sanguine Disciple.jpg"
import CuriooftheArchaeologian from "assets/images/items/Curio of the Archaeologian.jpg"
import CuriooftheWhiteHand from "assets/images/items/Curio of the White Hand.jpg"
import Custoditus from "assets/images/items/Custoditus.jpg"
import CyanYothianWarMare from "assets/images/items/Cyan Yothian War-Mare.jpg"
import DaggerofEnvysFury from "assets/images/items/Dagger of Envy's Fury.jpg"
import DaggerofNebthu from "assets/images/items/Dagger of Nebthu.jpg"
import DaggeroftheArchaeologian from "assets/images/items/Dagger of the Archaeologian.jpg"
import DaggeroftheBloodhunter from "assets/images/items/Dagger of the Bloodhunter.jpg"
import DaggeroftheFacelessSphinx from "assets/images/items/Dagger of the Faceless Sphinx.jpg"
import DanSangGum from "assets/images/items/Dan Sang Gum.jpg"
import DangPa from "assets/images/items/Dang Pa.jpg"
import DarkAmuletofSeveredSouls from "assets/images/items/Dark Amulet of Severed Souls.jpg"
import DarkEternal from "assets/images/items/Dark Eternal.jpg"
import DarkHeart from "assets/images/items/Dark Heart.jpg"
import Darkband from "assets/images/items/Darkband.jpg"
import DarkbladesArmbandsofConsumedSouls from "assets/images/items/Darkblade's Armbands of Consumed Souls.jpg"
import DarkbladesArmbandsofSecretDoors from "assets/images/items/Darkblade's Armbands of Secret Doors.jpg"
import DarkbladesBeltofConsumedSouls from "assets/images/items/Darkblade's Belt of Consumed Souls.jpg"
import DarkbladesBeltofSecretDoors from "assets/images/items/Darkblade's Belt of Secret Doors.jpg"
import DarkbladesBootsofSupremeDecree from "assets/images/items/Darkblade's Boots of Supreme Decree.jpg"
import DarkbladesBootsoftheDarkPact from "assets/images/items/Darkblade's Boots of the Dark Pact.jpg"
import DarkbladesBracersofSupremeDecree from "assets/images/items/Darkblade's Bracers of Supreme Decree.jpg"
import DarkbladesBracersoftheDarkPact from "assets/images/items/Darkblade's Bracers of the Dark Pact.jpg"
import DarkbladesGlovesofConsumedSouls from "assets/images/items/Darkblade's Gloves of Consumed Souls.jpg"
import DarkbladesGlovesofSecretDoors from "assets/images/items/Darkblade's Gloves of Secret Doors.jpg"
import DarkbladesHoodoftheEmissary from "assets/images/items/Darkblade's Hood of the Emissary.jpg"
import DarkbladesHoodoftheKingmaker from "assets/images/items/Darkblade's Hood of the Kingmaker.jpg"
import DarkbladesLeggingsofConsumedSouls from "assets/images/items/Darkblade's Leggings of Consumed Souls.jpg"
import DarkbladesLeggingsofSecretDoors from "assets/images/items/Darkblade's Leggings of Secret Doors.jpg"
import DarkbladesRobeoftheEmissary from "assets/images/items/Darkblade's Robe of the Emissary.jpg"
import DarkbladesTunicoftheKingmaker from "assets/images/items/Darkblade's Tunic of the Kingmaker.jpg"
import Darkchill from "assets/images/items/Darkchill.jpg"
import DarkcraftVesture from "assets/images/items/Darkcraft Vesture.jpg"
import DarkfuryLeggings from "assets/images/items/Darkfury Leggings.jpg"
import DarkfurySlippers from "assets/images/items/Darkfury Slippers.jpg"
import DarkrendTunic from "assets/images/items/Darkrend Tunic.jpg"
import Darkshear from "assets/images/items/Darkshear.jpg"
import DarkshroudCloak from "assets/images/items/Darkshroud Cloak.jpg"
import DarkslayerBracers from "assets/images/items/Darkslayer Bracers.jpg"
import DarkslayerHood from "assets/images/items/Darkslayer Hood.jpg"
import DarkstormSandals from "assets/images/items/Darkstorm Sandals.jpg"
import Darksun from "assets/images/items/Darksun.jpg"
import DeaconsArmbandsoftheEarthenPrison from "assets/images/items/Deacon's Armbands of the Earthen Prison.jpg"
import DeaconsBeltoftheSacredMountain from "assets/images/items/Deacon's Belt of the Sacred Mountain.jpg"
import DeaconsBootsoftheAbyss from "assets/images/items/Deacon's Boots of the Abyss.jpg"
import DeaconsBootsoftheEighteenPits from "assets/images/items/Deacon's Boots of the Eighteen Pits.jpg"
import DeaconsBracersoftheAbyss from "assets/images/items/Deacon's Bracers of the Abyss.jpg"
import DeaconsBracersoftheEighteenPits from "assets/images/items/Deacon's Bracers of the Eighteen Pits.jpg"
import DeaconsGauntletsoftheEighteenPits from "assets/images/items/Deacon's Gauntlets of the Eighteen Pits.jpg"
import DeaconsGirdleoftheSpillingBlood from "assets/images/items/Deacon's Girdle of the Spilling Blood.jpg"
import DeaconsGlovesoftheAbyss from "assets/images/items/Deacon's Gloves of the Abyss.jpg"
import DeaconsHarnessoftheEighteenPits from "assets/images/items/Deacon's Harness of the Eighteen Pits.jpg"
import DeaconsHelmoftheSacredMountain from "assets/images/items/Deacon's Helm of the Sacred Mountain.jpg"
import DeaconsHelmoftheSpillingBlood from "assets/images/items/Deacon's Helm of the Spilling Blood.jpg"
import DeaconsLeggingsoftheEarthenPrison from "assets/images/items/Deacon's Leggings of the Earthen Prison.jpg"
import DeaconsLegguardsoftheHallowWorlds from "assets/images/items/Deacon's Legguards of the Hallow Worlds.jpg"
import DeaconsStrapsoftheHallowWorlds from "assets/images/items/Deacon's Straps of the Hallow Worlds.jpg"
import DeadIronHammer from "assets/images/items/Dead Iron Hammer.jpg"
import DeathHarpoftheNineStars from "assets/images/items/Death Harp of the Nine Stars.jpg"
import DeathsDoor from "assets/images/items/Death's Door.jpg"
import DeathsWard from "assets/images/items/Death's Ward.jpg"
import DeathbloomThornCaster from "assets/images/items/Death-bloom Thorn Caster.jpg"
import DeathforceStaff from "assets/images/items/Deathforce Staff.jpg"
import DeathgaspMitts from "assets/images/items/Deathgasp Mitts.jpg"
import Deathgird from "assets/images/items/Deathgird.jpg"
import DeathhandBangles from "assets/images/items/Deathhand Bangles.jpg"
import Deathmark from "assets/images/items/Deathmark.jpg"
import DeathmavenHeavyHelm from "assets/images/items/Deathmaven Heavy Helm.jpg"
import DeathpalmsGloves from "assets/images/items/Deathpalms Gloves.jpg"
import Deathsong from "assets/images/items/Deathsong.jpg"
import Deathswoop from "assets/images/items/Deathswoop.jpg"
import DecayerGloves from "assets/images/items/Decayer Gloves.jpg"
import DeceitfulGloves from "assets/images/items/Deceitful Gloves.jpg"
import DeceiversArmbandsofUsheringTwilight from "assets/images/items/Deceiver's Armbands of Ushering Twilight.jpg"
import DeceiversBeltofUsheringTwilight from "assets/images/items/Deceiver's Belt of Ushering Twilight.jpg"
import DeceiversBootsofWhisperedDeeds from "assets/images/items/Deceiver's Boots of Whispered Deeds.jpg"
import DeceiversBracersofWhisperedDeeds from "assets/images/items/Deceiver's Bracers of Whispered Deeds.jpg"
import DeceiversGlovesoftheDuskRebellion from "assets/images/items/Deceiver's Gloves of the Dusk Rebellion.jpg"
import DeceiversPantsofUsheringTwilight from "assets/images/items/Deceiver's Pants of Ushering Twilight.jpg"
import DeceiversTunicoftheDuskRebellion from "assets/images/items/Deceiver's Tunic of the Dusk Rebellion.jpg"
import Deepwound from "assets/images/items/Deepwound.jpg"
import Demise from "assets/images/items/Demise.jpg"
import DemonMantleoftheLivingLegend from "assets/images/items/Demon Mantle of the Living Legend.jpg"
import DemonlinkWristbands from "assets/images/items/Demonlink Wristbands.jpg"
import Demonpiercer from "assets/images/items/Demonpiercer.jpg"
import Demontongue from "assets/images/items/Demontongue.jpg"
import DesecratedChestguard from "assets/images/items/Desecrated Chestguard.jpg"
import Despair from "assets/images/items/Despair.jpg"
import DespoilersArmstrapsofWhisperedDeeds from "assets/images/items/Despoiler's Arm-straps of Whispered Deeds.jpg"
import DespoilersBeltoftheDuskRebellion from "assets/images/items/Despoiler's Belt of the Dusk Rebellion.jpg"
import DespoilersBootsofUsheringTwilight from "assets/images/items/Despoiler's Boots of Ushering Twilight.jpg"
import DespoilersBracersofUsheringTwilight from "assets/images/items/Despoiler's Bracers of Ushering Twilight.jpg"
import DespoilersGlovesofUsheringTwilight from "assets/images/items/Despoiler's Gloves of Ushering Twilight.jpg"
import DespoilersHoodoftheDuskRebellion from "assets/images/items/Despoiler's Hood of the Dusk Rebellion.jpg"
import DespoilersLeggingsofWhisperedDeeds from "assets/images/items/Despoiler's Leggings of Whispered Deeds.jpg"
import DespoilersTunicofUsheringTwilight from "assets/images/items/Despoiler's Tunic of Ushering Twilight.jpg"
import DevourersRingoftheAbyss from "assets/images/items/Devourer's Ring of the Abyss.jpg"
import DevoutShoulders from "assets/images/items/Devout Shoulders.jpg"
import DiabolicPirateRing from "assets/images/items/Diabolic Pirate Ring.jpg"
import DiabolicalOpus from "assets/images/items/Diabolical Opus.jpg"
import DiamondetchedGirdle from "assets/images/items/Diamond-etched Girdle.jpg"
import DiarmadsRespect from "assets/images/items/Diarmad's Respect.jpg"
import DictatusCarver from "assets/images/items/Dictatus Carver.jpg"
import DilasBelt from "assets/images/items/Dila's Belt.jpg"
import DimshadeStraps from "assets/images/items/Dimshade Straps.jpg"
import DissulutusBracers from "assets/images/items/Dissulutus Bracers.jpg"
import DivinersArmbandsoftheEmissary from "assets/images/items/Diviner's Armbands of the Emissary.jpg"
import DivinersArmbandsoftheKingmaker from "assets/images/items/Diviner's Armbands of the Kingmaker.jpg"
import DivinersBeltofSupremeDecree from "assets/images/items/Diviner's Belt of Supreme Decree.jpg"
import DivinersBeltoftheDarkPact from "assets/images/items/Diviner's Belt of the Dark Pact.jpg"
import DivinersBracersofConsumedSouls from "assets/images/items/Diviner's Bracers of Consumed Souls.jpg"
import DivinersBracersofSecretDoors from "assets/images/items/Diviner's Bracers of Secret Doors.jpg"
import DivinersGlovesofConsumedSouls from "assets/images/items/Diviner's Gloves of Consumed Souls.jpg"
import DivinersGlovesofSecretDoors from "assets/images/items/Diviner's Gloves of Secret Doors.jpg"
import DivinersHoodofSupremeDecree from "assets/images/items/Diviner's Hood of Supreme Decree.jpg"
import DivinersHoodoftheDarkPact from "assets/images/items/Diviner's Hood of the Dark Pact.jpg"
import DivinersLeggingsoftheEmissary from "assets/images/items/Diviner's Leggings of the Emissary.jpg"
import DivinersLeggingsoftheKingmaker from "assets/images/items/Diviner's Leggings of the Kingmaker.jpg"
import DivinersRobeofConsumedSouls from "assets/images/items/Diviner's Robe of Consumed Souls.jpg"
import DivinersTunicofSecretDoors from "assets/images/items/Diviner's Tunic of Secret Doors.jpg"
import DoKki from "assets/images/items/Do Kki.jpg"
import DogmatistsTasset from "assets/images/items/Dogmatist's Tasset.jpg"
import DominatorsBoots from "assets/images/items/Dominator's Boots.jpg"
import DoublecurvedHyrkanianBow from "assets/images/items/Double-curved Hyrkanian Bow.jpg"
import DragonScaleMantleoftheLivingLegend from "assets/images/items/Dragon Scale Mantle of the Living Legend.jpg"
import DragonTear from "assets/images/items/Dragon Tear.jpg"
import DrawofFangs from "assets/images/items/Draw of Fangs.jpg"
import DrazgalsFabledShield from "assets/images/items/Drazgal's Fabled Shield.jpg"
import DreamersKeepsake from "assets/images/items/Dreamer's Keepsake.jpg"
import DualbandoftheBloodGod from "assets/images/items/Dual-band of the Blood God.jpg"
import DunedancerShoes from "assets/images/items/Dunedancer Shoes.jpg"
import DurableGauntlets from "assets/images/items/Durable Gauntlets.jpg"
import Duskfang from "assets/images/items/Duskfang.jpg"
import EarthshockBand from "assets/images/items/Earthshock Band.jpg"
import Earthwrack from "assets/images/items/Earthwrack.jpg"
import EastCleaveoftheAzureDragon from "assets/images/items/East Cleave of the Azure Dragon.jpg"
import EdgeofPurgatorialShadows from "assets/images/items/Edge of Purgatorial Shadows.jpg"
import EdgeofShaulun from "assets/images/items/Edge of Shaulun.jpg"
import EdgeofTartarus from "assets/images/items/Edge of Tartarus.jpg"
import EdgeoftheGoldenAge from "assets/images/items/Edge of the Golden Age.jpg"
import EdgeoftheNightSpirits from "assets/images/items/Edge of the Night Spirits.jpg"
import EdgeoftheUbahKan from "assets/images/items/Edge of the Ubah Kan.jpg"
import EdgescornSabatons from "assets/images/items/Edge-scorn Sabatons.jpg"
import EidolonChestguard from "assets/images/items/Eidolon Chestguard.jpg"
import EldermindHood from "assets/images/items/Eldermind Hood.jpg"
import EldritchGem from "assets/images/items/Eldritch Gem.jpg"
import ElementalWard from "assets/images/items/Elemental Ward.jpg"
import EllofTorment from "assets/images/items/Ell of Torment.jpg"
import EmblemofAshur from "assets/images/items/Emblem of Ashur.jpg"
import EmblemofDragonsScales from "assets/images/items/Emblem of Dragon's Scales.jpg"
import EmblemofRedRuin from "assets/images/items/Emblem of Red Ruin.jpg"
import EmeraldArmbands from "assets/images/items/Emerald Armbands.jpg"
import EmeraldBarbsofSubtleStriking from "assets/images/items/Emerald Barbs of Subtle Striking.jpg"
import EmeraldCrochideBelt from "assets/images/items/Emerald Croc-hide Belt.jpg"
import EmeraldCrochideGloves from "assets/images/items/Emerald Croc-hide Gloves.jpg"
import EmeraldTeethNecklace from "assets/images/items/Emerald Teeth Necklace.jpg"
import EmeraldhideShoes from "assets/images/items/Emerald-hide Shoes.jpg"
import EminentGirdle from "assets/images/items/Eminent Girdle.jpg"
import EmpoweringAtlanteanCatalyst from "assets/images/items/Empowering Atlantean Catalyst.jpg"
import EndlessBattleBlade from "assets/images/items/Endless Battle Blade.jpg"
import Endurance from "assets/images/items/Endurance.jpg"
import EnduringTasset from "assets/images/items/Enduring Tasset.jpg"
import EnergeticBand from "assets/images/items/Energetic Band.jpg"
import EnergizingShoulders from "assets/images/items/Energizing Shoulders.jpg"
import EnforcersBoon from "assets/images/items/Enforcer's Boon.jpg"
import EnforcersFavor from "assets/images/items/Enforcer's Favor.jpg"
import EnlightenedLoop from "assets/images/items/Enlightened Loop.jpg"
import EnlighteningAtlanteanCatalyst from "assets/images/items/Enlightening Atlantean Catalyst.jpg"
import Entropy from "assets/images/items/Entropy.jpg"
import EpithetofSkelos from "assets/images/items/Epithet of Skelos.jpg"
import EranSpahbedAjanta from "assets/images/items/Eran Spahbed Ajanta.jpg"
import EranSpahbedLock from "assets/images/items/Eran Spahbed Lock.jpg"
import EranSpahbedSpara from "assets/images/items/Eran Spahbed Spara.jpg"
import ErliksBladeofWidows from "assets/images/items/Erlik's Blade of Widows.jpg"
import ErliksKnifeoftheAfterlife from "assets/images/items/Erlik's Knife of the Afterlife.jpg"
import ErliksNinthSealoftheUnderworld from "assets/images/items/Erlik's Ninth Seal of the Underworld.jpg"
import ErliksRingoftheAfterlife from "assets/images/items/Erlik's Ring of the Afterlife.jpg"
import ErliksRingoftheUnderworld from "assets/images/items/Erlik's Ring of the Underworld.jpg"
import ErliksScytheoftheReaper from "assets/images/items/Erlik's Scythe of the Reaper.jpg"
import EssenceofCourage from "assets/images/items/Essence of Courage.jpg"
import EtchedKuthchemanPoniard from "assets/images/items/Etched Kuthcheman Poniard.jpg"
import EternalFaithBelt from "assets/images/items/Eternal Faith Belt.jpg"
import EternalFaithBoots from "assets/images/items/Eternal Faith Boots.jpg"
import EternalFaithGauntlets from "assets/images/items/Eternal Faith Gauntlets.jpg"
import EternalFaithTasset from "assets/images/items/Eternal Faith Tasset.jpg"
import Ethersense from "assets/images/items/Ethersense.jpg"
import ExaltatesArmbands from "assets/images/items/Exaltate's Armbands.jpg"
import ExaltatesBoots from "assets/images/items/Exaltate's Boots.jpg"
import ExaltatesBracers from "assets/images/items/Exaltate's Bracers.jpg"
import ExaltatesGirdle from "assets/images/items/Exaltate's Girdle.jpg"
import ExaltatesGloves from "assets/images/items/Exaltate's Gloves.jpg"
import ExaltatesHelm from "assets/images/items/Exaltate's Helm.jpg"
import ExaltatesJerkin from "assets/images/items/Exaltate's Jerkin.jpg"
import ExaltatesTasset from "assets/images/items/Exaltate's Tasset.jpg"
import Extentus from "assets/images/items/Extentus.jpg"
import EyeoftheWatcher from "assets/images/items/Eye of the Watcher.jpg"
import EyeofZamora from "assets/images/items/Eye of Zamora.jpg"
import EyesofZug from "assets/images/items/Eyes of Zug.jpg"
import FaceoftheMoon from "assets/images/items/Face of the Moon.jpg"
import FacemaskoftheBloodhunternm from "assets/images/items/Facemask of the Bloodhunter (nm).jpg"
import FacemaskoftheBloodhunter from "assets/images/items/Facemask of the Bloodhunter.jpg"
import Faithsteel from "assets/images/items/Faithsteel.jpg"
import FalchionoftheArenaMaster from "assets/images/items/Falchion of the Arena Master.jpg"
import FallenLeviathansMantleoftheLivingLegend from "assets/images/items/Fallen Leviathan's Mantle of the Living Legend.jpg"
import FangoftheVaaghasan from "assets/images/items/Fang of the Vaaghasan.jpg"
import FarmerNorfindirsNecklace from "assets/images/items/Farmer Norfindir's Necklace.jpg"
import Farspire from "assets/images/items/Farspire.jpg"
import FatalHyperboreanHierophantGem from "assets/images/items/Fatal Hyperborean Hierophant Gem.jpg"
import FatalHyperboreanSentinelGem from "assets/images/items/Fatal Hyperborean Sentinel Gem.jpg"
import FauldofBoneandHorn from "assets/images/items/Fauld of Bone and Horn.jpg"
import FauldoftheBlackSarcophagus from "assets/images/items/Fauld of the Black Sarcophagus.jpg"
import FauldoftheScatteredGods from "assets/images/items/Fauld of the Scattered Gods.jpg"
import FauldoftheSteelBehemoth from "assets/images/items/Fauld of the Steel Behemoth.jpg"
import FavoroftheSkeletonConcubines from "assets/images/items/Favor of the Skeleton Concubines.jpg"
import FeatherofIbis from "assets/images/items/Feather of Ibis.jpg"
import FellbladeofCrimsonSlaughter from "assets/images/items/Fellblade of Crimson Slaughter.jpg"
import FellhammeroftheSanguineDisciple from "assets/images/items/Fellhammer of the Sanguine Disciple.jpg"
import FencesArmbandsoftheDuskRebellion from "assets/images/items/Fence's Armbands of the Dusk Rebellion.jpg"
import FencesBracersofUsheringTwilight from "assets/images/items/Fence's Bracers of Ushering Twilight.jpg"
import FencesCordofWhisperedDeeds from "assets/images/items/Fence's Cord of Whispered Deeds.jpg"
import FencesCowlofUsheringTwilight from "assets/images/items/Fence's Cowl of Ushering Twilight.jpg"
import FencesGlovesofWhisperedDeeds from "assets/images/items/Fence's Gloves of Whispered Deeds.jpg"
import FencesPantsoftheDuskRebellion from "assets/images/items/Fence's Pants of the Dusk Rebellion.jpg"
import FencesTunicofUsheringTwilight from "assets/images/items/Fence's Tunic of Ushering Twilight.jpg"
import FeraBalteus from "assets/images/items/Fera Balteus.jpg"
import FeretrumofMitra from "assets/images/items/Feretrum of Mitra.jpg"
import FetishofCagedFiends from "assets/images/items/Fetish of Caged Fiends.jpg"
import FiercelordStraps from "assets/images/items/Fiercelord Straps.jpg"
import FilamentofNightmare from "assets/images/items/Filament of Nightmare.jpg"
import FireforgeAxe from "assets/images/items/Fireforge Axe.jpg"
import FireguardMantle from "assets/images/items/Fireguard Mantle.jpg"
import FiresoulHelm from "assets/images/items/Firesoul Helm.jpg"
import FistofSiptah from "assets/images/items/Fist of Siptah.jpg"
import FlamefuseHelm from "assets/images/items/Flamefuse Helm.jpg"
import FlamelashGloves from "assets/images/items/Flamelash Gloves.jpg"
import FlametemperArrows from "assets/images/items/Flametemper Arrows.jpg"
import FlameweaveSash from "assets/images/items/Flameweave Sash.jpg"
import FlashburstWristbands from "assets/images/items/Flashburst Wristbands.jpg"
import FlawmindNecklace from "assets/images/items/Flawmind Necklace.jpg"
import Fleshcarver from "assets/images/items/Fleshcarver.jpg"
import FleshflayerGloves from "assets/images/items/Fleshflayer Gloves.jpg"
import FleshmendersBracers from "assets/images/items/Fleshmender's Bracers.jpg"
import FleshstripperBoots from "assets/images/items/Fleshstripper Boots.jpg"
import FleshstripperLeggings from "assets/images/items/Fleshstripper Leggings.jpg"
import Foebane from "assets/images/items/Foebane.jpg"
import FootpadsArmbandsoftheBurningTemple from "assets/images/items/Footpad's Armbands of the Burning Temple.jpg"
import FootpadsArmbandsoftheFinalWay from "assets/images/items/Footpad's Armbands of the Final Way.jpg"
import FootpadsBandsoftheTenthCourt from "assets/images/items/Footpad's Bands of the Tenth Court.jpg"
import FootpadsBeltoftheBurningTemple from "assets/images/items/Footpad's Belt of the Burning Temple.jpg"
import FootpadsBeltoftheHiddenPalace from "assets/images/items/Footpad's Belt of the Hidden Palace.jpg"
import FootpadsBootsofEngulfingTwilight from "assets/images/items/Footpad's Boots of Engulfing Twilight.jpg"
import FootpadsBootsoftheNadir from "assets/images/items/Footpad's Boots of the Nadir.jpg"
import FootpadsBootsoftheSunderedCrown from "assets/images/items/Footpad's Boots of the Sundered Crown.jpg"
import FootpadsBootsoftheSwiftReturn from "assets/images/items/Footpad's Boots of the Swift Return.jpg"
import FootpadsBracersofEngulfingTwilight from "assets/images/items/Footpad's Bracers of Engulfing Twilight.jpg"
import FootpadsBracersoftheNadir from "assets/images/items/Footpad's Bracers of the Nadir.jpg"
import FootpadsBracersoftheSwiftReturn from "assets/images/items/Footpad's Bracers of the Swift Return.jpg"
import FootpadsGlovesoftheDeceiver from "assets/images/items/Footpad's Gloves of the Deceiver.jpg"
import FootpadsGlovesoftheFifthStage from "assets/images/items/Footpad's Gloves of the Fifth Stage.jpg"
import FootpadsGlovesoftheSmolderingThrone from "assets/images/items/Footpad's Gloves of the Smoldering Throne.jpg"
import FootpadsGlovesoftheStolenKingdom from "assets/images/items/Footpad's Gloves of the Stolen Kingdom.jpg"
import FootpadsHelmoftheHiddenPalace from "assets/images/items/Footpad's Helm of the Hidden Palace.jpg"
import FootpadsHelmoftheTenthCourt from "assets/images/items/Footpad's Helm of the Tenth Court.jpg"
import FootpadsJerkinoftheFifthStage from "assets/images/items/Footpad's Jerkin of the Fifth Stage.jpg"
import FootpadsJerkinoftheStolenKingdom from "assets/images/items/Footpad's Jerkin of the Stolen Kingdom.jpg"
import FootpadsLeggingsoftheBurningTemple from "assets/images/items/Footpad's Leggings of the Burning Temple.jpg"
import FootpadsLeggingsoftheFinalWay from "assets/images/items/Footpad's Leggings of the Final Way.jpg"
import FootpadsLeggingsoftheTenthCourt from "assets/images/items/Footpad's Leggings of the Tenth Court.jpg"
import FootpadsLegguardsoftheHiddenPalace from "assets/images/items/Footpad's Legguards of the Hidden Palace.jpg"
import FootpadsMaskoftheBurningTemple from "assets/images/items/Footpad's Mask of the Burning Temple.jpg"
import FootpadsMaskoftheFinalWay from "assets/images/items/Footpad's Mask of the Final Way.jpg"
import FootpadsStrapsoftheHiddenPalace from "assets/images/items/Footpad's Straps of the Hidden Palace.jpg"
import FootpadsTunicoftheDeceiver from "assets/images/items/Footpad's Tunic of the Deceiver.jpg"
import FootpadsTunicoftheSmolderingThrone from "assets/images/items/Footpad's Tunic of the Smoldering Throne.jpg"
import FootpadsWristbandsoftheSunderedCrown from "assets/images/items/Footpad's Wristbands of the Sundered Crown.jpg"
import FootstepsoftheVoid from "assets/images/items/Footsteps of the Void.jpg"
import FootwrapsoftheDarkwretch from "assets/images/items/Footwraps of the Darkwretch.jpg"
import FootwrapsoftheForsaken from "assets/images/items/Footwraps of the Forsaken.jpg"
import FootwrapsoftheHarbinger from "assets/images/items/Footwraps of the Harbinger.jpg"
import FootwrapsofthePrecursor from "assets/images/items/Footwraps of the Precursor.jpg"
import FootwrapsoftheReanimator from "assets/images/items/Footwraps of the Reanimator.jpg"
import ForbiddenFirestaff from "assets/images/items/Forbidden Firestaff.jpg"
import ForceofthePillars from "assets/images/items/Force of the Pillars.jpg"
import ForcefulPirateRing from "assets/images/items/Forceful Pirate Ring.jpg"
import Forestwalkers from "assets/images/items/Forestwalkers.jpg"
import Forgehammer from "assets/images/items/Forgehammer.jpg"
import FortifyingAtlanteanCatalyst from "assets/images/items/Fortifying Atlantean Catalyst.jpg"
import Fractalus from "assets/images/items/Fractalus.jpg"
import FreebootersArmstrapsofPiercedFlesh from "assets/images/items/Freebooter's Arm-straps of Pierced Flesh.jpg"
import FreebootersArmbandsoftheUntamed from "assets/images/items/Freebooter's Armbands of the Untamed.jpg"
import FreebootersArmguardoftheRoaringJungle from "assets/images/items/Freebooter's Armguard of the Roaring Jungle.jpg"
import FreebootersBeltofCrouchingCalm from "assets/images/items/Freebooter's Belt of Crouching Calm.jpg"
import FreebootersBeltofPiercedFlesh from "assets/images/items/Freebooter's Belt of Pierced Flesh.jpg"
import FreebootersBootsofthePrimeval from "assets/images/items/Freebooter's Boots of the Primeval.jpg"
import FreebootersBootsoftheSavageSun from "assets/images/items/Freebooter's Boots of the Savage Sun.jpg"
import FreebootersBootsoftheYellowSpring from "assets/images/items/Freebooter's Boots of the Yellow Spring.jpg"
import FreebootersBracersofthePrimeval from "assets/images/items/Freebooter's Bracers of the Primeval.jpg"
import FreebootersBracersoftheYellowSpring from "assets/images/items/Freebooter's Bracers of the Yellow Spring.jpg"
import FreebootersChestguardofStalkingFury from "assets/images/items/Freebooter's Chestguard of Stalking Fury.jpg"
import FreebootersGauntletsofStalkingFury from "assets/images/items/Freebooter's Gauntlets of Stalking Fury.jpg"
import FreebootersGauntletsoftheSecondCaste from "assets/images/items/Freebooter's Gauntlets of the Second Caste.jpg"
import FreebootersGirdleoftheUntamed from "assets/images/items/Freebooter's Girdle of the Untamed.jpg"
import FreebootersGlovesofGrinningSkulls from "assets/images/items/Freebooter's Gloves of Grinning Skulls.jpg"
import FreebootersGlovesoftheElderBond from "assets/images/items/Freebooter's Gloves of the Elder Bond.jpg"
import FreebootersHarnessoftheSecondCaste from "assets/images/items/Freebooter's Harness of the Second Caste.jpg"
import FreebootersHelmofCrouchingCalm from "assets/images/items/Freebooter's Helm of Crouching Calm.jpg"
import FreebootersHelmoftheRoaringJungle from "assets/images/items/Freebooter's Helm of the Roaring Jungle.jpg"
import FreebootersHelmoftheUntamed from "assets/images/items/Freebooter's Helm of the Untamed.jpg"
import FreebootersJerkinoftheElderBond from "assets/images/items/Freebooter's Jerkin of the Elder Bond.jpg"
import FreebootersLeggingsofPiercedFlesh from "assets/images/items/Freebooter's Leggings of Pierced Flesh.jpg"
import FreebootersLeggingsoftheUntamed from "assets/images/items/Freebooter's Leggings of the Untamed.jpg"
import FreebootersLegguardsofCrouchingCalm from "assets/images/items/Freebooter's Legguards of Crouching Calm.jpg"
import FreebootersLegguardsoftheRoaringJungle from "assets/images/items/Freebooter's Legguards of the Roaring Jungle.jpg"
import FreebootersStrapsofCrouchingCalm from "assets/images/items/Freebooter's Straps of Crouching Calm.jpg"
import FreebootersStrapsofthePaintedClaw from "assets/images/items/Freebooter's Straps of the Painted Claw.jpg"
import FreebootersTreadsofthePaintedClaw from "assets/images/items/Freebooter's Treads of the Painted Claw.jpg"
import FreebootersVambracesoftheSavageSun from "assets/images/items/Freebooter's Vambraces of the Savage Sun.jpg"
import FreebootersVestofGrinningSkulls from "assets/images/items/Freebooter's Vest of Grinning Skulls.jpg"
import FreneticGloves from "assets/images/items/Frenetic Gloves.jpg"
import FrostfireCowl from "assets/images/items/Frostfire Cowl.jpg"
import Frostfur from "assets/images/items/Frostfur.jpg"
import FrosthunterArrows from "assets/images/items/Frosthunter Arrows.jpg"
import Frostmaim from "assets/images/items/Frostmaim.jpg"
import FrostmawBoots from "assets/images/items/Frostmaw Boots.jpg"
import FrostmawGauntlets from "assets/images/items/Frostmaw Gauntlets.jpg"
import FrostmawHelm from "assets/images/items/Frostmaw Helm.jpg"
import FrostmawVambraces from "assets/images/items/Frostmaw Vambraces.jpg"
import FrostmistCloak from "assets/images/items/Frostmist Cloak.jpg"
import Frostram from "assets/images/items/Frostram.jpg"
import Frostspike from "assets/images/items/Frostspike.jpg"
import Frostwall from "assets/images/items/Frostwall.jpg"
import Furatus from "assets/images/items/Furatus.jpg"
import FuriousBand from "assets/images/items/Furious Band.jpg"
import FuriousSpirit from "assets/images/items/Furious Spirit.jpg"
import FuryofJovus from "assets/images/items/Fury of Jovus.jpg"
import FuryoftheSleepingStars from "assets/images/items/Fury of the Sleeping Stars.jpg"
import FuryoftheVoid from "assets/images/items/Fury of the Void.jpg"
import FuryofXotli from "assets/images/items/Fury of Xotli.jpg"
import FurysAegis from "assets/images/items/Fury's Aegis.jpg"
import Gale from "assets/images/items/Gale.jpg"
import GarbsoftheEarthMother from "assets/images/items/Garbs of the Earth Mother.jpg"
import GargantuanFist from "assets/images/items/Gargantuan Fist.jpg"
import GargoyleMastersDemise from "assets/images/items/Gargoyle Master's Demise.jpg"
import GauntletsofBalefulBlood from "assets/images/items/Gauntlets of Baleful Blood.jpg"
import GauntletsofBlackSpite from "assets/images/items/Gauntlets of Black Spite.jpg"
import GauntletsofBloodlust from "assets/images/items/Gauntlets of Bloodlust.jpg"
import GauntletsofBrutalCarnage from "assets/images/items/Gauntlets of Brutal Carnage.jpg"
import GauntletsofClarity from "assets/images/items/Gauntlets of Clarity.jpg"
import GauntletsofCourageousSouls from "assets/images/items/Gauntlets of Courageous Souls.jpg"
import GauntletsofFearlessSouls from "assets/images/items/Gauntlets of Fearless Souls.jpg"
import GauntletsofHeroicSoul from "assets/images/items/Gauntlets of Heroic Soul.jpg"
import GauntletsofIndomitableSouls from "assets/images/items/Gauntlets of Indomitable Souls.jpg"
import GauntletsofIndra from "assets/images/items/Gauntlets of Indra.jpg"
import GauntletsofRecklessChallenge from "assets/images/items/Gauntlets of Reckless Challenge.jpg"
import GauntletsoftheAssailant from "assets/images/items/Gauntlets of the Assailant.jpg"
import GauntletsoftheAtlantean from "assets/images/items/Gauntlets of the Atlantean.jpg"
import GauntletsoftheBerserkersFury from "assets/images/items/Gauntlets of the Berserker's Fury.jpg"
import GauntletsoftheBeyond from "assets/images/items/Gauntlets of the Beyond.jpg"
import GauntletsoftheBlackDragon from "assets/images/items/Gauntlets of the Black Dragon.jpg"
import GauntletsoftheBlackPharaoh from "assets/images/items/Gauntlets of the Black Pharaoh.jpg"
import GauntletsoftheBlackWarden from "assets/images/items/Gauntlets of the Black Warden.jpg"
import GauntletsoftheChaosAgent from "assets/images/items/Gauntlets of the Chaos Agent.jpg"
import GauntletsoftheDarkMessenger from "assets/images/items/Gauntlets of the Dark Messenger.jpg"
import GauntletsoftheDauntless from "assets/images/items/Gauntlets of the Dauntless.jpg"
import GauntletsoftheDefiant from "assets/images/items/Gauntlets of the Defiant.jpg"
import GauntletsoftheFallenEmpirenm from "assets/images/items/Gauntlets of the Fallen Empire (nm).jpg"
import GauntletsoftheFallenEmpire from "assets/images/items/Gauntlets of the Fallen Empire.jpg"
import GauntletsoftheInvincible from "assets/images/items/Gauntlets of the Invincible.jpg"
import GauntletsoftheLivingTarim from "assets/images/items/Gauntlets of the Living Tarim.jpg"
import GauntletsoftheMartialParagon from "assets/images/items/Gauntlets of the Martial Paragon.jpg"
import GauntletsoftheMilitesTempli from "assets/images/items/Gauntlets of the Milites Templi.jpg"
import GauntletsoftheOstiary from "assets/images/items/Gauntlets of the Ostiary.jpg"
import GauntletsofthePainlegion from "assets/images/items/Gauntlets of the Painlegion.jpg"
import GauntletsoftheProvenChampion from "assets/images/items/Gauntlets of the Proven Champion.jpg"
import GauntletsoftheRevelationsofTarim from "assets/images/items/Gauntlets of the Revelations of Tarim.jpg"
import GauntletsoftheSavageSlaughter from "assets/images/items/Gauntlets of the Savage Slaughter.jpg"
import GauntletsoftheScatteredGods from "assets/images/items/Gauntlets of the Scattered Gods.jpg"
import GauntletsoftheTirelessDefender from "assets/images/items/Gauntlets of the Tireless Defender.jpg"
import GauntletsoftheTormentor from "assets/images/items/Gauntlets of the Tormentor.jpg"
import GauntletsoftheTriumphant from "assets/images/items/Gauntlets of the Triumphant.jpg"
import GauntletsoftheUsurper from "assets/images/items/Gauntlets of the Usurper.jpg"
import GauntletsoftheValiant from "assets/images/items/Gauntlets of the Valiant.jpg"
import GauntletsoftheVanguard from "assets/images/items/Gauntlets of the Vanguard.jpg"
import GauntletsoftheVictoriousElite from "assets/images/items/Gauntlets of the Victorious Elite.jpg"
import GauntletsoftheWicked from "assets/images/items/Gauntlets of the Wicked.jpg"
import GauntletsofUnrest from "assets/images/items/Gauntlets of Unrest.jpg"
import GauntletsofUntamedViolence from "assets/images/items/Gauntlets of Untamed Violence.jpg"
import GauntletsofViolentRage from "assets/images/items/Gauntlets of Violent Rage.jpg"
import GemmaofRestoration from "assets/images/items/Gemma of Restoration.jpg"
import GeneralsArmguardsofHeavensPass from "assets/images/items/General's Armguards of Heaven's Pass.jpg"
import GeneralsArmguardsoftheBattlements from "assets/images/items/General's Armguards of the Battlements.jpg"
import GeneralsArmguardsoftheWatchtowers from "assets/images/items/General's Armguards of the Watchtowers.jpg"
import GeneralsBeltofHeavensPass from "assets/images/items/General's Belt of Heaven's Pass.jpg"
import GeneralsBeltoftheBattlements from "assets/images/items/General's Belt of the Battlements.jpg"
import GeneralsBeltoftheWatchtowers from "assets/images/items/General's Belt of the Watchtowers.jpg"
import GeneralsBootsofDynasticRule from "assets/images/items/General's Boots of Dynastic Rule.jpg"
import GeneralsBootsoftheAscendingKingdom from "assets/images/items/General's Boots of the Ascending Kingdom.jpg"
import GeneralsBootsoftheWarringStates from "assets/images/items/General's Boots of the Warring States.jpg"
import GeneralsChestguardoftheShiningSun from "assets/images/items/General's Chestguard of the Shining Sun.jpg"
import GeneralsChestplateoftheEasternSun from "assets/images/items/General's Chestplate of the Eastern Sun.jpg"
import GeneralsChestplateoftheGoldenSun from "assets/images/items/General's Chestplate of the Golden Sun.jpg"
import GeneralsGauntletsofHeavensPass from "assets/images/items/General's Gauntlets of Heaven's Pass.jpg"
import GeneralsGauntletsoftheBattlements from "assets/images/items/General's Gauntlets of the Battlements.jpg"
import GeneralsGauntletsoftheWatchtowers from "assets/images/items/General's Gauntlets of the Watchtowers.jpg"
import GeneralsHelmoftheEasternSun from "assets/images/items/General's Helm of the Eastern Sun.jpg"
import GeneralsHelmoftheGoldenSun from "assets/images/items/General's Helm of the Golden Sun.jpg"
import GeneralsHelmoftheShiningSun from "assets/images/items/General's Helm of the Shining Sun.jpg"
import GeneralsLegguardsofHeavensPass from "assets/images/items/General's Legguards of Heaven's Pass.jpg"
import GeneralsLegguardsoftheBattlements from "assets/images/items/General's Legguards of the Battlements.jpg"
import GeneralsLegguardsoftheWatchtowers from "assets/images/items/General's Legguards of the Watchtowers.jpg"
import GeneralsVambracesofDynasticRule from "assets/images/items/General's Vambraces of Dynastic Rule.jpg"
import GeneralsVambracesoftheAscendingKingdom from "assets/images/items/General's Vambraces of the Ascending Kingdom.jpg"
import GeneralsVambracesoftheWarringStates from "assets/images/items/General's Vambraces of the Warring States.jpg"
import Ghostfang from "assets/images/items/Ghostfang.jpg"
import Ghostflight from "assets/images/items/Ghostflight.jpg"
import GhostweaveDrapeUnchainedVersion from "assets/images/items/Ghostweave Drape (Unchained Version).jpg"
import GhostweaveDrape from "assets/images/items/Ghostweave Drape.jpg"
import GidaofBlackOblivion from "assets/images/items/Gida of Black Oblivion.jpg"
import GidaofDarkTerror from "assets/images/items/Gida of Dark Terror.jpg"
import GidaofNecroticDread from "assets/images/items/Gida of Necrotic Dread.jpg"
import GidaofPandemonium from "assets/images/items/Gida of Pandemonium.jpg"
import GidaoftheBloodmoon from "assets/images/items/Gida of the Bloodmoon.jpg"
import GidaoftheCloudcleaver from "assets/images/items/Gida of the Cloudcleaver.jpg"
import GidaoftheEcliptic from "assets/images/items/Gida of the Ecliptic.jpg"
import GidaoftheFirstCircle from "assets/images/items/Gida of the First Circle.jpg"
import GidaoftheJudgmentBolt from "assets/images/items/Gida of the Judgment Bolt.jpg"
import GidaoftheRiftcaller from "assets/images/items/Gida of the Riftcaller.jpg"
import GidaoftheSunderedSkies from "assets/images/items/Gida of the Sundered Skies.jpg"
import GidaoftheUnholyCommunion from "assets/images/items/Gida of the Unholy Communion.jpg"
import GirdleofBalefulBlood from "assets/images/items/Girdle of Baleful Blood.jpg"
import GirdleofBlackSpite from "assets/images/items/Girdle of Black Spite.jpg"
import GirdleofBlindDevotion from "assets/images/items/Girdle of Blind Devotion.jpg"
import GirdleofBoneandHorn from "assets/images/items/Girdle of Bone and Horn.jpg"
import GirdleofBrutalCarnage from "assets/images/items/Girdle of Brutal Carnage.jpg"
import GirdleofCelestialRadiance from "assets/images/items/Girdle of Celestial Radiance.jpg"
import GirdleofClawingMight from "assets/images/items/Girdle of Clawing Might.jpg"
import GirdleofEffulgentDevotion from "assets/images/items/Girdle of Effulgent Devotion.jpg"
import GirdleofErlik from "assets/images/items/Girdle of Erlik.jpg"
import GirdleofHeroicSoul from "assets/images/items/Girdle of Heroic Soul.jpg"
import GirdleofIlluminantConviction from "assets/images/items/Girdle of Illuminant Conviction.jpg"
import GirdleofIndomitableSouls from "assets/images/items/Girdle of Indomitable Souls.jpg"
import GirdleofInsanity from "assets/images/items/Girdle of Insanity.jpg"
import GirdleofJaggedBarbs from "assets/images/items/Girdle of Jagged Barbs.jpg"
import GirdleofPandemonium from "assets/images/items/Girdle of Pandemonium.jpg"
import GirdleofQuilledDarts from "assets/images/items/Girdle of Quilled Darts.jpg"
import GirdleoftheAscension from "assets/images/items/Girdle of the Ascension.jpg"
import GirdleoftheBerserkersFury from "assets/images/items/Girdle of the Berserker's Fury.jpg"
import GirdleoftheBlackPharaoh from "assets/images/items/Girdle of the Black Pharaoh.jpg"
import GirdleoftheBloodmoon from "assets/images/items/Girdle of the Bloodmoon.jpg"
import GirdleoftheChaosAgent from "assets/images/items/Girdle of the Chaos Agent.jpg"
import GirdleoftheCloudcleaver from "assets/images/items/Girdle of the Cloudcleaver.jpg"
import GirdleoftheDarkMessenger from "assets/images/items/Girdle of the Dark Messenger.jpg"
import GirdleoftheDeathstalker from "assets/images/items/Girdle of the Deathstalker.jpg"
import GirdleoftheEarthMother from "assets/images/items/Girdle of the Earth Mother.jpg"
import GirdleoftheEcliptic from "assets/images/items/Girdle of the Ecliptic.jpg"
import GirdleoftheEndlessSands from "assets/images/items/Girdle of the Endless Sands.jpg"
import GirdleoftheFirstCircle from "assets/images/items/Girdle of the First Circle.jpg"
import GirdleoftheFuriousSwipe from "assets/images/items/Girdle of the Furious Swipe.jpg"
import GirdleoftheHaunterintheDark from "assets/images/items/Girdle of the Haunter in the Dark.jpg"
import GirdleoftheHowlingGiant from "assets/images/items/Girdle of the Howling Giant.jpg"
import GirdleoftheIchorous from "assets/images/items/Girdle of the Ichorous.jpg"
import GirdleoftheInconceivable from "assets/images/items/Girdle of the Inconceivable.jpg"
import GirdleoftheInvincible from "assets/images/items/Girdle of the Invincible.jpg"
import GirdleoftheJudgmentBolt from "assets/images/items/Girdle of the Judgment Bolt.jpg"
import GirdleoftheKozakSlayer from "assets/images/items/Girdle of the Kozak Slayer.jpg"
import GirdleoftheLivingTarim from "assets/images/items/Girdle of the Living Tarim.jpg"
import GirdleoftheMartialParagon from "assets/images/items/Girdle of the Martial Paragon.jpg"
import GirdleoftheMembranous from "assets/images/items/Girdle of the Membranous.jpg"
import GirdleoftheOxmal from "assets/images/items/Girdle of the Oxmal.jpg"
import GirdleofthePainlegion from "assets/images/items/Girdle of the Painlegion.jpg"
import GirdleoftheProvenChampion from "assets/images/items/Girdle of the Proven Champion.jpg"
import GirdleoftheRavenflight from "assets/images/items/Girdle of the Ravenflight.jpg"
import GirdleoftheRefectory from "assets/images/items/Girdle of the Refectory.jpg"
import GirdleoftheRenegade from "assets/images/items/Girdle of the Renegade.jpg"
import GirdleoftheRevelationsofTarim from "assets/images/items/Girdle of the Revelations of Tarim.jpg"
import GirdleoftheRiftcaller from "assets/images/items/Girdle of the Riftcaller.jpg"
import GirdleoftheSavageFang from "assets/images/items/Girdle of the Savage Fang.jpg"
import GirdleoftheSavageSlaughter from "assets/images/items/Girdle of the Savage Slaughter.jpg"
import GirdleoftheShiveringStars from "assets/images/items/Girdle of the Shivering Stars.jpg"
import GirdleoftheSunderedSkies from "assets/images/items/Girdle of the Sundered Skies.jpg"
import GirdleoftheSwiftTalon from "assets/images/items/Girdle of the Swift Talon.jpg"
import GirdleoftheTirelessDefender from "assets/images/items/Girdle of the Tireless Defender.jpg"
import GirdleoftheTriumphant from "assets/images/items/Girdle of the Triumphant.jpg"
import GirdleoftheUbahKan from "assets/images/items/Girdle of the Ubah Kan.jpg"
import GirdleoftheValiant from "assets/images/items/Girdle of the Valiant.jpg"
import GirdleoftheVictoriousElite from "assets/images/items/Girdle of the Victorious Elite.jpg"
import GirdleofUntamedViolence from "assets/images/items/Girdle of Untamed Violence.jpg"
import GirdleofVernantFury from "assets/images/items/Girdle of Vernant Fury.jpg"
import GirdleofViolentRage from "assets/images/items/Girdle of Violent Rage.jpg"
import GirdleofWrithing from "assets/images/items/Girdle of Writhing.jpg"
import GlaiveofRedRuin from "assets/images/items/Glaive of Red Ruin.jpg"
import Gloomshield from "assets/images/items/Gloomshield.jpg"
import GloveoftheSwiftTalon from "assets/images/items/Glove of the Swift Talon.jpg"
import GlovesofBedlam from "assets/images/items/Gloves of Bedlam.jpg"
import GlovesofBestialRage from "assets/images/items/Gloves of Bestial Rage.jpg"
import GlovesofBlackWhispers from "assets/images/items/Gloves of Black Whispers.jpg"
import GlovesofBristlingIre from "assets/images/items/Gloves of Bristling Ire.jpg"
import GlovesofCelestialRadiance from "assets/images/items/Gloves of Celestial Radiance.jpg"
import GlovesofConcealingShadows from "assets/images/items/Gloves of Concealing Shadows.jpg"
import GlovesofCrimsonSlaughternm from "assets/images/items/Gloves of Crimson Slaughter (nm).jpg"
import GlovesofCrimsonSlaughter from "assets/images/items/Gloves of Crimson Slaughter.jpg"
import GlovesofDarkMalice from "assets/images/items/Gloves of Dark Malice.jpg"
import GlovesofDeadlyGuile from "assets/images/items/Gloves of Deadly Guile.jpg"
import GlovesofEffulgentDevotion from "assets/images/items/Gloves of Effulgent Devotion.jpg"
import GlovesofFerineAnger from "assets/images/items/Gloves of Ferine Anger.jpg"
import GlovesofFiendishInvocation from "assets/images/items/Gloves of Fiendish Invocation.jpg"
import GlovesofFlowingWater from "assets/images/items/Gloves of Flowing Water.jpg"
import GlovesofHaloga from "assets/images/items/Gloves of Haloga.jpg"
import GlovesofIlluminantConviction from "assets/images/items/Gloves of Illuminant Conviction.jpg"
import GlovesofIntricateSpite from "assets/images/items/Gloves of Intricate Spite.jpg"
import GlovesofLunacy from "assets/images/items/Gloves of Lunacy.jpg"
import GlovesofPandemonium from "assets/images/items/Gloves of Pandemonium.jpg"
import GlovesofQuilledDarts from "assets/images/items/Gloves of Quilled Darts.jpg"
import GlovesofRapturousBattle from "assets/images/items/Gloves of Rapturous Battle.jpg"
import GlovesofRedRuinnm from "assets/images/items/Gloves of Red Ruin (nm).jpg"
import GlovesofRedRuin from "assets/images/items/Gloves of Red Ruin.jpg"
import GlovesofRighteousSmiting from "assets/images/items/Gloves of Righteous Smiting.jpg"
import GlovesofSwiftstriking from "assets/images/items/Gloves of Swiftstriking.jpg"
import GlovesoftheAscension from "assets/images/items/Gloves of the Ascension.jpg"
import GlovesoftheBlackPharaoh from "assets/images/items/Gloves of the Black Pharaoh.jpg"
import GlovesoftheBloodDrinkernm from "assets/images/items/Gloves of the Blood Drinker (nm).jpg"
import GlovesoftheBloodDrinker from "assets/images/items/Gloves of the Blood Drinker.jpg"
import GlovesoftheBloodGodnm from "assets/images/items/Gloves of the Blood God (nm).jpg"
import GlovesoftheBloodGod from "assets/images/items/Gloves of the Blood God.jpg"
import GlovesoftheBloodhunternm from "assets/images/items/Gloves of the Bloodhunter (nm).jpg"
import GlovesoftheBloodhunter from "assets/images/items/Gloves of the Bloodhunter.jpg"
import GlovesoftheBloodmoon from "assets/images/items/Gloves of the Bloodmoon.jpg"
import GlovesoftheCacklingMarionette from "assets/images/items/Gloves of the Cackling Marionette.jpg"
import GlovesoftheClay from "assets/images/items/Gloves of the Clay.jpg"
import GlovesoftheCrawlingChaos from "assets/images/items/Gloves of the Crawling Chaos.jpg"
import GlovesoftheDarkMessenger from "assets/images/items/Gloves of the Dark Messenger.jpg"
import GlovesoftheDarkwretch from "assets/images/items/Gloves of the Darkwretch.jpg"
import GlovesoftheDeathGod from "assets/images/items/Gloves of the Death God.jpg"
import GlovesoftheDeathMasternm from "assets/images/items/Gloves of the Death Master (nm).jpg"
import GlovesoftheDeathMaster from "assets/images/items/Gloves of the Death Master.jpg"
import GlovesoftheDeathstalker from "assets/images/items/Gloves of the Deathstalker.jpg"
import GlovesoftheDoomsayer from "assets/images/items/Gloves of the Doomsayer.jpg"
import GlovesoftheEarthMother from "assets/images/items/Gloves of the Earth Mother.jpg"
import GlovesoftheEcliptic from "assets/images/items/Gloves of the Ecliptic.jpg"
import GlovesoftheExorcist from "assets/images/items/Gloves of the Exorcist.jpg"
import GlovesoftheFarseeker from "assets/images/items/Gloves of the Farseeker.jpg"
import GlovesoftheFirebrand from "assets/images/items/Gloves of the Firebrand.jpg"
import GlovesoftheFirstCircle from "assets/images/items/Gloves of the First Circle.jpg"
import GlovesoftheForsaken from "assets/images/items/Gloves of the Forsaken.jpg"
import GlovesoftheHarbinger from "assets/images/items/Gloves of the Harbinger.jpg"
import GlovesoftheHellWalkernm from "assets/images/items/Gloves of the Hell Walker (nm).jpg"
import GlovesoftheHellWalker from "assets/images/items/Gloves of the Hell Walker.jpg"
import GlovesoftheHuntmaster from "assets/images/items/Gloves of the Huntmaster.jpg"
import GlovesoftheLector from "assets/images/items/Gloves of the Lector.jpg"
import GlovesoftheOuterDark from "assets/images/items/Gloves of the Outer Dark.jpg"
import GlovesoftheOxmal from "assets/images/items/Gloves of the Oxmal.jpg"
import GlovesofthePrecursor from "assets/images/items/Gloves of the Precursor.jpg"
import GlovesoftheRagereaver from "assets/images/items/Gloves of the Ragereaver.jpg"
import GlovesoftheRavenflight from "assets/images/items/Gloves of the Ravenflight.jpg"
import GlovesoftheReanimator from "assets/images/items/Gloves of the Reanimator.jpg"
import GlovesoftheRevelations from "assets/images/items/Gloves of the Revelations.jpg"
import GlovesoftheRipplingLake from "assets/images/items/Gloves of the Rippling Lake.jpg"
import GlovesoftheSanguineDisciplenm from "assets/images/items/Gloves of the Sanguine Disciple (nm).jpg"
import GlovesoftheSanguineDisciple from "assets/images/items/Gloves of the Sanguine Disciple.jpg"
import GlovesoftheShiveringStars from "assets/images/items/Gloves of the Shivering Stars.jpg"
import GlovesoftheSilentSlayer from "assets/images/items/Gloves of the Silent Slayer.jpg"
import GlovesoftheStillPond from "assets/images/items/Gloves of the Still Pond.jpg"
import GlovesoftheStormbringer from "assets/images/items/Gloves of the Stormbringer.jpg"
import GlovesoftheStrangeBeyond from "assets/images/items/Gloves of the Strange Beyond.jpg"
import GlovesoftheUnslaked from "assets/images/items/Gloves of the Unslaked.jpg"
import GlovesoftheWardedBrute from "assets/images/items/Gloves of the Warded Brute.jpg"
import GlovesoftheWellsofNight from "assets/images/items/Gloves of the Wells of Night.jpg"
import GlovesoftheWhisperingBlade from "assets/images/items/Gloves of the Whispering Blade.jpg"
import GlovesofTranquility from "assets/images/items/Gloves of Tranquility.jpg"
import GlovesofTribulation from "assets/images/items/Gloves of Tribulation.jpg"
import GlovesofVehementThunder from "assets/images/items/Gloves of Vehement Thunder.jpg"
import GlovesofVengefulZeal from "assets/images/items/Gloves of Vengeful Zeal.jpg"
import GlovesofViciousFrenzy from "assets/images/items/Gloves of Vicious Frenzy.jpg"
import GlovesofVindictiveMalice from "assets/images/items/Gloves of Vindictive Malice.jpg"
import GlovesofWildFuror from "assets/images/items/Gloves of Wild Furor.jpg"
import GoldStitchedGloves from "assets/images/items/Gold-Stitched Gloves.jpg"
import GoldenRingofDexterity from "assets/images/items/Golden Ring of Dexterity.jpg"
import GoremongersArmband from "assets/images/items/Goremonger's Armband.jpg"
import GoremongersBoots from "assets/images/items/Goremonger's Boots.jpg"
import GoremongersBracers from "assets/images/items/Goremonger's Bracers.jpg"
import GoremongersGauntlets from "assets/images/items/Goremonger's Gauntlets.jpg"
import GoremongersGirdle from "assets/images/items/Goremonger's Girdle.jpg"
import GoremongersHarness from "assets/images/items/Goremonger's Harness.jpg"
import GoremongersHelm from "assets/images/items/Goremonger's Helm.jpg"
import GoremongersLeggings from "assets/images/items/Goremonger's Leggings.jpg"
import GorulgasMark from "assets/images/items/Gorulga's Mark.jpg"
import GorulgasShield from "assets/images/items/Gorulga's Shield.jpg"
import GossamerSlippers from "assets/images/items/Gossamer Slippers.jpg"
import GrandElderJerkin from "assets/images/items/Grand Elder Jerkin.jpg"
import GraspofaThousandBlossoms from "assets/images/items/Grasp of a Thousand Blossoms.jpg"
import GravecryptWristbands from "assets/images/items/Gravecrypt Wristbands.jpg"
import GreatCloakofBlessedWinds from "assets/images/items/Great Cloak of Blessed Winds.jpg"
import GreatCloakofTribalPrayers from "assets/images/items/Great Cloak of Tribal Prayers.jpg"
import GreatSwordoftheWardedBrute from "assets/images/items/Great Sword of the Warded Brute.jpg"
import GreataxeoftheCrimsonSea from "assets/images/items/Greataxe of the Crimson Sea.jpg"
import GreataxeoftheRedTide from "assets/images/items/Greataxe of the Red Tide.jpg"
import GreatshieldoftheFallenEmpire from "assets/images/items/Greatshield of the Fallen Empire.jpg"
import GreatswordoftheDeathMaster from "assets/images/items/Greatsword of the Death Master.jpg"
import GreatswordoftheFacelessChaos from "assets/images/items/Greatsword of the Faceless Chaos.jpg"
import GreavesofRedRuinnm from "assets/images/items/Greaves of Red Ruin (nm).jpg"
import GreavesofRedRuin from "assets/images/items/Greaves of Red Ruin.jpg"
import GreavesoftheFallenEmpirenm from "assets/images/items/Greaves of the Fallen Empire (nm).jpg"
import GreavesoftheFallenEmpire from "assets/images/items/Greaves of the Fallen Empire.jpg"
import GreedofShevatas from "assets/images/items/Greed of Shevatas.jpg"
import GriefscaleBoots from "assets/images/items/Griefscale Boots.jpg"
import GriefscaleHarness from "assets/images/items/Griefscale Harness.jpg"
import GriefscaleHelm from "assets/images/items/Griefscale Helm.jpg"
import GriefscaleLeggings from "assets/images/items/Griefscale Leggings.jpg"
import GrievousJamadhar from "assets/images/items/Grievous Jamadhar.jpg"
import GrimheraldChestguard from "assets/images/items/Grimherald Chestguard.jpg"
import GrimheraldHauberk from "assets/images/items/Grimherald Hauberk.jpg"
import GrimheraldJerkin from "assets/images/items/Grimherald Jerkin.jpg"
import GrimheraldRobe from "assets/images/items/Grimherald Robe.jpg"
import GrimheraldTunic from "assets/images/items/Grimherald Tunic.jpg"
import GrimjawBracers from "assets/images/items/Grimjaw Bracers.jpg"
import GrimjawGloves from "assets/images/items/Grimjaw Gloves.jpg"
import GrimjawHelm from "assets/images/items/Grimjaw Helm.jpg"
import GrimjawJerkin from "assets/images/items/Grimjaw Jerkin.jpg"
import Grimshaker from "assets/images/items/Grimshaker.jpg"
import Grimward from "assets/images/items/Grimward.jpg"
import Grimwrest from "assets/images/items/Grimwrest.jpg"
import GripsofBoneandHorn from "assets/images/items/Grips of Bone and Horn.jpg"
import GripsofErlik from "assets/images/items/Grips of Erlik.jpg"
import GripsofInsanity from "assets/images/items/Grips of Insanity.jpg"
import GripsoftheAmaranthineDrums from "assets/images/items/Grips of the Amaranthine Drums.jpg"
import GripsoftheEndlessSands from "assets/images/items/Grips of the Endless Sands.jpg"
import GripsoftheFacelessSphinx from "assets/images/items/Grips of the Faceless Sphinx.jpg"
import GripsoftheGhostoftheVeldt from "assets/images/items/Grips of the Ghost of the Veldt.jpg"
import GripsoftheGreatImpi from "assets/images/items/Grips of the Great Impi.jpg"
import GripsoftheHaunterintheDark from "assets/images/items/Grips of the Haunter in the Dark.jpg"
import GripsoftheHowlingGiant from "assets/images/items/Grips of the Howling Giant.jpg"
import GripsoftheIchorous from "assets/images/items/Grips of the Ichorous.jpg"
import GripsoftheInconceivable from "assets/images/items/Grips of the Inconceivable.jpg"
import GripsoftheMasqueroftheSands from "assets/images/items/Grips of the Masquer of the Sands.jpg"
import GripsoftheMembranous from "assets/images/items/Grips of the Membranous.jpg"
import GripsofthePrimalSpirit from "assets/images/items/Grips of the Primal Spirit.jpg"
import GripsoftheRefectory from "assets/images/items/Grips of the Refectory.jpg"
import GripsoftheSteelBehemoth from "assets/images/items/Grips of the Steel Behemoth.jpg"
import GripsoftheUbahKan from "assets/images/items/Grips of the Ubah Kan.jpg"
import GripsofWrithing from "assets/images/items/Grips of Writhing.jpg"
import GrizzlyBreeches from "assets/images/items/Grizzly Breeches.jpg"
import GrizzlyBrigandine from "assets/images/items/Grizzly Brigandine.jpg"
import GrizzlyMask from "assets/images/items/Grizzly Mask.jpg"
import GuisarmeoftheBastion from "assets/images/items/Guisarme of the Bastion.jpg"
import GunderlandBelt from "assets/images/items/Gunderland Belt.jpg"
import GunderlandBoots from "assets/images/items/Gunderland Boots.jpg"
import GunderlandBracers from "assets/images/items/Gunderland Bracers.jpg"
import GunderlandGreaves from "assets/images/items/Gunderland Greaves.jpg"
import GunderlandHelm from "assets/images/items/Gunderland Helm.jpg"
import GungSi from "assets/images/items/Gung Si.jpg"
import Gutstrap from "assets/images/items/Gutstrap.jpg"
import GyassConduit from "assets/images/items/Gyas's Conduit.jpg"
import GyassFetters from "assets/images/items/Gyas's Fetters.jpg"
import GyreoftheCloudcleaver from "assets/images/items/Gyre of the Cloudcleaver.jpg"
import GyreoftheJudgmentBolt from "assets/images/items/Gyre of the Judgment Bolt.jpg"
import GyreoftheRiftcaller from "assets/images/items/Gyre of the Riftcaller.jpg"
import GyreoftheSunderedSkies from "assets/images/items/Gyre of the Sundered Skies.jpg"
import HalberdoftheArchaeologian from "assets/images/items/Halberd of the Archaeologian.jpg"
import HalberdoftheOstiary from "assets/images/items/Halberd of the Ostiary.jpg"
import HallowedRingofDivineBlessings from "assets/images/items/Hallowed Ring of Divine Blessings.jpg"
import HammerofDreams from "assets/images/items/Hammer of Dreams.jpg"
import HammerofLambentFervor from "assets/images/items/Hammer of Lambent Fervor.jpg"
import HammerofPrimalWrath from "assets/images/items/Hammer of Primal Wrath.jpg"
import HammerofSolemnVows from "assets/images/items/Hammer of Solemn Vows.jpg"
import HammeroftheArenaVictor from "assets/images/items/Hammer of the Arena Victor.jpg"
import HammeroftheHowlingGiant from "assets/images/items/Hammer of the Howling Giant.jpg"
import HammeroftheLivingTarim from "assets/images/items/Hammer of the Living Tarim.jpg"
import HammeroftheRhinoRider from "assets/images/items/Hammer of the Rhino Rider.jpg"
import HammeroftheSanguineDisciple from "assets/images/items/Hammer of the Sanguine Disciple.jpg"
import HammeroftheVoid from "assets/images/items/Hammer of the Void.jpg"
import HandwrapsoftheCrawlingChaos from "assets/images/items/Hand-wraps of the Crawling Chaos.jpg"
import HandwrapsoftheFacelessChaos from "assets/images/items/Hand-wraps of the Faceless Chaos.jpg"
import HandwrapsoftheFacelessSphinx from "assets/images/items/Hand-wraps of the Faceless Sphinx.jpg"
import HandwrapsoftheHaunterintheDark from "assets/images/items/Hand-wraps of the Haunter in the Dark.jpg"
import HandwrapsoftheNebulous from "assets/images/items/Hand-wraps of the Nebulous.jpg"
import HandwrapsoftheOxmal from "assets/images/items/Hand-wraps of the Oxmal.jpg"
import HandwrapsoftheSepulcher from "assets/images/items/Hand-wraps of the Sepulcher.jpg"
import HandwrapsoftheShiveringStars from "assets/images/items/Hand-wraps of the Shivering Stars.jpg"
import HandwrapsoftheSpheres from "assets/images/items/Hand-wraps of the Spheres.jpg"
import HandwrapsoftheUnutterable from "assets/images/items/Hand-wraps of the Unutterable.jpg"
import HandguardofJaggedBarbs from "assets/images/items/Handguard of Jagged Barbs.jpg"
import HandguardsofArdentFire from "assets/images/items/Handguards of Ardent Fire.jpg"
import HandguardsofClawingMight from "assets/images/items/Handguards of Clawing Might.jpg"
import HandguardsofConflagrantFlame from "assets/images/items/Handguards of Conflagrant Flame.jpg"
import HandguardsofInfernalZeal from "assets/images/items/Handguards of Infernal Zeal.jpg"
import HandguardsoftheEternalBlaze from "assets/images/items/Handguards of the Eternal Blaze.jpg"
import HandguardsoftheFuriousSwipe from "assets/images/items/Handguards of the Furious Swipe.jpg"
import HandguardsoftheSavageFang from "assets/images/items/Handguards of the Savage Fang.jpg"
import HandguardsofVernantFury from "assets/images/items/Handguards of Vernant Fury.jpg"
import HarbingerofAcheron from "assets/images/items/Harbinger of Acheron.jpg"
import HarbingerofDyingBreaths from "assets/images/items/Harbinger of Dying Breaths.jpg"
import HarbingerofLamentation from "assets/images/items/Harbinger of Lamentation.jpg"
import HarlotsBow from "assets/images/items/Harlot's Bow.jpg"
import HarlotsCrossbow from "assets/images/items/Harlot's Crossbow.jpg"
import HarlotsStiletto from "assets/images/items/Harlot's Stiletto.jpg"
import HarnessofBestialRage from "assets/images/items/Harness of Bestial Rage.jpg"
import HarnessofBristlingIre from "assets/images/items/Harness of Bristling Ire.jpg"
import HarnessofBrutalCarnage from "assets/images/items/Harness of Brutal Carnage.jpg"
import HarnessofClarity from "assets/images/items/Harness of Clarity.jpg"
import HarnessofErlik from "assets/images/items/Harness of Erlik.jpg"
import HarnessofFerineAnger from "assets/images/items/Harness of Ferine Anger.jpg"
import HarnessofInsanity from "assets/images/items/Harness of Insanity.jpg"
import HarnessofJaggedBarbs from "assets/images/items/Harness of Jagged Barbs.jpg"
import HarnessofQuilledDarts from "assets/images/items/Harness of Quilled Darts.jpg"
import HarnessofRapturousBattle from "assets/images/items/Harness of Rapturous Battle.jpg"
import HarnessofRighteousSmiting from "assets/images/items/Harness of Righteous Smiting.jpg"
import HarnessoftheBerserkersFury from "assets/images/items/Harness of the Berserker's Fury.jpg"
import HarnessoftheBloodDrinkernm from "assets/images/items/Harness of the Blood Drinker (nm).jpg"
import HarnessoftheBloodDrinker from "assets/images/items/Harness of the Blood Drinker.jpg"
import HarnessoftheDeathstalker from "assets/images/items/Harness of the Deathstalker.jpg"
import HarnessoftheHaunterintheDark from "assets/images/items/Harness of the Haunter in the Dark.jpg"
import HarnessoftheHowlingGiant from "assets/images/items/Harness of the Howling Giant.jpg"
import HarnessoftheIchorus from "assets/images/items/Harness of the Ichorus.jpg"
import HarnessoftheInconceivable from "assets/images/items/Harness of the Inconceivable.jpg"
import HarnessoftheKozakSlayer from "assets/images/items/Harness of the Kozak Slayer.jpg"
import HarnessoftheMembranous from "assets/images/items/Harness of the Membranous.jpg"
import HarnessoftheRagereaver from "assets/images/items/Harness of the Ragereaver.jpg"
import HarnessoftheRavenflight from "assets/images/items/Harness of the Ravenflight.jpg"
import HarnessoftheRefectory from "assets/images/items/Harness of the Refectory.jpg"
import HarnessoftheSavageSlaughter from "assets/images/items/Harness of the Savage Slaughter.jpg"
import HarnessoftheStormbringer from "assets/images/items/Harness of the Stormbringer.jpg"
import HarnessoftheSwiftTalon from "assets/images/items/Harness of the Swift Talon.jpg"
import HarnessoftheUbahKan from "assets/images/items/Harness of the Ubah Kan.jpg"
import HarnessofTribulation from "assets/images/items/Harness of Tribulation.jpg"
import HarnessofUnrest from "assets/images/items/Harness of Unrest.jpg"
import HarnessofUntamedViolence from "assets/images/items/Harness of Untamed Violence.jpg"
import HarnessofVehementThunder from "assets/images/items/Harness of Vehement Thunder.jpg"
import HarnessofVengefulZeal from "assets/images/items/Harness of Vengeful Zeal.jpg"
import HarnessofViciousFrenzy from "assets/images/items/Harness of Vicious Frenzy.jpg"
import HarnessofViolentRage from "assets/images/items/Harness of Violent Rage.jpg"
import HarnessofWildFuror from "assets/images/items/Harness of Wild Furor.jpg"
import HarnessofWrithing from "assets/images/items/Harness of Writhing.jpg"
import Harrow from "assets/images/items/Harrow.jpg"
import HatoftheRipplingLake from "assets/images/items/Hat of the Rippling Lake.jpg"
import HatefreezeRing from "assets/images/items/Hatefreeze Ring.jpg"
import HatelessStrikes from "assets/images/items/Hateless Strikes.jpg"
import HauberkofSwiftstriking from "assets/images/items/Hauberk of Swiftstriking.jpg"
import HauberkoftheFarseeker from "assets/images/items/Hauberk of the Farseeker.jpg"
import HauberkoftheHuntmaster from "assets/images/items/Hauberk of the Huntmaster.jpg"
import Hawksight from "assets/images/items/Hawksight.jpg"
import HeadbandoftheKozakSlayer from "assets/images/items/Headband of the Kozak Slayer.jpg"
import HeaddressofBedlam from "assets/images/items/Headdress of Bedlam.jpg"
import HeaddressofLunacy from "assets/images/items/Headdress of Lunacy.jpg"
import HeaddressoftheAmaranthineDrums from "assets/images/items/Headdress of the Amaranthine Drums.jpg"
import HeaddressoftheBloodGodnm from "assets/images/items/Headdress of the Blood God (nm).jpg"
import HeaddressoftheBloodGod from "assets/images/items/Headdress of the Blood God.jpg"
import HeaddressoftheBlueSeaFemaleVersion from "assets/images/items/Headdress of the Blue Sea (Female Version).jpg"
import HeaddressoftheBlueSeaMaleVersion from "assets/images/items/Headdress of the Blue Sea (Male Version).jpg"
import HeaddressoftheCrawlingChaos from "assets/images/items/Headdress of the Crawling Chaos.jpg"
import HeaddressoftheEarthMother from "assets/images/items/Headdress of the Earth Mother.jpg"
import HeaddressoftheGrandMonarch from "assets/images/items/Headdress of the Grand Monarch.jpg"
import HeaddressoftheHellWalkernm from "assets/images/items/Headdress of the Hell Walker (nm).jpg"
import HeaddressoftheHellWalker from "assets/images/items/Headdress of the Hell Walker.jpg"
import HeaddressoftheRevelations from "assets/images/items/Headdress of the Revelations.jpg"
import HeaddressoftheSanguineDisciplenm from "assets/images/items/Headdress of the Sanguine Disciple (nm).jpg"
import HeaddressoftheSanguineDisciple from "assets/images/items/Headdress of the Sanguine Disciple.jpg"
import HeaddressoftheWellsofNight from "assets/images/items/Headdress of the Wells of Night.jpg"
import HeartofAtali from "assets/images/items/Heart of Atali.jpg"
import HeartofPashtun from "assets/images/items/Heart of Pashtun.jpg"
import HeartcrusherGrips from "assets/images/items/Heartcrusher Grips.jpg"
import HeartgirthGirdle from "assets/images/items/Heartgirth Girdle.jpg"
import HeartstrikeArrows from "assets/images/items/Heartstrike Arrows.jpg"
import HeaterShieldoftheFallenEmpire from "assets/images/items/Heater-Shield of the Fallen Empire.jpg"
import HeavenCrackerEarthBreaker from "assets/images/items/Heaven Cracker Earth Breaker.jpg"
import HeavenCrackerSoulSunderer from "assets/images/items/Heaven Cracker Soul Sunderer.jpg"
import HeavensBuchae from "assets/images/items/Heaven's Buchae.jpg"
import HeavensChang from "assets/images/items/Heaven's Chang.jpg"
import HeavensDanSangGum from "assets/images/items/Heaven's Dan Sang Gum.jpg"
import HeavensDangPa from "assets/images/items/Heaven's Dang Pa.jpg"
import HeavensDoKki from "assets/images/items/Heaven's Do Kki.jpg"
import HeavensGungSi from "assets/images/items/Heaven's Gung Si.jpg"
import HeavensJangBong from "assets/images/items/Heaven's Jang Bong.jpg"
import HeavensJangGum from "assets/images/items/Heaven's Jang Gum.jpg"
import HeavensJangSsangGum from "assets/images/items/Heaven's Jang Ssang Gum.jpg"
import HeavensJiPangEe from "assets/images/items/Heaven's Ji Pang-Ee.jpg"
import HeavensKalGum from "assets/images/items/Heaven's Kal Gum.jpg"
import HeavensTorment from "assets/images/items/Heaven's Torment.jpg"
import HeavensWolDo from "assets/images/items/Heaven's Wol Do.jpg"
import HeavenlyRain from "assets/images/items/Heavenly Rain.jpg"
import HeavenlyRepeater from "assets/images/items/Heavenly Repeater.jpg"
import HeavyJovianCape from "assets/images/items/Heavy Jovian Cape.jpg"
import HeklarsAccurstDagger from "assets/images/items/Hek'lar's Accurst Dagger.jpg"
import HeklarsCloak from "assets/images/items/Hek'lar's Cloak.jpg"
import Hellfire from "assets/images/items/Hellfire.jpg"
import HellfuryArmbands from "assets/images/items/Hellfury Armbands.jpg"
import HellfuryRobe from "assets/images/items/Hellfury Robe.jpg"
import HellfuryWristbands from "assets/images/items/Hellfury Wristbands.jpg"
import HellspawnedWristguard from "assets/images/items/Hellspawned Wristguard.jpg"
import HelmofArdentFire from "assets/images/items/Helm of Ardent Fire.jpg"
import HelmofBalefulBlood from "assets/images/items/Helm of Baleful Blood.jpg"
import HelmofBlackOblivion from "assets/images/items/Helm of Black Oblivion.jpg"
import HelmofBlackSpite from "assets/images/items/Helm of Black Spite.jpg"
import HelmofBloodlust from "assets/images/items/Helm of Bloodlust.jpg"
import HelmofBrutalCarnage from "assets/images/items/Helm of Brutal Carnage.jpg"
import HelmofCelestialRadiance from "assets/images/items/Helm of Celestial Radiance.jpg"
import HelmofClarity from "assets/images/items/Helm of Clarity.jpg"
import HelmofClawingMight from "assets/images/items/Helm of Clawing Might.jpg"
import HelmofConflagrantFlame from "assets/images/items/Helm of Conflagrant Flame.jpg"
import HelmofCourageousSouls from "assets/images/items/Helm of Courageous Souls.jpg"
import HelmofDarkTerror from "assets/images/items/Helm of Dark Terror.jpg"
import HelmofEffulgentDevotion from "assets/images/items/Helm of Effulgent Devotion.jpg"
import HelmofErlik from "assets/images/items/Helm of Erlik.jpg"
import HelmofFearlessSouls from "assets/images/items/Helm of Fearless Souls.jpg"
import HelmofFerineAnger from "assets/images/items/Helm of Ferine Anger.jpg"
import HelmofFlowingWater from "assets/images/items/Helm of Flowing Water.jpg"
import HelmofHeroicSoul from "assets/images/items/Helm of Heroic Soul.jpg"
import HelmofIlluminantConviction from "assets/images/items/Helm of Illuminant Conviction.jpg"
import HelmofIndomitableSouls from "assets/images/items/Helm of Indomitable Souls.jpg"
import HelmofIndra from "assets/images/items/Helm of Indra.jpg"
import HelmofInfernalZeal from "assets/images/items/Helm of Infernal Zeal.jpg"
import HelmofInsanity from "assets/images/items/Helm of Insanity.jpg"
import HelmofIntricateSpite from "assets/images/items/Helm of Intricate Spite.jpg"
import HelmofNecroticDread from "assets/images/items/Helm of Necrotic Dread.jpg"
import HelmofPandemonium from "assets/images/items/Helm of Pandemonium.jpg"
import HelmofRapturousBattle from "assets/images/items/Helm of Rapturous Battle.jpg"
import HelmofRecklessChallenge from "assets/images/items/Helm of Reckless Challenge.jpg"
import HelmofRighteousSmiting from "assets/images/items/Helm of Righteous Smiting.jpg"
import HelmofShatteredExistance from "assets/images/items/Helm of Shattered Existance.jpg"
import HelmofSwiftstriking from "assets/images/items/Helm of Swiftstriking.jpg"
import HelmoftheAscension from "assets/images/items/Helm of the Ascension.jpg"
import HelmoftheAssailant from "assets/images/items/Helm of the Assailant.jpg"
import HelmoftheAtlantean from "assets/images/items/Helm of the Atlantean.jpg"
import HelmoftheBerserkersFury from "assets/images/items/Helm of the Berserker's Fury.jpg"
import HelmoftheBeyond from "assets/images/items/Helm of the Beyond.jpg"
import HelmoftheBlackDragon from "assets/images/items/Helm of the Black Dragon.jpg"
import HelmoftheBlackPharaoh from "assets/images/items/Helm of the Black Pharaoh.jpg"
import HelmoftheBlackWarden from "assets/images/items/Helm of the Black Warden.jpg"
import HelmoftheBloodDrinkernm from "assets/images/items/Helm of the Blood Drinker (nm).jpg"
import HelmoftheBloodDrinker from "assets/images/items/Helm of the Blood Drinker.jpg"
import HelmoftheBloodmoon from "assets/images/items/Helm of the Bloodmoon.jpg"
import HelmoftheChaosAgent from "assets/images/items/Helm of the Chaos Agent.jpg"
import HelmoftheCrimsonFort from "assets/images/items/Helm of the Crimson Fort.jpg"
import HelmoftheDarkMessenger from "assets/images/items/Helm of the Dark Messenger.jpg"
import HelmoftheDauntless from "assets/images/items/Helm of the Dauntless.jpg"
import HelmoftheDeathstalker from "assets/images/items/Helm of the Deathstalker.jpg"
import HelmoftheDefiant from "assets/images/items/Helm of the Defiant.jpg"
import HelmoftheEcliptic from "assets/images/items/Helm of the Ecliptic.jpg"
import HelmoftheEternalBlaze from "assets/images/items/Helm of the Eternal Blaze.jpg"
import HelmoftheFallenEmpirenm from "assets/images/items/Helm of the Fallen Empire (nm).jpg"
import HelmoftheFallenEmpire from "assets/images/items/Helm of the Fallen Empire.jpg"
import HelmoftheFarseeker from "assets/images/items/Helm of the Farseeker.jpg"
import HelmoftheFirebrand from "assets/images/items/Helm of the Firebrand.jpg"
import HelmoftheFirstCircle from "assets/images/items/Helm of the First Circle.jpg"
import HelmoftheForsaken from "assets/images/items/Helm of the Forsaken.jpg"
import HelmoftheFuriousSwipe from "assets/images/items/Helm of the Furious Swipe.jpg"
import HelmoftheHowlingGiant from "assets/images/items/Helm of the Howling Giant.jpg"
import HelmoftheHuntmaster from "assets/images/items/Helm of the Huntmaster.jpg"
import HelmoftheIchorous from "assets/images/items/Helm of the Ichorous.jpg"
import HelmoftheInconceivable from "assets/images/items/Helm of the Inconceivable.jpg"
import HelmoftheInvincible from "assets/images/items/Helm of the Invincible.jpg"
import HelmoftheLivingTarim from "assets/images/items/Helm of the Living Tarim.jpg"
import HelmoftheMartialParagon from "assets/images/items/Helm of the Martial Paragon.jpg"
import HelmoftheMembranous from "assets/images/items/Helm of the Membranous.jpg"
import HelmoftheMilitesTempli from "assets/images/items/Helm of the Milites Templi.jpg"
import HelmoftheOstiary from "assets/images/items/Helm of the Ostiary.jpg"
import HelmoftheOxmal from "assets/images/items/Helm of the Oxmal.jpg"
import HelmofthePainlegion from "assets/images/items/Helm of the Painlegion.jpg"
import HelmofthePrimalSpirit from "assets/images/items/Helm of the Primal Spirit.jpg"
import HelmoftheProvenChampion from "assets/images/items/Helm of the Proven Champion.jpg"
import HelmoftheRagereaver from "assets/images/items/Helm of the Ragereaver.jpg"
import HelmoftheRefectory from "assets/images/items/Helm of the Refectory.jpg"
import HelmoftheRenegade from "assets/images/items/Helm of the Renegade.jpg"
import HelmoftheRevelationsofTarim from "assets/images/items/Helm of the Revelations of Tarim.jpg"
import HelmoftheSavageFang from "assets/images/items/Helm of the Savage Fang.jpg"
import HelmoftheSavageSlaughter from "assets/images/items/Helm of the Savage Slaughter.jpg"
import HelmoftheScatteredGods from "assets/images/items/Helm of the Scattered Gods.jpg"
import HelmoftheShiveringStars from "assets/images/items/Helm of the Shivering Stars.jpg"
import HelmoftheSteelBehemoth from "assets/images/items/Helm of the Steel Behemoth.jpg"
import HelmoftheStormbringer from "assets/images/items/Helm of the Stormbringer.jpg"
import HelmoftheTirelessDefender from "assets/images/items/Helm of the Tireless Defender.jpg"
import HelmoftheTormentor from "assets/images/items/Helm of the Tormentor.jpg"
import HelmoftheTriumphant from "assets/images/items/Helm of the Triumphant.jpg"
import HelmoftheUbahKan from "assets/images/items/Helm of the Ubah Kan.jpg"
import HelmoftheUnholyCommunion from "assets/images/items/Helm of the Unholy Communion.jpg"
import HelmoftheUsurper from "assets/images/items/Helm of the Usurper.jpg"
import HelmoftheValiant from "assets/images/items/Helm of the Valiant.jpg"
import HelmoftheVanguard from "assets/images/items/Helm of the Vanguard.jpg"
import HelmoftheVictoriousElite from "assets/images/items/Helm of the Victorious Elite.jpg"
import HelmoftheWailing from "assets/images/items/Helm of the Wailing.jpg"
import HelmoftheWicked from "assets/images/items/Helm of the Wicked.jpg"
import HelmofTranquility from "assets/images/items/Helm of Tranquility.jpg"
import HelmofTribulation from "assets/images/items/Helm of Tribulation.jpg"
import HelmofUnrest from "assets/images/items/Helm of Unrest.jpg"
import HelmofUntamedViolence from "assets/images/items/Helm of Untamed Violence.jpg"
import HelmofVehementThunder from "assets/images/items/Helm of Vehement Thunder.jpg"
import HelmofVengefulZeal from "assets/images/items/Helm of Vengeful Zeal.jpg"
import HelmofVernantFury from "assets/images/items/Helm of Vernant Fury.jpg"
import HelmofViciousFrenzy from "assets/images/items/Helm of Vicious Frenzy.jpg"
import HelmofViolentRage from "assets/images/items/Helm of Violent Rage.jpg"
import HelmofWildFuror from "assets/images/items/Helm of Wild Furor.jpg"
import HelmofWrithing from "assets/images/items/Helm of Writhing.jpg"
import HerosChestguard from "assets/images/items/Hero's Chestguard.jpg"
import HerosClanBlade from "assets/images/items/Hero's Clan Blade.jpg"
import HerosHauberk from "assets/images/items/Hero's Hauberk.jpg"
import HerosHellglaive from "assets/images/items/Hero's Hellglaive.jpg"
import HerosJerkin from "assets/images/items/Hero's Jerkin.jpg"
import HerosTunic from "assets/images/items/Hero's Tunic.jpg"
import HerokingsBreastplate from "assets/images/items/Heroking's Breastplate.jpg"
import HighPriestsNecklace from "assets/images/items/High Priest's Necklace.jpg"
import HighPriestsRingofDexterity from "assets/images/items/High Priest's Ring of Dexterity.jpg"
import HighPriestsRingofIntelligence from "assets/images/items/High Priest's Ring of Intelligence.jpg"
import HighPriestsRingofStrength from "assets/images/items/High Priest's Ring of Strength.jpg"
import HighPriestsRingofWisdom from "assets/images/items/High Priest's Ring of Wisdom.jpg"
import HighProtectorsTasset from "assets/images/items/High Protector's Tasset.jpg"
import HighlordsArrows from "assets/images/items/Highlord's Arrows.jpg"
import HighlordsAxe from "assets/images/items/Highlord's Axe.jpg"
import HighlordsBandofForce from "assets/images/items/Highlord's Band of Force.jpg"
import HighlordsBandofPower from "assets/images/items/Highlord's Band of Power.jpg"
import HighlordsBandofSlaughter from "assets/images/items/Highlord's Band of Slaughter.jpg"
import HighlordsBandofSwirlingMist from "assets/images/items/Highlord's Band of Swirling Mist.jpg"
import HighlordsBlade from "assets/images/items/Highlord's Blade.jpg"
import HighlordsBolts from "assets/images/items/Highlord's Bolts.jpg"
import HighlordsClaspofForce from "assets/images/items/Highlord's Clasp of Force.jpg"
import HighlordsCloakofCinders from "assets/images/items/Highlord's Cloak of Cinders.jpg"
import HighlordsCloakofForce from "assets/images/items/Highlord's Cloak of Force.jpg"
import HighlordsCloakofPower from "assets/images/items/Highlord's Cloak of Power.jpg"
import HighlordsCloakofShielding from "assets/images/items/Highlord's Cloak of Shielding.jpg"
import HighlordsCloakofSwirlingMist from "assets/images/items/Highlord's Cloak of Swirling Mist.jpg"
import HighlordsCrossbow from "assets/images/items/Highlord's Crossbow.jpg"
import HighlordsDirk from "assets/images/items/Highlord's Dirk.jpg"
import HighlordsGreatShield from "assets/images/items/Highlord's Great Shield.jpg"
import HighlordsGreatbow from "assets/images/items/Highlord's Greatbow.jpg"
import HighlordsGreatsword from "assets/images/items/Highlord's Greatsword.jpg"
import HighlordsKrys from "assets/images/items/Highlord's Krys.jpg"
import HighlordsMace from "assets/images/items/Highlord's Mace.jpg"
import HighlordsMarkofAbhorrence from "assets/images/items/Highlord's Mark of Abhorrence.jpg"
import HighlordsMaximofEntropy from "assets/images/items/Highlord's Maxim of Entropy.jpg"
import HighlordsPendantofFluidity from "assets/images/items/Highlord's Pendant of Fluidity.jpg"
import HighlordsPendantofPower from "assets/images/items/Highlord's Pendant of Power.jpg"
import HighlordsPendantofShielding from "assets/images/items/Highlord's Pendant of Shielding.jpg"
import HighlordsPendantofWisdom from "assets/images/items/Highlord's Pendant of Wisdom.jpg"
import HighlordsSanctum from "assets/images/items/Highlord's Sanctum.jpg"
import HighlordsScepter from "assets/images/items/Highlord's Scepter.jpg"
import HighlordsSpellGlaive from "assets/images/items/Highlord's Spell Glaive.jpg"
import HighlordsSpellsword from "assets/images/items/Highlord's Spellsword.jpg"
import HighlordsStaff from "assets/images/items/Highlord's Staff.jpg"
import HighlordsWarGlaive from "assets/images/items/Highlord's War Glaive.jpg"
import HighlordsWarMaul from "assets/images/items/Highlord's War Maul.jpg"
import HiveBludgeon from "assets/images/items/Hive Bludgeon.jpg"
import HiveHammer from "assets/images/items/Hive Hammer.jpg"
import HiveHasta from "assets/images/items/Hive Hasta.jpg"
import HiveKhopesh from "assets/images/items/Hive Khopesh.jpg"
import HonorsFocus from "assets/images/items/Honor's Focus.jpg"
import HonoredArmbandsoftheFourWinds from "assets/images/items/Honored Armbands of the Four Winds.jpg"
import HonoredBeltoftheFarHorizon from "assets/images/items/Honored Belt of the Far Horizon.jpg"
import HonoredBeltoftheMound from "assets/images/items/Honored Belt of the Mound.jpg"
import HonoredBeltofthePlains from "assets/images/items/Honored Belt of the Plains.jpg"
import HonoredBootsoftheAncestors from "assets/images/items/Honored Boots of the Ancestors.jpg"
import HonoredBootsoftheGoldenHorde from "assets/images/items/Honored Boots of the Golden Horde.jpg"
import HonoredBootsoftheGreensward from "assets/images/items/Honored Boots of the Greensward.jpg"
import HonoredBracersoftheGoldenHorde from "assets/images/items/Honored Bracers of the Golden Horde.jpg"
import HonoredBracersoftheGreensward from "assets/images/items/Honored Bracers of the Greensward.jpg"
import HonoredFauldoftheFarHorizon from "assets/images/items/Honored Fauld of the Far Horizon.jpg"
import HonoredFauldoftheMound from "assets/images/items/Honored Fauld of the Mound.jpg"
import HonoredGauntletsoftheFarHorizon from "assets/images/items/Honored Gauntlets of the Far Horizon.jpg"
import HonoredGauntletsoftheFourWinds from "assets/images/items/Honored Gauntlets of the Four Winds.jpg"
import HonoredGirdleoftheFourWinds from "assets/images/items/Honored Girdle of the Four Winds.jpg"
import HonoredGlovesoftheMound from "assets/images/items/Honored Gloves of the Mound.jpg"
import HonoredGlovesofthePlains from "assets/images/items/Honored Gloves of the Plains.jpg"
import HonoredGreavesoftheSevenSuns from "assets/images/items/Honored Greaves of the Seven Suns.jpg"
import HonoredHarnessoftheEverlastingSky from "assets/images/items/Honored Harness of the Everlasting Sky.jpg"
import HonoredHauberkofPassingSpirits from "assets/images/items/Honored Hauberk of Passing Spirits.jpg"
import HonoredHelmofPassingSpirits from "assets/images/items/Honored Helm of Passing Spirits.jpg"
import HonoredHelmoftheClans from "assets/images/items/Honored Helm of the Clans.jpg"
import HonoredHelmoftheEverlastingSky from "assets/images/items/Honored Helm of the Everlasting Sky.jpg"
import HonoredHelmoftheTribes from "assets/images/items/Honored Helm of the Tribes.jpg"
import HonoredJerkinoftheClans from "assets/images/items/Honored Jerkin of the Clans.jpg"
import HonoredJerkinoftheTribes from "assets/images/items/Honored Jerkin of the Tribes.jpg"
import HonoredLeggingsoftheFourWinds from "assets/images/items/Honored Leggings of the Four Winds.jpg"
import HonoredLegguardsofthePlains from "assets/images/items/Honored Legguards of the Plains.jpg"
import HonoredStrapsoftheFarHorizon from "assets/images/items/Honored Straps of the Far Horizon.jpg"
import HonoredStrapsoftheMound from "assets/images/items/Honored Straps of the Mound.jpg"
import HonoredStrapsofthePlains from "assets/images/items/Honored Straps of the Plains.jpg"
import HonoredVambracesoftheAncestors from "assets/images/items/Honored Vambraces of the Ancestors.jpg"
import HonoredVambracesoftheSevenSuns from "assets/images/items/Honored Vambraces of the Seven Suns.jpg"
import HoodofBlackWhispers from "assets/images/items/Hood of Black Whispers.jpg"
import HoodofConcealingShadows from "assets/images/items/Hood of Concealing Shadows.jpg"
import HoodofDarkMalice from "assets/images/items/Hood of Dark Malice.jpg"
import HoodofDeadlyGuile from "assets/images/items/Hood of Deadly Guile.jpg"
import HoodofEndlessNight from "assets/images/items/Hood of Endless Night.jpg"
import HoodofFiendishInvocation from "assets/images/items/Hood of Fiendish Invocation.jpg"
import HoodofHaloga from "assets/images/items/Hood of Haloga.jpg"
import HoodofJaggedBarbs from "assets/images/items/Hood of Jagged Barbs.jpg"
import HoodofQuilledDarts from "assets/images/items/Hood of Quilled Darts.jpg"
import HoodoftheClay from "assets/images/items/Hood of the Clay.jpg"
import HoodoftheDoomsayer from "assets/images/items/Hood of the Doomsayer.jpg"
import HoodoftheExorcist from "assets/images/items/Hood of the Exorcist.jpg"
import HoodoftheFacelessChaos from "assets/images/items/Hood of the Faceless Chaos.jpg"
import HoodoftheFacelessSphinx from "assets/images/items/Hood of the Faceless Sphinx.jpg"
import HoodoftheLector from "assets/images/items/Hood of the Lector.jpg"
import HoodoftheMerciless from "assets/images/items/Hood of the Merciless.jpg"
import HoodofthePutrescent from "assets/images/items/Hood of the Putrescent.jpg"
import HoodoftheRavenflight from "assets/images/items/Hood of the Ravenflight.jpg"
import HoodoftheSilentSlayer from "assets/images/items/Hood of the Silent Slayer.jpg"
import HoodoftheSwiftTalon from "assets/images/items/Hood of the Swift Talon.jpg"
import HoodoftheUsurper from "assets/images/items/Hood of the Usurper.jpg"
import HoodoftheWhisperingBlade from "assets/images/items/Hood of the Whispering Blade.jpg"
import HoodofVindictiveMalice from "assets/images/items/Hood of Vindictive Malice.jpg"
import HoovesoftheWardedBrute from "assets/images/items/Hooves of the Warded Brute.jpg"
import HornoftheWardedBrute from "assets/images/items/Horn of the Warded Brute.jpg"
import HornsoftheDarkwretch from "assets/images/items/Horns of the Darkwretch.jpg"
import HornsoftheEndlessSands from "assets/images/items/Horns of the Endless Sands.jpg"
import HornsoftheReanimator from "assets/images/items/Horns of the Reanimator.jpg"
import HorsehairBlanket from "assets/images/items/Horsehair Blanket.jpg"
import HousekarlsPledge from "assets/images/items/Housekarl's Pledge.jpg"
import HowlofthePack from "assets/images/items/Howl of the Pack.jpg"
import Howler from "assets/images/items/Howler.jpg"
import Hunger from "assets/images/items/Hunger.jpg"
import HyrkanianBitterWindBiter from "assets/images/items/Hyrkanian Bitter Wind-Biter.jpg"
import HyrkanianDreadAshTramper from "assets/images/items/Hyrkanian Dread Ash-Tramper.jpg"
import HyrkanianFleetScreamCatcher from "assets/images/items/Hyrkanian Fleet Scream-Catcher.jpg"
import HyrkanianGrimSkullTreader from "assets/images/items/Hyrkanian Grim Skull-Treader.jpg"
import HyrkanianPaleGhostChaser from "assets/images/items/Hyrkanian Pale Ghost-Chaser.jpg"
import HyrkanianResplendentSunStrider from "assets/images/items/Hyrkanian Resplendent Sun-Strider.jpg"
import HyrkanianSableShadowDasher from "assets/images/items/Hyrkanian Sable Shadow-Dasher.jpg"
import HyrkanianTwilightVoidRacer from "assets/images/items/Hyrkanian Twilight Void Racer.jpg"
import HyrkanianWickedChaosClapper from "assets/images/items/Hyrkanian Wicked Chaos-Clapper.jpg"
import Icestrike from "assets/images/items/Icestrike.jpg"
import Icethorn from "assets/images/items/Icethorn.jpg"
import IconoftheBloodGod from "assets/images/items/Icon of the Blood God.jpg"
import IconoclastsCrown from "assets/images/items/Iconoclast's Crown.jpg"
import Ieb from "assets/images/items/Ieb.jpg"
import IlluminatingAtlanteanCatalyst from "assets/images/items/Illuminating Atlantean Catalyst.jpg"
import IllusionistsLongsword from "assets/images/items/Illusionist's Longsword.jpg"
import IllusionistsStaff from "assets/images/items/Illusionist's Staff.jpg"
import ImmemorialChain from "assets/images/items/Immemorial Chain.jpg"
import ImpenetrableLegguards from "assets/images/items/Impenetrable Legguards.jpg"
import ImpenetrableWordofValka from "assets/images/items/Impenetrable Word of Valka.jpg"
import ImperialAcheronianHalberd from "assets/images/items/Imperial Acheronian Halberd.jpg"
import ImperialBluesteelSlaughterSteed from "assets/images/items/Imperial Bluesteel Slaughter Steed.jpg"
import ImperialBronzesteelSlaughterSteed from "assets/images/items/Imperial Bronzesteel Slaughter Steed.jpg"
import ImperialRedsteelSlaughterSteed from "assets/images/items/Imperial Redsteel Slaughter Steed.jpg"
import ImperviousTasset from "assets/images/items/Impervious Tasset.jpg"
import ImpiousWristbands from "assets/images/items/Impious Wristbands.jpg"
import IncandescentCane from "assets/images/items/Incandescent Cane.jpg"
import IncursionShroud from "assets/images/items/Incursion Shroud.jpg"
import InfernalMantleoftheLivingLegend from "assets/images/items/Infernal Mantle of the Living Legend.jpg"
import IniquitousSkullcap from "assets/images/items/Iniquitous Skullcap.jpg"
import InitiatesArmstrapsoftheHeavens from "assets/images/items/Initiate's Arm-straps of the Heavens.jpg"
import InitiatesArmstrapsoftheWaningMoon from "assets/images/items/Initiate's Arm-straps of the Waning Moon.jpg"
import InitiatesArmbandsoftheEternalEclipse from "assets/images/items/Initiate's Armbands of the Eternal Eclipse.jpg"
import InitiatesArmbandsoftheForbiddenArt from "assets/images/items/Initiate's Armbands of the Forbidden Art.jpg"
import InitiatesBandsoftheMoon from "assets/images/items/Initiate's Bands of the Moon.jpg"
import InitiatesBeltoftheCelestialHilt from "assets/images/items/Initiate's Belt of the Celestial Hilt.jpg"
import InitiatesBeltoftheExiled from "assets/images/items/Initiate's Belt of the Exiled.jpg"
import InitiatesBeltofTwiningSmoke from "assets/images/items/Initiate's Belt of Twining Smoke.jpg"
import InitiatesBootsoftheBurningDisc from "assets/images/items/Initiate's Boots of the Burning Disc.jpg"
import InitiatesBootsoftheEffulgentBlade from "assets/images/items/Initiate's Boots of the Effulgent Blade.jpg"
import InitiatesBootsoftheMoon from "assets/images/items/Initiate's Boots of the Moon.jpg"
import InitiatesBracersoftheBurningDisc from "assets/images/items/Initiate's Bracers of the Burning Disc.jpg"
import InitiatesCordofAwakening from "assets/images/items/Initiate's Cord of Awakening.jpg"
import InitiatesCowloftheMoon from "assets/images/items/Initiate's Cowl of the Moon.jpg"
import InitiatesGlovesofAwakening from "assets/images/items/Initiate's Gloves of Awakening.jpg"
import InitiatesGlovesoftheCelestialHilt from "assets/images/items/Initiate's Gloves of the Celestial Hilt.jpg"
import InitiatesGlovesoftheExiled from "assets/images/items/Initiate's Gloves of the Exiled.jpg"
import InitiatesGlovesofTwiningSmoke from "assets/images/items/Initiate's Gloves of Twining Smoke.jpg"
import InitiatesHoodoftheCrescent from "assets/images/items/Initiate's Hood of the Crescent.jpg"
import InitiatesHood from "assets/images/items/Initiate's Hood.jpg"
import InitiatesLeggingsoftheEternalEclipse from "assets/images/items/Initiate's Leggings of the Eternal Eclipse.jpg"
import InitiatesLeggingsoftheForbiddenArt from "assets/images/items/Initiate's Leggings of the Forbidden Art.jpg"
import InitiatesLeggingsoftheHeavens from "assets/images/items/Initiate's Leggings of the Heavens.jpg"
import InitiatesPantsoftheWaningMoon from "assets/images/items/Initiate's Pants of the Waning Moon.jpg"
import InitiatesRobesoftheCrescent from "assets/images/items/Initiate's Robes of the Crescent.jpg"
import InitiatesRobesoftheMoon from "assets/images/items/Initiate's Robes of the Moon.jpg"
import InitiatesSandalsoftheCrescent from "assets/images/items/Initiate's Sandals of the Crescent.jpg"
import InitiatesTunicoftheBurningDisc from "assets/images/items/Initiate's Tunic of the Burning Disc.jpg"
import InitiatesWrapsoftheCrescent from "assets/images/items/Initiate's Wraps of the Crescent.jpg"
import InitiatesWristbandsoftheEffulgentBlade from "assets/images/items/Initiate's Wristbands of the Effulgent Blade.jpg"
import InvigoratingShoulders from "assets/images/items/Invigorating Shoulders.jpg"
import IronBandofConstitution from "assets/images/items/Iron Band of Constitution.jpg"
import IroncladTrinketofEternalResilience from "assets/images/items/Ironclad Trinket of Eternal Resilience.jpg"
import Ironsmiter from "assets/images/items/Ironsmiter.jpg"
import IzielsHate from "assets/images/items/Iziel's Hate.jpg"
import IzielsSpite from "assets/images/items/Iziel's Spite.jpg"
import JaggedCut from "assets/images/items/Jagged Cut.jpg"
import JangBong from "assets/images/items/Jang Bong.jpg"
import JangGum from "assets/images/items/Jang Gum.jpg"
import JangSsangGum from "assets/images/items/Jang Ssang Gum.jpg"
import JawsnappersHide from "assets/images/items/Jawsnapper's Hide.jpg"
import JerkinofClawingMight from "assets/images/items/Jerkin of Clawing Might.jpg"
import JerkinofFlowingWater from "assets/images/items/Jerkin of Flowing Water.jpg"
import JerkinoftheAmaranthineDrums from "assets/images/items/Jerkin of the Amaranthine Drums.jpg"
import JerkinoftheDeathMasternm from "assets/images/items/Jerkin of the Death Master (nm).jpg"
import JerkinoftheDeathMaster from "assets/images/items/Jerkin of the Death Master.jpg"
import JerkinoftheFuriousSwipe from "assets/images/items/Jerkin of the Furious Swipe.jpg"
import JerkinoftheMasqueroftheSands from "assets/images/items/Jerkin of the Masquer of the Sands.jpg"
import JerkinofthePrimalSpirit from "assets/images/items/Jerkin of the Primal Spirit.jpg"
import JerkinoftheSavageFang from "assets/images/items/Jerkin of the Savage Fang.jpg"
import JerkinofVernantFury from "assets/images/items/Jerkin of Vernant Fury.jpg"
import JiPangEe from "assets/images/items/Ji Pang-Ee.jpg"
import JovianBattleCape from "assets/images/items/Jovian Battle Cape.jpg"
import JovianFaithCape from "assets/images/items/Jovian Faith Cape.jpg"
import JovianSpiritCape from "assets/images/items/Jovian Spirit Cape.jpg"
import Judgement from "assets/images/items/Judgement.jpg"
import JudicatorArcus from "assets/images/items/Judicator Arcus.jpg"
import KaPusementsToken from "assets/images/items/Ka-Pusement's Token.jpg"
import KakabaGuide from "assets/images/items/Kakaba Guide.jpg"
import KalGum from "assets/images/items/Kal Gum.jpg"
import KeeningEdge from "assets/images/items/Keening Edge.jpg"
import Kefmeh from "assets/images/items/Kefmeh.jpg"
import KegofAsgardianStout from "assets/images/items/Keg of Asgardian Stout.jpg"
import KegofHyrkanianTonic from "assets/images/items/Keg of Hyrkanian Tonic.jpg"
import KelAvashkCap from "assets/images/items/Kel'Avashk Cap.jpg"
import KelAvashkRobes from "assets/images/items/Kel'Avashk Robes.jpg"
import KelAvashkSandals from "assets/images/items/Kel'Avashk Sandals.jpg"
import KelAvashkSchenti from "assets/images/items/Kel'Avashk Schenti.jpg"
import KerimsBlessing from "assets/images/items/Kerim's Blessing.jpg"
import Kesht from "assets/images/items/Kesht.jpg"
import KhanjaroftheFacelessMan from "assets/images/items/Khanjar of the Faceless Man.jpg"
import Khemit from "assets/images/items/Khemit.jpg"
import KhorajanAghaQuiver from "assets/images/items/Khorajan Agha Quiver.jpg"
import KiarasGratitude from "assets/images/items/Kiara's Gratitude.jpg"
import KillerRhino from "assets/images/items/Killer Rhino.jpg"
import KiltoftheAmaranthineDrums from "assets/images/items/Kilt of the Amaranthine Drums.jpg"
import KiltofthePrimalSpirit from "assets/images/items/Kilt of the Primal Spirit.jpg"
import KingConansEsteem from "assets/images/items/King Conan's Esteem.jpg"
import KingConansTribute from "assets/images/items/King Conan's Tribute.jpg"
import KissoftheWhiteHand from "assets/images/items/Kiss of the White Hand.jpg"
import KnifeofDessication from "assets/images/items/Knife of Dessication.jpg"
import KnifeoftheCrawlingChaos from "assets/images/items/Knife of the Crawling Chaos.jpg"
import KnightoftheSilverTwilightToken from "assets/images/items/Knight of the Silver Twilight Token.jpg"
import KopasoftheDunes from "assets/images/items/Kopas of the Dunes.jpg"
import KosalanEndurance from "assets/images/items/Kosalan Endurance.jpg"
import KosalanEnruned from "assets/images/items/Kosalan Enruned.jpg"
import KosalanGrace from "assets/images/items/Kosalan Grace.jpg"
import KosalanMight from "assets/images/items/Kosalan Might.jpg"
import KothianBattleBracers from "assets/images/items/Kothian Battle Bracers.jpg"
import KothianBattleGauntlets from "assets/images/items/Kothian Battle Gauntlets.jpg"
import KothianBattleGreaves from "assets/images/items/Kothian Battle Greaves.jpg"
import KothianBattleHelm from "assets/images/items/Kothian Battle Helm.jpg"
import KothianBreastplate from "assets/images/items/Kothian Breastplate.jpg"
import Krakensbane from "assets/images/items/Krakensbane.jpg"
import KrisoftheStarCoffin from "assets/images/items/Kris of the Star Coffin.jpg"
import Kubri from "assets/images/items/Kubri.jpg"
import KuthchemanClaymore from "assets/images/items/Kuthcheman Claymore.jpg"
import KuthchemanCultistShield from "assets/images/items/Kuthcheman Cultist Shield.jpg"
import KuthchemanFlamberge from "assets/images/items/Kuthcheman Flamberge.jpg"
import KuthchemanGreatHammer from "assets/images/items/Kuthcheman Great Hammer.jpg"
import KuthchemanGreatsword from "assets/images/items/Kuthcheman Greatsword.jpg"
import KuthchemanGuardsmanPike from "assets/images/items/Kuthcheman Guardsman Pike.jpg"
import KuthchemanImpaler from "assets/images/items/Kuthcheman Impaler.jpg"
import KuthchemanLongbow from "assets/images/items/Kuthcheman Longbow.jpg"
import KuthchemanLongsword from "assets/images/items/Kuthcheman Longsword.jpg"
import KuthchemanPernach from "assets/images/items/Kuthcheman Pernach.jpg"
import KuthchemanSagaris from "assets/images/items/Kuthcheman Sagaris.jpg"
import KuthchemanTowerShield from "assets/images/items/Kuthcheman Tower Shield.jpg"
import KuthchemanWarAxe from "assets/images/items/Kuthcheman War Axe.jpg"
import KuthchemanWarBlade from "assets/images/items/Kuthcheman War Blade.jpg"
import KuthchemanZugiteStaff from "assets/images/items/Kuthcheman Zugite Staff.jpg"
import LacunalNexus from "assets/images/items/Lacunal Nexus.jpg"
import Lamentatus from "assets/images/items/Lamentatus.jpg"
import LastingFaithBelt from "assets/images/items/Lasting Faith Belt.jpg"
import LastingFaithBoots from "assets/images/items/Lasting Faith Boots.jpg"
import LastingFaithGauntlets from "assets/images/items/Lasting Faith Gauntlets.jpg"
import LastingFaithTasset from "assets/images/items/Lasting Faith Tasset.jpg"
import LatheofStars from "assets/images/items/Lathe of Stars.jpg"
import LaudedCuraticBand from "assets/images/items/Lauded Curatic Band.jpg"
import LaughingAuspicesoftheCelestial from "assets/images/items/Laughing Auspices of the Celestial.jpg"
import LeftHandofNergal from "assets/images/items/Left Hand of Nergal.jpg"
import LegendofShevatas from "assets/images/items/Legend of Shevatas.jpg"
import LeggingsofaThousandBlossoms from "assets/images/items/Leggings of a Thousand Blossoms.jpg"
import LeggingsofBedlam from "assets/images/items/Leggings of Bedlam.jpg"
import LeggingsofBestialRage from "assets/images/items/Leggings of Bestial Rage.jpg"
import LeggingsofBlackWhispers from "assets/images/items/Leggings of Black Whispers.jpg"
import LeggingsofBristlingIre from "assets/images/items/Leggings of Bristling Ire.jpg"
import LeggingsofClawingMight from "assets/images/items/Leggings of Clawing Might.jpg"
import LeggingsofConcealingShadows from "assets/images/items/Leggings of Concealing Shadows.jpg"
import LeggingsofDarkMalice from "assets/images/items/Leggings of Dark Malice.jpg"
import LeggingsofDeadlyGuile from "assets/images/items/Leggings of Deadly Guile.jpg"
import LeggingsofErlik from "assets/images/items/Leggings of Erlik.jpg"
import LeggingsofFerineAnger from "assets/images/items/Leggings of Ferine Anger.jpg"
import LeggingsofFiendishInvocation from "assets/images/items/Leggings of Fiendish Invocation.jpg"
import LeggingsofInsanity from "assets/images/items/Leggings of Insanity.jpg"
import LeggingsofIntricateSpite from "assets/images/items/Leggings of Intricate Spite.jpg"
import LeggingsofJaggedBarbs from "assets/images/items/Leggings of Jagged Barbs.jpg"
import LeggingsofLightUnpresent from "assets/images/items/Leggings of Light Unpresent.jpg"
import LeggingsofLunacy from "assets/images/items/Leggings of Lunacy.jpg"
import LeggingsofMirroredHeaven from "assets/images/items/Leggings of Mirrored Heaven.jpg"
import LeggingsofQuilledDarts from "assets/images/items/Leggings of Quilled Darts.jpg"
import LeggingsofReflection from "assets/images/items/Leggings of Reflection.jpg"
import LeggingsofSwiftstriking from "assets/images/items/Leggings of Swiftstriking.jpg"
import LeggingsoftheBloodGodnm from "assets/images/items/Leggings of the Blood God (nm).jpg"
import LeggingsoftheBloodGod from "assets/images/items/Leggings of the Blood God.jpg"
import LeggingsoftheClay from "assets/images/items/Leggings of the Clay.jpg"
import LeggingsoftheCrawlingChaos from "assets/images/items/Leggings of the Crawling Chaos.jpg"
import LeggingsoftheDeathGod from "assets/images/items/Leggings of the Death God.jpg"
import LeggingsoftheDeathstalker from "assets/images/items/Leggings of the Deathstalker.jpg"
import LeggingsoftheExorcist from "assets/images/items/Leggings of the Exorcist.jpg"
import LeggingsoftheFacelessChaos from "assets/images/items/Leggings of the Faceless Chaos.jpg"
import LeggingsoftheFacelessSpinx from "assets/images/items/Leggings of the Faceless Spinx.jpg"
import LeggingsoftheFarseeker from "assets/images/items/Leggings of the Farseeker.jpg"
import LeggingsoftheFirebrand from "assets/images/items/Leggings of the Firebrand.jpg"
import LeggingsoftheFuriousSwipe from "assets/images/items/Leggings of the Furious Swipe.jpg"
import LeggingsoftheHarbinger from "assets/images/items/Leggings of the Harbinger.jpg"
import LeggingsoftheHaunterintheDark from "assets/images/items/Leggings of the Haunter in the Dark.jpg"
import LeggingsoftheHowlingGiant from "assets/images/items/Leggings of the Howling Giant.jpg"
import LeggingsoftheHuntmaster from "assets/images/items/Leggings of the Huntmaster.jpg"
import LeggingsoftheIchorous from "assets/images/items/Leggings of the Ichorous.jpg"
import LeggingsoftheKozakSlayer from "assets/images/items/Leggings of the Kozak Slayer.jpg"
import LeggingsoftheLector from "assets/images/items/Leggings of the Lector.jpg"
import LeggingsoftheNebulous from "assets/images/items/Leggings of the Nebulous.jpg"
import LeggingsoftheOuterDark from "assets/images/items/Leggings of the Outer Dark.jpg"
import LeggingsoftheOxmal from "assets/images/items/Leggings of the Oxmal.jpg"
import LeggingsofthePrecursor from "assets/images/items/Leggings of the Precursor.jpg"
import LeggingsofthePutrescent from "assets/images/items/Leggings of the Putrescent.jpg"
import LeggingsoftheRagereaver from "assets/images/items/Leggings of the Ragereaver.jpg"
import LeggingsoftheRavenflight from "assets/images/items/Leggings of the Ravenflight.jpg"
import LeggingsoftheRefectory from "assets/images/items/Leggings of the Refectory.jpg"
import LeggingsoftheRipplingLake from "assets/images/items/Leggings of the Rippling Lake.jpg"
import LeggingsoftheSavageFang from "assets/images/items/Leggings of the Savage Fang.jpg"
import LeggingsoftheSepulcher from "assets/images/items/Leggings of the Sepulcher.jpg"
import LeggingsoftheShiveringStars from "assets/images/items/Leggings of the Shivering Stars.jpg"
import LeggingsoftheSilentSlayer from "assets/images/items/Leggings of the Silent Slayer.jpg"
import LeggingsoftheSpheres from "assets/images/items/Leggings of the Spheres.jpg"
import LeggingsoftheStarlessNight from "assets/images/items/Leggings of the Starless Night.jpg"
import LeggingsoftheStillPond from "assets/images/items/Leggings of the Still Pond.jpg"
import LeggingsoftheStrangeBeyond from "assets/images/items/Leggings of the Strange Beyond.jpg"
import LeggingsoftheSwiftTalon from "assets/images/items/Leggings of the Swift Talon.jpg"
import LeggingsoftheUbahKan from "assets/images/items/Leggings of the Ubah Kan.jpg"
import LeggingsoftheUnslaked from "assets/images/items/Leggings of the Unslaked.jpg"
import LeggingsoftheUnutterable from "assets/images/items/Leggings of the Unutterable.jpg"
import LeggingsoftheUsurper from "assets/images/items/Leggings of the Usurper.jpg"
import LeggingsoftheWellsofNight from "assets/images/items/Leggings of the Wells of Night.jpg"
import LeggingsofTranquility from "assets/images/items/Leggings of Tranquility.jpg"
import LeggingsofUnrest from "assets/images/items/Leggings of Unrest.jpg"
import LeggingsofUntamedViolence from "assets/images/items/Leggings of Untamed Violence.jpg"
import LeggingsofVernantFury from "assets/images/items/Leggings of Vernant Fury.jpg"
import LeggingsofViciousFrenzy from "assets/images/items/Leggings of Vicious Frenzy.jpg"
import LeggingsofVindictiveMalice from "assets/images/items/Leggings of Vindictive Malice.jpg"
import LeggingsofWildFuror from "assets/images/items/Leggings of Wild Furor.jpg"
import LegguardsofClarity from "assets/images/items/Legguards of Clarity.jpg"
import LegguardsofFlowingWater from "assets/images/items/Legguards of Flowing Water.jpg"
import LegguardsofRecklessChallenge from "assets/images/items/Legguards of Reckless Challenge.jpg"
import LegguardsoftheAnguishedHeart from "assets/images/items/Legguards of the Anguished Heart.jpg"
import LegguardsoftheAssailant from "assets/images/items/Legguards of the Assailant.jpg"
import LegguardsoftheAtlantean from "assets/images/items/Legguards of the Atlantean.jpg"
import LegguardsoftheBeyond from "assets/images/items/Legguards of the Beyond.jpg"
import LegguardsoftheBlackDragon from "assets/images/items/Legguards of the Black Dragon.jpg"
import LegguardsoftheBlackPharaoh from "assets/images/items/Legguards of the Black Pharaoh.jpg"
import LegguardsoftheBlackWarden from "assets/images/items/Legguards of the Black Warden.jpg"
import LegguardsoftheBloodlust from "assets/images/items/Legguards of the Bloodlust.jpg"
import LegguardsoftheCrimsonFort from "assets/images/items/Legguards of the Crimson Fort.jpg"
import LegguardsoftheDarkMessenger from "assets/images/items/Legguards of the Dark Messenger.jpg"
import LegguardsoftheDauntless from "assets/images/items/Legguards of the Dauntless.jpg"
import LegguardsoftheDefiant from "assets/images/items/Legguards of the Defiant.jpg"
import LegguardsoftheInconceivable from "assets/images/items/Legguards of the Inconceivable.jpg"
import LegguardsoftheLivingTarim from "assets/images/items/Legguards of the Living Tarim.jpg"
import LegguardsoftheMembranous from "assets/images/items/Legguards of the Membranous.jpg"
import LegguardsoftheMilitesTempli from "assets/images/items/Legguards of the Milites Templi.jpg"
import LegguardsoftheOstiary from "assets/images/items/Legguards of the Ostiary.jpg"
import LegguardsoftheRenegade from "assets/images/items/Legguards of the Renegade.jpg"
import LegguardsoftheRevelationsofTarim from "assets/images/items/Legguards of the Revelations of Tarim.jpg"
import LegguardsoftheTormentor from "assets/images/items/Legguards of the Tormentor.jpg"
import LegguardsoftheUsurper from "assets/images/items/Legguards of the Usurper.jpg"
import LegguardsoftheVanguard from "assets/images/items/Legguards of the Vanguard.jpg"
import LegguardsoftheWicked from "assets/images/items/Legguards of the Wicked.jpg"
import LegguardsofWrithing from "assets/images/items/Legguards of Writhing.jpg"
import LegionFightersRing from "assets/images/items/Legion Fighters Ring.jpg"
import LegionNecklace from "assets/images/items/Legion Necklace.jpg"
import LegionSpellwardersRing from "assets/images/items/Legion Spellwarders Ring.jpg"
import LiberatorsGreatsword from "assets/images/items/Liberator's Greatsword.jpg"
import LiberatorsHalberd from "assets/images/items/Liberator's Halberd.jpg"
import LiberatorsTrinket from "assets/images/items/Liberator's Trinket.jpg"
import Lifebringer from "assets/images/items/Lifebringer.jpg"
import LiltingBoneFlute from "assets/images/items/Lilting Bone Flute.jpg"
import LinkoftheOtherWorld from "assets/images/items/Link of the Other World.jpg"
import LinksofCetriss from "assets/images/items/Links of Cetriss.jpg"
import LiteratusHood from "assets/images/items/Literatus Hood.jpg"
import LiveryoftheDragonKing from "assets/images/items/Livery of the Dragon King.jpg"
import LoinclothoftheDarkwretch from "assets/images/items/Loincloth of the Darkwretch.jpg"
import LoinclothoftheForsaken from "assets/images/items/Loincloth of the Forsaken.jpg"
import LoinclothoftheReanimator from "assets/images/items/Loincloth of the Reanimator.jpg"
import LongbladeoftheSea from "assets/images/items/Longblade of the Sea.jpg"
import Longspire from "assets/images/items/Longspire.jpg"
import LoopoftheHellWalker from "assets/images/items/Loop of the Hell Walker.jpg"
import LordAtumKeketsCape from "assets/images/items/Lord Atum-Keket's Cape.jpg"
import LostSoulofJovus from "assets/images/items/Lost Soul of Jovus.jpg"
import LotusTalisman from "assets/images/items/Lotus Talisman.jpg"
import Lucis from "assets/images/items/Lucis.jpg"
import Luctus from "assets/images/items/Luctus.jpg"
import MaahesCracklingSpite from "assets/images/items/Maahes' Crackling Spite.jpg"
import MaceoftheBloodGod from "assets/images/items/Mace of the Blood God.jpg"
import MaceoftheChampion from "assets/images/items/Mace of the Champion.jpg"
import MaceoftheCloudseer from "assets/images/items/Mace of the Cloudseer.jpg"
import Madfang from "assets/images/items/Madfang.jpg"
import MagewalkSlippers from "assets/images/items/Magewalk Slippers.jpg"
import MajesticGloves from "assets/images/items/Majestic Gloves.jpg"
import MalefactorsClaymore from "assets/images/items/Malefactor's Claymore.jpg"
import MalefactorsQuarterstaff from "assets/images/items/Malefactor's Quarterstaff.jpg"
import MalevolentGauntlets from "assets/images/items/Malevolent Gauntlets.jpg"
import MaliceBand from "assets/images/items/Malice Band.jpg"
import MammuthusShield from "assets/images/items/Mammuthus Shield.jpg"
import ManaclesoftheEndlessSands from "assets/images/items/Manacles of the Endless Sands.jpg"
import ManiacalHarm from "assets/images/items/Maniacal Harm.jpg"
import Manslayer from "assets/images/items/Manslayer.jpg"
import MantleofElevenResplendentPrayers from "assets/images/items/Mantle of Eleven Resplendent Prayers.jpg"
import MantleofValkasWrath from "assets/images/items/Mantle of Valka's Wrath.jpg"
import MarcelinFamilySignum from "assets/images/items/Marcelin Family Signum.jpg"
import MarcelinPike from "assets/images/items/Marcelin Pike.jpg"
import MariquesBitchmageCache from "assets/images/items/Marique's Bitchmage Cache.jpg"
import MariquesGoldscaleCache from "assets/images/items/Marique's Goldscale Cache.jpg"
import MariquesBlackLeatherCache from "assets/images/items/Mariques Black Leather Cache.jpg"
import MarkofDeception from "assets/images/items/Mark of Deception.jpg"
import MarkofLightning from "assets/images/items/Mark of Lightning.jpg"
import MarkofMetamorphosis from "assets/images/items/Mark of Metamorphosis.jpg"
import MarkofSuspicion from "assets/images/items/Mark of Suspicion.jpg"
import MarkoftheAncientSands from "assets/images/items/Mark of the Ancient Sands.jpg"
import MarkoftheEndlessSands from "assets/images/items/Mark of the Endless Sands.jpg"
import MarkoftheSerpentKing from "assets/images/items/Mark of the Serpent King.jpg"
import MarkedSerpentweave from "assets/images/items/Marked Serpentweave.jpg"
import MartialCloak from "assets/images/items/Martial Cloak.jpg"
import MaskofAcheron from "assets/images/items/Mask of Acheron.jpg"
import MaskofBenMorgh from "assets/images/items/Mask of Ben Morgh.jpg"
import MaskofBestialRage from "assets/images/items/Mask of Bestial Rage.jpg"
import MaskofBristlingIre from "assets/images/items/Mask of Bristling Ire.jpg"
import MaskofConajohara from "assets/images/items/Mask of Conajohara.jpg"
import MaskofCrimsonSlaughternm from "assets/images/items/Mask of Crimson Slaughter (nm).jpg"
import MaskofCrimsonSlaughter from "assets/images/items/Mask of Crimson Slaughter.jpg"
import MaskofRedRuinnm from "assets/images/items/Mask of Red Ruin (nm).jpg"
import MaskofRedRuin from "assets/images/items/Mask of Red Ruin.jpg"
import MaskoftheDeathGod from "assets/images/items/Mask of the Death God.jpg"
import MaskoftheDeathMasternm from "assets/images/items/Mask of the Death Master (nm).jpg"
import MaskoftheDeathMaster from "assets/images/items/Mask of the Death Master.jpg"
import MaskoftheGhostoftheVeldt from "assets/images/items/Mask of the Ghost of the Veldt.jpg"
import MaskoftheGreatImpi from "assets/images/items/Mask of the Great Impi.jpg"
import MaskoftheHarbinger from "assets/images/items/Mask of the Harbinger.jpg"
import MaskoftheOuterDark from "assets/images/items/Mask of the Outer Dark.jpg"
import MaskofthePrecursor from "assets/images/items/Mask of the Precursor.jpg"
import MaskoftheStarlessNight from "assets/images/items/Mask of the Starless Night.jpg"
import MaskoftheStrangeBeyond from "assets/images/items/Mask of the Strange Beyond.jpg"
import MaskofUnsettledMinds from "assets/images/items/Mask of Unsettled Minds.jpg"
import Massacre from "assets/images/items/Massacre.jpg"
import MaulofConajohara from "assets/images/items/Maul of Conajohara.jpg"
import MauloftheRagingEarth from "assets/images/items/Maul of the Raging Earth.jpg"
import MauloftheVeiledMoon from "assets/images/items/Maul of the Veiled Moon.jpg"
import MediatorsCloak from "assets/images/items/Mediator's Cloak.jpg"
import MeditationRod from "assets/images/items/Meditation Rod.jpg"
import MediumsArmbandsofConsumedSouls from "assets/images/items/Medium's Armbands of Consumed Souls.jpg"
import MediumsArmbandsofSecretDoors from "assets/images/items/Medium's Armbands of Secret Doors.jpg"
import MediumsBeltofConsumedSouls from "assets/images/items/Medium's Belt of Consumed Souls.jpg"
import MediumsBeltofSecretDoors from "assets/images/items/Medium's Belt of Secret Doors.jpg"
import MediumsBootsoftheEmissary from "assets/images/items/Medium's Boots of the Emissary.jpg"
import MediumsBootsoftheKingmaker from "assets/images/items/Medium's Boots of the Kingmaker.jpg"
import MediumsBracersoftheEmissary from "assets/images/items/Medium's Bracers of the Emissary.jpg"
import MediumsBracersoftheKingmaker from "assets/images/items/Medium's Bracers of the Kingmaker.jpg"
import MediumsGlovesofSupremeDecree from "assets/images/items/Medium's Gloves of Supreme Decree.jpg"
import MediumsGlovesoftheDarkPact from "assets/images/items/Medium's Gloves of the Dark Pact.jpg"
import MediumsHoodofConsumedSouls from "assets/images/items/Medium's Hood of Consumed Souls.jpg"
import MediumsHoodofSecretDoors from "assets/images/items/Medium's Hood of Secret Doors.jpg"
import MediumsLeggingsofConsumedSouls from "assets/images/items/Medium's Leggings of Consumed Souls.jpg"
import MediumsLeggingsofSecretDoors from "assets/images/items/Medium's Leggings of Secret Doors.jpg"
import MediumsRobeoftheDarkPact from "assets/images/items/Medium's Robe of the Dark Pact.jpg"
import MediumsTunicofSupremeDecree from "assets/images/items/Medium's Tunic of Supreme Decree.jpg"
import MercenarysArmstrapsofthePaintedClaw from "assets/images/items/Mercenary's Arm-straps of the Painted Claw.jpg"
import MercenarysArmbandsofthePrimeval from "assets/images/items/Mercenary's Armbands of the Primeval.jpg"
import MercenarysArmguardsoftheSavageSun from "assets/images/items/Mercenary's Armguards of the Savage Sun.jpg"
import MercenarysBeltofGrinningSkulls from "assets/images/items/Mercenary's Belt of Grinning Skulls.jpg"
import MercenarysBeltofStalkingFury from "assets/images/items/Mercenary's Belt of Stalking Fury.jpg"
import MercenarysBeltoftheElderBond from "assets/images/items/Mercenary's Belt of the Elder Bond.jpg"
import MercenarysBootsofPiercedFlesh from "assets/images/items/Mercenary's Boots of Pierced Flesh.jpg"
import MercenarysBootsoftheRoaringJungle from "assets/images/items/Mercenary's Boots of the Roaring Jungle.jpg"
import MercenarysBracersofCrouchingCalm from "assets/images/items/Mercenary's Bracers of Crouching Calm.jpg"
import MercenarysBracersoftheUntamed from "assets/images/items/Mercenary's Bracers of the Untamed.jpg"
import MercenarysChestguardoftheRoaringJungle from "assets/images/items/Mercenary's Chestguard of the Roaring Jungle.jpg"
import MercenarysGauntletsoftheRoaringJungle from "assets/images/items/Mercenary's Gauntlets of the Roaring Jungle.jpg"
import MercenarysGauntletsoftheUntamed from "assets/images/items/Mercenary's Gauntlets of the Untamed.jpg"
import MercenarysGirdleoftheSecondCaste from "assets/images/items/Mercenary's Girdle of the Second Caste.jpg"
import MercenarysGlovesofCrouchingCalm from "assets/images/items/Mercenary's Gloves of Crouching Calm.jpg"
import MercenarysHarnessoftheUntamed from "assets/images/items/Mercenary's Harness of the Untamed.jpg"
import MercenarysHelmofGrinningSkulls from "assets/images/items/Mercenary's Helm of Grinning Skulls.jpg"
import MercenarysHelmofStalkingFury from "assets/images/items/Mercenary's Helm of Stalking Fury.jpg"
import MercenarysHelmoftheElderBond from "assets/images/items/Mercenary's Helm of the Elder Bond.jpg"
import MercenarysHelmoftheSecondCaste from "assets/images/items/Mercenary's Helm of the Second Caste.jpg"
import MercenarysJerkinofCrouchingCalm from "assets/images/items/Mercenary's Jerkin of Crouching Calm.jpg"
import MercenarysLeggingsofthePaintedClaw from "assets/images/items/Mercenary's Leggings of the Painted Claw.jpg"
import MercenarysLeggingsofthePrimeval from "assets/images/items/Mercenary's Leggings of the Primeval.jpg"
import MercenarysLegguardsoftheSavageSun from "assets/images/items/Mercenary's Legguards of the Savage Sun.jpg"
import MercenarysLegguardsoftheYellowSpring from "assets/images/items/Mercenary's Legguards of the Yellow Spring.jpg"
import MercenarysStrapsofPiercedFlesh from "assets/images/items/Mercenary's Straps of Pierced Flesh.jpg"
import MercenarysStrapsoftheYellowSpring from "assets/images/items/Mercenary's Straps of the Yellow Spring.jpg"
import MercenarysVambracesoftheRoaringJungle from "assets/images/items/Mercenary's Vambraces of the Roaring Jungle.jpg"
import MercenarysVestofPiercedFlesh from "assets/images/items/Mercenary's Vest of Pierced Flesh.jpg"
import MerusGrandStaff from "assets/images/items/Meru's Grand Staff.jpg"
import Miasmacies from "assets/images/items/Miasmacies.jpg"
import MightoftheSerpentMen from "assets/images/items/Might of the Serpent Men.jpg"
import MightoftheWrathful from "assets/images/items/Might of the Wrathful.jpg"
import MindsIre from "assets/images/items/Mind's Ire.jpg"
import MindblazeRing from "assets/images/items/Mindblaze Ring.jpg"
import MindcurseStaff from "assets/images/items/Mindcurse Staff.jpg"
import MindwreathCap from "assets/images/items/Mindwreath Cap.jpg"
import MiningAxeoftheOxmal from "assets/images/items/Mining Axe of the Oxmal.jpg"
import MirrorofShadow from "assets/images/items/Mirror of Shadow.jpg"
import Miseryblunt from "assets/images/items/Misery (blunt).jpg"
import Misery from "assets/images/items/Misery.jpg"
import MissionarysBoots from "assets/images/items/Missionary's Boots.jpg"
import MissionarysBracers from "assets/images/items/Missionary's Bracers.jpg"
import MissionarysRerebrace from "assets/images/items/Missionary's Rerebrace.jpg"
import MissionarysShield from "assets/images/items/Missionary's Shield.jpg"
import MiteroftheCloudcleaver from "assets/images/items/Miter of the Cloudcleaver.jpg"
import MiteroftheJudgmentBolt from "assets/images/items/Miter of the Judgment Bolt.jpg"
import MiteroftheRiftcaller from "assets/images/items/Miter of the Riftcaller.jpg"
import MiteroftheSunderedSkies from "assets/images/items/Miter of the Sundered Skies.jpg"
import MitrasMarkofDivineBlessings from "assets/images/items/Mitra's Mark of Divine Blessings.jpg"
import MonksArmstrapsoftheUnderworld from "assets/images/items/Monk's Arm-straps of the Underworld.jpg"
import MonksArmbandsoftheEighteenPits from "assets/images/items/Monk's Armbands of the Eighteen Pits.jpg"
import MonksBeltoftheNineSprings from "assets/images/items/Monk's Belt of the Nine Springs.jpg"
import MonksBeltoftheUnderworld from "assets/images/items/Monk's Belt of the Underworld.jpg"
import MonksBootsofSacrifice from "assets/images/items/Monk's Boots of Sacrifice.jpg"
import MonksBootsoftheEarthenPrison from "assets/images/items/Monk's Boots of the Earthen Prison.jpg"
import MonksBootsoftheHallowWorlds from "assets/images/items/Monk's Boots of the Hallow Worlds.jpg"
import MonksBootsoftheLimitlessCipher from "assets/images/items/Monk's Boots of the Limitless Cipher.jpg"
import MonksBracersoftheEarthenPrison from "assets/images/items/Monk's Bracers of the Earthen Prison.jpg"
import MonksBracersoftheHallowWorlds from "assets/images/items/Monk's Bracers of the Hallow Worlds.jpg"
import MonksBracersoftheLimitlessCipher from "assets/images/items/Monk's Bracers of the Limitless Cipher.jpg"
import MonksGauntletsoftheSpillingBlood from "assets/images/items/Monk's Gauntlets of the Spilling Blood.jpg"
import MonksGirdleoftheEighteenPits from "assets/images/items/Monk's Girdle of the Eighteen Pits.jpg"
import MonksGlovesofBalance from "assets/images/items/Monk's Gloves of Balance.jpg"
import MonksGlovesoftheBlackThread from "assets/images/items/Monk's Gloves of the Black Thread.jpg"
import MonksGlovesoftheSacredMountain from "assets/images/items/Monk's Gloves of the Sacred Mountain.jpg"
import MonksHarnessoftheSpillingBlood from "assets/images/items/Monk's Harness of the Spilling Blood.jpg"
import MonksHelmoftheAbyss from "assets/images/items/Monk's Helm of the Abyss.jpg"
import MonksHelmoftheEighteenPits from "assets/images/items/Monk's Helm of the Eighteen Pits.jpg"
import MonksHoodoftheUnderworld from "assets/images/items/Monk's Hood of the Underworld.jpg"
import MonksJerkinoftheSacredMountain from "assets/images/items/Monk's Jerkin of the Sacred Mountain.jpg"
import MonksLeggingsoftheNineSprings from "assets/images/items/Monk's Leggings of the Nine Springs.jpg"
import MonksLegguardsoftheAbyss from "assets/images/items/Monk's Legguards of the Abyss.jpg"
import MonksMaskoftheNineSprings from "assets/images/items/Monk's Mask of the Nine Springs.jpg"
import MonksRobesofBalance from "assets/images/items/Monk's Robes of Balance.jpg"
import MonksStrapsofSacrifice from "assets/images/items/Monk's Straps of Sacrifice.jpg"
import MonksStrapsoftheAbyss from "assets/images/items/Monk's Straps of the Abyss.jpg"
import MonksStrapsoftheNineSprings from "assets/images/items/Monk's Straps of the Nine Springs.jpg"
import MonksThreadsoftheUnderworld from "assets/images/items/Monk's Threads of the Underworld.jpg"
import MonksTunicoftheBlackThread from "assets/images/items/Monk's Tunic of the Black Thread.jpg"
import MordecBelt from "assets/images/items/Mordec Belt.jpg"
import MordecBlade from "assets/images/items/Mordec Blade.jpg"
import MordecBoots from "assets/images/items/Mordec Boots.jpg"
import MordecGauntlets from "assets/images/items/Mordec Gauntlets.jpg"
import MordecGreaves from "assets/images/items/Mordec Greaves.jpg"
import MordecHammer from "assets/images/items/Mordec Hammer.jpg"
import MortiferousBoots from "assets/images/items/Mortiferous Boots.jpg"
import MortiferousChestguard from "assets/images/items/Mortiferous Chestguard.jpg"
import MortiferousHelm from "assets/images/items/Mortiferous Helm.jpg"
import MortiferousTasset from "assets/images/items/Mortiferous Tasset.jpg"
import MysticsArmbandsoftheSoaringHeart from "assets/images/items/Mystic's Armbands of the Soaring Heart.jpg"
import MysticsBandsoftheThreeClarities from "assets/images/items/Mystic's Bands of the Three Clarities.jpg"
import MysticsBeltoftheExaltedSpirit from "assets/images/items/Mystic's Belt of the Exalted Spirit.jpg"
import MysticsBeltoftheSoaringGod from "assets/images/items/Mystic's Belt of the Soaring God.jpg"
import MysticsBootsoftheCrumblingTower from "assets/images/items/Mystic's Boots of the Crumbling Tower.jpg"
import MysticsBootsofthePurpleSun from "assets/images/items/Mystic's Boots of the Purple Sun.jpg"
import MysticsBracersoftheCrumblingTower from "assets/images/items/Mystic's Bracers of the Crumbling Tower.jpg"
import MysticsBracersofthePurpleSun from "assets/images/items/Mystic's Bracers of the Purple Sun.jpg"
import MysticsBraidofShimmeringLight from "assets/images/items/Mystic's Braid of Shimmering Light.jpg"
import MysticsBreastplateoftheAureate from "assets/images/items/Mystic's Breastplate of the Aureate.jpg"
import MysticsCoverofYag from "assets/images/items/Mystic's Cover of Yag.jpg"
import MysticsCoveringsofShimmeringLight from "assets/images/items/Mystic's Coverings of Shimmering Light.jpg"
import MysticsDelight from "assets/images/items/Mystic's Delight.jpg"
import MysticsGauntletsoftheCrumblingTower from "assets/images/items/Mystic's Gauntlets of the Crumbling Tower.jpg"
import MysticsGirdleoftheBloodyStone from "assets/images/items/Mystic's Girdle of the Bloody Stone.jpg"
import MysticsGlovesoftheEldritch from "assets/images/items/Mystic's Gloves of the Eldritch.jpg"
import MysticsGlovesofthePurpleSun from "assets/images/items/Mystic's Gloves of the Purple Sun.jpg"
import MysticsHandwrapsoftheAureate from "assets/images/items/Mystic's Hand-wraps of the Aureate.jpg"
import MysticsHarnessoftheCrumblingTower from "assets/images/items/Mystic's Harness of the Crumbling Tower.jpg"
import MysticsHelmoftheBloodyStone from "assets/images/items/Mystic's Helm of the Bloody Stone.jpg"
import MysticsHelmoftheSoaringGod from "assets/images/items/Mystic's Helm of the Soaring God.jpg"
import MysticsLeggingsoftheSoaringHeart from "assets/images/items/Mystic's Leggings of the Soaring Heart.jpg"
import MysticsLeggingsoftheThreeClarities from "assets/images/items/Mystic's Leggings of the Three Clarities.jpg"
import MysticsLegguardsoftheGreenOnes from "assets/images/items/Mystic's Legguards of the Green Ones.jpg"
import MysticsMaskoftheExaltedSpirit from "assets/images/items/Mystic's Mask of the Exalted Spirit.jpg"
import MysticsSashofYag from "assets/images/items/Mystic's Sash of Yag.jpg"
import MysticsShoesoftheAureate from "assets/images/items/Mystic's Shoes of the Aureate.jpg"
import MysticsStrapsoftheAureate from "assets/images/items/Mystic's Straps of the Aureate.jpg"
import MysticsStrapsoftheGreenOnes from "assets/images/items/Mystic's Straps of the Green Ones.jpg"
import MysticsVestmentoftheEldritch from "assets/images/items/Mystic's Vestment of the Eldritch.jpg"
import MysticsWriststrapsoftheEldritch from "assets/images/items/Mystic's Wrist-straps of the Eldritch.jpg"
import Nakush from "assets/images/items/Nakush.jpg"
import Nakuum from "assets/images/items/Nakuum.jpg"
import NamelessGlaive from "assets/images/items/Nameless Glaive.jpg"
import NecklaceofFreezingGale from "assets/images/items/Necklace of Freezing Gale.jpg"
import NecklaceofRelentlessBellicosity from "assets/images/items/Necklace of Relentless Bellicosity.jpg"
import NecklaceoftheManicHaze from "assets/images/items/Necklace of the Manic Haze.jpg"
import NecklaceofthePrimalSpirit from "assets/images/items/Necklace of the Primal Spirit.jpg"
import NecklaceofThousandSouls from "assets/images/items/Necklace of Thousand Souls.jpg"
import NecklaceofTirelessSagacity from "assets/images/items/Necklace of Tireless Sagacity.jpg"
import NecklaceofWormfire from "assets/images/items/Necklace of Wormfire.jpg"
import Needlebag from "assets/images/items/Needlebag.jpg"
import NeedlesofBoneandHorn from "assets/images/items/Needles of Bone and Horn.jpg"
import NeedlesoftheFreezingGale from "assets/images/items/Needles of the Freezing Gale.jpg"
import NefariousChest from "assets/images/items/Nefarious Chest.jpg"
import Nehfu from "assets/images/items/Nehfu.jpg"
import Neith from "assets/images/items/Neith.jpg"
import NemedianSkinningKnife from "assets/images/items/Nemedian Skinning Knife.jpg"
import Nemesis from "assets/images/items/Nemesis.jpg"
import NeophytesArmbandsofSovereignRule from "assets/images/items/Neophyte's Armbands of Sovereign Rule.jpg"
import NeophytesArmbandsofSupremeDecree from "assets/images/items/Neophyte's Armbands of Supreme Decree.jpg"
import NeophytesArmbandsoftheDarkPact from "assets/images/items/Neophyte's Armbands of the Dark Pact.jpg"
import NeophytesArmbandsoftheMandate from "assets/images/items/Neophyte's Armbands of the Mandate.jpg"
import NeophytesBeltofRegalMight from "assets/images/items/Neophyte's Belt of Regal Might.jpg"
import NeophytesBeltoftheEmissary from "assets/images/items/Neophyte's Belt of the Emissary.jpg"
import NeophytesBeltoftheKingmaker from "assets/images/items/Neophyte's Belt of the Kingmaker.jpg"
import NeophytesBootsofConsumedSouls from "assets/images/items/Neophyte's Boots of Consumed Souls.jpg"
import NeophytesBootsofImperialAssent from "assets/images/items/Neophyte's Boots of Imperial Assent.jpg"
import NeophytesBootsofSecretDoors from "assets/images/items/Neophyte's Boots of Secret Doors.jpg"
import NeophytesBracersofConsumedSouls from "assets/images/items/Neophyte's Bracers of Consumed Souls.jpg"
import NeophytesBracersofImperialAssent from "assets/images/items/Neophyte's Bracers of Imperial Assent.jpg"
import NeophytesBracersofPrestige from "assets/images/items/Neophyte's Bracers of Prestige.jpg"
import NeophytesBracersofSecretDoors from "assets/images/items/Neophyte's Bracers of Secret Doors.jpg"
import NeophytesGauntletsoftheEmperorsFavor from "assets/images/items/Neophyte's Gauntlets of the Emperor's Favor.jpg"
import NeophytesGirdleoftheEmperorsFavor from "assets/images/items/Neophyte's Girdle of the Emperor's Favor.jpg"
import NeophytesGlovesofRegalMight from "assets/images/items/Neophyte's Gloves of Regal Might.jpg"
import NeophytesGlovesoftheEmissary from "assets/images/items/Neophyte's Gloves of the Emissary.jpg"
import NeophytesGlovesoftheKingmaker from "assets/images/items/Neophyte's Gloves of the Kingmaker.jpg"
import NeophytesHoodofConsumedSouls from "assets/images/items/Neophyte's Hood of Consumed Souls.jpg"
import NeophytesHoodofPrestige from "assets/images/items/Neophyte's Hood of Prestige.jpg"
import NeophytesHoodofSecretDoors from "assets/images/items/Neophyte's Hood of Secret Doors.jpg"
import NeophytesLeggingsofSupremeDecree from "assets/images/items/Neophyte's Leggings of Supreme Decree.jpg"
import NeophytesLeggingsoftheDarkPact from "assets/images/items/Neophyte's Leggings of the Dark Pact.jpg"
import NeophytesLeggingsoftheMandate from "assets/images/items/Neophyte's Leggings of the Mandate.jpg"
import NeophytesPantsofSovereignRule from "assets/images/items/Neophyte's Pants of Sovereign Rule.jpg"
import NeophytesRobeofConsumedSouls from "assets/images/items/Neophyte's Robe of Consumed Souls.jpg"
import NeophytesRobesofImperialAssent from "assets/images/items/Neophyte's Robes of Imperial Assent.jpg"
import NeophytesTunicofSecretDoors from "assets/images/items/Neophyte's Tunic of Secret Doors.jpg"
import NergalsBludgeonofAgonizingWounds from "assets/images/items/Nergal's Bludgeon of Agonizing Wounds.jpg"
import NergalsLanternoftheBurningSky from "assets/images/items/Nergal's Lantern of the Burning Sky.jpg"
import NergalsRingoftheBurningSky from "assets/images/items/Nergal's Ring of the Burning Sky.jpg"
import NergalsRingoftheEternalStorm from "assets/images/items/Nergal's Ring of the Eternal Storm.jpg"
import NergalsScimiteroftheBurningSky from "assets/images/items/Nergal's Scimiter of the Burning Sky.jpg"
import NergalsTridentoftheEternalStorm from "assets/images/items/Nergal's Trident of the Eternal Storm.jpg"
import NescientHelm from "assets/images/items/Nescient Helm.jpg"
import Neter from "assets/images/items/Neter.jpg"
import Nggoth from "assets/images/items/Nggoth.jpg"
import NightsShroud from "assets/images/items/Night's Shroud.jpg"
import NightlordBracers from "assets/images/items/Nightlord Bracers.jpg"
import NihilisticArmbands from "assets/images/items/Nihilistic Armbands.jpg"
import NihilisticCowl from "assets/images/items/Nihilistic Cowl.jpg"
import NihilisticGloves from "assets/images/items/Nihilistic Gloves.jpg"
import NihilisticPants from "assets/images/items/Nihilistic Pants.jpg"
import NihilisticRobe from "assets/images/items/Nihilistic Robe.jpg"
import NihilisticSash from "assets/images/items/Nihilistic Sash.jpg"
import NihilisticSlippers from "assets/images/items/Nihilistic Slippers.jpg"
import NihilisticWristbands from "assets/images/items/Nihilistic Wristbands.jpg"
import NilustheBloodWake from "assets/images/items/Nilus the Blood Wake.jpg"
import Nimbus from "assets/images/items/Nimbus.jpg"
import NithingBeheader from "assets/images/items/Nithing Beheader.jpg"
import NithingCrossbow from "assets/images/items/Nithing Crossbow.jpg"
import NithingFang from "assets/images/items/Nithing Fang.jpg"
import NoggsClubofHate from "assets/images/items/Nogg's Club of Hate.jpg"
import NoggsNeedle from "assets/images/items/Nogg's Needle.jpg"
import NorthCleaveoftheBlackTortoise from "assets/images/items/North Cleave of the Black Tortoise.jpg"
import NorthernFrostcape from "assets/images/items/Northern Frostcape.jpg"
import NourishingThoughts from "assets/images/items/Nourishing Thoughts.jpg"
import ObdurateMace from "assets/images/items/Obdurate Mace.jpg"
import Obliteratus from "assets/images/items/Obliteratus.jpg"
import OccultGemofDexterity from "assets/images/items/Occult Gem of Dexterity.jpg"
import OccultGemofStrength from "assets/images/items/Occult Gem of Strength.jpg"
import Okush from "assets/images/items/Okush.jpg"
import OphidianBand from "assets/images/items/Ophidian Band.jpg"
import OpusAdnullatus from "assets/images/items/Opus Adnullatus.jpg"
import OpusIgnis from "assets/images/items/Opus Ignis.jpg"
import OpusofAshandBlood from "assets/images/items/Opus of Ash and Blood.jpg"
import OrastessRobe from "assets/images/items/Orastes's Robe.jpg"
import OrbShard from "assets/images/items/Orb Shard.jpg"
import OtherworldlyFlute from "assets/images/items/Otherworldly Flute.jpg"
import OuroborosRing from "assets/images/items/Ouroboros Ring.jpg"
import OutcastMagesCache from "assets/images/items/Outcast Mage's Cache.jpg"
import Oxleg from "assets/images/items/Oxleg.jpg"
import PackleaderJerkin from "assets/images/items/Packleader Jerkin.jpg"
import PadsolesofBlackWhispers from "assets/images/items/Padsoles of Black Whispers.jpg"
import PadsolesofDarkMalice from "assets/images/items/Padsoles of Dark Malice.jpg"
import PadsolesofDeadlyGuile from "assets/images/items/Padsoles of Deadly Guile.jpg"
import PadsolesoftheSilentSlayer from "assets/images/items/Padsoles of the Silent Slayer.jpg"
import PainoftheDamned from "assets/images/items/Pain of the Damned.jpg"
import PainsEdge from "assets/images/items/Pain's Edge.jpg"
import PaladinsBaneblade from "assets/images/items/Paladin's Baneblade.jpg"
import PaladinsSiegeShield from "assets/images/items/Paladin's Siege Shield.jpg"
import PaladinsWidowmaker from "assets/images/items/Paladin's Widowmaker.jpg"
import PallidEngraver from "assets/images/items/Pallid Engraver.jpg"
import PallidusLibram from "assets/images/items/Pallidus Libram.jpg"
import PanopticPirateRing from "assets/images/items/Panoptic Pirate Ring.jpg"
import ParchedBladeofSlaughterWine from "assets/images/items/Parched Blade of Slaughter Wine.jpg"
import PartizanofRedRuin from "assets/images/items/Partizan of Red Ruin.jpg"
import PathofAhriman from "assets/images/items/Path of Ahriman.jpg"
import PathoftheEnlightened from "assets/images/items/Path of the Enlightened.jpg"
import PathfindersLoop from "assets/images/items/Pathfinder's Loop.jpg"
import PatronVambraces from "assets/images/items/Patron Vambraces.jpg"
import PatronageoftheFourFiends from "assets/images/items/Patronage of the Four Fiends.jpg"
import PauldronoftheSteelBehemoth from "assets/images/items/Pauldron of the Steel Behemoth.jpg"
import PauldronsofIndra from "assets/images/items/Pauldrons of Indra.jpg"
import PavisofFealty from "assets/images/items/Pavis of Fealty.jpg"
import PearlofHeaven from "assets/images/items/Pearl of Heaven.jpg"
import PearlRingofAssault from "assets/images/items/Pearl Ring of Assault.jpg"
import PendantofBlessing from "assets/images/items/Pendant of Blessing.jpg"
import PendantofContention from "assets/images/items/Pendant of Contention.jpg"
import PendantofPreservation from "assets/images/items/Pendant of Preservation.jpg"
import PendantofShielding from "assets/images/items/Pendant of Shielding.jpg"
import PendantoftheLegionCommander from "assets/images/items/Pendant of the Legion Commander.jpg"
import PendantofthePenitentPilgrim from "assets/images/items/Pendant of the Penitent Pilgrim.jpg"
import PendantofTribulationsEverlasting from "assets/images/items/Pendant of Tribulations Everlasting.jpg"
import PerennialGirdle from "assets/images/items/Perennial Girdle.jpg"
import PermanentTravellingMerchantContract from "assets/images/items/Permanent Travelling Merchant Contract.jpg"
import PetalsofLilium from "assets/images/items/Petals of Lilium.jpg"
import PhantomWard from "assets/images/items/Phantom Ward.jpg"
import PharohsGuardCache from "assets/images/items/Pharoh's Guard Cache.jpg"
import PhialofHeavenlyKnowledge from "assets/images/items/Phial of Heavenly Knowledge.jpg"
import PhilosopherArmbands from "assets/images/items/Philosopher Armbands.jpg"
import PhortahzCrossbow from "assets/images/items/Phortahz Crossbow.jpg"
import PickaxeoftheUbahKan from "assets/images/items/Pickaxe of the Ubah Kan.jpg"
import PickpocketsArmbandsoftheDeceiver from "assets/images/items/Pickpocket's Armbands of the Deceiver.jpg"
import PickpocketsArmbandsoftheSmolderingThrone from "assets/images/items/Pickpocket's Armbands of the Smoldering Throne.jpg"
import PickpocketsBandsoftheFifthStage from "assets/images/items/Pickpocket's Bands of the Fifth Stage.jpg"
import PickpocketsBeltofEngulfingTwilight from "assets/images/items/Pickpocket's Belt of Engulfing Twilight.jpg"
import PickpocketsBeltoftheNadir from "assets/images/items/Pickpocket's Belt of the Nadir.jpg"
import PickpocketsBeltoftheSunderedCrown from "assets/images/items/Pickpocket's Belt of the Sundered Crown.jpg"
import PickpocketsBeltoftheSwiftReturn from "assets/images/items/Pickpocket's Belt of the Swift Return.jpg"
import PickpocketsBootsoftheBurningTemple from "assets/images/items/Pickpocket's Boots of the Burning Temple.jpg"
import PickpocketsBootsoftheFinalWay from "assets/images/items/Pickpocket's Boots of the Final Way.jpg"
import PickpocketsBracersoftheBurningTemple from "assets/images/items/Pickpocket's Bracers of the Burning Temple.jpg"
import PickpocketsBracersoftheHiddenPalace from "assets/images/items/Pickpocket's Bracers of the Hidden Palace.jpg"
import PickpocketsBracersoftheTenthCourt from "assets/images/items/Pickpocket's Bracers of the Tenth Court.jpg"
import PickpocketsGlovesofEngulfingTwilight from "assets/images/items/Pickpocket's Gloves of Engulfing Twilight.jpg"
import PickpocketsGlovesoftheNadir from "assets/images/items/Pickpocket's Gloves of the Nadir.jpg"
import PickpocketsGlovesoftheSunderedCrown from "assets/images/items/Pickpocket's Gloves of the Sundered Crown.jpg"
import PickpocketsGlovesoftheSwiftReturn from "assets/images/items/Pickpocket's Gloves of the Swift Return.jpg"
import PickpocketsHelmoftheHiddenPalace from "assets/images/items/Pickpocket's Helm of the Hidden Palace.jpg"
import PickpocketsJerkinoftheHiddenPalace from "assets/images/items/Pickpocket's Jerkin of the Hidden Palace.jpg"
import PickpocketsJerkinoftheTenthCourt from "assets/images/items/Pickpocket's Jerkin of the Tenth Court.jpg"
import PickpocketsLeggingsoftheDeceiver from "assets/images/items/Pickpocket's Leggings of the Deceiver.jpg"
import PickpocketsLeggingsoftheFifthStage from "assets/images/items/Pickpocket's Leggings of the Fifth Stage.jpg"
import PickpocketsLeggingsoftheSmolderingThrone from "assets/images/items/Pickpocket's Leggings of the Smoldering Throne.jpg"
import PickpocketsLegguardsoftheStolenKingdom from "assets/images/items/Pickpocket's Legguards of the Stolen Kingdom.jpg"
import PickpocketsMaskoftheBurningTemple from "assets/images/items/Pickpocket's Mask of the Burning Temple.jpg"
import PickpocketsMaskoftheFinalWay from "assets/images/items/Pickpocket's Mask of the Final Way.jpg"
import PickpocketsStrapsoftheStolenKingdom from "assets/images/items/Pickpocket's Straps of the Stolen Kingdom.jpg"
import PickpocketsTunicoftheFinalWay from "assets/images/items/Pickpocket's Tunic of the Final Way.jpg"
import PickpocketsWristbandsoftheFinalway from "assets/images/items/Pickpocket's Wristbands of the Final way.jpg"
import PilgrimsArmbandsoftheBloodyStone from "assets/images/items/Pilgrim's Armbands of the Bloody Stone.jpg"
import PilgrimsBandsoftheExaltedSpirit from "assets/images/items/Pilgrim's Bands of the Exalted Spirit.jpg"
import PilgrimsBeltofShimmeringLight from "assets/images/items/Pilgrim's Belt of Shimmering Light.jpg"
import PilgrimsBeltoftheGreenOnes from "assets/images/items/Pilgrim's Belt of the Green Ones.jpg"
import PilgrimsBeltoftheThreeClarities from "assets/images/items/Pilgrim's Belt of the Three Clarities.jpg"
import PilgrimsBootsoftheCrumblingTower from "assets/images/items/Pilgrim's Boots of the Crumbling Tower.jpg"
import PilgrimsBootsofthePurpleSun from "assets/images/items/Pilgrim's Boots of the Purple Sun.jpg"
import PilgrimsBracersofthePurpleSun from "assets/images/items/Pilgrim's Bracers of the Purple Sun.jpg"
import PilgrimsBraidofYag from "assets/images/items/Pilgrim's Braid of Yag.jpg"
import PilgrimsClothofYag from "assets/images/items/Pilgrim's Cloth of Yag.jpg"
import PilgrimsGauntletsoftheSoaringHeart from "assets/images/items/Pilgrim's Gauntlets of the Soaring Heart.jpg"
import PilgrimsGirdleoftheSoaringHeart from "assets/images/items/Pilgrim's Girdle of the Soaring Heart.jpg"
import PilgrimsGlovesofShimmeringLight from "assets/images/items/Pilgrim's Gloves of Shimmering Light.jpg"
import PilgrimsGlovesoftheGreenOnes from "assets/images/items/Pilgrim's Gloves of the Green Ones.jpg"
import PilgrimsHarnessoftheCrumblingTower from "assets/images/items/Pilgrim's Harness of the Crumbling Tower.jpg"
import PilgrimsHeadband from "assets/images/items/Pilgrim's Headband.jpg"
import PilgrimsHeaddress from "assets/images/items/Pilgrim's Headdress.jpg"
import PilgrimsHelmoftheCrumblingTower from "assets/images/items/Pilgrim's Helm of the Crumbling Tower.jpg"
import PilgrimsHelmofthePurpleSun from "assets/images/items/Pilgrim's Helm of the Purple Sun.jpg"
import PilgrimsHelmet from "assets/images/items/Pilgrim's Helmet.jpg"
import PilgrimsHoodoftheAureate from "assets/images/items/Pilgrim's Hood of the Aureate.jpg"
import PilgrimsHoodoftheEldritch from "assets/images/items/Pilgrim's Hood of the Eldritch.jpg"
import PilgrimsJerkinoftheAureate from "assets/images/items/Pilgrim's Jerkin of the Aureate.jpg"
import PilgrimsJerkinofthePurpleSun from "assets/images/items/Pilgrim's Jerkin of the Purple Sun.jpg"
import PilgrimsLeatherHelm from "assets/images/items/Pilgrim's Leather Helm.jpg"
import PilgrimsLeggingsoftheBloodyStone from "assets/images/items/Pilgrim's Leggings of the Bloody Stone.jpg"
import PilgrimsLeggingsoftheExaltedSpirit from "assets/images/items/Pilgrim's Leggings of the Exalted Spirit.jpg"
import PilgrimsLegguardsoftheSoaringGod from "assets/images/items/Pilgrim's Legguards of the Soaring God.jpg"
import PilgrimsRobesoftheEldritch from "assets/images/items/Pilgrim's Robes of the Eldritch.jpg"
import PilgrimsSandalsoftheEldritch from "assets/images/items/Pilgrim's Sandals of the Eldritch.jpg"
import PilgrimsStrapsoftheAureate from "assets/images/items/Pilgrim's Straps of the Aureate.jpg"
import PilgrimsStrapsoftheSoaringGod from "assets/images/items/Pilgrim's Straps of the Soaring God.jpg"
import PilgrimsWrapsoftheThreeClarities from "assets/images/items/Pilgrim's Wraps of the Three Clarities.jpg"
import PilgrimsWriststrapsoftheEldritch from "assets/images/items/Pilgrim's Wrist-straps of the Eldritch.jpg"
import PitFightersClawedCord from "assets/images/items/Pit Fighter's Clawed Cord.jpg"
import PitFightersFrayedChoker from "assets/images/items/Pit Fighter's Frayed Choker.jpg"
import PitFightersGorget from "assets/images/items/Pit Fighter's Gorget.jpg"
import PitFightersHereticalEye from "assets/images/items/Pit Fighter's Heretical Eye.jpg"
import PitFightersIconofRapture from "assets/images/items/Pit Fighter's Icon of Rapture.jpg"
import PitFightersRemembrance from "assets/images/items/Pit Fighter's Remembrance.jpg"
import PitFightersTatteredChoker from "assets/images/items/Pit Fighter's Tattered Choker.jpg"
import PitfightersBattleCache from "assets/images/items/Pitfighter's Battle Cache.jpg"
import PitilessArmstrap from "assets/images/items/Pitiless Arm-strap.jpg"
import PlackartoftheSteelBehemoth from "assets/images/items/Plackart of the Steel Behemoth.jpg"
import PlumedHelmofDivinity from "assets/images/items/Plumed Helm of Divinity.jpg"
import PoShaLongsword from "assets/images/items/Po-Sha Longsword.jpg"
import PoderesofCelestialRadiance from "assets/images/items/Poderes of Celestial Radiance.jpg"
import PoderesofEffulgentDevotion from "assets/images/items/Poderes of Effulgent Devotion.jpg"
import PoderesofIlluminantConviction from "assets/images/items/Poderes of Illuminant Conviction.jpg"
import PoderesoftheAscension from "assets/images/items/Poderes of the Ascension.jpg"
import PolearmoftheBlackPharaoh from "assets/images/items/Polearm of the Black Pharaoh.jpg"
import PraeceptumBands from "assets/images/items/Praeceptum Bands.jpg"
import PraetoricArbitrator from "assets/images/items/Praetoric Arbitrator.jpg"
import PriestsBeltoftheBlackThread from "assets/images/items/Priest's Belt of the Black Thread.jpg"
import PriestsBootsoftheNineSprings from "assets/images/items/Priest's Boots of the Nine Springs.jpg"
import PriestsBootsoftheUnderworld from "assets/images/items/Priest's Boots of the Underworld.jpg"
import PriestsBracersoftheNineSprings from "assets/images/items/Priest's Bracers of the Nine Springs.jpg"
import PriestsCoilsofSacrifice from "assets/images/items/Priest's Coils of Sacrifice.jpg"
import PriestsCordofBalance from "assets/images/items/Priest's Cord of Balance.jpg"
import PriestsCrestofBalance from "assets/images/items/Priest's Crest of Balance.jpg"
import PriestsFauldoftheLimitlessCipher from "assets/images/items/Priest's Fauld of the Limitless Cipher.jpg"
import PriestsGlovesoftheUnderworld from "assets/images/items/Priest's Gloves of the Underworld.jpg"
import PriestsRaimentoftheUnderworld from "assets/images/items/Priest's Raiment of the Underworld.jpg"
import PriestsStrapsoftheLimitlessCipher from "assets/images/items/Priest's Straps of the Limitless Cipher.jpg"
import PriestsStrapsoftheUnderworld from "assets/images/items/Priest's Straps of the Underworld.jpg"
import PriestsThreadsofSacrifice from "assets/images/items/Priest's Threads of Sacrifice.jpg"
import PriestsVisageoftheBlackThread from "assets/images/items/Priest's Visage of the Black Thread.jpg"
import PrizeofZamora from "assets/images/items/Prize of Zamora.jpg"
import ProfaneOpus from "assets/images/items/Profane Opus.jpg"
import ProjectilesoftheBloodDrinker from "assets/images/items/Projectiles of the Blood Drinker.jpg"
import ProphetsCacheofOblivion from "assets/images/items/Prophet's Cache of Oblivion.jpg"
import ProseliteArmbands from "assets/images/items/Proselite Armbands.jpg"
import PungentAbsorber from "assets/images/items/Pungent Absorber.jpg"
import PurebloodGirdle from "assets/images/items/Pureblood Girdle.jpg"
import PutharjathsLegacy from "assets/images/items/Putharjath's Legacy.jpg"
import PutrescentBlade from "assets/images/items/Putrescent Blade.jpg"
import QuartermastersBand from "assets/images/items/Quartermaster's Band.jpg"
import QuartermastersRemedialBand from "assets/images/items/Quartermaster's Remedial Band.jpg"
import QuartermastersWarBand from "assets/images/items/Quartermaster's War Band.jpg"
import QueenBlade from "assets/images/items/Queen Blade.jpg"
import QuickeningAtlanteanCatalyst from "assets/images/items/Quickening Atlantean Catalyst.jpg"
import QuicknessoftheKatari from "assets/images/items/Quickness of the Katari.jpg"
import QuicksenseRing from "assets/images/items/Quicksense Ring.jpg"
import Quicksilver from "assets/images/items/Quicksilver.jpg"
import QuicksilveredLeggings from "assets/images/items/Quicksilvered Leggings.jpg"
import QuillofIbis from "assets/images/items/Quill of Ibis.jpg"
import QuiverofBarbedTongues from "assets/images/items/Quiver of Barbed Tongues.jpg"
import QuiverofBlackAsps from "assets/images/items/Quiver of Black Asps.jpg"
import QuiverofRakedFlesh from "assets/images/items/Quiver of Raked Flesh.jpg"
import RadiantCharmofFury from "assets/images/items/Radiant Charm of Fury.jpg"
import RageofXotli from "assets/images/items/Rage of Xotli.jpg"
import RaidersArmbandsoftheCovertTrail from "assets/images/items/Raider's Armbands of the Covert Trail.jpg"
import RaidersArmbandsofWorldsEdge from "assets/images/items/Raider's Armbands of World's Edge.jpg"
import RaidersBeltoftheCovertTrail from "assets/images/items/Raider's Belt of the Covert Trail.jpg"
import RaidersBeltoftheGrasslands from "assets/images/items/Raider's Belt of the Grasslands.jpg"
import RaidersBeltoftheWickedHearth from "assets/images/items/Raider's Belt of the Wicked Hearth.jpg"
import RaidersBeltofWorldsEdge from "assets/images/items/Raider's Belt of World's Edge.jpg"
import RaidersBootsofaHundredEyes from "assets/images/items/Raider's Boots of a Hundred Eyes.jpg"
import RaidersBootsoftheGraspingWild from "assets/images/items/Raider's Boots of the Grasping Wild.jpg"
import RaidersBootsoftheHowlingMoon from "assets/images/items/Raider's Boots of the Howling Moon.jpg"
import RaidersBootsoftheHowlingWind from "assets/images/items/Raider's Boots of the Howling Wind.jpg"
import RaidersChestguardoftheKhan from "assets/images/items/Raider's Chestguard of the Khan.jpg"
import RaidersFeralWarRing from "assets/images/items/Raider's Feral War Ring.jpg"
import RaidersGauntletsoftheKhan from "assets/images/items/Raider's Gauntlets of the Khan.jpg"
import RaidersGlovesoftheBloodyFang from "assets/images/items/Raider's Gloves of the Bloody Fang.jpg"
import RaidersGlovesoftheRitualFlame from "assets/images/items/Raider's Gloves of the Ritual Flame.jpg"
import RaidersGlovesofWovenClouds from "assets/images/items/Raider's Gloves of Woven Clouds.jpg"
import RaidersHelmoftheGrasslands from "assets/images/items/Raider's Helm of the Grasslands.jpg"
import RaidersHoodofWorldsEdge from "assets/images/items/Raider's Hood of World's Edge.jpg"
import RaidersJerkinoftheRitualFlame from "assets/images/items/Raider's Jerkin of the Ritual Flame.jpg"
import RaidersJerkinofWovenClouds from "assets/images/items/Raider's Jerkin of Woven Clouds.jpg"
import RaidersLeggingsoftheCovertTrail from "assets/images/items/Raider's Leggings of the Covert Trail.jpg"
import RaidersLeggingsoftheWickedHearth from "assets/images/items/Raider's Leggings of the Wicked Hearth.jpg"
import RaidersLeggingsofWorldsEdge from "assets/images/items/Raider's Leggings of World's Edge.jpg"
import RaidersMaskoftheCovertTrail from "assets/images/items/Raider's Mask of the Covert Trail.jpg"
import RaidersStrapsofaHundredEyes from "assets/images/items/Raider's Straps of a Hundred Eyes.jpg"
import RaidersStrapsoftheGraspingWild from "assets/images/items/Raider's Straps of the Grasping Wild.jpg"
import RaidersTunicoftheBloodyFang from "assets/images/items/Raider's Tunic of the Bloody Fang.jpg"
import RaidersVambracesoftheHowlingMoon from "assets/images/items/Raider's Vambraces of the Howling Moon.jpg"
import RaidersWristbandsoftheHowlingWind from "assets/images/items/Raider's Wristbands of the Howling Wind.jpg"
import RainofRespondingDragon from "assets/images/items/Rain of Responding Dragon.jpg"
import Ramnyr from "assets/images/items/Ramnyr.jpg"
import RareRelic from "assets/images/items/Rare Relic.jpg"
import Rattlecurse from "assets/images/items/Rattlecurse.jpg"
import RavensFeast from "assets/images/items/Raven's Feast.jpg"
import RavenbonePauldrons from "assets/images/items/Ravenbone Pauldrons.jpg"
import RavenclawArmbands from "assets/images/items/Ravenclaw Armbands.jpg"
import RavenclawBracers from "assets/images/items/Ravenclaw Bracers.jpg"
import RavenclawHelm from "assets/images/items/Ravenclaw Helm.jpg"
import RavenclawTasset from "assets/images/items/Ravenclaw Tasset.jpg"
import RavenkinGloves from "assets/images/items/Ravenkin Gloves.jpg"
import RavenkinHood from "assets/images/items/Ravenkin Hood.jpg"
import RavensilkLeggings from "assets/images/items/Ravensilk Leggings.jpg"
import RavensilkVest from "assets/images/items/Ravensilk Vest.jpg"
import Razhar from "assets/images/items/Razhar.jpg"
import RazoroftheDivinitySerpent from "assets/images/items/Razor of the Divinity Serpent.jpg"
import ReadersArmstrapsoftheCrescent from "assets/images/items/Reader's Arm-straps of the Crescent.jpg"
import ReadersArmstrapsoftheMoon from "assets/images/items/Reader's Arm-straps of the Moon.jpg"
import ReadersArmbandsoftheBurningDisc from "assets/images/items/Reader's Armbands of the Burning Disc.jpg"
import ReadersArmbandsoftheEffulgentBlade from "assets/images/items/Reader's Armbands of the Effulgent Blade.jpg"
import ReadersBandsoftheExiled from "assets/images/items/Reader's Bands of the Exiled.jpg"
import ReadersBeltoftheBurningDisc from "assets/images/items/Reader's Belt of the Burning Disc.jpg"
import ReadersBeltoftheCrescent from "assets/images/items/Reader's Belt of the Crescent.jpg"
import ReadersBeltoftheEffulgentBlade from "assets/images/items/Reader's Belt of the Effulgent Blade.jpg"
import ReadersBeltoftheMoon from "assets/images/items/Reader's Belt of the Moon.jpg"
import ReadersBootsoftheCelestialHilt from "assets/images/items/Reader's Boots of the Celestial Hilt.jpg"
import ReadersBootsoftheExiled from "assets/images/items/Reader's Boots of the Exiled.jpg"
import ReadersBootsofTwiningSmoke from "assets/images/items/Reader's Boots of Twining Smoke.jpg"
import ReadersBraceletsofAwakening from "assets/images/items/Reader's Bracelets of Awakening.jpg"
import ReadersBracersofTwiningSmoke from "assets/images/items/Reader's Bracers of Twining Smoke.jpg"
import ReadersCowloftheCrescent from "assets/images/items/Reader's Cowl of the Crescent.jpg"
import ReadersCowloftheEffulgentBlade from "assets/images/items/Reader's Cowl of the Effulgent Blade.jpg"
import ReadersGlovesoftheEternalEclipse from "assets/images/items/Reader's Gloves of the Eternal Eclipse.jpg"
import ReadersGlovesoftheForbiddenArt from "assets/images/items/Reader's Gloves of the Forbidden Art.jpg"
import ReadersGlovesoftheHeavens from "assets/images/items/Reader's Gloves of the Heavens.jpg"
import ReadersGlovesoftheWaningMoon from "assets/images/items/Reader's Gloves of the Waning Moon.jpg"
import ReadersHoodoftheBurningDisc from "assets/images/items/Reader's Hood of the Burning Disc.jpg"
import ReadersLeggingsoftheEffulgentBlade from "assets/images/items/Reader's Leggings of the Effulgent Blade.jpg"
import ReadersLeggingsoftheMoon from "assets/images/items/Reader's Leggings of the Moon.jpg"
import ReadersRobesoftheHeavens from "assets/images/items/Reader's Robes of the Heavens.jpg"
import ReadersRobesoftheWaningMoon from "assets/images/items/Reader's Robes of the Waning Moon.jpg"
import ReadersSandalsofAwakening from "assets/images/items/Reader's Sandals of Awakening.jpg"
import ReadersTunicoftheEternalEclipse from "assets/images/items/Reader's Tunic of the Eternal Eclipse.jpg"
import ReadersTunicoftheForbiddenArt from "assets/images/items/Reader's Tunic of the Forbidden Art.jpg"
import ReadersWristbandsoftheCelestialHilt from "assets/images/items/Reader's Wristbands of the Celestial Hilt.jpg"
import Reaper from "assets/images/items/Reaper.jpg"
import RebelsBattleaxe from "assets/images/items/Rebel's Battleaxe.jpg"
import RebelsDagger from "assets/images/items/Rebel's Dagger.jpg"
import RebelsLongbow from "assets/images/items/Rebel's Longbow.jpg"
import RecruitsAgility from "assets/images/items/Recruit's Agility.jpg"
import RecruitsCloak from "assets/images/items/Recruit's Cloak.jpg"
import RecruitsIntellect from "assets/images/items/Recruit's Intellect.jpg"
import RecruitsPotency from "assets/images/items/Recruit's Potency.jpg"
import RecruitsStrength from "assets/images/items/Recruit's Strength.jpg"
import RecruitsVigor from "assets/images/items/Recruit's Vigor.jpg"
import RecurveBowofImpossibleVines from "assets/images/items/Recurve Bow of Impossible Vines.jpg"
import RedbloodCloak from "assets/images/items/Redblood Cloak.jpg"
import ReddenedLacerator from "assets/images/items/Reddened Lacerator.jpg"
import Redfang from "assets/images/items/Redfang.jpg"
import RedfuryWarWolf from "assets/images/items/Redfury War Wolf.jpg"
import Redspray from "assets/images/items/Redspray.jpg"
import RedtalonGauntlets from "assets/images/items/Redtalon Gauntlets.jpg"
import RejuvinatingShoulders from "assets/images/items/Rejuvinating Shoulders.jpg"
import RelicofDarkBlessings from "assets/images/items/Relic of Dark Blessings.jpg"
import RelicofFallenStars from "assets/images/items/Relic of Fallen Stars.jpg"
import RelicoftheAncientSands from "assets/images/items/Relic of the Ancient Sands.jpg"
import RelicoftheHellWalker from "assets/images/items/Relic of the Hell Walker.jpg"
import RelicoftheOysterMucus from "assets/images/items/Relic of the Oyster Mucus.jpg"
import RelivingMantram from "assets/images/items/Reliving Mantram.jpg"
import Remorse from "assets/images/items/Remorse.jpg"
import RenatosBow from "assets/images/items/Renato's Bow.jpg"
import RenatosCrossbow from "assets/images/items/Renato's Crossbow.jpg"
import RepressorsCodex from "assets/images/items/Repressor's Codex.jpg"
import RepressorsDagger from "assets/images/items/Repressor's Dagger.jpg"
import RepressorsFlamebrand from "assets/images/items/Repressor's Flamebrand.jpg"
import RepressorsTrident from "assets/images/items/Repressor's Trident.jpg"
import RequiemofPain from "assets/images/items/Requiem of Pain.jpg"
import RerebraceofRedRuinnm from "assets/images/items/Rerebrace of Red Ruin (nm).jpg"
import RerebraceofRedRuin from "assets/images/items/Rerebrace of Red Ruin.jpg"
import RerebraceoftheBloodDrinkernm from "assets/images/items/Rerebrace of the Blood Drinker (nm).jpg"
import RerebraceoftheBloodDrinker from "assets/images/items/Rerebrace of the Blood Drinker.jpg"
import RerebraceoftheDeathMasternm from "assets/images/items/Rerebrace of the Death Master (nm).jpg"
import RerebraceoftheDeathMaster from "assets/images/items/Rerebrace of the Death Master.jpg"
import RerebraceoftheFallenEmpirenm from "assets/images/items/Rerebrace of the Fallen Empire (nm).jpg"
import RerebraceoftheFallenEmpire from "assets/images/items/Rerebrace of the Fallen Empire.jpg"
import RerebraceoftheSanguineDisciplenm from "assets/images/items/Rerebrace of the Sanguine Disciple (nm).jpg"
import RerebraceoftheSanguineDisciple from "assets/images/items/Rerebrace of the Sanguine Disciple.jpg"
import RestorativeRing from "assets/images/items/Restorative Ring.jpg"
import Retribution from "assets/images/items/Retribution.jpg"
import RevenantRing from "assets/images/items/Revenant Ring.jpg"
import RevivfyingAtlanteanCatalyst from "assets/images/items/Revivfying Atlantean Catalyst.jpg"
import RightHandofNergal from "assets/images/items/Right Hand of Nergal.jpg"
import RingofAmratheLion from "assets/images/items/Ring of Amra the Lion.jpg"
import RingofAnarchy from "assets/images/items/Ring of Anarchy.jpg"
import RingofAncientPython from "assets/images/items/Ring of Ancient Python.jpg"
import RingofBrokenPromises from "assets/images/items/Ring of Broken Promises.jpg"
import RingofChthonicNightmares from "assets/images/items/Ring of Chthonic Nightmares.jpg"
import RingofConservation from "assets/images/items/Ring of Conservation.jpg"
import RingofCorruption from "assets/images/items/Ring of Corruption.jpg"
import RingofDagon from "assets/images/items/Ring of Dagon.jpg"
import RingofFlamingFury from "assets/images/items/Ring of Flaming Fury.jpg"
import RingofGrounding from "assets/images/items/Ring of Grounding.jpg"
import RingofImpossibleSecrets from "assets/images/items/Ring of Impossible Secrets.jpg"
import RingofInsightfulAction from "assets/images/items/Ring of Insightful Action.jpg"
import RingofIntent from "assets/images/items/Ring of Intent.jpg"
import RingofIronSkin from "assets/images/items/Ring of Iron Skin.jpg"
import RingofKatar from "assets/images/items/Ring of Katar.jpg"
import RingofMemory from "assets/images/items/Ring of Memory.jpg"
import RingofMordec from "assets/images/items/Ring of Mordec.jpg"
import RingofOldAcheron from "assets/images/items/Ring of Old Acheron.jpg"
import RingofProfaneKnowledge from "assets/images/items/Ring of Profane Knowledge.jpg"
import RingofProtection from "assets/images/items/Ring of Protection.jpg"
import RingofResolve from "assets/images/items/Ring of Resolve.jpg"
import RingofScalding from "assets/images/items/Ring of Scalding.jpg"
import RingofSkelos from "assets/images/items/Ring of Skelos.jpg"
import RingofSwiftStorms from "assets/images/items/Ring of Swift Storms.jpg"
import RingoftheArsonist from "assets/images/items/Ring of the Arsonist.jpg"
import RingoftheAstralStep from "assets/images/items/Ring of the Astral Step.jpg"
import RingoftheBurningBeacon from "assets/images/items/Ring of the Burning Beacon.jpg"
import RingoftheExcavator from "assets/images/items/Ring of the Excavator.jpg"
import RingoftheFallenEmpire from "assets/images/items/Ring of the Fallen Empire.jpg"
import RingoftheHierophant from "assets/images/items/Ring of the Hierophant.jpg"
import RingoftheJungleCat from "assets/images/items/Ring of the Jungle Cat.jpg"
import RingofthePonderousLady from "assets/images/items/Ring of the Ponderous Lady.jpg"
import RingoftheSerpentFather from "assets/images/items/Ring of the Serpent Father.jpg"
import RingoftheVampireSquid from "assets/images/items/Ring of the Vampire Squid.jpg"
import RingofWarmastersWrath from "assets/images/items/Ring of Warmaster's Wrath.jpg"
import RingofYimsha from "assets/images/items/Ring of Yimsha.jpg"
import RipperoftheFacelessChaos from "assets/images/items/Ripper of the Faceless Chaos.jpg"
import RitualisticArmguards from "assets/images/items/Ritualistic Armguards.jpg"
import RobeofFiendishInvocation from "assets/images/items/Robe of Fiendish Invocation.jpg"
import RobesofaThousandBlossoms from "assets/images/items/Robes of a Thousand Blossoms.jpg"
import RodofRighteousMight from "assets/images/items/Rod of Righteous Might.jpg"
import RodoftheResplendentPhoenix from "assets/images/items/Rod of the Resplendent Phoenix.jpg"
import RooksCunning from "assets/images/items/Rook's Cunning.jpg"
import RooktalonBolts from "assets/images/items/Rooktalon Bolts.jpg"
import RookwardensChestguard from "assets/images/items/Rookwarden's Chestguard.jpg"
import RookwardensHelm from "assets/images/items/Rookwarden's Helm.jpg"
import RootofDeath from "assets/images/items/Root of Death.jpg"
import Rotbolter from "assets/images/items/Rotbolter.jpg"
import RoyalAquilonianBrandy from "assets/images/items/Royal Aquilonian Brandy.jpg"
import RoyalAtlanteanDagger from "assets/images/items/Royal Atlantean Dagger.jpg"
import RoyalAtlanteanGown from "assets/images/items/Royal Atlantean Gown.jpg"
import RoyalDragonEliteBelt from "assets/images/items/Royal Dragon Elite Belt.jpg"
import RoyalDragonEliteBoots from "assets/images/items/Royal Dragon Elite Boots.jpg"
import RoyalDragonEliteCloak from "assets/images/items/Royal Dragon Elite Cloak.jpg"
import RoyalDragonEliteCuirass from "assets/images/items/Royal Dragon Elite Cuirass.jpg"
import RoyalDragonEliteHelm from "assets/images/items/Royal Dragon Elite Helm.jpg"
import RoyalDragonEliteLegguards from "assets/images/items/Royal Dragon Elite Legguards.jpg"
import RoyalDragonEliteVambraces from "assets/images/items/Royal Dragon Elite Vambraces.jpg"
import RoyalSignet from "assets/images/items/Royal Signet.jpg"
import RoyalWarSteed from "assets/images/items/Royal War Steed.jpg"
import RoyalZingaranBlade from "assets/images/items/Royal Zingaran Blade.jpg"
import RoyalZingaranSabre from "assets/images/items/Royal Zingaran Sabre.jpg"
import RubyRingofStrength from "assets/images/items/Ruby Ring of Strength.jpg"
import RunicBandofInherentHatred from "assets/images/items/Runic Band of Inherent Hatred.jpg"
import RusticFauld from "assets/images/items/Rustic Fauld.jpg"
import RuthlessBlade from "assets/images/items/Ruthless Blade.jpg"
import SaboteurRing from "assets/images/items/Saboteur Ring.jpg"
import SadisticProbe from "assets/images/items/Sadistic Probe.jpg"
import SagarisoftheTwelfthDynasty from "assets/images/items/Sagaris of the Twelfth Dynasty.jpg"
import SagesArmbandsoftheCrumblingTower from "assets/images/items/Sage's Armbands of the Crumbling Tower.jpg"
import SagesBeltoftheAureate from "assets/images/items/Sage's Belt of the Aureate.jpg"
import SagesBeltofthePurpleSun from "assets/images/items/Sage's Belt of the Purple Sun.jpg"
import SagesBootsoftheBloodyStone from "assets/images/items/Sage's Boots of the Bloody Stone.jpg"
import SagesBootsoftheSoaringGod from "assets/images/items/Sage's Boots of the Soaring God.jpg"
import SagesBracersoftheBloodyStone from "assets/images/items/Sage's Bracers of the Bloody Stone.jpg"
import SagesBracersoftheSoaringGod from "assets/images/items/Sage's Bracers of the Soaring God.jpg"
import SagesBraidoftheEldritch from "assets/images/items/Sage's Braid of the Eldritch.jpg"
import SagesBreastplateoftheThreeClarities from "assets/images/items/Sage's Breastplate of the Three Clarities.jpg"
import SagesCoverofShimmeringLight from "assets/images/items/Sage's Cover of Shimmering Light.jpg"
import SagesCoveringsoftheEldritch from "assets/images/items/Sage's Coverings of the Eldritch.jpg"
import SagesGauntletsoftheCrumblingTower from "assets/images/items/Sage's Gauntlets of the Crumbling Tower.jpg"
import SagesGirdleoftheCrumblingTower from "assets/images/items/Sage's Girdle of the Crumbling Tower.jpg"
import SagesGlovesoftheEldritch from "assets/images/items/Sage's Gloves of the Eldritch.jpg"
import SagesGlovesofthePurpleSun from "assets/images/items/Sage's Gloves of the Purple Sun.jpg"
import SagesHandwrapsoftheAureate from "assets/images/items/Sage's Hand-wraps of the Aureate.jpg"
import SagesHarnessoftheSoaringHeart from "assets/images/items/Sage's Harness of the Soaring Heart.jpg"
import SagesHelmoftheGreenOnes from "assets/images/items/Sage's Helm of the Green Ones.jpg"
import SagesHelmoftheSoaringHeart from "assets/images/items/Sage's Helm of the Soaring Heart.jpg"
import SagesJerkinoftheGreenOnes from "assets/images/items/Sage's Jerkin of the Green Ones.jpg"
import SagesLeggingsoftheAureate from "assets/images/items/Sage's Leggings of the Aureate.jpg"
import SagesLeggingsoftheCrumblingTower from "assets/images/items/Sage's Leggings of the Crumbling Tower.jpg"
import SagesLegguardsofthePurpleSun from "assets/images/items/Sage's Legguards of the Purple Sun.jpg"
import SagesMaskoftheThreeClarities from "assets/images/items/Sage's Mask of the Three Clarities.jpg"
import SagesPauldronsoftheAureate from "assets/images/items/Sage's Pauldrons of the Aureate.jpg"
import SagesSandalsofYag from "assets/images/items/Sage's Sandals of Yag.jpg"
import SagesSashoftheEldritch from "assets/images/items/Sage's Sash of the Eldritch.jpg"
import SagesShoesoftheExaltedSpirit from "assets/images/items/Sage's Shoes of the Exalted Spirit.jpg"
import SagesStrapsoftheExaltedSpirit from "assets/images/items/Sage's Straps of the Exalted Spirit.jpg"
import SagesStrapsofthePurpleSun from "assets/images/items/Sage's Straps of the Purple Sun.jpg"
import SagesVestmentofShimmeringLight from "assets/images/items/Sage's Vestment of Shimmering Light.jpg"
import SagesWriststrapsofYag from "assets/images/items/Sage's Wrist-straps of Yag.jpg"
import Sagewrath from "assets/images/items/Sagewrath.jpg"
import SaintlyProtector from "assets/images/items/Saintly Protector.jpg"
import SamooresRadiantScripture from "assets/images/items/Samoore's Radiant Scripture.jpg"
import SamooresStaffofDivinity from "assets/images/items/Samoore's Staff of Divinity.jpg"
import SanctimoniousHelm from "assets/images/items/Sanctimonious Helm.jpg"
import SandalsofIndomitableSouls from "assets/images/items/Sandals of Indomitable Souls.jpg"
import SandalsoftheCrawlingChaos from "assets/images/items/Sandals of the Crawling Chaos.jpg"
import SandalsoftheFacelessChaos from "assets/images/items/Sandals of the Faceless Chaos.jpg"
import SandalsoftheFacelessSphinx from "assets/images/items/Sandals of the Faceless Sphinx.jpg"
import SandalsoftheHaunterintheDark from "assets/images/items/Sandals of the Haunter in the Dark.jpg"
import SandalsoftheHowlingGiant from "assets/images/items/Sandals of the Howling Giant.jpg"
import SandalsoftheOxmal from "assets/images/items/Sandals of the Oxmal.jpg"
import SandalsofthePrimalSpirit from "assets/images/items/Sandals of the Primal Spirit.jpg"
import SandalsoftheShiveringStars from "assets/images/items/Sandals of the Shivering Stars.jpg"
import SandalsoftheUbahKan from "assets/images/items/Sandals of the Ubah Kan.jpg"
import SashofaThousandBlossoms from "assets/images/items/Sash of a Thousand Blossoms.jpg"
import SashoftheAmaranthineDrums from "assets/images/items/Sash of the Amaranthine Drums.jpg"
import SashoftheBloodGodnm from "assets/images/items/Sash of the Blood God (nm).jpg"
import SashoftheBloodGod from "assets/images/items/Sash of the Blood God.jpg"
import SashoftheBloodhunternm from "assets/images/items/Sash of the Bloodhunter (nm).jpg"
import SashoftheBloodhunter from "assets/images/items/Sash of the Bloodhunter.jpg"
import SashoftheFacelessSphinx from "assets/images/items/Sash of the Faceless Sphinx.jpg"
import SashoftheRevelations from "assets/images/items/Sash of the Revelations.jpg"
import SavageDeathBelt from "assets/images/items/Savage Death Belt.jpg"
import SavageDeathBoots from "assets/images/items/Savage Death Boots.jpg"
import SavageDeathBracers from "assets/images/items/Savage Death Bracers.jpg"
import SavageDeathPantaloons from "assets/images/items/Savage Death Pantaloons.jpg"
import SavageLeggings from "assets/images/items/Savage Leggings.jpg"
import SavantSAncientScripts from "assets/images/items/Savant'S Ancient Scripts.jpg"
import SavantsArmbandsofAwakening from "assets/images/items/Savant's Armbands of Awakening.jpg"
import SavantsArmbandsoftheCelestialHilt from "assets/images/items/Savant's Armbands of the Celestial Hilt.jpg"
import SavantsArmbandsofTwiningSmoke from "assets/images/items/Savant's Armbands of Twining Smoke.jpg"
import SavantsBandsoftheMoon from "assets/images/items/Savant's Bands of the Moon.jpg"
import SavantsBeltoftheEternalEclipse from "assets/images/items/Savant's Belt of the Eternal Eclipse.jpg"
import SavantsBeltoftheForbiddenArt from "assets/images/items/Savant's Belt of the Forbidden Art.jpg"
import SavantsBeltoftheWaningMoon from "assets/images/items/Savant's Belt of the Waning Moon.jpg"
import SavantsBootsoftheEffulgentBlade from "assets/images/items/Savant's Boots of the Effulgent Blade.jpg"
import SavantsBootsoftheMoon from "assets/images/items/Savant's Boots of the Moon.jpg"
import SavantsBracersoftheBurningDisc from "assets/images/items/Savant's Bracers of the Burning Disc.jpg"
import SavantsCowloftheEternalEclipse from "assets/images/items/Savant's Cowl of the Eternal Eclipse.jpg"
import SavantsCowloftheWaningMoon from "assets/images/items/Savant's Cowl of the Waning Moon.jpg"
import SavantsGlovesoftheBurningDisc from "assets/images/items/Savant's Gloves of the Burning Disc.jpg"
import SavantsGlovesoftheCrescent from "assets/images/items/Savant's Gloves of the Crescent.jpg"
import SavantsGlovesoftheEffulgentBlade from "assets/images/items/Savant's Gloves of the Effulgent Blade.jpg"
import SavantsHoodoftheForbiddenArt from "assets/images/items/Savant's Hood of the Forbidden Art.jpg"
import SavantsLeggingsoftheCelestialHilt from "assets/images/items/Savant's Leggings of the Celestial Hilt.jpg"
import SavantsLeggingsoftheExiled from "assets/images/items/Savant's Leggings of the Exiled.jpg"
import SavantsLeggingsofTwiningSmoke from "assets/images/items/Savant's Leggings of Twining Smoke.jpg"
import SavantsMantleoftheHeavens from "assets/images/items/Savant's Mantle of the Heavens.jpg"
import SavantsPantsofAwakening from "assets/images/items/Savant's Pants of Awakening.jpg"
import SavantsRegaliaoftheMoon from "assets/images/items/Savant's Regalia of the Moon.jpg"
import SavantsRobesoftheCrescent from "assets/images/items/Savant's Robes of the Crescent.jpg"
import SavantsSandalsoftheCrescent from "assets/images/items/Savant's Sandals of the Crescent.jpg"
import SavantsSashoftheHeavens from "assets/images/items/Savant's Sash of the Heavens.jpg"
import SavantsStrapsoftheExiled from "assets/images/items/Savant's Straps of the Exiled.jpg"
import SavantsTunicoftheBurningDisc from "assets/images/items/Savant's Tunic of the Burning Disc.jpg"
import SavantsTunicoftheEffulgentBlade from "assets/images/items/Savant's Tunic of the Effulgent Blade.jpg"
import SavantsWristbandsoftheEffulgentBlade from "assets/images/items/Savant's Wristbands of the Effulgent Blade.jpg"
import SavantsWristsoftheCrescent from "assets/images/items/Savant's Wrists of the Crescent.jpg"
import SaviorsMace from "assets/images/items/Savior's Mace.jpg"
import SaviorsMantleoftheLivingLegend from "assets/images/items/Savior's Mantle of the Living Legend.jpg"
import SaviorsShieldEternal from "assets/images/items/Savior's Shield Eternal.jpg"
import SaviorsSkyPiercer from "assets/images/items/Savior's Sky Piercer.jpg"
import SaviorsSpetum from "assets/images/items/Savior's Spetum.jpg"
import SaviorsSpiteHammer from "assets/images/items/Savior's Spite Hammer.jpg"
import SaviorsTotemPole from "assets/images/items/Savior's Totem Pole.jpg"
import SaviorsWarhammer from "assets/images/items/Savior's Warhammer.jpg"
import ScalesofHardiness from "assets/images/items/Scales of Hardiness.jpg"
import ScarabHornRing from "assets/images/items/Scarab Horn Ring.jpg"
import ScarclawBoots from "assets/images/items/Scarclaw Boots.jpg"
import ScarclawHauberk from "assets/images/items/Scarclaw Hauberk.jpg"
import ScarclawHelm from "assets/images/items/Scarclaw Helm.jpg"
import ScarclawLeggings from "assets/images/items/Scarclaw Leggings.jpg"
import ScarhideBelt from "assets/images/items/Scarhide Belt.jpg"
import ScarhideBoots from "assets/images/items/Scarhide Boots.jpg"
import ScarhideBracers from "assets/images/items/Scarhide Bracers.jpg"
import ScarhideHelm from "assets/images/items/Scarhide Helm.jpg"
import ScarletFightersRing from "assets/images/items/Scarlet Fighters Ring.jpg"
import ScarletMarkofManipulation from "assets/images/items/Scarlet Mark of Manipulation.jpg"
import ScarletNecklace from "assets/images/items/Scarlet Necklace.jpg"
import ScarletSpellwardersRing from "assets/images/items/Scarlet Spellwarders Ring.jpg"
import ScepterofReturn from "assets/images/items/Scepter of Return.jpg"
import ScepterofTenThousandHells from "assets/images/items/Scepter of Ten Thousand Hells.jpg"
import ScepteroftheAugustOnes from "assets/images/items/Scepter of the August Ones.jpg"
import ScholarsArmbandsoftheBurningDisc from "assets/images/items/Scholar's Armbands of the Burning Disc.jpg"
import ScholarsArmbandsoftheEffulgentBlade from "assets/images/items/Scholar's Armbands of the Effulgent Blade.jpg"
import ScholarsBandoftheCrescent from "assets/images/items/Scholar's Band of the Crescent.jpg"
import ScholarsBandsoftheHeavens from "assets/images/items/Scholar's Bands of the Heavens.jpg"
import ScholarsBeltoftheBurningDisc from "assets/images/items/Scholar's Belt of the Burning Disc.jpg"
import ScholarsBeltoftheCrescent from "assets/images/items/Scholar's Belt of the Crescent.jpg"
import ScholarsBeltoftheEffulgentBlade from "assets/images/items/Scholar's Belt of the Effulgent Blade.jpg"
import ScholarsBootsoftheEternalEclipse from "assets/images/items/Scholar's Boots of the Eternal Eclipse.jpg"
import ScholarsBootsoftheForbiddenArt from "assets/images/items/Scholar's Boots of the Forbidden Art.jpg"
import ScholarsBootsoftheHeavens from "assets/images/items/Scholar's Boots of the Heavens.jpg"
import ScholarsBraceletoftheWaningMoon from "assets/images/items/Scholar's Bracelet of the Waning Moon.jpg"
import ScholarsBracersoftheForbiddenArt from "assets/images/items/Scholar's Bracers of the Forbidden Art.jpg"
import ScholarsCowloftheCelestialHilt from "assets/images/items/Scholar's Cowl of the Celestial Hilt.jpg"
import ScholarsDoubletofAwakening from "assets/images/items/Scholar's Doublet of Awakening.jpg"
import ScholarsGlovesoftheBurningDisc from "assets/images/items/Scholar's Gloves of the Burning Disc.jpg"
import ScholarsGlovesoftheEffulgentBlade from "assets/images/items/Scholar's Gloves of the Effulgent Blade.jpg"
import ScholarsGlovesoftheMoon from "assets/images/items/Scholar's Gloves of the Moon.jpg"
import ScholarsGraspoftheCrescent from "assets/images/items/Scholar's Grasp of the Crescent.jpg"
import ScholarsHoodofAwakening from "assets/images/items/Scholar's Hood of Awakening.jpg"
import ScholarsHoodofTwiningSmoke from "assets/images/items/Scholar's Hood of Twining Smoke.jpg"
import ScholarsLeggingsoftheBurningDisc from "assets/images/items/Scholar's Leggings of the Burning Disc.jpg"
import ScholarsLeggingsoftheEffulgentBlade from "assets/images/items/Scholar's Leggings of the Effulgent Blade.jpg"
import ScholarsLeggingsoftheMoon from "assets/images/items/Scholar's Leggings of the Moon.jpg"
import ScholarsMantleoftheExiled from "assets/images/items/Scholar's Mantle of the Exiled.jpg"
import ScholarsPantsoftheCrescent from "assets/images/items/Scholar's Pants of the Crescent.jpg"
import ScholarsRegaliaoftheExiled from "assets/images/items/Scholar's Regalia of the Exiled.jpg"
import ScholarsSandalsoftheWaningMoon from "assets/images/items/Scholar's Sandals of the Waning Moon.jpg"
import ScholarsSashoftheMoon from "assets/images/items/Scholar's Sash of the Moon.jpg"
import ScholarsStrapsoftheMoon from "assets/images/items/Scholar's Straps of the Moon.jpg"
import ScholarsTunicoftheCelestialHilt from "assets/images/items/Scholar's Tunic of the Celestial Hilt.jpg"
import ScholarsTunicofTwiningSmoke from "assets/images/items/Scholar's Tunic of Twining Smoke.jpg"
import ScholarsWristbandsoftheEternalEclipse from "assets/images/items/Scholar's Wristbands of the Eternal Eclipse.jpg"
import ScholarisChain from "assets/images/items/Scholaris Chain.jpg"
import ScimitarofRedRuin from "assets/images/items/Scimitar of Red Ruin.jpg"
import ScipiosNecklaceofProtection from "assets/images/items/Scipio's Necklace of Protection.jpg"
import ScorchedBandoftheInferno from "assets/images/items/Scorched Band of the Inferno.jpg"
import ScoriaceousCacheofOblivion from "assets/images/items/Scoriaceous Cache of Oblivion.jpg"
import Scourge from "assets/images/items/Scourge.jpg"
import ScribesStaff from "assets/images/items/Scribe's Staff.jpg"
import ScriptureofCoronalSkies from "assets/images/items/Scripture of Coronal Skies.jpg"
import ScrollofSnowandSorrow from "assets/images/items/Scroll of Snow and Sorrow.jpg"
import SealofAnarchy from "assets/images/items/Seal of Anarchy.jpg"
import SealofDeepestTartaros from "assets/images/items/Seal of Deepest Tartaros.jpg"
import SealofDivertion from "assets/images/items/Seal of Divertion.jpg"
import SealofPrivilege from "assets/images/items/Seal of Privilege.jpg"
import SealoftheBlackWind from "assets/images/items/Seal of the Black Wind.jpg"
import SearingSword from "assets/images/items/Searing Sword.jpg"
import SecondWind from "assets/images/items/Second Wind.jpg"
import Sekhmet from "assets/images/items/Sekhmet.jpg"
import SepulchersWard from "assets/images/items/Sepulcher's Ward.jpg"
import Sepulcher from "assets/images/items/Sepulcher.jpg"
import Serenity from "assets/images/items/Serenity.jpg"
import SerpentsScale from "assets/images/items/Serpent's Scale.jpg"
import SerpentscaleBelt from "assets/images/items/Serpentscale Belt.jpg"
import Servatus from "assets/images/items/Servatus.jpg"
import SetsJudgement from "assets/images/items/Set's Judgement.jpg"
import SetsPerversion from "assets/images/items/Set's Perversion.jpg"
import SetsPotency from "assets/images/items/Set's Potency.jpg"
import SetsPower from "assets/images/items/Set's Power.jpg"
import SetsScrutiny from "assets/images/items/Set's Scrutiny.jpg"
import SewerKingsRegalia from "assets/images/items/Sewer King's Regalia.jpg"
import ShadowofZath from "assets/images/items/Shadow of Zath.jpg"
import ShadowsArmstrapsofUsheringTwilight from "assets/images/items/Shadow's Arm-straps of Ushering Twilight.jpg"
import ShadowsArmbandsoftheBurningTemple from "assets/images/items/Shadow's Armbands of the Burning Temple.jpg"
import ShadowsArmbandsoftheFinalWay from "assets/images/items/Shadow's Armbands of the Final Way.jpg"
import ShadowsBandsoftheTenthCourt from "assets/images/items/Shadow's Bands of the Tenth Court.jpg"
import ShadowsBane from "assets/images/items/Shadow's Bane.jpg"
import ShadowsBeltoftheBurningTemple from "assets/images/items/Shadow's Belt of the Burning Temple.jpg"
import ShadowsBeltoftheFinalWay from "assets/images/items/Shadow's Belt of the Final Way.jpg"
import ShadowsBeltoftheHiddenPalace from "assets/images/items/Shadow's Belt of the Hidden Palace.jpg"
import ShadowsBeltoftheTenthCourt from "assets/images/items/Shadow's Belt of the Tenth Court.jpg"
import ShadowsBootsoftheDeceiver from "assets/images/items/Shadow's Boots of the Deceiver.jpg"
import ShadowsBootsoftheDuskRebellion from "assets/images/items/Shadow's Boots of the Dusk Rebellion.jpg"
import ShadowsBootsoftheFifthStage from "assets/images/items/Shadow's Boots of the Fifth Stage.jpg"
import ShadowsBootsoftheSmolderingThrone from "assets/images/items/Shadow's Boots of the Smoldering Throne.jpg"
import ShadowsBootsoftheStolenKingdom from "assets/images/items/Shadow's Boots of the Stolen Kingdom.jpg"
import ShadowsBracersoftheDuskRebellion from "assets/images/items/Shadow's Bracers of the Dusk Rebellion.jpg"
import ShadowsBracersoftheFifthStage from "assets/images/items/Shadow's Bracers of the Fifth Stage.jpg"
import ShadowsBracersoftheSmolderingThrone from "assets/images/items/Shadow's Bracers of the Smoldering Throne.jpg"
import ShadowsBracersoftheStolenKingdom from "assets/images/items/Shadow's Bracers of the Stolen Kingdom.jpg"
import ShadowsBreechesofUsheringTwilight from "assets/images/items/Shadow's Breeches of Ushering Twilight.jpg"
import ShadowsCordofUsheringTwilight from "assets/images/items/Shadow's Cord of Ushering Twilight.jpg"
import ShadowsEdge from "assets/images/items/Shadow's Edge.jpg"
import ShadowsFauldoftheTenthCourt from "assets/images/items/Shadow's Fauld of the Tenth Court.jpg"
import ShadowsGlovesoftheBurningTemple from "assets/images/items/Shadow's Gloves of the Burning Temple.jpg"
import ShadowsGlovesoftheFinalWay from "assets/images/items/Shadow's Gloves of the Final Way.jpg"
import ShadowsGlovesoftheHiddenPalace from "assets/images/items/Shadow's Gloves of the Hidden Palace.jpg"
import ShadowsGlovesoftheTenthCourt from "assets/images/items/Shadow's Gloves of the Tenth Court.jpg"
import ShadowsGlovesofUsheringTwilight from "assets/images/items/Shadow's Gloves of Ushering Twilight.jpg"
import ShadowsHelmoftheNadir from "assets/images/items/Shadow's Helm of the Nadir.jpg"
import ShadowsHelmoftheSwiftReturn from "assets/images/items/Shadow's Helm of the Swift Return.jpg"
import ShadowsHoodofWhisperedDeeds from "assets/images/items/Shadow's Hood of Whispered Deeds.jpg"
import ShadowsJerkinoftheNadir from "assets/images/items/Shadow's Jerkin of the Nadir.jpg"
import ShadowsJerkinoftheSwiftReturn from "assets/images/items/Shadow's Jerkin of the Swift Return.jpg"
import ShadowsLeggingsoftheBurningTemple from "assets/images/items/Shadow's Leggings of the Burning Temple.jpg"
import ShadowsLeggingsoftheFinalWay from "assets/images/items/Shadow's Leggings of the Final Way.jpg"
import ShadowsLegguardsoftheHiddenPalace from "assets/images/items/Shadow's Legguards of the Hidden Palace.jpg"
import ShadowsMaskofEngulfingTwilight from "assets/images/items/Shadow's Mask of Engulfing Twilight.jpg"
import ShadowsMaskoftheSunderedCrown from "assets/images/items/Shadow's Mask of the Sundered Crown.jpg"
import ShadowsStrapsoftheHiddenPalace from "assets/images/items/Shadow's Straps of the Hidden Palace.jpg"
import ShadowsTunicofEngulfingTwilight from "assets/images/items/Shadow's Tunic of Engulfing Twilight.jpg"
import ShadowsTunicoftheSunderedCrown from "assets/images/items/Shadow's Tunic of the Sundered Crown.jpg"
import ShadowsTunicofWhisperedDeeds from "assets/images/items/Shadow's Tunic of Whispered Deeds.jpg"
import ShadowsWristbandsoftheDeceiver from "assets/images/items/Shadow's Wristbands of the Deceiver.jpg"
import ShadowbroodGloves from "assets/images/items/Shadowbrood Gloves.jpg"
import Shadowcord from "assets/images/items/Shadowcord.jpg"
import Shadowdrinker from "assets/images/items/Shadowdrinker.jpg"
import ShadowyBracers from "assets/images/items/Shadowy Bracers.jpg"
import ShahStinger from "assets/images/items/Shah Stinger.jpg"
import ShardofTartarosdexterity from "assets/images/items/Shard of Tartaros (dexterity).jpg"
import ShardofTartarosintelligence from "assets/images/items/Shard of Tartaros (intelligence).jpg"
import ShardBladeofWraal from "assets/images/items/Shard-Blade of Wraal.jpg"
import Shatterfist from "assets/images/items/Shatterfist.jpg"
import ShatushofPandemonium from "assets/images/items/Shatush of Pandemonium.jpg"
import ShatushoftheBloodmoon from "assets/images/items/Shatush of the Bloodmoon.jpg"
import ShatushoftheEcliptic from "assets/images/items/Shatush of the Ecliptic.jpg"
import ShatushoftheFirstCircle from "assets/images/items/Shatush of the First Circle.jpg"
import ShausReflection from "assets/images/items/Shau's Reflection.jpg"
import Shawabti from "assets/images/items/Shawabti.jpg"
import ShawloftheDeparted from "assets/images/items/Shawl of the Departed.jpg"
import SheduofArcingSkies from "assets/images/items/Shedu of Arcing Skies.jpg"
import ShemiteExileCache from "assets/images/items/Shemite Exile Cache.jpg"
import ShemiteExileTunic from "assets/images/items/Shemite Exile Tunic.jpg"
import ShemiteExileWristguards from "assets/images/items/Shemite Exile Wristguards.jpg"
import ShemiteMercenaryArmbands from "assets/images/items/Shemite Mercenary Armbands.jpg"
import ShemiteMercenaryBoots from "assets/images/items/Shemite Mercenary Boots.jpg"
import ShemiteMercenaryGrips from "assets/images/items/Shemite Mercenary Grips.jpg"
import ShemiteMercenaryLeggings from "assets/images/items/Shemite Mercenary Leggings.jpg"
import ShemiteMercenaryTunic from "assets/images/items/Shemite Mercenary Tunic.jpg"
import ShemiteMercenaryTurban from "assets/images/items/Shemite Mercenary Turban.jpg"
import ShemiteMercenaryWristbands from "assets/images/items/Shemite Mercenary Wristbands.jpg"
import ShemiteWayfarerArmbands from "assets/images/items/Shemite Wayfarer Armbands.jpg"
import ShemiteWayfarerBelt from "assets/images/items/Shemite Wayfarer Belt.jpg"
import ShemiteWayfarerBoots from "assets/images/items/Shemite Wayfarer Boots.jpg"
import ShemiteWayfarerLeggings from "assets/images/items/Shemite Wayfarer Leggings.jpg"
import ShemiteWayfarerTunic from "assets/images/items/Shemite Wayfarer Tunic.jpg"
import ShemiteWayfarerWristbands from "assets/images/items/Shemite Wayfarer Wristbands.jpg"
import Shemmu from "assets/images/items/Shemmu.jpg"
import ShendohofArdentFire from "assets/images/items/Shendoh of Ardent Fire.jpg"
import ShendohofConflagrantFlame from "assets/images/items/Shendoh of Conflagrant Flame.jpg"
import ShendohofInfernalZeal from "assets/images/items/Shendoh of Infernal Zeal.jpg"
import ShendohoftheEternalBlaze from "assets/images/items/Shendoh of the Eternal Blaze.jpg"
import ShendohoftheWhisperingBlade from "assets/images/items/Shendoh of the Whispering Blade.jpg"
import ShevatasJewelHikedBlade from "assets/images/items/Shevatas Jewel-Hiked Blade.jpg"
import ShieldofAmra from "assets/images/items/Shield of Amra.jpg"
import ShieldofTearsUnshed from "assets/images/items/Shield of Tears Unshed.jpg"
import ShieldoftheBlackPharaoh from "assets/images/items/Shield of the Black Pharaoh.jpg"
import ShieldoftheFallenEmpire from "assets/images/items/Shield of the Fallen Empire.jpg"
import ShieldoftheKozakSlayer from "assets/images/items/Shield of the Kozak Slayer.jpg"
import ShieldoftheShiveringStars from "assets/images/items/Shield of the Shivering Stars.jpg"
import ShieldoftheSoulEater from "assets/images/items/Shield of the Soul Eater.jpg"
import ShieldofYag from "assets/images/items/Shield of Yag.jpg"
import ShillelaghofSogoth from "assets/images/items/Shillelagh of Sogoth.jpg"
import ShinpadsoftheBlackPharaoh from "assets/images/items/Shin-pads of the Black Pharaoh.jpg"
import ShinpadsoftheDarkMessenger from "assets/images/items/Shin-pads of the Dark Messenger.jpg"
import ShinstrapsoftheBloodGodnm from "assets/images/items/Shin-straps of the Blood God (nm).jpg"
import ShinstrapsoftheBloodGod from "assets/images/items/Shin-straps of the Blood God.jpg"
import ShinstrapsoftheDeathMasternm from "assets/images/items/Shin-straps of the Death Master (nm).jpg"
import ShinstrapsoftheDeathMaster from "assets/images/items/Shin-straps of the Death Master.jpg"
import ShivoftheAutumnNight from "assets/images/items/Shiv of the Autumn Night.jpg"
import ShivoftheTriumphant from "assets/images/items/Shiv of the Triumphant.jpg"
import ShocksandBelt from "assets/images/items/Shocksand Belt.jpg"
import ShoulderPadoftheCacklingMarionette from "assets/images/items/Shoulder Pad of the Cackling Marionette.jpg"
import ShoulderStrapofBoneandHorn from "assets/images/items/Shoulder Strap of Bone and Horn.jpg"
import ShoulderStrapoftheGreatImpi from "assets/images/items/Shoulder Strap of the Great Impi.jpg"
import ShoveloftheDarkMessenger from "assets/images/items/Shovel of the Dark Messenger.jpg"
import ShriekingWind from "assets/images/items/Shrieking Wind.jpg"
import ShrillBoneFlute from "assets/images/items/Shrill Bone Flute.jpg"
import ShroudofElevenForbiddenNames from "assets/images/items/Shroud of Eleven Forbidden Names.jpg"
import ShroudoftheGhostCrowsSpite from "assets/images/items/Shroud of the Ghost Crow's Spite.jpg"
import ShroudoftheOuterDark from "assets/images/items/Shroud of the Outer Dark.jpg"
import ShroudofZath from "assets/images/items/Shroud of Zath.jpg"
import Shukusht from "assets/images/items/Shu'kusht.jpg"
import Siegebreaker from "assets/images/items/Siegebreaker.jpg"
import SigilofFuneralFlames from "assets/images/items/Sigil of Funeral Flames.jpg"
import SigilofYigsDominion from "assets/images/items/Sigil of Yig's Dominion.jpg"
import SignetofAnarchy from "assets/images/items/Signet of Anarchy.jpg"
import SinisterTunic from "assets/images/items/Sinister Tunic.jpg"
import Sinstrike from "assets/images/items/Sinstrike.jpg"
import SiroccosLament from "assets/images/items/Sirocco's Lament.jpg"
import SkirmishersArrows from "assets/images/items/Skirmisher's Arrows.jpg"
import SkirmishersBlade from "assets/images/items/Skirmisher's Blade.jpg"
import SkirmishersBolts from "assets/images/items/Skirmisher's Bolts.jpg"
import SkirmishersCrossbow from "assets/images/items/Skirmisher's Crossbow.jpg"
import SkirmishersDirk from "assets/images/items/Skirmisher's Dirk.jpg"
import SkirmishersGreatShield from "assets/images/items/Skirmisher's Great Shield.jpg"
import SkirmishersGreatbow from "assets/images/items/Skirmisher's Greatbow.jpg"
import SkirmishersGreatsword from "assets/images/items/Skirmisher's Greatsword.jpg"
import SkirmishersKrys from "assets/images/items/Skirmisher's Krys.jpg"
import SkirmishersMarkofAbhorrence from "assets/images/items/Skirmisher's Mark of Abhorrence.jpg"
import SkirmishersMaximofEntropy from "assets/images/items/Skirmisher's Maxim of Entropy.jpg"
import SkirmishersSanctum from "assets/images/items/Skirmisher's Sanctum.jpg"
import SkirmishersScepter from "assets/images/items/Skirmisher's Scepter.jpg"
import SkirmishersSpellGlaive from "assets/images/items/Skirmisher's Spell Glaive.jpg"
import SkirmishersSpellsword from "assets/images/items/Skirmisher's Spellsword.jpg"
import SkirmishersStaff from "assets/images/items/Skirmisher's Staff.jpg"
import SkirmishersWarFist from "assets/images/items/Skirmisher's War Fist.jpg"
import SkirmishersWarGlaive from "assets/images/items/Skirmisher's War Glaive.jpg"
import SkirmishersWarMaul from "assets/images/items/Skirmisher's War Maul.jpg"
import SkirtoftheCacklingMarionette from "assets/images/items/Skirt of the Cackling Marionette.jpg"
import SkirtoftheDragonKing from "assets/images/items/Skirt of the Dragon King.jpg"
import SkirtoftheGhostoftheVeldt from "assets/images/items/Skirt of the Ghost of the Veldt.jpg"
import SkirtoftheHellWalkernm from "assets/images/items/Skirt of the Hell Walker (nm).jpg"
import SkirtoftheHellWalker from "assets/images/items/Skirt of the Hell Walker.jpg"
import Skrymir from "assets/images/items/Skrymir.jpg"
import SkullClaspofBloodyCarnage from "assets/images/items/Skull Clasp of Bloody Carnage.jpg"
import SkullGateGauntlets from "assets/images/items/Skull Gate Gauntlets.jpg"
import SkullGatePauldrons from "assets/images/items/Skull Gate Pauldrons.jpg"
import SkullGateSabatons from "assets/images/items/Skull Gate Sabatons.jpg"
import Skullcracker from "assets/images/items/Skullcracker.jpg"
import Skyfire from "assets/images/items/Skyfire.jpg"
import SkyhawksEdge from "assets/images/items/Skyhawk's Edge.jpg"
import Skylance from "assets/images/items/Skylance.jpg"
import SkyshearArmbands from "assets/images/items/Skyshear Armbands.jpg"
import SkyshearBoots from "assets/images/items/Skyshear Boots.jpg"
import SkyshearBracers from "assets/images/items/Skyshear Bracers.jpg"
import SkyshearGauntlets from "assets/images/items/Skyshear Gauntlets.jpg"
import SkyshearGirdle from "assets/images/items/Skyshear Girdle.jpg"
import SkyshearHelm from "assets/images/items/Skyshear Helm.jpg"
import SkyshearJerkin from "assets/images/items/Skyshear Jerkin.jpg"
import SkyshearTasset from "assets/images/items/Skyshear Tasset.jpg"
import Skystorm from "assets/images/items/Skystorm.jpg"
import SlayersMantleoftheLivingLegend from "assets/images/items/Slayer's Mantle of the Living Legend.jpg"
import SleightcraftMitts from "assets/images/items/Sleightcraft Mitts.jpg"
import SliverofPureIcedexterity from "assets/images/items/Sliver of Pure Ice (dexterity).jpg"
import SliverofPureIcewisdom from "assets/images/items/Sliver of Pure Ice (wisdom).jpg"
import SmileofTartaros from "assets/images/items/Smile of Tartaros.jpg"
import SmiteoftheNorthernWastes from "assets/images/items/Smite of the Northern Wastes.jpg"
import SnakeheadofIntelligence from "assets/images/items/Snakehead of Intelligence.jpg"
import SnakeswiftPadsoles from "assets/images/items/Snakeswift Padsoles.jpg"
import SnaketoothDagger from "assets/images/items/Snaketooth Dagger.jpg"
import SnowcloudCloak from "assets/images/items/Snowcloud Cloak.jpg"
import Solace from "assets/images/items/Solace.jpg"
import SolesoftheEndlessSands from "assets/images/items/Soles of the Endless Sands.jpg"
import SolesoftheGhostoftheVeldt from "assets/images/items/Soles of the Ghost of the Veldt.jpg"
import SongofDemise from "assets/images/items/Song of Demise.jpg"
import SongoftheFourWailingElohim from "assets/images/items/Song of the Four Wailing Elohim.jpg"
import SorcerersArmbandsofRegalMight from "assets/images/items/Sorcerer's Armbands of Regal Might.jpg"
import SorcerersArmbandsoftheEmperorsFavor from "assets/images/items/Sorcerer's Armbands of the Emperor's Favor.jpg"
import SorcerersBeltofSovereignRule from "assets/images/items/Sorcerer's Belt of Sovereign Rule.jpg"
import SorcerersBootsofPrestige from "assets/images/items/Sorcerer's Boots of Prestige.jpg"
import SorcerersBracersofImperialAssent from "assets/images/items/Sorcerer's Bracers of Imperial Assent.jpg"
import SorcerersBracersofPrestige from "assets/images/items/Sorcerer's Bracers of Prestige.jpg"
import SorcerersDread from "assets/images/items/Sorcerer's Dread.jpg"
import SorcerersGauntletsofImperialAssent from "assets/images/items/Sorcerer's Gauntlets of Imperial Assent.jpg"
import SorcerersGirdleoftheMandate from "assets/images/items/Sorcerer's Girdle of the Mandate.jpg"
import SorcerersGlovesofPrestige from "assets/images/items/Sorcerer's Gloves of Prestige.jpg"
import SorcerersHelmoftheMandate from "assets/images/items/Sorcerer's Helm of the Mandate.jpg"
import SorcerersHoodofSovereignRule from "assets/images/items/Sorcerer's Hood of Sovereign Rule.jpg"
import SorcerersLeggingsofRegalMight from "assets/images/items/Sorcerer's Leggings of Regal Might.jpg"
import SorcerersLeggingsoftheEmperorsFavor from "assets/images/items/Sorcerer's Leggings of the Emperor's Favor.jpg"
import SorcerersRobeofPrestige from "assets/images/items/Sorcerer's Robe of Prestige.jpg"
import SorcerersRobesofImperialAssent from "assets/images/items/Sorcerer's Robes of Imperial Assent.jpg"
import SosunPattahoftheEndlessSands from "assets/images/items/Sosun Pattah of the Endless Sands.jpg"
import SoulofAtali from "assets/images/items/Soul of Atali.jpg"
import SoulofPashtun from "assets/images/items/Soul of Pashtun.jpg"
import Soulbearer from "assets/images/items/Soulbearer.jpg"
import SoulblessedRod from "assets/images/items/Soulblessed Rod.jpg"
import Soulcleaver from "assets/images/items/Soulcleaver.jpg"
import Soulcrush from "assets/images/items/Soulcrush.jpg"
import Souldrinker from "assets/images/items/Souldrinker.jpg"
import Soulgrist from "assets/images/items/Soulgrist.jpg"
import Soulguard from "assets/images/items/Soulguard.jpg"
import Soulharrow from "assets/images/items/Soulharrow.jpg"
import SoulmarkBelt from "assets/images/items/Soulmark Belt.jpg"
import SoulrendersMark from "assets/images/items/Soulrender's Mark.jpg"
import SoulscreamNecklace from "assets/images/items/Soulscream Necklace.jpg"
import Soulsplitter from "assets/images/items/Soulsplitter.jpg"
import Soulstorm from "assets/images/items/Soulstorm.jpg"
import Soulthief from "assets/images/items/Soulthief.jpg"
import SoulthunderSpangenhelm from "assets/images/items/Soulthunder Spangenhelm.jpg"
import SoulwatchHood from "assets/images/items/Soulwatch Hood.jpg"
import SoulwoundGloves from "assets/images/items/Soulwound Gloves.jpg"
import SouthCleaveoftheVermillionBird from "assets/images/items/South Cleave of the Vermillion Bird.jpg"
import SovereignBattleblade from "assets/images/items/Sovereign Battleblade.jpg"
import SovereignofAnarchy from "assets/images/items/Sovereign of Anarchy.jpg"
import SpearofAratus from "assets/images/items/Spear of Aratus.jpg"
import SpearofIshti from "assets/images/items/Spear of Ishti.jpg"
import SpearofNephrenKa from "assets/images/items/Spear of Nephren-Ka.jpg"
import SpearoftheDarkSun from "assets/images/items/Spear of the Dark Sun.jpg"
import SpearofthePagoda from "assets/images/items/Spear of the Pagoda.jpg"
import SpearofthePillars from "assets/images/items/Spear of the Pillars.jpg"
import SpectralCape from "assets/images/items/Spectral Cape.jpg"
import SpellbaneMantle from "assets/images/items/Spellbane Mantle.jpg"
import SpellguardHelm from "assets/images/items/Spellguard Helm.jpg"
import SpiderwardBreastplate from "assets/images/items/Spiderward Breastplate.jpg"
import SpikeShield from "assets/images/items/Spike Shield.jpg"
import SpineofDagon from "assets/images/items/Spine of Dagon.jpg"
import Spinebreaker from "assets/images/items/Spinebreaker.jpg"
import Spineduster from "assets/images/items/Spineduster.jpg"
import Spinegrist from "assets/images/items/Spinegrist.jpg"
import SpinesofRepose from "assets/images/items/Spines of Repose.jpg"
import SpireoftheFirmament from "assets/images/items/Spire of the Firmament.jpg"
import SpiritofJovus from "assets/images/items/Spirit of Jovus.jpg"
import SpiritarkGloves from "assets/images/items/Spiritark Gloves.jpg"
import Spiritguard from "assets/images/items/Spiritguard.jpg"
import SpiritualRing from "assets/images/items/Spiritual Ring.jpg"
import SpiritualWard from "assets/images/items/Spiritual Ward.jpg"
import SpitefulGauntlets from "assets/images/items/Spiteful Gauntlets.jpg"
import SprightlyPiratePendant from "assets/images/items/Sprightly Pirate Pendant.jpg"
import SquareShieldoftheZiggurat from "assets/images/items/Square Shield of the Ziggurat.jpg"
import StaffofDevoutPiety from "assets/images/items/Staff of Devout Piety.jpg"
import StaffofErlik from "assets/images/items/Staff of Erlik.jpg"
import StaffofEternalConfluence from "assets/images/items/Staff of Eternal Confluence.jpg"
import StaffofKwan from "assets/images/items/Staff of Kwan.jpg"
import StaffofSouls from "assets/images/items/Staff of Souls.jpg"
import StaffoftheCrustacean from "assets/images/items/Staff of the Crustacean.jpg"
import StaffoftheGladiator from "assets/images/items/Staff of the Gladiator.jpg"
import StaffofthePrimalSpirit from "assets/images/items/Staff of the Primal Spirit.jpg"
import StaffoftheShiveringStars from "assets/images/items/Staff of the Shivering Stars.jpg"
import StalkersArmstrapsoftheBattlethrall from "assets/images/items/Stalker's Arm-straps of the Battlethrall.jpg"
import StalkersArmbandsofArcaneDeath from "assets/images/items/Stalker's Armbands of Arcane Death.jpg"
import StalkersArmbandsoftheSilentKill from "assets/images/items/Stalker's Armbands of the Silent Kill.jpg"
import StalkersBeltofShatteredSouls from "assets/images/items/Stalker's Belt of Shattered Souls.jpg"
import StalkersBeltoftheBlackArts from "assets/images/items/Stalker's Belt of the Black Arts.jpg"
import StalkersBeltoftheFirebringer from "assets/images/items/Stalker's Belt of the Firebringer.jpg"
import StalkersBootsofCharredEarth from "assets/images/items/Stalker's Boots of Charred Earth.jpg"
import StalkersBootsoftheHiddenTomb from "assets/images/items/Stalker's Boots of the Hidden Tomb.jpg"
import StalkersBootsofWaningDusk from "assets/images/items/Stalker's Boots of Waning Dusk.jpg"
import StalkersBracersofCharredEarth from "assets/images/items/Stalker's Bracers of Charred Earth.jpg"
import StalkersBracersoftheGrimCabal from "assets/images/items/Stalker's Bracers of the Grim Cabal.jpg"
import StalkersBracersoftheHiddenTomb from "assets/images/items/Stalker's Bracers of the Hidden Tomb.jpg"
import StalkersCordofCreepingDeath from "assets/images/items/Stalker's Cord of Creeping Death.jpg"
import StalkersDeathmaskofCreepingDeath from "assets/images/items/Stalker's Deathmask of Creeping Death.jpg"
import StalkersFauldofMalice from "assets/images/items/Stalker's Fauld of Malice.jpg"
import StalkersGlovesofCharredEarth from "assets/images/items/Stalker's Gloves of Charred Earth.jpg"
import StalkersGlovesoftheGrimCabal from "assets/images/items/Stalker's Gloves of the Grim Cabal.jpg"
import StalkersGlovesoftheHiddenTomb from "assets/images/items/Stalker's Gloves of the Hidden Tomb.jpg"
import StalkersGripsofWaningDusk from "assets/images/items/Stalker's Grips of Waning Dusk.jpg"
import StalkersJerkinofWaningDusk from "assets/images/items/Stalker's Jerkin of Waning Dusk.jpg"
import StalkersLeggingsofArcaneDeath from "assets/images/items/Stalker's Leggings of Arcane Death.jpg"
import StalkersLeggingsoftheBattlethrall from "assets/images/items/Stalker's Leggings of the Battlethrall.jpg"
import StalkersLeggingsoftheSilentKill from "assets/images/items/Stalker's Leggings of the Silent Kill.jpg"
import StalkersMaskofShatteredSouls from "assets/images/items/Stalker's Mask of Shattered Souls.jpg"
import StalkersMaskoftheFirebringer from "assets/images/items/Stalker's Mask of the Firebringer.jpg"
import StalkersSpauldofMalice from "assets/images/items/Stalker's Spauld of Malice.jpg"
import StalkersTunicofCharredEarth from "assets/images/items/Stalker's Tunic of Charred Earth.jpg"
import StalkersTunicoftheGrimCabal from "assets/images/items/Stalker's Tunic of the Grim Cabal.jpg"
import StalkersTunicoftheHiddenTomb from "assets/images/items/Stalker's Tunic of the Hidden Tomb.jpg"
import StalkersVeiloftheBlackArts from "assets/images/items/Stalker's Veil of the Black Arts.jpg"
import StalkersWristbandsofWaningDusk from "assets/images/items/Stalker's Wristbands of Waning Dusk.jpg"
import StalwartRing from "assets/images/items/Stalwart Ring.jpg"
import StaminaoftheWolf from "assets/images/items/Stamina of the Wolf.jpg"
import StarTouchedMantleoftheLivingLegend from "assets/images/items/Star Touched Mantle of the Living Legend.jpg"
import StaunchguardPlateBoots from "assets/images/items/Staunchguard Plate Boots.jpg"
import StaveofMaleficRites from "assets/images/items/Stave of Malefic Rites.jpg"
import StaveoftheHellWalkernm from "assets/images/items/Stave of the Hell Walker (nm).jpg"
import StaveoftheHellWalker from "assets/images/items/Stave of the Hell Walker.jpg"
import SteadfastArmguards from "assets/images/items/Steadfast Armguards.jpg"
import SteadfastnessofJovus from "assets/images/items/Steadfastness of Jovus.jpg"
import SteelforgedSalvationoftheUndyingAtlantis from "assets/images/items/Steelforged Salvation of the Undying Atlantis.jpg"
import SteelspirirtLegguards from "assets/images/items/Steelspirirt Legguards.jpg"
import SteelspiritArmguards from "assets/images/items/Steelspirit Armguards.jpg"
import SteelspiritBoots from "assets/images/items/Steelspirit Boots.jpg"
import SteelspiritChestguard from "assets/images/items/Steelspirit Chestguard.jpg"
import SteelspiritGauntlets from "assets/images/items/Steelspirit Gauntlets.jpg"
import SteelspiritGirdle from "assets/images/items/Steelspirit Girdle.jpg"
import SteelspiritHelm from "assets/images/items/Steelspirit Helm.jpg"
import SteelspiritVambraces from "assets/images/items/Steelspirit Vambraces.jpg"
import StingoftheRepugnant from "assets/images/items/Sting of the Repugnant.jpg"
import Stonesplitter from "assets/images/items/Stonesplitter.jpg"
import Stormpike from "assets/images/items/Stormpike.jpg"
import StormrendGauntlets from "assets/images/items/Stormrend Gauntlets.jpg"
import Stormslash from "assets/images/items/Stormslash.jpg"
import Stragis from "assets/images/items/Stragis.jpg"
import StranglersArmbandsoftheHiddenTomb from "assets/images/items/Strangler's Armbands of the Hidden Tomb.jpg"
import StranglersBeltofCharredEarth from "assets/images/items/Strangler's Belt of Charred Earth.jpg"
import StranglersBeltoftheGrimCabal from "assets/images/items/Strangler's Belt of the Grim Cabal.jpg"
import StranglersBeltoftheHiddenTomb from "assets/images/items/Strangler's Belt of the Hidden Tomb.jpg"
import StranglersBootsofArcaneDeath from "assets/images/items/Strangler's Boots of Arcane Death.jpg"
import StranglersBootsofMalice from "assets/images/items/Strangler's Boots of Malice.jpg"
import StranglersBootsoftheBattlethrall from "assets/images/items/Strangler's Boots of the Battlethrall.jpg"
import StranglersBootsoftheSilentKill from "assets/images/items/Strangler's Boots of the Silent Kill.jpg"
import StranglersBracersofArcaneDeath from "assets/images/items/Strangler's Bracers of Arcane Death.jpg"
import StranglersBracersoftheBattlethrall from "assets/images/items/Strangler's Bracers of the Battlethrall.jpg"
import StranglersBracersoftheSilentKill from "assets/images/items/Strangler's Bracers of the Silent Kill.jpg"
import StranglersCordofWaningDusk from "assets/images/items/Strangler's Cord of Waning Dusk.jpg"
import StranglersFauldofWaningDusk from "assets/images/items/Strangler's Fauld of Waning Dusk.jpg"
import StranglersGlovesofCreepingDeath from "assets/images/items/Strangler's Gloves of Creeping Death.jpg"
import StranglersGlovesofShatteredSouls from "assets/images/items/Strangler's Gloves of Shattered Souls.jpg"
import StranglersGlovesoftheBlackArts from "assets/images/items/Strangler's Gloves of the Black Arts.jpg"
import StranglersGlovesoftheFirebringer from "assets/images/items/Strangler's Gloves of the Firebringer.jpg"
import StranglersLeggingsofCharredEarth from "assets/images/items/Strangler's Leggings of Charred Earth.jpg"
import StranglersLeggingsoftheGrimCabal from "assets/images/items/Strangler's Leggings of the Grim Cabal.jpg"
import StranglersLeggingsoftheHiddenTomb from "assets/images/items/Strangler's Leggings of the Hidden Tomb.jpg"
import StranglersMaskoftheHiddenTomb from "assets/images/items/Strangler's Mask of the Hidden Tomb.jpg"
import StranglersMaskofWaningDusk from "assets/images/items/Strangler's Mask of Waning Dusk.jpg"
import StranglersStrapsofWaningDusk from "assets/images/items/Strangler's Straps of Waning Dusk.jpg"
import StranglersTunicofCreepingDeath from "assets/images/items/Strangler's Tunic of Creeping Death.jpg"
import StranglersTunicofShatteredSouls from "assets/images/items/Strangler's Tunic of Shattered Souls.jpg"
import StranglersTunicoftheBlackArts from "assets/images/items/Strangler's Tunic of the Black Arts.jpg"
import StranglersTunicoftheFirebringer from "assets/images/items/Strangler's Tunic of the Firebringer.jpg"
import StranglersVeiloftheGrimCabal from "assets/images/items/Strangler's Veil of the Grim Cabal.jpg"
import StranglersWristbandsofMalice from "assets/images/items/Strangler's Wristbands of Malice.jpg"
import StranglersArmstrapsofCharredEarth from "assets/images/items/Stranglers Arm-straps of Charred Earth.jpg"
import StrapsoftheGrandMonarch from "assets/images/items/Straps of the Grand Monarch.jpg"
import StrapsoftheRevelations from "assets/images/items/Straps of the Revelations.jpg"
import StrifescarArmbands from "assets/images/items/Strifescar Armbands.jpg"
import StrifescarBoots from "assets/images/items/Strifescar Boots.jpg"
import StrifescarBracers from "assets/images/items/Strifescar Bracers.jpg"
import StrifescarGauntlets from "assets/images/items/Strifescar Gauntlets.jpg"
import StrifescarGirdle from "assets/images/items/Strifescar Girdle.jpg"
import StrifescarHarness from "assets/images/items/Strifescar Harness.jpg"
import StrifescarHelm from "assets/images/items/Strifescar Helm.jpg"
import StrifescarTasset from "assets/images/items/Strifescar Tasset.jpg"
import StromsSabre from "assets/images/items/Strom's Sabre.jpg"
import SturdyPirateRing from "assets/images/items/Sturdy Pirate Ring.jpg"
import SubjugatorAxe from "assets/images/items/Subjugator Axe.jpg"
import SubjugatorBlade from "assets/images/items/Subjugator Blade.jpg"
import SubjugatorDagger from "assets/images/items/Subjugator Dagger.jpg"
import SubjugatorStaff from "assets/images/items/Subjugator Staff.jpg"
import SubjugatorSword from "assets/images/items/Subjugator Sword.jpg"
import SummonersArmbandsofImperialAssent from "assets/images/items/Summoner's Armbands of Imperial Assent.jpg"
import SummonersBandsofSovereignRule from "assets/images/items/Summoner's Bands of Sovereign Rule.jpg"
import SummonersBootsofSovereignRule from "assets/images/items/Summoner's Boots of Sovereign Rule.jpg"
import SummonersBootsoftheMandate from "assets/images/items/Summoner's Boots of the Mandate.jpg"
import SummonersBracersoftheMandate from "assets/images/items/Summoner's Bracers of the Mandate.jpg"
import SummonersCinctureofPrestige from "assets/images/items/Summoner's Cincture of Prestige.jpg"
import SummonersCrownofRegalMight from "assets/images/items/Summoner's Crown of Regal Might.jpg"
import SummonersGauntletsofImperialAssent from "assets/images/items/Summoner's Gauntlets of Imperial Assent.jpg"
import SummonersGirdleofImperialAssent from "assets/images/items/Summoner's Girdle of Imperial Assent.jpg"
import SummonersGlovesofPrestige from "assets/images/items/Summoner's Gloves of Prestige.jpg"
import SummonersHelmoftheEmperorsFavor from "assets/images/items/Summoner's Helm of the Emperor's Favor.jpg"
import SummonersLeggingsofImperialAssent from "assets/images/items/Summoner's Leggings of Imperial Assent.jpg"
import SummonersLeggingsofPrestige from "assets/images/items/Summoner's Leggings of Prestige.jpg"
import SummonersRobesofRegalMight from "assets/images/items/Summoner's Robes of Regal Might.jpg"
import SummonersRobesoftheEmperorsFavor from "assets/images/items/Summoner's Robes of the Emperor's Favor.jpg"
import SummonersStrapsofPrestige from "assets/images/items/Summoner's Straps of Prestige.jpg"
import Sunspark from "assets/images/items/Sunspark.jpg"
import Sunward from "assets/images/items/Sunward.jpg"
import SurberecsCollar from "assets/images/items/Surberec's Collar.jpg"
import SwiftStygianFestivalStallion from "assets/images/items/Swift Stygian Festival Stallion.jpg"
import SwiftshankTreads from "assets/images/items/Swiftshank Treads.jpg"
import SwordofAshur from "assets/images/items/Sword of Ashur.jpg"
import SwordofScarletFire from "assets/images/items/Sword of Scarlet Fire.jpg"
import SwordoftheCrimsonFort from "assets/images/items/Sword of the Crimson Fort.jpg"
import SwordoftheDeathMaster from "assets/images/items/Sword of the Death Master.jpg"
import SwordoftheOldCommander from "assets/images/items/Sword of the Old Commander.jpg"
import SwordoftheYellowHand from "assets/images/items/Sword of the Yellow Hand.jpg"
import SylphlikeSash from "assets/images/items/Sylphlike Sash.jpg"
import TacticiansGauntlets from "assets/images/items/Tactician's Gauntlets.jpg"
import Taerra from "assets/images/items/Taerra.jpg"
import TailoftheVaaghasan from "assets/images/items/Tail of the Vaaghasan.jpg"
import Talion from "assets/images/items/Talion.jpg"
import TalismanofDeath from "assets/images/items/Talisman of Death.jpg"
import TalismanoftheZiggurat from "assets/images/items/Talisman of the Ziggurat.jpg"
import TalonsofBlackOblivion from "assets/images/items/Talons of Black Oblivion.jpg"
import TalonsofDarkTerror from "assets/images/items/Talons of Dark Terror.jpg"
import TalonsofNecroticDread from "assets/images/items/Talons of Necrotic Dread.jpg"
import TalonsoftheCacklingMarionette from "assets/images/items/Talons of the Cackling Marionette.jpg"
import TalonsoftheUnholyCommunion from "assets/images/items/Talons of the Unholy Communion.jpg"
import Talonthrust from "assets/images/items/Talonthrust.jpg"
import TamarasCorsairCache from "assets/images/items/Tamara's Corsair Cache.jpg"
import TamarinBattleBow from "assets/images/items/Tamarin Battle Bow.jpg"
import TamarinBattleCrossbow from "assets/images/items/Tamarin Battle Crossbow.jpg"
import TamarinBattleScimitar from "assets/images/items/Tamarin Battle Scimitar.jpg"
import TamarinBattleShield from "assets/images/items/Tamarin Battle Shield.jpg"
import TamarinBattleSpire from "assets/images/items/Tamarin Battle Spire.jpg"
import TamarinBattleStaff from "assets/images/items/Tamarin Battle Staff.jpg"
import TamarinBattleWard from "assets/images/items/Tamarin Battle Ward.jpg"
import TarimsBladeofSanctity from "assets/images/items/Tarim's Blade of Sanctity.jpg"
import TarimsEmblemofSanctity from "assets/images/items/Tarim's Emblem of Sanctity.jpg"
import TarimsRingoftheHolyWord from "assets/images/items/Tarim's Ring of the Holy Word.jpg"
import TarimsShieldofSanctity from "assets/images/items/Tarim's Shield of Sanctity.jpg"
import TarimsTwinaxeofSanctity from "assets/images/items/Tarim's Twin-axe of Sanctity.jpg"
import TassetofBalefulBlood from "assets/images/items/Tasset of Baleful Blood.jpg"
import TassetofBlackSpite from "assets/images/items/Tasset of Black Spite.jpg"
import TassetofBrutalCarnage from "assets/images/items/Tasset of Brutal Carnage.jpg"
import TassetofCourageousSouls from "assets/images/items/Tasset of Courageous Souls.jpg"
import TassetofCrimsonSlaughternm from "assets/images/items/Tasset of Crimson Slaughter (nm).jpg"
import TassetofCrimsonSlaughter from "assets/images/items/Tasset of Crimson Slaughter.jpg"
import TassetofFearlessSouls from "assets/images/items/Tasset of Fearless Souls.jpg"
import TassetofHeroicSoul from "assets/images/items/Tasset of Heroic Soul.jpg"
import TassetofIndomitableSouls from "assets/images/items/Tasset of Indomitable Souls.jpg"
import TassetofRapturousBattle from "assets/images/items/Tasset of Rapturous Battle.jpg"
import TassetofRedRuinnm from "assets/images/items/Tasset of Red Ruin (nm).jpg"
import TassetofRedRuin from "assets/images/items/Tasset of Red Ruin.jpg"
import TassetofRighteousSmiting from "assets/images/items/Tasset of Righteous Smiting.jpg"
import TassetoftheBerserkersFury from "assets/images/items/Tasset of the Berserker's Fury.jpg"
import TassetoftheBloodhunternm from "assets/images/items/Tasset of the Bloodhunter (nm).jpg"
import TassetoftheBloodhunter from "assets/images/items/Tasset of the Bloodhunter.jpg"
import TassetoftheChaosAgent from "assets/images/items/Tasset of the Chaos Agent.jpg"
import TassetoftheDoomsayer from "assets/images/items/Tasset of the Doomsayer.jpg"
import TassetoftheFallenEmpirenm from "assets/images/items/Tasset of the Fallen Empire (nm).jpg"
import TassetoftheFallenEmpire from "assets/images/items/Tasset of the Fallen Empire.jpg"
import TassetoftheInvincible from "assets/images/items/Tasset of the Invincible.jpg"
import TassetoftheMartialParagon from "assets/images/items/Tasset of the Martial Paragon.jpg"
import TassetofthePainlegion from "assets/images/items/Tasset of the Painlegion.jpg"
import TassetoftheProvenChampion from "assets/images/items/Tasset of the Proven Champion.jpg"
import TassetoftheSavageSlaughter from "assets/images/items/Tasset of the Savage Slaughter.jpg"
import TassetoftheStormbringer from "assets/images/items/Tasset of the Stormbringer.jpg"
import TassetoftheTirelessDefender from "assets/images/items/Tasset of the Tireless Defender.jpg"
import TassetoftheTriumphant from "assets/images/items/Tasset of the Triumphant.jpg"
import TassetoftheValiant from "assets/images/items/Tasset of the Valiant.jpg"
import TassetoftheVictoriousElite from "assets/images/items/Tasset of the Victorious Elite.jpg"
import TassetoftheWardedBrute from "assets/images/items/Tasset of the Warded Brute.jpg"
import TassetofTribulation from "assets/images/items/Tasset of Tribulation.jpg"
import TassetofVehementThunder from "assets/images/items/Tasset of Vehement Thunder.jpg"
import TassetofVengefulZeal from "assets/images/items/Tasset of Vengeful Zeal.jpg"
import TassetofViolentRage from "assets/images/items/Tasset of Violent Rage.jpg"
import TearoftheSadist from "assets/images/items/Tear of the Sadist.jpg"
import Tectus from "assets/images/items/Tectus.jpg"
import TeethoftheDrowned from "assets/images/items/Teeth of the Drowned.jpg"
import Tekesh from "assets/images/items/Tekesh.jpg"
import TelkarioftheCloudcleaver from "assets/images/items/Telkari of the Cloudcleaver.jpg"
import TelkarioftheJudgmentBolt from "assets/images/items/Telkari of the Judgment Bolt.jpg"
import TelkarioftheRiftcaller from "assets/images/items/Telkari of the Riftcaller.jpg"
import TelkarioftheSunderedSkies from "assets/images/items/Telkari of the Sundered Skies.jpg"
import TenebrousGirdle from "assets/images/items/Tenebrous Girdle.jpg"
import TeremsefisDesign from "assets/images/items/Teremsefi's Design.jpg"
import TerminatorsDiremaul from "assets/images/items/Terminator's Diremaul.jpg"
import TerminatorsDreadmaul from "assets/images/items/Terminator's Dreadmaul.jpg"
import TerminatorsMantleoftheLivingLegend from "assets/images/items/Terminator's Mantle of the Living Legend.jpg"
import Terminus from "assets/images/items/Terminus.jpg"
import TessosGlory from "assets/images/items/Tesso's Glory.jpg"
import TessosHonor from "assets/images/items/Tesso's Honor.jpg"
import TessosPride from "assets/images/items/Tesso's Pride.jpg"
import TessosStrife from "assets/images/items/Tesso's Strife.jpg"
import ThaumaturgesArmbandsofImperialAssent from "assets/images/items/Thaumaturge's Armbands of Imperial Assent.jpg"
import ThaumaturgesArmbandsofPrestige from "assets/images/items/Thaumaturge's Armbands of Prestige.jpg"
import ThaumaturgesBeltofPrestige from "assets/images/items/Thaumaturge's Belt of Prestige.jpg"
import ThaumaturgesBootsofRegalMight from "assets/images/items/Thaumaturge's Boots of Regal Might.jpg"
import ThaumaturgesBootsoftheEmperorsFavor from "assets/images/items/Thaumaturge's Boots of the Emperor's Favor.jpg"
import ThaumaturgesBracersofRegalMight from "assets/images/items/Thaumaturge's Bracers of Regal Might.jpg"
import ThaumaturgesBracersoftheEmperorsFavor from "assets/images/items/Thaumaturge's Bracers of the Emperor's Favor.jpg"
import ThaumaturgesGauntletsoftheMandate from "assets/images/items/Thaumaturge's Gauntlets of the Mandate.jpg"
import ThaumaturgesGirdleofImperialAssent from "assets/images/items/Thaumaturge's Girdle of Imperial Assent.jpg"
import ThaumaturgesGlovesofSovereignRule from "assets/images/items/Thaumaturge's Gloves of Sovereign Rule.jpg"
import ThaumaturgesHelmofImperialAssent from "assets/images/items/Thaumaturge's Helm of Imperial Assent.jpg"
import ThaumaturgesLeggingsofImperialAssent from "assets/images/items/Thaumaturge's Leggings of Imperial Assent.jpg"
import ThaumaturgesLeggingsofPrestige from "assets/images/items/Thaumaturge's Leggings of Prestige.jpg"
import ThaumaturgesRobesoftheMandate from "assets/images/items/Thaumaturge's Robes of the Mandate.jpg"
import ThaumaturgesTunicofSovereignRule from "assets/images/items/Thaumaturge's Tunic of Sovereign Rule.jpg"
import TheAgonyofAges from "assets/images/items/The Agony of Ages.jpg"
import TheArtofEasternRiding from "assets/images/items/The Art of Eastern Riding.jpg"
import TheAugustOnesImpassibleGrin from "assets/images/items/The August Ones' Impassible Grin.jpg"
import TheBalefulBlade from "assets/images/items/The Baleful Blade.jpg"
import TheCastle from "assets/images/items/The Castle.jpg"
import TheCirclesNotch from "assets/images/items/The Circle's Notch.jpg"
import TheCloudscar from "assets/images/items/The Cloudscar.jpg"
import TheConquerorsCrown from "assets/images/items/The Conqueror's Crown.jpg"
import TheConvictionofWill from "assets/images/items/The Conviction of Will.jpg"
import TheCrescentofBlood from "assets/images/items/The Crescent of Blood.jpg"
import TheDeathofInnocents from "assets/images/items/The Death of Innocents.jpg"
import TheEndofKings from "assets/images/items/The End of Kings.jpg"
import TheEnduringHate from "assets/images/items/The Enduring Hate.jpg"
import TheEyeoftheBretheren from "assets/images/items/The Eye of the Bretheren.jpg"
import TheFleetedWing from "assets/images/items/The Fleeted Wing.jpg"
import TheFrostflight from "assets/images/items/The Frostflight.jpg"
import TheFuryofIziel from "assets/images/items/The Fury of Iziel.jpg"
import TheGildedGrave from "assets/images/items/The Gilded Grave.jpg"
import TheHavenofWar from "assets/images/items/The Haven of War.jpg"
import TheHeartofAtlantis from "assets/images/items/The Heart of Atlantis.jpg"
import TheHelotofSacrilege from "assets/images/items/The Helot of Sacrilege.jpg"
import TheHorizonsSeveringDivide from "assets/images/items/The Horizon's Severing Divide.jpg"
import TheImmortalEdge from "assets/images/items/The Immortal Edge.jpg"
import TheInfernusofDagon from "assets/images/items/The Infernus of Dagon.jpg"
import TheJackdawsTithe from "assets/images/items/The Jackdaw's Tithe.jpg"
import TheLostSoul from "assets/images/items/The Lost Soul.jpg"
import TheMarkofGwahlur from "assets/images/items/The Mark of Gwahlur.jpg"
import TheMightofArctos from "assets/images/items/The Might of Arctos.jpg"
import TheMouthofBarbedPromises from "assets/images/items/The Mouth of Barbed Promises.jpg"
import TheNarthexofHell from "assets/images/items/The Narthex of Hell.jpg"
import TheNecrosofDagon from "assets/images/items/The Necros of Dagon.jpg"
import TheRock from "assets/images/items/The Rock.jpg"
import TheScimitarofDunes from "assets/images/items/The Scimitar of Dunes.jpg"
import TheSerpentsPull from "assets/images/items/The Serpent's Pull.jpg"
import TheShieldofAlkmeenon from "assets/images/items/The Shield of Alkmeenon.jpg"
import TheShieldofChaos from "assets/images/items/The Shield of Chaos.jpg"
import TheShieldofEntropy from "assets/images/items/The Shield of Entropy.jpg"
import TheSilentKnell from "assets/images/items/The Silent Knell.jpg"
import TheSilentLullaby from "assets/images/items/The Silent Lullaby.jpg"
import TheStormHarbor from "assets/images/items/The Storm Harbor.jpg"
import TheStranglersHand from "assets/images/items/The Strangler's Hand.jpg"
import TheSubtleDisguise from "assets/images/items/The Subtle Disguise.jpg"
import TheThreeFangsofReckoning from "assets/images/items/The Three Fangs of Reckoning.jpg"
import TheTigersWill from "assets/images/items/The Tiger's Will.jpg"
import TheTomeofStorms from "assets/images/items/The Tome of Storms.jpg"
import TheTwinnedMoons from "assets/images/items/The Twinned Moons.jpg"
import TheUnconquerableRiddleofSteel from "assets/images/items/The Unconquerable Riddle of Steel.jpg"
import TheWatersEdge from "assets/images/items/The Water's Edge.jpg"
import TheurgicDagger from "assets/images/items/Theurgic Dagger.jpg"
import ThiefsArmbandsofEngulfingTwilight from "assets/images/items/Thief's Armbands of Engulfing Twilight.jpg"
import ThiefsArmbandsoftheSunderedCrown from "assets/images/items/Thief's Armbands of the Sundered Crown.jpg"
import ThiefsBandsoftheNadir from "assets/images/items/Thief's Bands of the Nadir.jpg"
import ThiefsBeltoftheDeceiver from "assets/images/items/Thief's Belt of the Deceiver.jpg"
import ThiefsBeltoftheFifthStage from "assets/images/items/Thief's Belt of the Fifth Stage.jpg"
import ThiefsBeltoftheSmolderingThrone from "assets/images/items/Thief's Belt of the Smoldering Throne.jpg"
import ThiefsBeltoftheStolenKingdom from "assets/images/items/Thief's Belt of the Stolen Kingdom.jpg"
import ThiefsBootsoftheBurningTemple from "assets/images/items/Thief's Boots of the Burning Temple.jpg"
import ThiefsBracersoftheBurningTemple from "assets/images/items/Thief's Bracers of the Burning Temple.jpg"
import ThiefsBracersoftheTenthCourt from "assets/images/items/Thief's Bracers of the Tenth Court.jpg"
import ThiefsFauldoftheNadir from "assets/images/items/Thief's Fauld of the Nadir.jpg"
import ThiefsGlovesoftheBurningTemple from "assets/images/items/Thief's Gloves of the Burning Temple.jpg"
import ThiefsGlovesoftheHiddenPalace from "assets/images/items/Thief's Gloves of the Hidden Palace.jpg"
import ThiefsGlovesoftheTenthCourt from "assets/images/items/Thief's Gloves of the Tenth Court.jpg"
import ThiefsHelmoftheFifthStage from "assets/images/items/Thief's Helm of the Fifth Stage.jpg"
import ThiefsHelmoftheStolenKingdom from "assets/images/items/Thief's Helm of the Stolen Kingdom.jpg"
import ThiefsJerkinoftheHiddenPalace from "assets/images/items/Thief's Jerkin of the Hidden Palace.jpg"
import ThiefsJerkinoftheTenthCourt from "assets/images/items/Thief's Jerkin of the Tenth Court.jpg"
import ThiefsLeggingsofEngulfingTwilight from "assets/images/items/Thief's Leggings of Engulfing Twilight.jpg"
import ThiefsLeggingsoftheSunderedCrown from "assets/images/items/Thief's Leggings of the Sundered Crown.jpg"
import ThiefsLegguardsoftheSwiftReturn from "assets/images/items/Thief's Legguards of the Swift Return.jpg"
import ThiefsMaskoftheDeceiver from "assets/images/items/Thief's Mask of the Deceiver.jpg"
import ThiefsMaskoftheSmolderingThrone from "assets/images/items/Thief's Mask of the Smoldering Throne.jpg"
import ThiefsStrapsoftheSwiftReturn from "assets/images/items/Thief's Straps of the Swift Return.jpg"
import ThiefsTunicoftheBurningTemple from "assets/images/items/Thief's Tunic of the Burning Temple.jpg"
import ThiefsWristbandsoftheFinalWay from "assets/images/items/Thief's Wristbands of the Final Way.jpg"
import Thirst from "assets/images/items/Thirst.jpg"
import ThriceHowledEdgeofFrenzy from "assets/images/items/Thrice-Howled Edge of Frenzy.jpg"
import ThrowingAxeoftheZiggurat from "assets/images/items/Throwing Axe of the Ziggurat.jpg"
import ThugsArmstrapsoftheFirebringer from "assets/images/items/Thug's Arm-straps of the Firebringer.jpg"
import ThugsArmbandsofShatteredSouls from "assets/images/items/Thug's Armbands of Shattered Souls.jpg"
import ThugsArmbandsoftheBlackArts from "assets/images/items/Thug's Armbands of the Black Arts.jpg"
import ThugsBeltofArcaneDeath from "assets/images/items/Thug's Belt of Arcane Death.jpg"
import ThugsBeltofMalice from "assets/images/items/Thug's Belt of Malice.jpg"
import ThugsBeltoftheBattlethrall from "assets/images/items/Thug's Belt of the Battlethrall.jpg"
import ThugsBeltoftheSilentKill from "assets/images/items/Thug's Belt of the Silent Kill.jpg"
import ThugsBootsofCharredEarth from "assets/images/items/Thug's Boots of Charred Earth.jpg"
import ThugsBootsoftheGrimCabal from "assets/images/items/Thug's Boots of the Grim Cabal.jpg"
import ThugsBootsoftheHiddenTomb from "assets/images/items/Thug's Boots of the Hidden Tomb.jpg"
import ThugsBootsofWaningDusk from "assets/images/items/Thug's Boots of Waning Dusk.jpg"
import ThugsBracersofCharredEarth from "assets/images/items/Thug's Bracers of Charred Earth.jpg"
import ThugsBracersoftheGrimCabal from "assets/images/items/Thug's Bracers of the Grim Cabal.jpg"
import ThugsBracersoftheHiddenTomb from "assets/images/items/Thug's Bracers of the Hidden Tomb.jpg"
import ThugsFauldofCreepingDeath from "assets/images/items/Thug's Fauld of Creeping Death.jpg"
import ThugsGlovesofArcaneDeath from "assets/images/items/Thug's Gloves of Arcane Death.jpg"
import ThugsGlovesofMalice from "assets/images/items/Thug's Gloves of Malice.jpg"
import ThugsGlovesoftheBattlethrall from "assets/images/items/Thug's Gloves of the Battlethrall.jpg"
import ThugsGlovesoftheSilentKill from "assets/images/items/Thug's Gloves of the Silent Kill.jpg"
import ThugsLeggingsofShatteredSouls from "assets/images/items/Thug's Leggings of Shattered Souls.jpg"
import ThugsLeggingsoftheBlackArts from "assets/images/items/Thug's Leggings of the Black Arts.jpg"
import ThugsLeggingsoftheFirebringer from "assets/images/items/Thug's Leggings of the Firebringer.jpg"
import ThugsMaskofCharredEarth from "assets/images/items/Thug's Mask of Charred Earth.jpg"
import ThugsMaskoftheHiddenTomb from "assets/images/items/Thug's Mask of the Hidden Tomb.jpg"
import ThugsMaskofWaningDusk from "assets/images/items/Thug's Mask of Waning Dusk.jpg"
import ThugsStrapsofCreepingDeath from "assets/images/items/Thug's Straps of Creeping Death.jpg"
import ThugsTunicofCharredEarth from "assets/images/items/Thug's Tunic of Charred Earth.jpg"
import ThugsTunicoftheGrimCabal from "assets/images/items/Thug's Tunic of the Grim Cabal.jpg"
import ThugsTunicoftheHiddenTomb from "assets/images/items/Thug's Tunic of the Hidden Tomb.jpg"
import ThugsTunicofWaningDusk from "assets/images/items/Thug's Tunic of Waning Dusk.jpg"
import ThugsVeiloftheGrimCabal from "assets/images/items/Thug's Veil of the Grim Cabal.jpg"
import ThugsWristbandsofWaningDusk from "assets/images/items/Thug's Wristbands of Waning Dusk.jpg"
import ThunderMantleoftheLivingLegend from "assets/images/items/Thunder Mantle of the Living Legend.jpg"
import ThunderRiverHelm from "assets/images/items/Thunder River Helm.jpg"
import ThunderingGlaive from "assets/images/items/Thundering Glaive.jpg"
import ThunderskinBracers from "assets/images/items/Thunderskin Bracers.jpg"
import TickleroftheAutumnNight from "assets/images/items/Tickler of the Autumn Night.jpg"
import TigersArmstrapsofPiercedFlesh from "assets/images/items/Tiger's Arm-straps of Pierced Flesh.jpg"
import TigersArmbandsoftheUntamed from "assets/images/items/Tiger's Armbands of the Untamed.jpg"
import TigersArmguardsoftheRoaringJungle from "assets/images/items/Tiger's Armguards of the Roaring Jungle.jpg"
import TigersBeltofCrouchingCalm from "assets/images/items/Tiger's Belt of Crouching Calm.jpg"
import TigersBeltofPiercedFlesh from "assets/images/items/Tiger's Belt of Pierced Flesh.jpg"
import TigersBeltoftheRoaringJungle from "assets/images/items/Tiger's Belt of the Roaring Jungle.jpg"
import TigersBootsofGrinningSkulls from "assets/images/items/Tiger's Boots of Grinning Skulls.jpg"
import TigersBootsofStalkingFury from "assets/images/items/Tiger's Boots of Stalking Fury.jpg"
import TigersBootsoftheElderBond from "assets/images/items/Tiger's Boots of the Elder Bond.jpg"
import TigersBootsoftheSecondCaste from "assets/images/items/Tiger's Boots of the Second Caste.jpg"
import TigersBracersoftheElderBond from "assets/images/items/Tiger's Bracers of the Elder Bond.jpg"
import TigersBracersoftheSecondCaste from "assets/images/items/Tiger's Bracers of the Second Caste.jpg"
import TigersChestguardoftheSavageSun from "assets/images/items/Tiger's Chestguard of the Savage Sun.jpg"
import TigersGauntletsoftheRoaringJungle from "assets/images/items/Tiger's Gauntlets of the Roaring Jungle.jpg"
import TigersGauntletsoftheUntamed from "assets/images/items/Tiger's Gauntlets of the Untamed.jpg"
import TigersGirdleoftheUntamed from "assets/images/items/Tiger's Girdle of the Untamed.jpg"
import TigersGlovesofCrouchingCalm from "assets/images/items/Tiger's Gloves of Crouching Calm.jpg"
import TigersGlovesofPiercedFlesh from "assets/images/items/Tiger's Gloves of Pierced Flesh.jpg"
import TigersHarnessofthePrimeval from "assets/images/items/Tiger's Harness of the Primeval.jpg"
import TigersHelmofthePaintedClaw from "assets/images/items/Tiger's Helm of the Painted Claw.jpg"
import TigersHelmofthePrimeval from "assets/images/items/Tiger's Helm of the Primeval.jpg"
import TigersHelmoftheSavageSun from "assets/images/items/Tiger's Helm of the Savage Sun.jpg"
import TigersHelmoftheYellowSpring from "assets/images/items/Tiger's Helm of the Yellow Spring.jpg"
import TigersJerkinoftheYellowSpring from "assets/images/items/Tiger's Jerkin of the Yellow Spring.jpg"
import TigersLeggingsofPiercedFlesh from "assets/images/items/Tiger's Leggings of Pierced Flesh.jpg"
import TigersLeggingsoftheUntamed from "assets/images/items/Tiger's Leggings of the Untamed.jpg"
import TigersLegguardsofCrouchingCalm from "assets/images/items/Tiger's Legguards of Crouching Calm.jpg"
import TigersLegguardsoftheRoaringJungle from "assets/images/items/Tiger's Legguards of the Roaring Jungle.jpg"
import TigersStrapsofCrouchingCalm from "assets/images/items/Tiger's Straps of Crouching Calm.jpg"
import TigersStrapsofGrinningSkulls from "assets/images/items/Tiger's Straps of Grinning Skulls.jpg"
import TigersVambracesofStalkingFury from "assets/images/items/Tiger's Vambraces of Stalking Fury.jpg"
import TigersVestofthePaintedClaw from "assets/images/items/Tiger's Vest of the Painted Claw.jpg"
import Tigerstrike from "assets/images/items/Tigerstrike.jpg"
import Tigerswipe from "assets/images/items/Tigerswipe.jpg"
import TimewornGloves from "assets/images/items/Timeworn Gloves.jpg"
import TitanslayerCloak from "assets/images/items/Titanslayer Cloak.jpg"
import ToilofWoes from "assets/images/items/Toil of Woes.jpg"
import ToirdealbachsSeal from "assets/images/items/Toirdealbach's Seal.jpg"
import TokenofTerror from "assets/images/items/Token of Terror.jpg"
import TokenoftheDivinitySerpent from "assets/images/items/Token of the Divinity Serpent.jpg"
import TokenofTorment from "assets/images/items/Token of Torment.jpg"
import TokensofFrozenEarth from "assets/images/items/Tokens of Frozen Earth.jpg"
import TokensoftheGreatImpi from "assets/images/items/Tokens of the Great Impi.jpg"
import TomeofDeificReverence from "assets/images/items/Tome of Deific Reverence.jpg"
import TomeofHolyObeisance from "assets/images/items/Tome of Holy Obeisance.jpg"
import TomeoftheBlackGale from "assets/images/items/Tome of the Black Gale.jpg"
import TomeoftheUndying from "assets/images/items/Tome of the Undying.jpg"
import TongueoftheEightWayWyrm from "assets/images/items/Tongue of the Eight-Way Wyrm.jpg"
import TongueoftheVengefulSerpent from "assets/images/items/Tongue of the Vengeful Serpent.jpg"
import Torment from "assets/images/items/Torment.jpg"
import TotemofOrigins from "assets/images/items/Totem of Origins.jpg"
import TotemoftheBloodGod from "assets/images/items/Totem of the Blood God.jpg"
import TotemoftheEternalWinter from "assets/images/items/Totem of the Eternal Winter.jpg"
import TotemoftheFacelessSphinx from "assets/images/items/Totem of the Faceless Sphinx.jpg"
import TrappersBolts from "assets/images/items/Trapper's Bolts.jpg"
import TrappersHook from "assets/images/items/Trapper's Hook.jpg"
import TrappersKnife from "assets/images/items/Trapper's Knife.jpg"
import TrappersSword from "assets/images/items/Trapper's Sword.jpg"
import TraumaticReflection from "assets/images/items/Traumatic Reflection.jpg"
import TreadlightBoots from "assets/images/items/Treadlight Boots.jpg"
import TreadsoftheOuterDark from "assets/images/items/Treads of the Outer Dark.jpg"
import TriGlaveoftheDemonsRoar from "assets/images/items/Tri-Glave of the Demon's Roar.jpg"
import TrialofFlame from "assets/images/items/Trial of Flame.jpg"
import TribalNecklaceofBloodyCarnage from "assets/images/items/Tribal Necklace of Bloody Carnage.jpg"
import TrickstersCharm from "assets/images/items/Trickster's Charm.jpg"
import TridentofOkeanos from "assets/images/items/Trident of Okeanos.jpg"
import TridentoftheGatheringStorm from "assets/images/items/Trident of the Gathering Storm.jpg"
import TrinketofBoneandHorn from "assets/images/items/Trinket of Bone and Horn.jpg"
import TrinketofOldAcheron from "assets/images/items/Trinket of Old Acheron.jpg"
import TrinketofSharpenedBlades from "assets/images/items/Trinket of Sharpened Blades.jpg"
import TrinketoftheEarthMother from "assets/images/items/Trinket of the Earth Mother.jpg"
import TritonsDepths from "assets/images/items/Triton's Depths.jpg"
import TrophiesoftheHunt from "assets/images/items/Trophies of the Hunt.jpg"
import TruestrikeArmbands from "assets/images/items/Truestrike Armbands.jpg"
import TumultsVeil from "assets/images/items/Tumult's Veil.jpg"
import TumultuousThunder from "assets/images/items/Tumultuous Thunder.jpg"
import TunicofBedlam from "assets/images/items/Tunic of Bedlam.jpg"
import TunicofBenevolence from "assets/images/items/Tunic of Benevolence.jpg"
import TunicofBlackWhispers from "assets/images/items/Tunic of Black Whispers.jpg"
import TunicofConcealingShadows from "assets/images/items/Tunic of Concealing Shadows.jpg"
import TunicofCrimsonSlaughternm from "assets/images/items/Tunic of Crimson Slaughter (nm).jpg"
import TunicofCrimsonSlaughter from "assets/images/items/Tunic of Crimson Slaughter.jpg"
import TunicofDarkMalice from "assets/images/items/Tunic of Dark Malice.jpg"
import TunicofDeadlyGuile from "assets/images/items/Tunic of Deadly Guile.jpg"
import TunicofHaloga from "assets/images/items/Tunic of Haloga.jpg"
import TunicofIntricateSpite from "assets/images/items/Tunic of Intricate Spite.jpg"
import TunicofLunacy from "assets/images/items/Tunic of Lunacy.jpg"
import TunicoftheClay from "assets/images/items/Tunic of the Clay.jpg"
import TunicoftheCrawlingChaos from "assets/images/items/Tunic of the Crawling Chaos.jpg"
import TunicoftheDeathGod from "assets/images/items/Tunic of the Death God.jpg"
import TunicoftheDoomsayer from "assets/images/items/Tunic of the Doomsayer.jpg"
import TunicoftheExorcist from "assets/images/items/Tunic of the Exorcist.jpg"
import TunicoftheFacelessChaos from "assets/images/items/Tunic of the Faceless Chaos.jpg"
import TunicoftheFacelessSphinx from "assets/images/items/Tunic of the Faceless Sphinx.jpg"
import TunicoftheFirebrand from "assets/images/items/Tunic of the Firebrand.jpg"
import TunicoftheHarbinger from "assets/images/items/Tunic of the Harbinger.jpg"
import TunicoftheLector from "assets/images/items/Tunic of the Lector.jpg"
import TunicoftheNebulous from "assets/images/items/Tunic of the Nebulous.jpg"
import TunicoftheOxmal from "assets/images/items/Tunic of the Oxmal.jpg"
import TunicofthePrecursor from "assets/images/items/Tunic of the Precursor.jpg"
import TunicofthePutrescent from "assets/images/items/Tunic of the Putrescent.jpg"
import TunicoftheRipplingLake from "assets/images/items/Tunic of the Rippling Lake.jpg"
import TunicoftheSepulcher from "assets/images/items/Tunic of the Sepulcher.jpg"
import TunicoftheShiveringStars from "assets/images/items/Tunic of the Shivering Stars.jpg"
import TunicoftheSilentSlayer from "assets/images/items/Tunic of the Silent Slayer.jpg"
import TunicoftheSpheres from "assets/images/items/Tunic of the Spheres.jpg"
import TunicoftheStillPond from "assets/images/items/Tunic of the Still Pond.jpg"
import TunicoftheStrangeBeyond from "assets/images/items/Tunic of the Strange Beyond.jpg"
import TunicoftheUnslaked from "assets/images/items/Tunic of the Unslaked.jpg"
import TunicoftheUnutterable from "assets/images/items/Tunic of the Unutterable.jpg"
import TunicoftheUsurper from "assets/images/items/Tunic of the Usurper.jpg"
import TunicoftheWellsofNight from "assets/images/items/Tunic of the Wells of Night.jpg"
import TunicofTranquility from "assets/images/items/Tunic of Tranquility.jpg"
import TunicofVindictiveMalice from "assets/images/items/Tunic of Vindictive Malice.jpg"
import Tunsus from "assets/images/items/Tunsus.jpg"
import TurbulentWarhack from "assets/images/items/Turbulent Warhack.jpg"
import TwigsoftheOcean from "assets/images/items/Twigs of the Ocean.jpg"
import Tyranny from "assets/images/items/Tyranny.jpg"
import UnderdwellersSpear from "assets/images/items/Underdweller's Spear.jpg"
import UndulatingBandofYig from "assets/images/items/Undulating Band of Yig.jpg"
import UnerringCrossfire from "assets/images/items/Unerring Crossfire.jpg"
import UnholySkullsplitter from "assets/images/items/Unholy Skullsplitter.jpg"
import UpholderArmguards from "assets/images/items/Upholder Armguards.jpg"
import UtilityShoulders from "assets/images/items/Utility Shoulders.jpg"
import UtricsHealingCloak from "assets/images/items/Utric's Healing Cloak.jpg"
import UtricsJustBlade from "assets/images/items/Utric's Just Blade.jpg"
import UtricsKeenKnife from "assets/images/items/Utric's Keen Knife.jpg"
import UtricsLawfulMace from "assets/images/items/Utric's Lawful Mace.jpg"
import UtricsSealofLaw from "assets/images/items/Utric's Seal of Law.jpg"
import UtricsShimmeringCloak from "assets/images/items/Utric's Shimmering Cloak.jpg"
import Vaedus from "assets/images/items/Vaedus.jpg"
import ValkasIllimitableAegis from "assets/images/items/Valka's Illimitable Aegis.jpg"
import ValkasWoeHymn from "assets/images/items/Valka's Woe Hymn.jpg"
import ValorousCarcanet from "assets/images/items/Valorous Carcanet.jpg"
import VambraceofCrimsonSlaughternm from "assets/images/items/Vambrace of Crimson Slaughter (nm).jpg"
import VambraceofCrimsonSlaughter from "assets/images/items/Vambrace of Crimson Slaughter.jpg"
import VambraceofRedRuinnm from "assets/images/items/Vambrace of Red Ruin (nm).jpg"
import VambraceofRedRuin from "assets/images/items/Vambrace of Red Ruin.jpg"
import VambraceoftheSanguineDisciplenm from "assets/images/items/Vambrace of the Sanguine Disciple (nm).jpg"
import VambraceoftheSanguineDisciple from "assets/images/items/Vambrace of the Sanguine Disciple.jpg"
import VambracesofBalefulBlood from "assets/images/items/Vambraces of Baleful Blood.jpg"
import VambracesofBlackSpite from "assets/images/items/Vambraces of Black Spite.jpg"
import VambracesofBoneandHorn from "assets/images/items/Vambraces of Bone and Horn.jpg"
import VambracesofHeroicSoul from "assets/images/items/Vambraces of Heroic Soul.jpg"
import VambracesofIndomitableSouls from "assets/images/items/Vambraces of Indomitable Souls.jpg"
import VambracesofRecklessChallenge from "assets/images/items/Vambraces of Reckless Challenge.jpg"
import VambracesoftheAssailant from "assets/images/items/Vambraces of the Assailant.jpg"
import VambracesoftheAtlantean from "assets/images/items/Vambraces of the Atlantean.jpg"
import VambracesoftheBeyond from "assets/images/items/Vambraces of the Beyond.jpg"
import VambracesoftheBlackDragon from "assets/images/items/Vambraces of the Black Dragon.jpg"
import VambracesoftheBlackPharaoh from "assets/images/items/Vambraces of the Black Pharaoh.jpg"
import VambracesoftheBlackWarden from "assets/images/items/Vambraces of the Black Warden.jpg"
import VambracesoftheBloodDrinkernm from "assets/images/items/Vambraces of the Blood Drinker (nm).jpg"
import VambracesoftheBloodDrinker from "assets/images/items/Vambraces of the Blood Drinker.jpg"
import VambracesoftheBloodhunternm from "assets/images/items/Vambraces of the Bloodhunter (nm).jpg"
import VambracesoftheBloodhunter from "assets/images/items/Vambraces of the Bloodhunter.jpg"
import VambracesoftheChaosAgent from "assets/images/items/Vambraces of the Chaos Agent.jpg"
import VambracesoftheCrimsonFort from "assets/images/items/Vambraces of the Crimson Fort.jpg"
import VambracesoftheDarkMessenger from "assets/images/items/Vambraces of the Dark Messenger.jpg"
import VambracesoftheDauntless from "assets/images/items/Vambraces of the Dauntless.jpg"
import VambracesoftheDefiant from "assets/images/items/Vambraces of the Defiant.jpg"
import VambracesoftheFallenEmpirenm from "assets/images/items/Vambraces of the Fallen Empire (nm).jpg"
import VambracesoftheFallenEmpire from "assets/images/items/Vambraces of the Fallen Empire.jpg"
import VambracesoftheGreatImpi from "assets/images/items/Vambraces of the Great Impi.jpg"
import VambracesoftheHellWalkernm from "assets/images/items/Vambraces of the Hell Walker (nm).jpg"
import VambracesoftheHellWalker from "assets/images/items/Vambraces of the Hell Walker.jpg"
import VambracesoftheInvincible from "assets/images/items/Vambraces of the Invincible.jpg"
import VambracesoftheMartialParagon from "assets/images/items/Vambraces of the Martial Paragon.jpg"
import VambracesoftheMasqueroftheSands from "assets/images/items/Vambraces of the Masquer of the Sands.jpg"
import VambracesoftheMilitesTempli from "assets/images/items/Vambraces of the Milites Templi.jpg"
import VambracesoftheOstiary from "assets/images/items/Vambraces of the Ostiary.jpg"
import VambracesofthePainlegion from "assets/images/items/Vambraces of the Painlegion.jpg"
import VambracesoftheProvenChampion from "assets/images/items/Vambraces of the Proven Champion.jpg"
import VambracesoftheScatteredGods from "assets/images/items/Vambraces of the Scattered Gods.jpg"
import VambracesoftheSteelBehemoth from "assets/images/items/Vambraces of the Steel Behemoth.jpg"
import VambracesoftheTirelessDefender from "assets/images/items/Vambraces of the Tireless Defender.jpg"
import VambracesoftheTormentor from "assets/images/items/Vambraces of the Tormentor.jpg"
import VambracesoftheTriumphant from "assets/images/items/Vambraces of the Triumphant.jpg"
import VambracesoftheUsurper from "assets/images/items/Vambraces of the Usurper.jpg"
import VambracesoftheValiant from "assets/images/items/Vambraces of the Valiant.jpg"
import VambracesoftheVanguard from "assets/images/items/Vambraces of the Vanguard.jpg"
import VambracesoftheVictoriousElite from "assets/images/items/Vambraces of the Victorious Elite.jpg"
import VambracesoftheWicked from "assets/images/items/Vambraces of the Wicked.jpg"
import VanirAvenger from "assets/images/items/Vanir Avenger.jpg"
import VanirBloodiedBand from "assets/images/items/Vanir Bloodied Band.jpg"
import VanirButcherAxe from "assets/images/items/Vanir Butcher Axe.jpg"
import VanirFleshcarver from "assets/images/items/Vanir Fleshcarver.jpg"
import VanirSquareShield from "assets/images/items/Vanir Square Shield.jpg"
import VanirStonecrusher from "assets/images/items/Vanir Stonecrusher.jpg"
import VanirWarriorsCache from "assets/images/items/Vanir Warriors Cache.jpg"
import VashianKeffiyeh from "assets/images/items/Vashian Keffiyeh.jpg"
import VashianSchenti from "assets/images/items/Vashian Schenti.jpg"
import VashianThreads from "assets/images/items/Vashian Threads.jpg"
import VashianTunic from "assets/images/items/Vashian Tunic.jpg"
import Venakis from "assets/images/items/Venakis.jpg"
import Vengeance from "assets/images/items/Vengeance.jpg"
import VenomshieldBelt from "assets/images/items/Venomshield Belt.jpg"
import VenturersArmstrapsofGrinningSkulls from "assets/images/items/Venturer's Arm-straps of Grinning Skulls.jpg"
import VenturersArmbandsoftheSecondCaste from "assets/images/items/Venturer's Armbands of the Second Caste.jpg"
import VenturersArmguardsofStalkingFury from "assets/images/items/Venturer's Armguards of Stalking Fury.jpg"
import VenturersBeltofthePaintedClaw from "assets/images/items/Venturer's Belt of the Painted Claw.jpg"
import VenturersBeltoftheSavageSun from "assets/images/items/Venturer's Belt of the Savage Sun.jpg"
import VenturersBeltoftheYellowSpring from "assets/images/items/Venturer's Belt of the Yellow Spring.jpg"
import VenturersBootsofCrouchingCalm from "assets/images/items/Venturer's Boots of Crouching Calm.jpg"
import VenturersBootsoftheRoaringJungle from "assets/images/items/Venturer's Boots of the Roaring Jungle.jpg"
import VenturersBracersofCrouchingCalm from "assets/images/items/Venturer's Bracers of Crouching Calm.jpg"
import VenturersBracersoftheUntamed from "assets/images/items/Venturer's Bracers of the Untamed.jpg"
import VenturersChestguardoftheRoaringJungle from "assets/images/items/Venturer's Chestguard of the Roaring Jungle.jpg"
import VenturersGauntletsofthePrimeval from "assets/images/items/Venturer's Gauntlets of the Primeval.jpg"
import VenturersGauntletsoftheSavageSun from "assets/images/items/Venturer's Gauntlets of the Savage Sun.jpg"
import VenturersGirdleofthePrimeval from "assets/images/items/Venturer's Girdle of the Primeval.jpg"
import VenturersGlovesofthePaintedClaw from "assets/images/items/Venturer's Gloves of the Painted Claw.jpg"
import VenturersGlovesoftheYellowSpring from "assets/images/items/Venturer's Gloves of the Yellow Spring.jpg"
import VenturersHarnessoftheUntamed from "assets/images/items/Venturer's Harness of the Untamed.jpg"
import VenturersHelmofCrouchingCalm from "assets/images/items/Venturer's Helm of Crouching Calm.jpg"
import VenturersHelmofPiercedFlesh from "assets/images/items/Venturer's Helm of Pierced Flesh.jpg"
import VenturersHelmoftheUntamed from "assets/images/items/Venturer's Helm of the Untamed.jpg"
import VenturersHelm from "assets/images/items/Venturer's Helm.jpg"
import VenturersLeggingsofGrinningSkulls from "assets/images/items/Venturer's Leggings of Grinning Skulls.jpg"
import VenturersLeggingsoftheSecondCaste from "assets/images/items/Venturer's Leggings of the Second Caste.jpg"
import VenturersLegguardsofStalkingFury from "assets/images/items/Venturer's Legguards of Stalking Fury.jpg"
import VenturersLegguardsoftheElderBond from "assets/images/items/Venturer's Legguards of the Elder Bond.jpg"
import VenturersStrapsofPiercedFlesh from "assets/images/items/Venturer's Straps of Pierced Flesh.jpg"
import VenturersStrapsoftheElderBond from "assets/images/items/Venturer's Straps of the Elder Bond.jpg"
import VenturersTreadsofPiercedFlesh from "assets/images/items/Venturer's Treads of Pierced Flesh.jpg"
import VenturersVambracesoftheRoaringJungle from "assets/images/items/Venturer's Vambraces of the Roaring Jungle.jpg"
import VenturersVestofPiercedFlesh from "assets/images/items/Venturer's Vest of Pierced Flesh.jpg"
import VermiculatedFangofallFiends from "assets/images/items/Vermiculated Fang of all Fiends.jpg"
import VermiculatedTokenofallFiends from "assets/images/items/Vermiculated Token of all Fiends.jpg"
import VestoftheBloodGodnm from "assets/images/items/Vest of the Blood God (nm).jpg"
import VestoftheBloodGod from "assets/images/items/Vest of the Blood God.jpg"
import VestoftheBloodhunternm from "assets/images/items/Vest of the Bloodhunter (nm).jpg"
import VestoftheBloodhunter from "assets/images/items/Vest of the Bloodhunter.jpg"
import VestoftheGhostoftheVeldt from "assets/images/items/Vest of the Ghost of the Veldt.jpg"
import VestoftheHellWalkernm from "assets/images/items/Vest of the Hell Walker (nm).jpg"
import VestoftheHellWalker from "assets/images/items/Vest of the Hell Walker.jpg"
import VestmentoftheCacklingMarionette from "assets/images/items/Vestment of the Cackling Marionette.jpg"
import VestmentoftheGrandMonarch from "assets/images/items/Vestment of the Grand Monarch.jpg"
import VestmentoftheRevelations from "assets/images/items/Vestment of the Revelations.jpg"
import VestmentsoftheGreatImpi from "assets/images/items/Vestments of the Great Impi.jpg"
import VeteransBag from "assets/images/items/Veteran's Bag.jpg"
import ViciousCapeofIllIntent from "assets/images/items/Vicious Cape of Ill Intent.jpg"
import ViciousDrape from "assets/images/items/Vicious Drape.jpg"
import ViciousHoundBoots from "assets/images/items/Vicious Hound Boots.jpg"
import VigdisSoothsayersRing from "assets/images/items/Vigdis Soothsayer's Ring.jpg"
import VigdisWiccanBand from "assets/images/items/Vigdis Wiccan Band.jpg"
import VigilantSerpentweave from "assets/images/items/Vigilant Serpentweave.jpg"
import VigortouchHarness from "assets/images/items/Vigortouch Harness.jpg"
import ViolinShieldoftheTwelfthDynasty from "assets/images/items/Violin Shield of the Twelfth Dynasty.jpg"
import ViridianArrows from "assets/images/items/Viridian Arrows.jpg"
import ViridianBolts from "assets/images/items/Viridian Bolts.jpg"
import Virtue from "assets/images/items/Virtue.jpg"
import VisageofElderShadows from "assets/images/items/Visage of Elder Shadows.jpg"
import VisageoftheMasqueroftheSands from "assets/images/items/Visage of the Masquer of the Sands.jpg"
import ViseoftheAnointed from "assets/images/items/Vise of the Anointed.jpg"
import VoidWarden from "assets/images/items/Void Warden.jpg"
import Voidcage from "assets/images/items/Voidcage.jpg"
import VortexGem from "assets/images/items/Vortex Gem.jpg"
import VotanthicRaiment from "assets/images/items/Votanthic Raiment.jpg"
import VowsoftheEmpire from "assets/images/items/Vows of the Empire.jpg"
import Vyre from "assets/images/items/Vyre.jpg"
import WalkersArmstrapsoftheAncestors from "assets/images/items/Walker's Arm-straps of the Ancestors.jpg"
import WalkersArmbandsoftheGreensward from "assets/images/items/Walker's Armbands of the Greensward.jpg"
import WalkersBeltofPassingSpirits from "assets/images/items/Walker's Belt of Passing Spirits.jpg"
import WalkersBeltoftheClans from "assets/images/items/Walker's Belt of the Clans.jpg"
import WalkersBeltoftheTribes from "assets/images/items/Walker's Belt of the Tribes.jpg"
import WalkersBootsoftheFarHorizon from "assets/images/items/Walker's Boots of the Far Horizon.jpg"
import WalkersBootsoftheFourWinds from "assets/images/items/Walker's Boots of the Four Winds.jpg"
import WalkersBracersoftheFourWinds from "assets/images/items/Walker's Bracers of the Four Winds.jpg"
import WalkersFauldoftheAncestors from "assets/images/items/Walker's Fauld of the Ancestors.jpg"
import WalkersFauldoftheSevenSuns from "assets/images/items/Walker's Fauld of the Seven Suns.jpg"
import WalkersGauntletsoftheEverlastingSky from "assets/images/items/Walker's Gauntlets of the Everlasting Sky.jpg"
import WalkersGirdleoftheEverlastingSky from "assets/images/items/Walker's Girdle of the Everlasting Sky.jpg"
import WalkersGlovesofPassingSpirits from "assets/images/items/Walker's Gloves of Passing Spirits.jpg"
import WalkersGlovesoftheClans from "assets/images/items/Walker's Gloves of the Clans.jpg"
import WalkersGlovesoftheTribes from "assets/images/items/Walker's Gloves of the Tribes.jpg"
import WalkersJerkinoftheFarHorizon from "assets/images/items/Walker's Jerkin of the Far Horizon.jpg"
import WalkersLeggingsoftheGreensward from "assets/images/items/Walker's Leggings of the Greensward.jpg"
import WalkersLegguardsoftheGoldenHorde from "assets/images/items/Walker's Legguards of the Golden Horde.jpg"
import WalkersStrapsoftheGoldenHorde from "assets/images/items/Walker's Straps of the Golden Horde.jpg"
import WalkersStrapsoftheSevenSuns from "assets/images/items/Walker's Straps of the Seven Suns.jpg"
import WalkersTunicoftheMound from "assets/images/items/Walker's Tunic of the Mound.jpg"
import WalkersVambracesoftheMound from "assets/images/items/Walker's Vambraces of the Mound.jpg"
import WallofEternalWinter from "assets/images/items/Wall of Eternal Winter.jpg"
import WaningBoundary from "assets/images/items/Waning Boundary.jpg"
import WarMammoth from "assets/images/items/War Mammoth.jpg"
import WardoftheArchLector from "assets/images/items/Ward of the Arch Lector.jpg"
import WargloryArmbands from "assets/images/items/Warglory Armbands.jpg"
import WargloryBoots from "assets/images/items/Warglory Boots.jpg"
import WargloryChestguard from "assets/images/items/Warglory Chestguard.jpg"
import WargloryGauntlets from "assets/images/items/Warglory Gauntlets.jpg"
import WargloryGirdle from "assets/images/items/Warglory Girdle.jpg"
import WargloryHelm from "assets/images/items/Warglory Helm.jpg"
import WargloryLegguards from "assets/images/items/Warglory Legguards.jpg"
import WargloryVambraces from "assets/images/items/Warglory Vambraces.jpg"
import Warhaven from "assets/images/items/Warhaven.jpg"
import WarheraldGirdle from "assets/images/items/Warherald Girdle.jpg"
import WarhoofBoots from "assets/images/items/Warhoof Boots.jpg"
import WarlordsArrows from "assets/images/items/Warlord's Arrows.jpg"
import WarlordsAxe from "assets/images/items/Warlord's Axe.jpg"
import WarlordsBandofMight from "assets/images/items/Warlord's Band of Might.jpg"
import WarlordsBandofPower from "assets/images/items/Warlord's Band of Power.jpg"
import WarlordsBlade from "assets/images/items/Warlord's Blade.jpg"
import WarlordsBolts from "assets/images/items/Warlord's Bolts.jpg"
import WarlordsCinch from "assets/images/items/Warlord's Cinch.jpg"
import WarlordsCloak from "assets/images/items/Warlord's Cloak.jpg"
import WarlordsCrossbow from "assets/images/items/Warlord's Crossbow.jpg"
import WarlordsDagger from "assets/images/items/Warlord's Dagger.jpg"
import WarlordsGreatShield from "assets/images/items/Warlord's Great Shield.jpg"
import WarlordsGreatbow from "assets/images/items/Warlord's Greatbow.jpg"
import WarlordsGreatsword from "assets/images/items/Warlord's Greatsword.jpg"
import WarlordsMace from "assets/images/items/Warlord's Mace.jpg"
import WarlordsMarkofLoathing from "assets/images/items/Warlord's Mark of Loathing.jpg"
import WarlordsMaximofChaos from "assets/images/items/Warlord's Maxim of Chaos.jpg"
import WarlordsMysticBlade from "assets/images/items/Warlord's Mystic Blade.jpg"
import WarlordsPendantofShielding from "assets/images/items/Warlord's Pendant of Shielding.jpg"
import WarlordsSanctum from "assets/images/items/Warlord's Sanctum.jpg"
import WarlordsScepter from "assets/images/items/Warlord's Scepter.jpg"
import WarlordsSpellGlaive from "assets/images/items/Warlord's Spell Glaive.jpg"
import WarlordsSpellsword from "assets/images/items/Warlord's Spellsword.jpg"
import WarlordsStaff from "assets/images/items/Warlord's Staff.jpg"
import WarlordsWarGlaive from "assets/images/items/Warlord's War Glaive.jpg"
import WarlordsWarHammer from "assets/images/items/Warlord's War Hammer.jpg"
import WarmasterDreadfists from "assets/images/items/Warmaster Dreadfists.jpg"
import WarmongerRing from "assets/images/items/Warmonger Ring.jpg"
import WarmongersBattlebow from "assets/images/items/Warmonger's Battlebow.jpg"
import WarmongersClub from "assets/images/items/Warmonger's Club.jpg"
import WarmongersDagger from "assets/images/items/Warmonger's Dagger.jpg"
import WarmongersMask from "assets/images/items/Warmonger's Mask.jpg"
import WarmongersShield from "assets/images/items/Warmonger's Shield.jpg"
import WaspstingBolts from "assets/images/items/Waspsting Bolts.jpg"
import WatchCaptainsHonorShield from "assets/images/items/Watch Captain's Honor Shield.jpg"
import WatcheroftheDen from "assets/images/items/Watcher of the Den.jpg"
import WatchersSerpentweave from "assets/images/items/Watcher's Serpentweave.jpg"
import Wavebreaker from "assets/images/items/Wavebreaker.jpg"
import WestCleaveoftheWhiteTiger from "assets/images/items/West Cleave of the White Tiger.jpg"
import WestermarckCrossbow from "assets/images/items/Westermarck Crossbow.jpg"
import WestermarckJavelin from "assets/images/items/Westermarck Javelin.jpg"
import WestermarckMace from "assets/images/items/Westermarck Mace.jpg"
import WestermarckMantle from "assets/images/items/Westermarck Mantle.jpg"
import WestermarckShortBow from "assets/images/items/Westermarck Short Bow.jpg"
import WetlandGauntlets from "assets/images/items/Wetland Gauntlets.jpg"
import WhispererofEvilLuck from "assets/images/items/Whisperer of Evil Luck.jpg"
import WhisperingTouch from "assets/images/items/Whispering Touch.jpg"
import WhispersilkDrape from "assets/images/items/Whispersilk Drape.jpg"
import Whisperstride from "assets/images/items/Whisperstride.jpg"
import WhiteHandDeathgloves from "assets/images/items/White Hand Deathgloves.jpg"
import WhiteHandFists from "assets/images/items/White Hand Fists.jpg"
import WhiteHandGemofHolyStorm from "assets/images/items/White Hand Gem of Holy Storm.jpg"
import WhiteHandGemofUnholyStrike from "assets/images/items/White Hand Gem of Unholy Strike.jpg"
import WhiteHandWarders from "assets/images/items/White Hand Warders.jpg"
import WhiteHandWitchweaves from "assets/images/items/White Hand Witchweaves.jpg"
import WhitemoonChain from "assets/images/items/Whitemoon Chain.jpg"
import WickedHeart from "assets/images/items/Wicked Heart.jpg"
import WidowduskArmstraps from "assets/images/items/Widowdusk Arm-straps.jpg"
import WidowduskBelt from "assets/images/items/Widowdusk Belt.jpg"
import WidowduskBracers from "assets/images/items/Widowdusk Bracers.jpg"
import WidowduskFauld from "assets/images/items/Widowdusk Fauld.jpg"
import WidowduskHood from "assets/images/items/Widowdusk Hood.jpg"
import WidowduskMitts from "assets/images/items/Widowdusk Mitts.jpg"
import WidowduskPadsoles from "assets/images/items/Widowdusk Padsoles.jpg"
import WidowduskTunic from "assets/images/items/Widowdusk Tunic.jpg"
import WildclawGauntlets from "assets/images/items/Wildclaw Gauntlets.jpg"
import WildguardGirdle from "assets/images/items/Wildguard Girdle.jpg"
import WildhoundBracers from "assets/images/items/Wildhound Bracers.jpg"
import WildlingHauberk from "assets/images/items/Wildling Hauberk.jpg"
import WildmightGloves from "assets/images/items/Wildmight Gloves.jpg"
import WildstriderArmbands from "assets/images/items/Wildstrider Armbands.jpg"
import WildstriderBoots from "assets/images/items/Wildstrider Boots.jpg"
import WildstriderBracers from "assets/images/items/Wildstrider Bracers.jpg"
import WildstriderGirdle from "assets/images/items/Wildstrider Girdle.jpg"
import WildstriderGloves from "assets/images/items/Wildstrider Gloves.jpg"
import WildstriderHelm from "assets/images/items/Wildstrider Helm.jpg"
import WildstriderJerkin from "assets/images/items/Wildstrider Jerkin.jpg"
import WildstriderTasset from "assets/images/items/Wildstrider Tasset.jpg"
import WildthornBand from "assets/images/items/Wildthorn Band.jpg"
import WillofAtali from "assets/images/items/Will of Atali.jpg"
import WillofSalvation from "assets/images/items/Will of Salvation.jpg"
import WillcasterCirclet from "assets/images/items/Willcaster Circlet.jpg"
import WindoftheVanir from "assets/images/items/Wind of the Vanir.jpg"
import WindsGrasp from "assets/images/items/Wind's Grasp.jpg"
import Windfury from "assets/images/items/Windfury.jpg"
import Windpiercer from "assets/images/items/Windpiercer.jpg"
import WingsofSalvation from "assets/images/items/Wings of Salvation.jpg"
import WitchboneNecklace from "assets/images/items/Witchbone Necklace.jpg"
import WitchbornTasset from "assets/images/items/Witchborn Tasset.jpg"
import Wizenbone from "assets/images/items/Wizenbone.jpg"
import WolDo from "assets/images/items/Wol Do.jpg"
import WolfSnarl from "assets/images/items/Wolf Snarl.jpg"
import WolfTamersBlade from "assets/images/items/Wolf Tamer's Blade.jpg"
import WolfTamersCloak from "assets/images/items/Wolf Tamer's Cloak.jpg"
import WolfTamersLongblade from "assets/images/items/Wolf Tamer's Longblade.jpg"
import WolfTamersShield from "assets/images/items/Wolf Tamer's Shield.jpg"
import WolfToothPendant from "assets/images/items/Wolf Tooth Pendant.jpg"
import WolfsArmbandsoftheCovertTrail from "assets/images/items/Wolf's Armbands of the Covert Trail.jpg"
import WolfsArmbandsoftheWickedHearth from "assets/images/items/Wolf's Armbands of the Wicked Hearth.jpg"
import WolfsArmbandsofWorldsEdge from "assets/images/items/Wolf's Armbands of World's Edge.jpg"
import WolfsArmguardsoftheGrasslands from "assets/images/items/Wolf's Armguards of the Grasslands.jpg"
import WolfsBeltoftheCovertTrail from "assets/images/items/Wolf's Belt of the Covert Trail.jpg"
import WolfsBeltoftheGrasslands from "assets/images/items/Wolf's Belt of the Grasslands.jpg"
import WolfsBeltoftheWickedHearth from "assets/images/items/Wolf's Belt of the Wicked Hearth.jpg"
import WolfsBeltofWorldsEdge from "assets/images/items/Wolf's Belt of World's Edge.jpg"
import WolfsBootsoftheBloodyFang from "assets/images/items/Wolf's Boots of the Bloody Fang.jpg"
import WolfsBootsoftheKhan from "assets/images/items/Wolf's Boots of the Khan.jpg"
import WolfsBootsoftheRitualFlame from "assets/images/items/Wolf's Boots of the Ritual Flame.jpg"
import WolfsBootsofWovenClouds from "assets/images/items/Wolf's Boots of Woven Clouds.jpg"
import WolfsChestguardoftheHowlingMoon from "assets/images/items/Wolf's Chestguard of the Howling Moon.jpg"
import WolfsGauntletsoftheGrasslands from "assets/images/items/Wolf's Gauntlets of the Grasslands.jpg"
import WolfsGlovesoftheCovertTrail from "assets/images/items/Wolf's Gloves of the Covert Trail.jpg"
import WolfsGlovesoftheWickedHearth from "assets/images/items/Wolf's Gloves of the Wicked Hearth.jpg"
import WolfsGlovesofWorldsEdge from "assets/images/items/Wolf's Gloves of World's Edge.jpg"
import WolfsHelmoftheHowlingMoon from "assets/images/items/Wolf's Helm of the Howling Moon.jpg"
import WolfsHoodofaHundredEyes from "assets/images/items/Wolf's Hood of a Hundred Eyes.jpg"
import WolfsHoodoftheGraspingWild from "assets/images/items/Wolf's Hood of the Grasping Wild.jpg"
import WolfsJerkinofaHundredEyes from "assets/images/items/Wolf's Jerkin of a Hundred Eyes.jpg"
import WolfsJerkinoftheGraspingWild from "assets/images/items/Wolf's Jerkin of the Grasping Wild.jpg"
import WolfsLeggingsoftheCovertTrail from "assets/images/items/Wolf's Leggings of the Covert Trail.jpg"
import WolfsLeggingsoftheWickedHearth from "assets/images/items/Wolf's Leggings of the Wicked Hearth.jpg"
import WolfsLeggingsofWorldsEdge from "assets/images/items/Wolf's Leggings of World's Edge.jpg"
import WolfsLegguardsoftheGrasslands from "assets/images/items/Wolf's Legguards of the Grasslands.jpg"
import WolfsMaskoftheHowlingWind from "assets/images/items/Wolf's Mask of the Howling Wind.jpg"
import WolfsStrapsoftheRitualFlame from "assets/images/items/Wolf's Straps of the Ritual Flame.jpg"
import WolfsStrapsofWovenClouds from "assets/images/items/Wolf's Straps of Woven Clouds.jpg"
import WolfsTunicoftheHowlingWind from "assets/images/items/Wolf's Tunic of the Howling Wind.jpg"
import WolfsVambracesoftheKhan from "assets/images/items/Wolf's Vambraces of the Khan.jpg"
import WolfsWristbandsoftheBloodyFang from "assets/images/items/Wolf's Wristbands of the Bloody Fang.jpg"
import Wolfsbane from "assets/images/items/Wolfsbane.jpg"
import WolfsteelSabatons from "assets/images/items/Wolfsteel Sabatons.jpg"
import WoundhoeofPictsRuin from "assets/images/items/Wound-hoe of Picts Ruin.jpg"
import WrapofDragonFlight from "assets/images/items/Wrap of Dragon Flight.jpg"
import WrapoftheDragonKing from "assets/images/items/Wrap of the Dragon King.jpg"
import WrapoftheEndlessSands from "assets/images/items/Wrap of the Endless Sands.jpg"
import WrapoftheExuberant from "assets/images/items/Wrap of the Exuberant.jpg"
import WrapoftheHellWalkernm from "assets/images/items/Wrap of the Hell Walker (nm).jpg"
import WrapoftheHellWalker from "assets/images/items/Wrap of the Hell Walker.jpg"
import WrapoftheMasqueroftheSands from "assets/images/items/Wrap of the Masquer of the Sands.jpg"
import WrapoftheOxmal from "assets/images/items/Wrap of the Oxmal.jpg"
import WrapoftheShiveringStars from "assets/images/items/Wrap of the Shivering Stars.jpg"
import WrapsoftheEarthMother from "assets/images/items/Wraps of the Earth Mother.jpg"
import WrathoftheDarkSun from "assets/images/items/Wrath of the Dark Sun.jpg"
import WrathofXotli from "assets/images/items/Wrath of Xotli.jpg"
import WrathwardHelm from "assets/images/items/Wrathward Helm.jpg"
import WreathofEther from "assets/images/items/Wreath of Ether.jpg"
import WreathoftheUnruly from "assets/images/items/Wreath of the Unruly.jpg"
import WreathofVapors from "assets/images/items/Wreath of Vapors.jpg"
import WriststrapsoftheBloodGodnm from "assets/images/items/Wrist-straps of the Blood God (nm).jpg"
import WriststrapsoftheBloodGod from "assets/images/items/Wrist-straps of the Blood God.jpg"
import WriststrapsoftheDeathMasternm from "assets/images/items/Wrist-straps of the Death Master (nm).jpg"
import WriststrapsoftheDeathMaster from "assets/images/items/Wrist-straps of the Death Master.jpg"
import WristbandoftheCrawlingChaos from "assets/images/items/Wristband of the Crawling Chaos.jpg"
import WristbandoftheFacelessChaos from "assets/images/items/Wristband of the Faceless Chaos.jpg"
import WristbandoftheFacelessSphinx from "assets/images/items/Wristband of the Faceless Sphinx.jpg"
import WristbandoftheNebulous from "assets/images/items/Wristband of the Nebulous.jpg"
import WristbandoftheSepulcher from "assets/images/items/Wristband of the Sepulcher.jpg"
import WristbandoftheSpheres from "assets/images/items/Wristband of the Spheres.jpg"
import WristbandoftheUnutterable from "assets/images/items/Wristband of the Unutterable.jpg"
import WristbandsoftheWhisperingBlade from "assets/images/items/Wristbands of the Whispering Blade.jpg"
import WristwrapsofConcealingShadows from "assets/images/items/Wristwraps of Concealing Shadows.jpg"
import WristwrapsofFiendishInvocation from "assets/images/items/Wristwraps of Fiendish Invocation.jpg"
import WristwrapsofIntricateSpite from "assets/images/items/Wristwraps of Intricate Spite.jpg"
import WristwrapsoftheDarkwretch from "assets/images/items/Wristwraps of the Darkwretch.jpg"
import WristwrapsoftheDoomsayer from "assets/images/items/Wristwraps of the Doomsayer.jpg"
import WristwrapsoftheFirebrand from "assets/images/items/Wristwraps of the Firebrand.jpg"
import WristwrapsoftheForsaken from "assets/images/items/Wristwraps of the Forsaken.jpg"
import WristwrapsoftheHarbinger from "assets/images/items/Wristwraps of the Harbinger.jpg"
import WristwrapsofthePrecursor from "assets/images/items/Wristwraps of the Precursor.jpg"
import WristwrapsoftheReanimator from "assets/images/items/Wristwraps of the Reanimator.jpg"
import WristwrapsofVindictiveMalice from "assets/images/items/Wristwraps of Vindictive Malice.jpg"
import Ytothdagger from "assets/images/items/Y'toth (dagger).jpg"
import YmirishFrostband from "assets/images/items/Ymirish Frostband.jpg"
import Ytoth from "assets/images/items/Ytoth.jpg"
import YunMarkofImmolation from "assets/images/items/Yun Mark of Immolation.jpg"
import YunsColdFlame from "assets/images/items/Yun's Cold Flame.jpg"
import YunsCrowBeakedKisses from "assets/images/items/Yun's Crow-Beaked Kisses.jpg"
import ZealofAtali from "assets/images/items/Zeal of Atali.jpg"
import ZoriasSpire from "assets/images/items/Zoria's Spire.jpg"
import ZugiteHereticStaff from "assets/images/items/Zugite Heretic Staff.jpg"
import ZugiteKnightTotem from "assets/images/items/Zugite Knight Totem.jpg"
import ZugiteSacrificialPoniard from "assets/images/items/Zugite Sacrificial Poniard.jpg"
import ZukalasReliquary from "assets/images/items/Zukala's Reliquary.jpg"
import ZukalasRites from "assets/images/items/Zukala's Rites.jpg"
import ZukasPrizedHelm from "assets/images/items/Zukas' Prized Helm.jpg"

//abilities

import AbsoluteFarseerElixir from "assets/images/items/Absolute Farseer Elixir.jpg"
import AbsoluteMoonspill from "assets/images/items/Absolute Moonspill.jpg"
import AbsoluteWitchsour from "assets/images/items/Absolute Witchsour.jpg"
import BattleburnStout from "assets/images/items/Battleburn Stout.jpg"
import BonesoulAle from "assets/images/items/Bonesoul Ale.jpg"
import BrewofAcuteAcumen from "assets/images/items/Brew of Acute Acumen.jpg"
import BrewofAcuteAptitude from "assets/images/items/Brew of Acute Aptitude.jpg"
import BrewofAcuteBrawn from "assets/images/items/Brew of Acute Brawn.jpg"
import BrewofAcuteForesight from "assets/images/items/Brew of Acute Foresight.jpg"
import BrewofAcuteFortitude from "assets/images/items/Brew of Acute Fortitude.jpg"
import BrewofVigorousAcumen from "assets/images/items/Brew of Vigorous Acumen.jpg"
import BrewofVigorousAptitude from "assets/images/items/Brew of Vigorous Aptitude.jpg"
import BrewofVigorousBrawn from "assets/images/items/Brew of Vigorous Brawn.jpg"
import BrewofVigorousForesight from "assets/images/items/Brew of Vigorous Foresight.jpg"
import ClarifiedBloodroyalBrandy from "assets/images/items/Clarified Bloodroyal Brandy.jpg"
import ClarifiedDevilsmead from "assets/images/items/Clarified Devilsmead.jpg"
import ClarifiedSoursap from "assets/images/items/Clarified Soursap.jpg"
import CombatRatingBoost4h from "assets/images/items/Combat Rating Boost (4h).jpg"
import CriticalRatingBoost4h from "assets/images/items/Critical Rating Boost (4h).jpg"
import CynosuralAle from "assets/images/items/Cynosural Ale.jpg"
import Daggamalt from "assets/images/items/Daggamalt.jpg"
import DireGreatmaneAle from "assets/images/items/Dire Greatmane Ale.jpg"
import DireRainofKhitai from "assets/images/items/Dire Rain of Khitai.jpg"
import DireSweetpressedHaste from "assets/images/items/Dire Sweetpressed Haste.jpg"
import ElixirofBruteForce from "assets/images/items/Elixir of Brute Force.jpg"
import ElixirofGuile from "assets/images/items/Elixir of Guile.jpg"
import ElixirofInvigorativeRejuvenation from "assets/images/items/Elixir of Invigorative Rejuvenation.jpg"
import ElixirofMysticalExcellence from "assets/images/items/Elixir of Mystical Excellence.jpg"
import ElixirofMysticalReplenishment from "assets/images/items/Elixir of Mystical Replenishment.jpg"
import ElixirofPrecision from "assets/images/items/Elixir of Precision.jpg"
import ExcellentAmrita from "assets/images/items/Excellent Amrita.jpg"
import ExcellentBrawlbracerAle from "assets/images/items/Excellent Brawlbracer Ale.jpg"
import ExcellentEtherdew from "assets/images/items/Excellent Etherdew.jpg"
import ExceptionalElixirofResurgence from "assets/images/items/Exceptional Elixir of Resurgence.jpg"
import ExhaustingTraps from "assets/images/items/Exhausting Traps.jpg"
import FatalConcoction from "assets/images/items/Fatal Concoction.jpg"
import GoldenWineofXuthal from "assets/images/items/Golden Wine of Xuthal.jpg"
import GroupKingsFeast from "assets/images/items/Group King's Feast.jpg"
import HealRatingBoost4h from "assets/images/items/Heal Rating Boost (4h).jpg"
import HealthPotion from "assets/images/items/Health Potion.jpg"
import KingsFeast from "assets/images/items/King's Feast.jpg"
import KingsmightAle from "assets/images/items/Kingsmight Ale.jpg"
import LegofFena from "assets/images/items/Leg of Fena.jpg"
import MagicDamageBoost4h from "assets/images/items/Magic Damage Boost (4h).jpg"
import MajorRuneStoneofAscensionV from "assets/images/items/Major Rune Stone of Ascension (V).jpg"
import MajorRuneStoneofAscension from "assets/images/items/Major Rune Stone of Ascension.jpg"
import MajorRuneStoneofBerserkersFuryV from "assets/images/items/Major Rune Stone of Berserker's Fury (V).jpg"
import MajorRuneStoneofBerserkersFury from "assets/images/items/Major Rune Stone of Berserker's Fury.jpg"
import MajorRuneStoneofQuilledDartsV from "assets/images/items/Major Rune Stone of Quilled Darts (V).jpg"
import MajorRuneStoneofQuilledDarts from "assets/images/items/Major Rune Stone of Quilled Darts.jpg"
import MajorRuneStoneoftheChaosAgentV from "assets/images/items/Major Rune Stone of the Chaos Agent (V).jpg"
import MajorRuneStoneoftheChaosAgent from "assets/images/items/Major Rune Stone of the Chaos Agent.jpg"
import MajorRuneStoneoftheEternalBlazeV from "assets/images/items/Major Rune Stone of the Eternal Blaze (V).jpg"
import MajorRuneStoneoftheEternalBlaze from "assets/images/items/Major Rune Stone of the Eternal Blaze.jpg"
import MajorRuneStoneoftheExile from "assets/images/items/Major Rune Stone of the Exile.jpg"
import MajorRuneStoneoftheFirstCircleV from "assets/images/items/Major Rune Stone of the First Circle (V).jpg"
import MajorRuneStoneoftheFirstCircle from "assets/images/items/Major Rune Stone of the First Circle.jpg"
import MajorRuneStoneoftheFuriousSwipeV from "assets/images/items/Major Rune Stone of the Furious Swipe (V).jpg"
import MajorRuneStoneoftheFuriousSwipe from "assets/images/items/Major Rune Stone of the Furious Swipe.jpg"
import MajorRuneStoneoftheJudgmentBoltV from "assets/images/items/Major Rune Stone of the Judgment Bolt (V).jpg"
import MajorRuneStoneoftheJudgmentBolt from "assets/images/items/Major Rune Stone of the Judgment Bolt.jpg"
import MajorRuneStoneofthePitFighter from "assets/images/items/Major Rune Stone of the Pit Fighter.jpg"
import MajorRuneStoneoftheProvenChampionV from "assets/images/items/Major Rune Stone of the Proven Champion (V).jpg"
import MajorRuneStoneoftheProvenChampion from "assets/images/items/Major Rune Stone of the Proven Champion.jpg"
import MajorRuneStoneoftheRedWake from "assets/images/items/Major Rune Stone of the Red Wake.jpg"
import MajorRuneStoneoftheSecondWind from "assets/images/items/Major Rune Stone of the Second Wind.jpg"
import MajorRuneStoneoftheSilentSlayerV from "assets/images/items/Major Rune Stone of the Silent Slayer (V).jpg"
import MajorRuneStoneoftheSilentSlayer from "assets/images/items/Major Rune Stone of the Silent Slayer.jpg"
import MajorRuneStoneoftheTirelessDefenderV from "assets/images/items/Major Rune Stone of the Tireless Defender (V).jpg"
import MajorRuneStoneoftheTirelessDefender from "assets/images/items/Major Rune Stone of the Tireless Defender.jpg"
import MajorRuneStoneofUnholyCommunionV from "assets/images/items/Major Rune Stone of Unholy Communion (V).jpg"
import MajorRuneStoneofUnholyCommunion from "assets/images/items/Major Rune Stone of Unholy Communion.jpg"
import ManaPotion from "assets/images/items/Mana Potion.jpg"
import MinorBrewofAcumen from "assets/images/items/Minor Brew of Acumen.jpg"
import MinorBrewofAcuteStriking from "assets/images/items/Minor Brew of Acute Striking.jpg"
import MinorBrewofAptitude from "assets/images/items/Minor Brew of Aptitude.jpg"
import MinorBrewofBrawn from "assets/images/items/Minor Brew of Brawn.jpg"
import MinorBrewofForesight from "assets/images/items/Minor Brew of Foresight.jpg"
import MinorBrewofFortitude from "assets/images/items/Minor Brew of Fortitude.jpg"
import MinorElixirofResurgence from "assets/images/items/Minor Elixir of Resurgence.jpg"
import MinorRuneStoneoftheClaretTrail from "assets/images/items/Minor Rune Stone of the Claret Trail.jpg"
import Moonspill from "assets/images/items/Moonspill.jpg"
import MorphWolfPictWarrior from "assets/images/items/Morph  Wolf Pict Warrior.jpg"
import MorphChildoftheGoat from "assets/images/items/Morph Child of the Goat.jpg"
import MorphCholericFiend from "assets/images/items/Morph Choleric Fiend.jpg"
import MorphCrocodilePictChieftain from "assets/images/items/Morph Crocodile Pict Chieftain.jpg"
import MorphDecayingCorpse from "assets/images/items/Morph Decaying Corpse.jpg"
import MorphGrimCurate from "assets/images/items/Morph Grim Curate.jpg"
import MorphPantherPictBerserker from "assets/images/items/Morph Panther Pict Berserker.jpg"
import MorphPhlegmaticFiend from "assets/images/items/Morph Phlegmatic Fiend.jpg"
import MorphUndead from "assets/images/items/Morph Undead.jpg"
import Narcinthe from "assets/images/items/Narcinthe.jpg"
import PetBlackLotus from "assets/images/items/Pet Black Lotus.jpg"
import PetFleetCinderFuDog from "assets/images/items/Pet Fleet Cinder Fu Dog.jpg"
import PetGoldenLotus from "assets/images/items/Pet Golden Lotus.jpg"
import PetGreyLotus from "assets/images/items/Pet Grey Lotus.jpg"
import PetYellowLotus from "assets/images/items/Pet Yellow Lotus.jpg"
import PharmaconofAvoidance from "assets/images/items/Pharmacon of Avoidance.jpg"
import PharmaconofNegation from "assets/images/items/Pharmacon of Negation.jpg"
import PolymorphLycanthropicMorph from "assets/images/items/Polymorph Lycanthropic Morph.jpg"
import PotentBittersharp from "assets/images/items/Potent Bittersharp.jpg"
import PotentDaggamalt from "assets/images/items/Potent Daggamalt.jpg"
import PotentSoursap from "assets/images/items/Potent Soursap.jpg"
import PotionofConstitution4h from "assets/images/items/Potion of Constitution (4h).jpg"
import PotionofDexterity4h from "assets/images/items/Potion of Dexterity (4h).jpg"
import PotionofIntellect4h from "assets/images/items/Potion of Intellect (4h).jpg"
import PotionofStrength4h from "assets/images/items/Potion of Strength (4h).jpg"
import PotionofWisdom4h from "assets/images/items/Potion of Wisdom (4h).jpg"
import PurifiedDaggamalt from "assets/images/items/Purified Daggamalt.jpg"
import PurifiedMoonspill from "assets/images/items/Purified Moonspill.jpg"
import PurifiedSweetpressedHaste from "assets/images/items/Purified Sweetpressed Haste.jpg"
import RedDeviledDates from "assets/images/items/Red Deviled Dates.jpg"
import RefinedElixirofBruteForce from "assets/images/items/Refined Elixir of Brute Force.jpg"
import RefinedElixirofGuile from "assets/images/items/Refined Elixir of Guile.jpg"
import RefinedElixirofInvigorativeRejuvenation from "assets/images/items/Refined Elixir of Invigorative Rejuvenation.jpg"
import RefinedElixirofMysticalExcellence from "assets/images/items/Refined Elixir of Mystical Excellence.jpg"
import RefinedElixirofMysticalReplenishment from "assets/images/items/Refined Elixir of Mystical Replenishment.jpg"
import RefinedElixirofPrecision from "assets/images/items/Refined Elixir of Precision.jpg"
import RefinedPharmaconofAvoidance from "assets/images/items/Refined Pharmacon of Avoidance.jpg"
import RefinedPharmaconofNegation from "assets/images/items/Refined Pharmacon of Negation.jpg"
import RefinedPhiltreofConstitution from "assets/images/items/Refined Philtre of Constitution.jpg"
import RefinedPhiltreofDexterity from "assets/images/items/Refined Philtre of Dexterity.jpg"
import RefinedPhiltreofIntellect from "assets/images/items/Refined Philtre of Intellect.jpg"
import RefinedPhiltreofStrength from "assets/images/items/Refined Philtre of Strength.jpg"
import RefinedPhiltreofWisdom from "assets/images/items/Refined Philtre of Wisdom.jpg"
import RejuvenationoftheGhagha from "assets/images/items/Rejuvenation of the Ghagha.jpg"
import RuneStoneofSharedBloodshed from "assets/images/items/Rune Stone of Shared Bloodshed.jpg"
import RuneStoneoftheCrimsonPath from "assets/images/items/Rune Stone of the Crimson Path.jpg"
import RuneStoneoftheEiglophians from "assets/images/items/Rune Stone of the Eiglophians.jpg"
import RuneStoneoftheEmeraldLotus from "assets/images/items/Rune Stone of the Emerald Lotus.jpg"
import RuneStoneoftheLastResort from "assets/images/items/Rune Stone of the Last Resort.jpg"
import RuneStoneoftheRoyalStables from "assets/images/items/Rune Stone of the Royal Stables.jpg"
import RuneStoneoftheStyx from "assets/images/items/Rune Stone of the Styx.jpg"
import RuneStoneoftheWarmonks from "assets/images/items/Rune Stone of the Warmonks.jpg"
import SealofYog from "assets/images/items/Seal of Yog.jpg"
import SelfResurrectionPotion from "assets/images/items/Self-Resurrection Potion.jpg"
import SoulslakeMead from "assets/images/items/Soulslake Mead.jpg"
import StaminaPotion from "assets/images/items/Stamina Potion.jpg"
import SweetpressedHaste from "assets/images/items/Sweetpressed Haste.jpg"
import UnlimitedMorphDuskFiend from "assets/images/items/Unlimited Morph Dusk Fiend.jpg"
import UnlimitedMorphGrimBlade from "assets/images/items/Unlimited Morph Grim Blade.jpg"
import UnlimitedMorphHyperboreanWarrior from "assets/images/items/Unlimited Morph Hyperborean Warrior.jpg"
import LycanthropicMorph from "assets/images/items/Lycanthropic Morph.jpg"


const Items:any = {
"A Father's Devotion":AFathersDevotion,
"A Father's Pledge":AFathersPledge,
"A Father's Will":AFathersWill,
"A Father's Wrath":AFathersWrath,
"Abyssal Cape of the Fallen Empire":AbyssalCapeoftheFallenEmpire,
"Abyssal Cloak of Crimson Slaughter":AbyssalCloakofCrimsonSlaughter,
"Abyssal Cloak of the Death Master":AbyssalCloakoftheDeathMaster,
"Abyssal Cloak of the Hell Walker":AbyssalCloakoftheHellWalker,
"Abyssal Demon Pendant of Assault":AbyssalDemonPendantofAssault,
"Abyssal Demon Pendant of Constitution":AbyssalDemonPendantofConstitution,
"Abyssal Demon Pendant of Dexterity":AbyssalDemonPendantofDexterity,
"Abyssal Demon Pendant of Intelligence":AbyssalDemonPendantofIntelligence,
"Abyssal Demon Pendant of Strength":AbyssalDemonPendantofStrength,
"Abyssal Demon Pendant of Wisdom":AbyssalDemonPendantofWisdom,
"Abyssal Demon Ring of Assault":AbyssalDemonRingofAssault,
"Abyssal Demon Ring of Constitution":AbyssalDemonRingofConstitution,
"Abyssal Demon Ring of Dexterity":AbyssalDemonRingofDexterity,
"Abyssal Demon Ring of Intelligence":AbyssalDemonRingofIntelligence,
"Abyssal Demon Ring of Strength":AbyssalDemonRingofStrength,
"Abyssal Demon Ring of Wisdom":AbyssalDemonRingofWisdom,
"Abyssal Gale":AbyssalGale,
"Abyssal Hammer":AbyssalHammer,
"Abyssal Shroud":AbyssalShroud,
"Abyssal Slicer":AbyssalSlicer,
"Abyssal Sting":AbyssalSting,
"Accensus":Accensus,
"Achiton of Celestial Radiance":AchitonofCelestialRadiance,
"Achiton of Effulgent Devotion":AchitonofEffulgentDevotion,
"Achiton of Illuminant Conviction":AchitonofIlluminantConviction,
"Achiton of the Ascension":AchitonoftheAscension,
"Acolyte's Arm-straps of Balance":AcolytesArmstrapsofBalance,
"Acolyte's Armbands of the Spilling Blood":AcolytesArmbandsoftheSpillingBlood,
"Acolyte's Belt of Sacrifice":AcolytesBeltofSacrifice,
"Acolyte's Belt of the Hallow Worlds":AcolytesBeltoftheHallowWorlds,
"Acolyte's Belt of the Limitless Cipher":AcolytesBeltoftheLimitlessCipher,
"Acolyte's Boots of the Abyss":AcolytesBootsoftheAbyss,
"Acolyte's Boots of the Eighteen Pits":AcolytesBootsoftheEighteenPits,
"Acolyte's Boots of the Nine Springs":AcolytesBootsoftheNineSprings,
"Acolyte's Boots of the Underworld":AcolytesBootsoftheUnderworld,
"Acolyte's Gauntlets of the Earthen Prison":AcolytesGauntletsoftheEarthenPrison,
"Acolyte's Girdle of the Earthen Prison":AcolytesGirdleoftheEarthenPrison,
"Acolyte's Gloves of Sacrifice":AcolytesGlovesofSacrifice,
"Acolyte's Gloves of the Hallow Worlds":AcolytesGlovesoftheHallowWorlds,
"Acolyte's Gloves of the Limitless Cipher":AcolytesGlovesoftheLimitlessCipher,
"Acolyte's Harness of the Eighteen Pits":AcolytesHarnessoftheEighteenPits,
"Acolyte's Helm of the Abyss":AcolytesHelmoftheAbyss,
"Acolyte's Hood of the Underworld":AcolytesHoodoftheUnderworld,
"Acolyte's Jerkin of the Abyss":AcolytesJerkinoftheAbyss,
"Acolyte's Leggings of the Black Thread":AcolytesLeggingsoftheBlackThread,
"Acolyte's Leggings of the Spilling Blood":AcolytesLeggingsoftheSpillingBlood,
"Acolyte's Legguards of the Sacred Mountain":AcolytesLegguardsoftheSacredMountain,
"Acolyte's Mask of the Nine Springs":AcolytesMaskoftheNineSprings,
"Acolyte's Robes of the Underworld":AcolytesRobesoftheUnderworld,
"Acolyte's Straps of the Black Thread":AcolytesStrapsoftheBlackThread,
"Acolyte's Straps of the Sacred Mountain":AcolytesStrapsoftheSacredMountain,
"Acolyte's Threads of Balance":AcolytesThreadsofBalance,
"Acutus":Acutus,
"Adventurer's Pack-Bag":AdventurersPackBag,
"Advocacy of the August Ones":AdvocacyoftheAugustOnes,
"Aegis of Dhurkan Blackblade":AegisofDhurkanBlackblade,
"Aegis of Five Mercies":AegisofFiveMercies,
"Aegis of Khan":AegisofKhan,
"Aegis of the Blood God":AegisoftheBloodGod,
"Aegis of the Jackal":AegisoftheJackal,
"Aegis of the Warlord":AegisoftheWarlord,
"Aegrus Mal":AegrusMal,
"Aelfirth's Grace":AelfrithsGrace,
"Aelfirth's Gratitude":AelfrithsGratitude,
"Aelfirth's Honour":AelfrithsHonour,
"Aelfirth's Tribute":AelfrithsTribute,
"Aged Bone Flute":AgedBoneFlute,
"Agilis":Agilis,
"Agonizing Bludgeon":AgonizingBludgeon,
"Ahnefet":Ahnefet,
"Akinakes of the Ruinous Miasma":AkinakesoftheRuinousMiasma,
"Akivneteh":Akivneteh,
"Alchemist's Pendant":AlchemistsPendant,
"All-Seeing-Eye of Mystical Supremacy":AllSeeingEyeofMysticalSupremacy,
"Alpha Hound Fang":AlphaHoundFang,
"Alpha Skull Helm":AlphaSkullHelm,
"Alvazar's Gloves":AlvazarsGloves,
"Alvazar's Vest":AlvazarsVest,
"Amethyst Ring of Wisdom":AmethystRingofWisdom,
"Amra's Pride":AmrasPride,
"Amtah":Amtah,
"Amulet of Ancient Python":AmuletofAncientPython,
"Amulet of Crimson Slaughter":AmuletofCrimsonSlaughter,
"Amulet of Finesse":AmuletofFinesse,
"Amulet of Good Fortune":AmuletofGoodFortune,
"Amulet of Orastes":AmuletofOrastes,
"Amulet of Pure Ice":AmuletofPureIce,
"Amulet of Souls":AmuletofSouls,
"Amulet of the Asshuri":AmuletoftheAsshuri,
"Amulet of the Esoteric Pendulum":AmuletoftheEsotericPendulum,
"Amulet of the Hell Walker":AmuletoftheHellWalker,
"Amulet of Zarallo":AmuletofZarallo,
"Ancient Arbalest":AncientArbalest,
"Ancient Blade":AncientBlade,
"Ancient Bone Flute":AncientBoneFlute,
"Ancient Kukri":AncientKukri,
"Ancient Mace":AncientMace,
"Ancient Scroll":AncientScroll,
"Ancient Serpent Staff":AncientSerpentStaff,
"Ancient Shield":AncientShield,
"Ancient Spear":AncientSpear,
"Ancient War Scythe":AncientWarScythe,
"Ancient Warhammer":AncientWarhammer,
"Angerwake Helm":AngerwakeHelm,
"Anktar Longshot":AnktarLongshot,
"Antillian Boots":AntillianBoots,
"Antillian Jerkin":AntillianJerkin,
"Antillian Leggings":AntillianLeggings,
"Antlers of Bone and Horn":AntlersofBoneandHorn,
"Anvilrage":Anvilrage,
"Anvilstrike":Anvilstrike,
"Apotheosis of Hate":ApotheosisofHate,
"Apotheosis of Pain":ApotheosisofPain,
"Arakh of the Archaeologian":ArakhoftheArchaeologian,
"Arc of Eternal Winter":ArcofEternalWinter,
"Arca of Jaggta-Noga":ArcaofJaggtaNoga,
"Arcane Shield":ArcaneShield,
"Arcfire Opus":ArcfireOpus,
"Archdeacon's Armbands of the Eighteen Pits":ArchdeaconsArmbandsoftheEighteenPits,
"Archdeacon's Belt of the Abyss":ArchdeaconsBeltoftheAbyss,
"Archdeacon's Boots of the Sacred Mountain":ArchdeaconsBootsoftheSacredMountain,
"Archdeacon's Boots of the Spilling Blood":ArchdeaconsBootsoftheSpillingBlood,
"Archdeacon's Bracers of the Sacred Mountain":ArchdeaconsBracersoftheSacredMountain,
"Archdeacon's Bracers of the Spilling Blood":ArchdeaconsBracersoftheSpillingBlood,
"Archdeacon's Gauntlets of the Eighteen Pits":ArchdeaconsGauntletsoftheEighteenPits,
"Archdeacon's Girdle of the Eighteen Pits":ArchdeaconsGirdleoftheEighteenPits,
"Archdeacon's Gloves of the Abyss":ArchdeaconsGlovesoftheAbyss,
"Archdeacon's Harness of the Earthen Prison":ArchdeaconsHarnessoftheEarthenPrison,
"Archdeacon's Helm of the Earthen Prison":ArchdeaconsHelmoftheEarthenPrison,
"Archdeacon's Helm of the Hallow Worlds":ArchdeaconsHelmoftheHallowWorlds,
"Archdeacon's Jerkin of the Hallow Worlds":ArchdeaconsJerkinoftheHallowWorlds,
"Archdeacon's Leggings of the Eighteen Pits":ArchdeaconsLeggingsoftheEighteenPits,
"Archdeacon's Legguards of the Abyss":ArchdeaconsLegguardsoftheAbyss,
"Archdeacon's Straps of the Abyss":ArchdeaconsStrapsoftheAbyss,
"Archer's Serpentweave":ArchersSerpentweave,
"Archpriest's Belt of the Nine Springs":ArchpriestsBeltoftheNineSprings,
"Archpriest's Boots of Balance":ArchpriestsBootsofBalance,
"Archpriest's Boots of the Black Thread":ArchpriestsBootsoftheBlackThread,
"Archpriest's Bracers of the Black Thread":ArchpriestsBracersoftheBlackThread,
"Archpriest's Coils of the Underworld":ArchpriestsCoilsoftheUnderworld,
"Archpriest's Cord of the Underworld":ArchpriestsCordoftheUnderworld,
"Archpriest's Crest of Sacrifice":ArchpriestsCrestofSacrifice,
"Archpriest's Fauld of the Nine Springs":ArchpriestsFauldoftheNineSprings,
"Archpriest's Gloves of the Nine Springs":ArchpriestsGlovesoftheNineSprings,
"Archpriest's Gloves of the Underworld":ArchpriestsGlovesoftheUnderworld,
"Archpriest's Raiment of Sacrifice":ArchpriestsRaimentofSacrifice,
"Archpriest's Straps of Balance":ArchpriestsStrapsofBalance,
"Archpriest's Straps of the Nine Springs":ArchpriestsStrapsoftheNineSprings,
"Archpriest's Threads of the Underworld":ArchpriestsThreadsoftheUnderworld,
"Archpriest's Tunic of the Limitless Cipher":ArchpriestsTunicoftheLimitlessCipher,
"Archpriest's Visage of the Limitless Cipher":ArchpriestsVisageoftheLimitlessCipher,
"Ardent Atlantean Relic":ArdentAtlanteanRelic,
"Zealous Atlantean Relic":ZealousAtlanteanRelic,
"Mystic Atlantean Relic":MysticAtlanteanRelic,
"Holy Atlantean Relic":HolyAtlanteanRelic,
"Hastening Atlantean Relic":HasteningAtlanteanRelic,
"Fervent Atlantean Relic":FerventAtlanteanRelic,
"Arm Band of the Amaranthine Drums":ArmBandoftheAmaranthineDrums,
"Arm Bands of the Ghost of the Veldt":ArmBandsoftheGhostoftheVeldt,
"Arm Bands of the Masquer of the Sands":ArmBandsoftheMasqueroftheSands,
"Arm Binding of the Earth Mother":ArmBindingoftheEarthMother,
"Arm Guard of the Warded Brute":ArmGuardoftheWardedBrute,
"Arm Guards of the Earth Mother":ArmGuardsoftheEarthMother,
"Arm Guards of the Endless Sands":ArmGuardsoftheEndlessSands,
"Arm of the Great Bear":ArmoftheGreatBear,
"Arm Straps of the Warded Brute":ArmStrapsoftheWardedBrute,
"Arm-bands of the Bloodhunter (nm)":ArmbandsoftheBloodhunternm,
"Arm-bands of the Bloodhunter":ArmbandsoftheBloodhunter,
"Arm-bands of the Dark Messenger":ArmbandsoftheDarkMessenger,
"Arm-bands of the Hell Walker (nm)":ArmbandsoftheHellWalkernm,
"Arm-bands of the Hell Walker":ArmbandsoftheHellWalker,
"Arm-straps of Bedlam":ArmstrapsofBedlam,
"Arm-straps of Black Whispers":ArmstrapsofBlackWhispers,
"Arm-straps of Crimson Slaughter (nm)":ArmstrapsofCrimsonSlaughternm,
"Arm-straps of Crimson Slaughter":ArmstrapsofCrimsonSlaughter,
"Arm-straps of Dark Malice":ArmstrapsofDarkMalice,
"Arm-straps of Deadly Guile":ArmstrapsofDeadlyGuile,
"Arm-straps of the Blood God (nm)":ArmstrapsoftheBloodGodnm,
"Arm-straps of the Blood God":ArmstrapsoftheBloodGod,
"Arm-straps of the Crawling Chaos":ArmstrapsoftheCrawlingChaos,
"Arm-straps of the Faceless Chaos":ArmstrapsoftheFacelessChaos,
"Arm-straps of the Faceless Sphinx":ArmstrapsoftheFacelessSphinx,
"Arm-straps of the Lector":ArmstrapsoftheLector,
"Arm-straps of the Oxmal":ArmstrapsoftheOxmal,
"Arm-straps of the Scattered Gods":ArmstrapsoftheScatteredGods,
"Arm-straps of the Sepulcher":ArmstrapsoftheSepulcher,
"Arm-straps of the Shivering Stars":ArmstrapsoftheShiveringStars,
"Arm-straps of the Silent Slayer":ArmstrapsoftheSilentSlayer,
"Arm-straps of the Spheres":ArmstrapsoftheSpheres,
"Arm-straps of the Ubah Kan":ArmstrapsoftheUbahKan,
"Arm-straps of the Unutterable":ArmstrapsoftheUnutterable,
"Arm-wraps of the Crawling Chaos":ArmwrapsoftheCrawlingChaos,
"Armband of Ardent Fire":ArmbandofArdentFire,
"Armband of Brutal Carnage":ArmbandofBrutalCarnage,
"Armband of Conflagrant Flame":ArmbandofConflagrantFlame,
"Armband of Infernal Zeal":ArmbandofInfernalZeal,
"Armband of the Savage Slaughter":ArmbandoftheSavageSlaughter,
"Armbands of Bestial Rage":ArmbandsofBestialRage,
"Armbands of Black Oblivion":ArmbandsofBlackOblivion,
"Armbands of Bristling Ire":ArmbandsofBristlingIre,
"Armbands of Celestial Radiance":ArmbandsofCelestialRadiance,
"Armbands of Clawing Might":ArmbandsofClawingMight,
"Armbands of Concealing Shadows":ArmbandsofConcealingShadows,
"Armbands of Dark Terror":ArmbandsofDarkTerror,
"Armbands of Effulgent Devotion":ArmbandsofEffulgentDevotion,
"Armbands of Erlik":ArmbandsofErlik,
"Armbands of Ferine Anger":ArmbandsofFerineAnger,
"Armbands of Illuminant Conviction":ArmbandsofIlluminantConviction,
"Armbands of Insanity":ArmbandsofInsanity,
"Armbands of Jagged Barbs":ArmbandsofJaggedBarbs,
"Armbands of Necrotic Dread":ArmbandsofNecroticDread,
"Armbands of Pandemonium":ArmbandsofPandemonium,
"Armbands of Quilled Darts":ArmbandsofQuilledDarts,
"Armbands of Rapturous Battle":ArmbandsofRapturousBattle,
"Armbands of Righteous Smiting":ArmbandsofRighteousSmiting,
"Armbands of Swiftstriking":ArmbandsofSwiftstriking,
"Armbands of the Ascension":ArmbandsoftheAscension,
"Armbands of the Berserker's Fury":ArmbandsoftheBerserkersFury,
"Armbands of the Bloodmoon":ArmbandsoftheBloodmoon,
"Armbands of the Clay":ArmbandsoftheClay,
"Armbands of the Cloudcleaver":ArmbandsoftheCloudcleaver,
"Armbands of the Death God":ArmbandsoftheDeathGod,
"Armbands of the Deathstalker":ArmbandsoftheDeathstalker,
"Armbands of the Ecliptic":ArmbandsoftheEcliptic,
"Armbands of the Eternal Blaze":ArmbandsoftheEternalBlaze,
"Armbands of the Exorcist":ArmbandsoftheExorcist,
"Armbands of the Farseeker":ArmbandsoftheFarseeker,
"Armbands of the First Circle":ArmbandsoftheFirstCircle,
"Armbands of the Furious Swipe":ArmbandsoftheFuriousSwipe,
"Armbands of the Haunter in the Dark":ArmbandsoftheHaunterintheDark,
"Armbands of the Howling Giant":ArmbandsoftheHowlingGiant,
"Armbands of the Huntmaster":ArmbandsoftheHuntmaster,
"Armbands of the Ichorous":ArmbandsoftheIchorous,
"Armbands of the Inconceivable":ArmbandsoftheInconceivable,
"Armbands of the Judgment Bolt":ArmbandsoftheJudgmentBolt,
"Armbands of the Kozak Slayer":ArmbandsoftheKozakSlayer,
"Armbands of the Living Tarim":ArmbandsoftheLivingTarim,
"Armbands of the Membranous":ArmbandsoftheMembranous,
"Armbands of the Merciless":ArmbandsoftheMerciless,
"Armbands of the Oxmal":ArmbandsoftheOxmal,
"Armbands of the Ravenflight":ArmbandsoftheRavenflight,
"Armbands of the Refectory":ArmbandsoftheRefectory,
"Armbands of the Renegade":ArmbandsoftheRenegade,
"Armbands of the Revelations of Tarim":ArmbandsoftheRevelationsofTarim,
"Armbands of the Riftcaller":ArmbandsoftheRiftcaller,
"Armbands of the Savage Fang":ArmbandsoftheSavageFang,
"Armbands of the Shivering Stars":ArmbandsoftheShiveringStars,
"Armbands of the Stormbringer":ArmbandsoftheStormbringer,
"Armbands of the Strange Beyond":ArmbandsoftheStrangeBeyond,
"Armbands of the Sundered Skies":ArmbandsoftheSunderedSkies,
"Armbands of the Swift Talon":ArmbandsoftheSwiftTalon,
"Armbands of the Ubah Kan":ArmbandsoftheUbahKan,
"Armbands of the Unholy Communion":ArmbandsoftheUnholyCommunion,
"Armbands of the Usurper":ArmbandsoftheUsurper,
"Armbands of the Whispering Blade":ArmbandsoftheWhisperingBlade,
"Armbands of Tribulation":ArmbandsofTribulation,
"Armbands of Untamed Violence":ArmbandsofUntamedViolence,
"Armbands of Vehement Thunder":ArmbandsofVehementThunder,
"Armbands of Vengeful Zeal":ArmbandsofVengefulZeal,
"Armbands of Vernant Fury":ArmbandsofVernantFury,
"Armbands of Vindictive Malice":ArmbandsofVindictiveMalice,
"Armbands of Violent Rage":ArmbandsofViolentRage,
"Armbands of Writhing":ArmbandsofWrithing,
"Armguards of Baleful Blood":ArmguardsofBalefulBlood,
"Armguards of Black Spite":ArmguardsofBlackSpite,
"Armguards of Courageous Souls":ArmguardsofCourageousSouls,
"Armguards of Fearless Souls":ArmguardsofFearlessSouls,
"Armguards of Heroic Soul":ArmguardsofHeroicSoul,
"Armguards of Indomitable Souls":ArmguardsofIndomitableSouls,
"Armguards of Reckless Challenge":ArmguardsofRecklessChallenge,
"Armguards of Robustness":ArmguardsofRobustness,
"Armguards of the Assailant":ArmguardsoftheAssailant,
"Armguards of the Atlantean":ArmguardsoftheAtlantean,
"Armguards of the Beyond":ArmguardsoftheBeyond,
"Armguards of the Black Dragon":ArmguardsoftheBlackDragon,
"Armguards of the Black Pharaoh":ArmguardsoftheBlackPharaoh,
"Armguards of the Black Warden":ArmguardsoftheBlackWarden,
"Armguards of the Chaos Agent":ArmguardsoftheChaosAgent,
"Armguards of the Crimson Fort":ArmguardsoftheCrimsonFort,
"Armguards of the Dark Messenger":ArmguardsoftheDarkMessenger,
"Armguards of the Dauntless":ArmguardsoftheDauntless,
"Armguards of the Defiant":ArmguardsoftheDefiant,
"Armguards of the Haunter in the Dark":ArmguardsoftheHaunterintheDark,
"Armguards of the Howling Giant":ArmguardsoftheHowlingGiant,
"Armguards of the Invincible":ArmguardsoftheInvincible,
"Armguards of the Martial Paragon":ArmguardsoftheMartialParagon,
"Armguards of the Milites Templi":ArmguardsoftheMilitesTempli,
"Armguards of the Ostiary":ArmguardsoftheOstiary,
"Armguards of the Painlegion":ArmguardsofthePainlegion,
"Armguards of the Proven Champion":ArmguardsoftheProvenChampion,
"Armguards of the Tireless Defender":ArmguardsoftheTirelessDefender,
"Armguards of the Tormentor":ArmguardsoftheTormentor,
"Armguards of the Triumphant":ArmguardsoftheTriumphant,
"Armguards of the Usurper":ArmguardsoftheUsurper,
"Armguards of the Valiant":ArmguardsoftheValiant,
"Armguards of the Vanguard":ArmguardsoftheVanguard,
"Armguards of the Victorious Elite":ArmguardsoftheVictoriousElite,
"Armguards of the Wicked":ArmguardsoftheWicked,
"Arm-straps of Lunacy":ArmstrapsofLunacy,
"Arm-straps of the Nebulous":ArmstrapsoftheNebulous,
"Arm-straps of the Wells of Night":ArmstrapsoftheWellsofNight,
"Armwrap of Intricate Spite":ArmwrapofIntricateSpite,
"Armwrap of the Firebrand":ArmwrapoftheFirebrand,
"Armwraps of Fiendish Invocation":ArmwrapsofFiendishInvocation,
"Armwraps of the Darkwretch":ArmwrapsoftheDarkwretch,
"Armwraps of the Doomsayer":ArmwrapsoftheDoomsayer,
"Armwraps of the Forsaken":ArmwrapsoftheForsaken,
"Armwraps of the Harbinger":ArmwrapsoftheHarbinger,
"Armwraps of the Precursor":ArmwrapsofthePrecursor,
"Armwraps of the Reanimator":ArmwrapsoftheReanimator,
"Arrows of the Bastion":ArrowsoftheBastion,
"Arrows of the Haunter in the Dark":ArrowsoftheHaunterintheDark,
"Artefact of the Faceless Sphinx":ArtefactoftheFacelessSphinx,
"Artisan's Tunic":ArtisansTunic,
"Ash Mantle of the Living Legend":AshMantleoftheLivingLegend,
"Asp of Mystical Supremacy":AspofMysticalSupremacy,
"Aspfang":Aspfang,
"Astral Handguards":AstralHandguards,
"Astrum":Astrum,
"Avalanche Band":AvalancheBand,
"Axe of Red Ruin":AxeofRedRuin,
"Axe of the Archaeologian":AxeoftheArchaeologian,
"Axe of the Red Tide":AxeoftheRedTide,
"Axis of Sickening Dreams":AxisofSickeningDreams,
"Axis of Tartarus":AxisofTartarus,
"Bag of Engulfment":BagofEngulfment,
"Bagirwa Totem":BagirwaTotem,
"Balthus's Buckskin Chaps":BalthussBuckskinChaps,
"Balthus's Buckskin Jerkin":BalthussBuckskinJerkin,
"Balthus's Wolf Bow":BalthussWolfBow,
"Balthus's Wolf Crossbow":BalthussWolfCrossbow,
"Balthus's Woodland Helm":BalthussWoodlandHelm,
"Balthus's Woodsman Belt":BalthussWoodsmanBelt,
"Balthus's Woodsman Boots":BalthussWoodsmanBoots,
"Balthus's Woodsman Bracers":BalthussWoodsmanBracers,
"Balthus's Woodsman Brassards":BalthussWoodsmanBrassards,
"Balthus's Woodsman Gloves":BalthussWoodsmanGloves,
"Bamboo Javelin":BambooJavelin,
"Band of Bloodthirst":BandofBloodthirst,
"Band of Force":BandofForce,
"Band of Khan":BandofKhan,
"Band of Power":BandofPower,
"Band of the Celestial Bureaucracy":BandoftheCelestialBureaucracy,
"Band of the Immortals":BandoftheImmortals,
"Band of the Rampaging":BandoftheRampaging,
"Band of the Sanguine Disciple":BandoftheSanguineDisciple,
"Band of the Twice-Conquered":BandoftheTwiceConquered,
"Band of the Wall Guardian":BandoftheWallGuardian,
"Bandit's Armbands of a Hundred Eyes":BanditsArmbandsofaHundredEyes,
"Bandit's Armbands of the Grasping Wild":BanditsArmbandsoftheGraspingWild,
"Bandit's Armbands of the Howling Wind":BanditsArmbandsoftheHowlingWind,
"Bandit's Armguards of the Howling Moon":BanditsArmguardsoftheHowlingMoon,
"Bandit's Belt of the Bloody Fang":BanditsBeltoftheBloodyFang,
"Bandit's Belt of the Khan":BanditsBeltoftheKhan,
"Bandit's Belt of the Ritual Flame":BanditsBeltoftheRitualFlame,
"Bandit's Belt of Woven Clouds":BanditsBeltofWovenClouds,
"Bandit's Boots of the Covert Trail":BanditsBootsoftheCovertTrail,
"Bandit's Boots of the Grasslands":BanditsBootsoftheGrasslands,
"Bandit's Boots of World's Edge":BanditsBootsofWorldsEdge,
"Bandit's Chestguard of the Grasslands":BanditsChestguardoftheGrasslands,
"Bandit's Gauntlets of the Grasslands":BanditsGauntletsoftheGrasslands,
"Bandit's Gloves of the Covert Trail":BanditsGlovesoftheCovertTrail,
"Bandit's Gloves of the Wicked Hearth":BanditsGlovesoftheWickedHearth,
"Bandit's Gloves of World's Edge":BanditsGlovesofWorldsEdge,
"Bandit's Helm of the Khan":BanditsHelmoftheKhan,
"Bandit's Hood of the Ritual Flame":BanditsHoodoftheRitualFlame,
"Bandit's Hood of Woven Clouds":BanditsHoodofWovenClouds,
"Bandit's Jerkin of World's Edge":BanditsJerkinofWorldsEdge,
"Bandit's Leggings of a Hundred Eyes":BanditsLeggingsofaHundredEyes,
"Bandit's Leggings of the Grasping Wild":BanditsLeggingsoftheGraspingWild,
"Bandit's Leggings of the Howling Wind":BanditsLeggingsoftheHowlingWind,
"Bandit's Legguards of the Howling Moon":BanditsLegguardsoftheHowlingMoon,
"Bandit's Mask of the Bloody Fang":BanditsMaskoftheBloodyFang,
"Bandit's Straps of World's Edge":BanditsStrapsofWorldsEdge,
"Bandit's Tunic of the Covert Trail":BanditsTunicoftheCovertTrail,
"Bandit's Vambraces of the Grasslands":BanditsVambracesoftheGrasslands,
"Bandit's Wristbands of the Covert Trail":BanditsWristbandsoftheCovertTrail,
"Bands of the Outer Dark":BandsoftheOuterDark,
"Bangle of the Ghost of the Veldt":BangleoftheGhostoftheVeldt,
"Bangle of the Primal Spirit":BangleofthePrimalSpirit,
"Bangles of the Faceless Chaos":BanglesoftheFacelessChaos,
"Bangles of the Faceless Sphinx":BanglesoftheFacelessSphinx,
"Barbarous Loincloth":BarbarousLoincloth,
"Barbs of Persuasion":BarbsofPersuasion,
"Barbs of the Blood Drinker":BarbsoftheBloodDrinker,
"Barbs of the Masquer of the Sands":BarbsoftheMasqueroftheSands,
"Barrier of Clouded Frost":BarrierofCloudedFrost,
"Battleblessed Opus":BattleblessedOpus,
"Battlebrace":Battlebrace,
"Battlegrace Boots":BattlegraceBoots,
"Battlestance Boots":BattlestanceBoots,
"Battlewarden":Battlewarden,
"Bear Claws of Divine Might":BearClawsofDivineMight,
"Beast Hunter's Barbs":BeastHuntersBarbs,
"Beast Hunter's Malice Breaker":BeastHuntersMaliceBreaker,
"Beast Hunter's Mantle of the Living Legend":BeastHuntersMantleoftheLivingLegend,
"Beast Hunter's Reaper Crossbow":BeastHuntersReaperCrossbow,
"Beast Mantle of Bone and Horn":BeastMantleofBoneandHorn,
"Beastclaw":Beastclaw,
"Beastmaster's Bevor":BeastmastersBevor,
"Beastmaster's Corded Claw":BeastmastersCordedClaw,
"Beastmaster's Heretical Eye":BeastmastersHereticalEye,
"Beastmaster's Icon of Faith":BeastmastersIconofFaith,
"Beastmaster's Rugged Choker":BeastmastersRuggedChoker,
"Beastmaster's Strand of Bones":BeastmastersStrandofBones,
"Beastmaster's Tanned Choker":BeastmastersTannedChoker,
"Believer's Armbands of the Crumbling Tower":BelieversArmbandsoftheCrumblingTower,
"Believer's Bands of the Aureate":BelieversBandsoftheAureate,
"Believer's Belt of the Aureate":BelieversBeltoftheAureate,
"Believer's Belt of the Eldritch":BelieversBeltoftheEldritch,
"Believer's Belt of the Purple Sun":BelieversBeltofthePurpleSun,
"Believer's Boots of the Green Ones":BelieversBootsoftheGreenOnes,
"Believer's Boots of the Soaring Heart":BelieversBootsoftheSoaringHeart,
"Believer's Bracers of the Green Ones":BelieversBracersoftheGreenOnes,
"Believer's Bracers of the Soaring Heart":BelieversBracersoftheSoaringHeart,
"Believer's Braid of the Eldritch":BelieversBraidoftheEldritch,
"Believer's Cloth of the Eldritch":BelieversClothoftheEldritch,
"Believer's Gauntlets of the Bloody Stone":BelieversGauntletsoftheBloodyStone,
"Believer's Gloves of the Soaring God":BelieversGlovesoftheSoaringGod,
"Believer's Gloves of Yag":BelieversGlovesofYag,
"Believer's Harness of the Bloody Stone":BelieversHarnessoftheBloodyStone,
"Believer's Helm of the Purple Sun":BelieversHelmofthePurpleSun,
"Believer's Hood of the Eldritch":BelieversHoodoftheEldritch,
"Believer's Jerkin of the Exalted Spirit":BelieversJerkinoftheExaltedSpirit,
"Believer's Jerkin of the Soaring God":BelieversJerkinoftheSoaringGod,
"Believer's Leggings of the Aureate":BelieversLeggingsoftheAureate,
"Believer's Leggings of the Crumbling Tower":BelieversLeggingsoftheCrumblingTower,
"Believer's Legguards of the Purple Sun":BelieversLegguardsofthePurpleSun,
"Believer's Robes of Yag":BelieversRobesofYag,
"Believer's Sandals of Shimmering Light":BelieversSandalsofShimmeringLight,
"Believer's Shoes of the Three Clarities":BelieversShoesoftheThreeClarities,
"Believer's Straps of the Purple Sun":BelieversStrapsofthePurpleSun,
"Believer's Straps of the Three Clarities":BelieversStrapsoftheThreeClarities,
"Believer's Wraps of the Exalted Spirit":BelieversWrapsoftheExaltedSpirit,
"Believer's Wrist-straps of Shimmering Light":BelieversWriststrapsofShimmeringLight,
"Belt of Ardent Fire":BeltofArdentFire,
"Belt of Bedlam":BeltofBedlam,
"Belt of Ben Morgh":BeltofBenMorgh,
"Belt of Bestial Rage":BeltofBestialRage,
"Belt of Black Oblivion":BeltofBlackOblivion,
"Belt of Black Whispers":BeltofBlackWhispers,
"Belt of Bloodlust":BeltofBloodlust,
"Belt of Bristling Ire":BeltofBristlingIre,
"Belt of Clarity":BeltofClarity,
"Belt of Concealing Shadows":BeltofConcealingShadows,
"Belt of Conflagrant Flame":BeltofConflagrantFlame,
"Belt of Courageous Souls":BeltofCourageousSouls,
"Belt of Crimson Slaughter (nm)":BeltofCrimsonSlaughternm,
"Belt of Crimson Slaughter":BeltofCrimsonSlaughter,
"Belt of Dark Malice":BeltofDarkMalice,
"Belt of Dark Terror":BeltofDarkTerror,
"Belt of Deadly Guile":BeltofDeadlyGuile,
"Belt of Fearless Souls":BeltofFearlessSouls,
"Belt of Ferine Anger":BeltofFerineAnger,
"Belt of Fiendish Invocation":BeltofFiendishInvocation,
"Belt of Haloga":BeltofHaloga,
"Belt of Infernal Zeal":BeltofInfernalZeal,
"Belt of Intricate Spite":BeltofIntricateSpite,
"Belt of Lunacy":BeltofLunacy,
"Belt of Necrotic Dread":BeltofNecroticDread,
"Belt of Rapturous Battle":BeltofRapturousBattle,
"Belt of Reckless Challenge":BeltofRecklessChallenge,
"Belt of Red Ruin (nm)":BeltofRedRuinnm,
"Belt of Red Ruin":BeltofRedRuin,
"Belt of Righteous Smiting":BeltofRighteousSmiting,
"Belt of Swiftstriking":BeltofSwiftstriking,
"Belt of the Assailant":BeltoftheAssailant,
"Belt of the Atlantean":BeltoftheAtlantean,
"Belt of the Beyond":BeltoftheBeyond,
"Belt of the Black Dragon":BeltoftheBlackDragon,
"Belt of the Black Pharaoh":BeltoftheBlackPharaoh,
"Belt of the Black Warden":BeltoftheBlackWarden,
"Belt of the Blood Drinker (nm)":BeltoftheBloodDrinkernm,
"Belt of the Blood Drinker":BeltoftheBloodDrinker,
"Belt of the Clay":BeltoftheClay,
"Belt of the Crawling Chaos":BeltoftheCrawlingChaos,
"Belt of the Crimson Fort":BeltoftheCrimsonFort,
"Belt of the Dark Messenger":BeltoftheDarkMessenger,
"Belt of the Darkwretch":BeltoftheDarkwretch,
"Belt of the Dauntless":BeltoftheDauntless,
"Belt of the Death God":BeltoftheDeathGod,
"Belt of the Death Master (nm)":BeltoftheDeathMasternm,
"Belt of the Death Master":BeltoftheDeathMaster,
"Belt of the Defiant":BeltoftheDefiant,
"Belt of the Doomsayer":BeltoftheDoomsayer,
"Belt of the Eternal Blaze":BeltoftheEternalBlaze,
"Belt of the Exorcist":BeltoftheExorcist,
"Belt of the Faceless Chaos":BeltoftheFacelessChaos,
"Belt of the Faceless Sphinx":BeltoftheFacelessSphinx,
"Belt of the Fallen Empire (nm)":BeltoftheFallenEmpirenm,
"Belt of the Fallen Empire":BeltoftheFallenEmpire,
"Belt of the Farseeker":BeltoftheFarseeker,
"Belt of the Firebrand":BeltoftheFirebrand,
"Belt of the Forsaken":BeltoftheForsaken,
"Belt of the Ghost of the Veldt":BeltoftheGhostoftheVeldt,
"Belt of the Great Impi":BeltoftheGreatImpi,
"Belt of the Harbinger":BeltoftheHarbinger,
"Belt of the Huntmaster":BeltoftheHuntmaster,
"Belt of the Lector":BeltoftheLector,
"Belt of the Milites Templi":BeltoftheMilitesTempli,
"Belt of the Nebulous":BeltoftheNebulous,
"Belt of the Ostiary":BeltoftheOstiary,
"Belt of the Outer Dark":BeltoftheOuterDark,
"Belt of the Precursor":BeltofthePrecursor,
"Belt of the Primal Spirit":BeltofthePrimalSpirit,
"Belt of the Putrescent":BeltofthePutrescent,
"Belt of the Ragereaver":BeltoftheRagereaver,
"Belt of the Reanimator":BeltoftheReanimator,
"Belt of the Rippling Lake":BeltoftheRipplingLake,
"Belt of the Sanguine Disciple (nm)":BeltoftheSanguineDisciplenm,
"Belt of the Sanguine Disciple":BeltoftheSanguineDisciple,
"Belt of the Scattered Gods":BeltoftheScatteredGods,
"Belt of the Sepulcher":BeltoftheSepulcher,
"Belt of the Silent Slayer":BeltoftheSilentSlayer,
"Belt of the Spheres":BeltoftheSpheres,
"Belt of the Still Pond":BeltoftheStillPond,
"Belt of the Stormbringer":BeltoftheStormbringer,
"Belt of the Strange Beyond":BeltoftheStrangeBeyond,
"Belt of the Tormentor":BeltoftheTormentor,
"Belt of the Ubah Kan":BeltoftheUbahKan,
"Belt of the Unholy Communion":BeltoftheUnholyCommunion,
"Belt of the Unslaked":BeltoftheUnslaked,
"Belt of the Unutterable":BeltoftheUnutterable,
"Belt of the Usurper":BeltoftheUsurper,
"Belt of the Vanguard":BeltoftheVanguard,
"Belt of the Warded Brute":BeltoftheWardedBrute,
"Belt of the Wells of Night":BeltoftheWellsofNight,
"Belt of the Whispering Blade":BeltoftheWhisperingBlade,
"Belt of the Wicked":BeltoftheWicked,
"Belt of Tranquility":BeltofTranquility,
"Belt of Tribulation":BeltofTribulation,
"Belt of Vehement Thunder":BeltofVehementThunder,
"Belt of Vengeful Zeal":BeltofVengefulZeal,
"Belt of Vicious Frenzy":BeltofViciousFrenzy,
"Belt of Vindictive Malice":BeltofVindictiveMalice,
"Belt of Wild Furor":BeltofWildFuror,
"Binding of the Endless Sands":BindingoftheEndlessSands,
"Binding of the Enslaving Opiate":BindingoftheEnslavingOpiate,
"Binding of the Void":BindingoftheVoid,
"Bindings of Ardent Fire":BindingsofArdentFire,
"Bindings of Black Oblivion":BindingsofBlackOblivion,
"Bindings of Conflagrant Flame":BindingsofConflagrantFlame,
"Bindings of Dark Terror":BindingsofDarkTerror,
"Bindings of Infernal Zeal":BindingsofInfernalZeal,
"Bindings of Necrotic Dread":BindingsofNecroticDread,
"Bindings of the Darkwretch":BindingsoftheDarkwretch,
"Bindings of the Eternal Blaze":BindingsoftheEternalBlaze,
"Bindings of the Forsaken":BindingsoftheForsaken,
"Bindings of the Reanimator":BindingsoftheReanimator,
"Bindings of the Unholy Communion":BindingsoftheUnholyCommunion,
"Bindings of the Whispering Blade":BindingsoftheWhisperingBlade,
"Bite of the Winter Sun":BiteoftheWinterSun,
"Bitter-Steel Band":BitterSteelBand,
"Bitterfrost":Bitterfrost,
"Black Dragon Claw":BlackDragonClaw,
"Black Dragon Cloak":BlackDragonCloak,
"Black Dragon Scale":BlackDragonScale,
"Black Dragon Tail":BlackDragonTail,
"Black Dragon Tongue":BlackDragonTongue,
"Black Dragon Tooth":BlackDragonTooth,
"Black Pharaoh's Soul Blade":BlackPharaohsSoulBlade,
"Black Vash":BlackVash,
"Blackfang":Blackfang,
"Blackfist":Blackfist,
"Blackgrasp":Blackgrasp,
"Blackice Band":BlackiceBand,
"Blackmarrow Boots":BlackmarrowBoots,
"Blackmarrow Chest":BlackmarrowChest,
"Blackmarrow Helm":BlackmarrowHelm,
"Blackmarrow Leggings":BlackmarrowLeggings,
"Blackrain Arbalest":BlackrainArbalest,
"Blackruin":Blackruin,
"Blackshard":Blackshard,
"Blacksorrow":Blacksorrow,
"Blacksting":Blacksting,
"Blacksulphur Armbands":BlacksulphurArmbands,
"Blacksulphur Cowl":BlacksulphurCowl,
"Blacksulphur Gloves":BlacksulphurGloves,
"Blacksulphur Pants":BlacksulphurPants,
"Blacksulphur Robe":BlacksulphurRobe,
"Blacksulphur Sash":BlacksulphurSash,
"Blacksulphur Slippers":BlacksulphurSlippers,
"Blacksulphur Wristbands":BlacksulphurWristbands,
"Blackwatch Armguards":BlackwatchArmguards,
"Blade of Endless Night":BladeofEndlessNight,
"Blade of Khan":BladeofKhan,
"Blade of Marred Spirits":BladeofMarredSpirits,
"Blade of Refectory":BladeofRefectory,
"Blade of Resilience":BladeofResilience,
"Blade of the Ancient Sands":BladeoftheAncientSands,
"Blade of the Black Pharaoh":BladeoftheBlackPharaoh,
"Blade of the Bloodhunter":BladeoftheBloodhunter,
"Blade of the Crowned Serpent":BladeoftheCrownedSerpent,
"Blade of the Dark Sun":BladeoftheDarkSun,
"Blade of the Enslaving Opiate":BladeoftheEnslavingOpiate,
"Blade of the Fallen King":BladeoftheFallenKing,
"Blade of the Manic Haze":BladeoftheManicHaze,
"Blade of the Pillars":BladeofthePillars,
"Blade of the Turanian Army":BladeoftheTuranianArmy,
"Blade of the Void":BladeoftheVoid,
"Blade's Arm-straps of Charred Earth":BladesArmstrapsofCharredEarth,
"Blade's Armbands of the Hidden Tomb":BladesArmbandsoftheHiddenTomb,
"Blade's Belt of Charred Earth":BladesBeltofCharredEarth,
"Blade's Belt of the Grim Cabal":BladesBeltoftheGrimCabal,
"Blade's Belt of the Hidden Tomb":BladesBeltoftheHiddenTomb,
"Blade's Boots of Creeping Death":BladesBootsofCreepingDeath,
"Blade's Boots of Shattered Souls":BladesBootsofShatteredSouls,
"Blade's Boots of the Black Arts":BladesBootsoftheBlackArts,
"Blade's Boots of the Firebringer":BladesBootsoftheFirebringer,
"Blade's Bracers of Shattered Souls":BladesBracersofShatteredSouls,
"Blade's Bracers of the Black Arts":BladesBracersoftheBlackArts,
"Blade's Bracers of the Firebringer":BladesBracersoftheFirebringer,
"Blade's Breeches of the Grim Cabal":BladesBreechesoftheGrimCabal,
"Blade's Cord of Waning Dusk":BladesCordofWaningDusk,
"Blade's Deathmask of Malice":BladesDeathmaskofMalice,
"Blade's Fauld of Waning Dusk":BladesFauldofWaningDusk,
"Blade's Gloves of Charred Earth":BladesGlovesofCharredEarth,
"Blade's Gloves of the Hidden Tomb":BladesGlovesoftheHiddenTomb,
"Blade's Grips of the Grim Cabal":BladesGripsoftheGrimCabal,
"Blade's Grips of Waning Dusk":BladesGripsofWaningDusk,
"Blade's Jerkin of Malice":BladesJerkinofMalice,
"Blade's Leggings of Charred Earth":BladesLeggingsofCharredEarth,
"Blade's Leggings of the Hidden Tomb":BladesLeggingsoftheHiddenTomb,
"Blade's Mask of the Battlethrall":BladesMaskoftheBattlethrall,
"Blade's Mask of the Silent Kill":BladesMaskoftheSilentKill,
"Blade's Spauld of Waning Dusk":BladesSpauldofWaningDusk,
"Blade's Straps of the Grim Cabal":BladesStrapsoftheGrimCabal,
"Blade's Tunic of Arcane Death":BladesTunicofArcaneDeath,
"Blade's Tunic of the Battlethrall":BladesTunicoftheBattlethrall,
"Blade's Tunic of the Silent Kill":BladesTunicoftheSilentKill,
"Blade's Veil of Arcane Death":BladesVeilofArcaneDeath,
"Blade's Wristbands of Creeping Death":BladesWristbandsofCreepingDeath,
"Bladebarrier Girdle":BladebarrierGirdle,
"Bladefeint Sabatons":BladefeintSabatons,
"Bladekissed Cloak of the Final Goodnight":BladekissedCloakoftheFinalGoodnight,
"Blanched Vambraces":BlanchedVambraces,
"Blessed Do Kki":BlessedDoKki,
"Blessed Gem":BlessedGem,
"Blessed Signet":BlessedSignet,
"Blesswar Bracers":BlesswarBracers,
"Blight":Blight,
"Blighted Halberd":BlightedHalberd,
"Blood Choker":BloodChoker,
"Blood of the Damned":BloodoftheDamned,
"Blood Scripture of Xotli":BloodScriptureofXotli,
"Blood Summoner":BloodSummoner,
"Blood-ritual Boots":BloodritualBoots,
"Bloodbane":Bloodbane,
"Bloodbarbs":Bloodbarbs,
"Bloodbeak":Bloodbeak,
"Bloodbeggar Bolts":BloodbeggarBolts,
"Bloodbeggar Shafts":BloodbeggarShafts,
"Bloodbrute Chestguard":BloodbruteChestguard,
"Bloodbrute Legguards":BloodbruteLegguards,
"Bloodcarve":Bloodcarve,
"Blooded Arm-straps of the Mound":BloodedArmstrapsoftheMound,
"Blooded Armbands of the Four Winds":BloodedArmbandsoftheFourWinds,
"Blooded Belt of the Far Horizon":BloodedBeltoftheFarHorizon,
"Blooded Belt of the Mound":BloodedBeltoftheMound,
"Blooded Belt of the Plains":BloodedBeltofthePlains,
"Blooded Boots of Passing Spirits":BloodedBootsofPassingSpirits,
"Blooded Boots of the Clans":BloodedBootsoftheClans,
"Blooded Boots of the Everlasting Sky":BloodedBootsoftheEverlastingSky,
"Blooded Boots of the Tribes":BloodedBootsoftheTribes,
"Blooded Bracers of Passing Spirits":BloodedBracersofPassingSpirits,
"Blooded Bracers of the Clans":BloodedBracersoftheClans,
"Blooded Bracers of the Everlasting Sky":BloodedBracersoftheEverlastingSky,
"Blooded Fauld of the Mound":BloodedFauldoftheMound,
"Blooded Gauntlets of the Greensward":BloodedGauntletsoftheGreensward,
"Blooded Girdle of the Four Winds":BloodedGirdleoftheFourWinds,
"Blooded Gloves of the Ancestors":BloodedGlovesoftheAncestors,
"Blooded Gloves of the Golden Horde":BloodedGlovesoftheGoldenHorde,
"Blooded Gloves of the Seven Suns":BloodedGlovesoftheSevenSuns,
"Blooded Harness of the Greensward":BloodedHarnessoftheGreensward,
"Blooded Helm of the Four Winds":BloodedHelmoftheFourWinds,
"Blooded Helm of the Mound":BloodedHelmoftheMound,
"Blooded Helm of the Plains":BloodedHelmofthePlains,
"Blooded Jerkin of the Golden Horde":BloodedJerkinoftheGoldenHorde,
"Blooded Jerkin of the Seven Suns":BloodedJerkinoftheSevenSuns,
"Blooded Legguards of the Plains":BloodedLegguardsofthePlains,
"Blooded Straps of the Far Horizon":BloodedStrapsoftheFarHorizon,
"Blooded Straps of the Plains":BloodedStrapsofthePlains,
"Blooded Tunic of the Ancestors":BloodedTunicoftheAncestors,
"Blooded Vambraces of the Tribes":BloodedVambracesoftheTribes,
"Bloodedge":Bloodedge,
"Bloodfen Mitts":BloodfenMitts,
"Bloodguard":Bloodguard,
"Bloodhammer":Bloodhammer,
"Bloodmire Gauntlets":BloodmireGauntlets,
"Bloodnail":Bloodnail,
"Bloodregent Claymore":BloodregentClaymore,
"Bloodsap":Bloodsap,
"Bloodscythe Gauntlets":BloodscytheGauntlets,
"Bloodseeker Blade":BloodseekerBlade,
"Bloodseeker Claymore":BloodseekerClaymore,
"Bloodseer's Armbands":BloodseersArmbands,
"Bloodseer's Boots":BloodseersBoots,
"Bloodseer's Cowl":BloodseersCowl,
"Bloodseer's Gloves":BloodseersGloves,
"Bloodseer's Robe":BloodseersRobe,
"Bloodseer's Sash":BloodseersSash,
"Bloodseer's Tasset":BloodseersTasset,
"Bloodseer's Wristbands":BloodseersWristbands,
"Bloodseraph's Armguards":BloodseraphsArmguards,
"Bloodseraph's Boots":BloodseraphsBoots,
"Bloodseraph's Chestguard":BloodseraphsChestguard,
"Bloodseraph's Gauntlets":BloodseraphsGauntlets,
"Bloodseraph's Girdle":BloodseraphsGirdle,
"Bloodseraph's Helm":BloodseraphsHelm,
"Bloodseraph's Legguards":BloodseraphsLegguards,
"Bloodseraph's Vambraces":BloodseraphsVambraces,
"Bloodsinger":Bloodsinger,
"Bloodsire Boots":BloodsireBoots,
"Bloodsire Harness":BloodsireHarness,
"Bloodsire Helm":BloodsireHelm,
"Bloodsire Tasset":BloodsireTasset,
"Bloodskew":Bloodskew,
"Bloodsnare Gloves":BloodsnareGloves,
"Bloodstreak":Bloodstreak,
"Bloodtainted Band":BloodtaintedBand,
"Bloodtainted Hoop":BloodtaintedHoop,
"Bloodthirst Recurve":BloodthirstRecurve,
"Bloodtrail Sabatons":BloodtrailSabatons,
"Bloodvaliant Gauntlets":BloodvaliantGauntlets,
"Bloodweasel Boots":BloodweaselBoots,
"Blossoming Death":BlossomingDeath,
"Bludgeon of the Icy Tomb":BludgeonoftheIcyTomb,
"Bluefury War Wolf":BluefuryWarWolf,
"Body Bag":BodyBag,
"Bolts of Black Sorrow":BoltsofBlackSorrow,
"Bolts of Conflagration":BoltsofConflagration,
"Bolts of Raked Flesh":BoltsofRakedFlesh,
"Bolts of the Armsmaster":BoltsoftheArmsmaster,
"Bolts of the Haunter in the Dark":BoltsoftheHaunterintheDark,
"Bolts of Winter's Breath":BoltsofWintersBreath,
"Bond of Anarchy":BondofAnarchy,
"Bond of the Champion of Cimmeria":BondoftheChampionofCimmeria,
"Bone Loop":BoneLoop,
"Bone-picker's Belt":BonepickersBelt,
"Bone-picker's Helm":BonepickersHelm,
"Bonebiter":Bonebiter,
"Bonechill Talisman":BonechillTalisman,
"Bonecleave":Bonecleave,
"Boneharbor":Boneharbor,
"Bonesever":Bonesever,
"Boneshadow Mask":BoneshadowMask,
"Boneshard":Boneshard,
"Boneshred Gloves":BoneshredGloves,
"Boots of a Thousand Blossoms":BootsofaThousandBlossoms,
"Boots of Ardent Fire":BootsofArdentFire,
"Boots of Baleful Blood":BootsofBalefulBlood,
"Boots of Bedlam":BootsofBedlam,
"Boots of Ben Morgh":BootsofBenMorgh,
"Boots of Berserker's Fury":BootsofBerserkersFury,
"Boots of Bestial Rage":BootsofBestialRage,
"Boots of Black Oblivion":BootsofBlackOblivion,
"Boots of Black Spite":BootsofBlackSpite,
"Boots of Bloodlust":BootsofBloodlust,
"Boots of Bone and Horn":BootsofBoneandHorn,
"Boots of Bristling Ire":BootsofBristlingIre,
"Boots of Brutal Carnage":BootsofBrutalCarnage,
"Boots of Celestial Radiance":BootsofCelestialRadiance,
"Boots of Clarity":BootsofClarity,
"Boots of Clawing Might":BootsofClawingMight,
"Boots of Concealing Shadows":BootsofConcealingShadows,
"Boots of Conflagrant Flame":BootsofConflagrantFlame,
"Boots of Courageous Souls":BootsofCourageousSouls,
"Boots of Crimson Slaughter (nm)":BootsofCrimsonSlaughternm,
"Boots of Crimson Slaughter":BootsofCrimsonSlaughter,
"Boots of Dark Terror":BootsofDarkTerror,
"Boots of Effulgent Devotion":BootsofEffulgentDevotion,
"Boots of Erlik":BootsofErlik,
"Boots of Fearless Souls":BootsofFearlessSouls,
"Boots of Ferine Anger":BootsofFerineAnger,
"Boots of Fiendish Invocation":BootsofFiendishInvocation,
"Boots of Flowing Water":BootsofFlowingWater,
"Boots of Heroic Soul":BootsofHeroicSoul,
"Boots of Illuminant Conviction":BootsofIlluminantConviction,
"Boots of Infernal Zeal":BootsofInfernalZeal,
"Boots of Insanity":BootsofInsanity,
"Boots of Intricate Spite":BootsofIntricateSpite,
"Boots of Jagged Barbs":BootsofJaggedBarbs,
"Boots of Lunacy":BootsofLunacy,
"Boots of Necrotic Dread":BootsofNecroticDread,
"Boots of Pandemonium":BootsofPandemonium,
"Boots of Quilled Darts":BootsofQuilledDarts,
"Boots of Rapturous Battle":BootsofRapturousBattle,
"Boots of Reckless Challenge":BootsofRecklessChallenge,
"Boots of Righteous Smiting":BootsofRighteousSmiting,
"Boots of Swiftstriking":BootsofSwiftstriking,
"Boots of the Amaranthine Drums":BootsoftheAmaranthineDrums,
"Boots of the Ascension":BootsoftheAscension,
"Boots of the Assailant":BootsoftheAssailant,
"Boots of the Atlantean":BootsoftheAtlantean,
"Boots of the Beyond":BootsoftheBeyond,
"Boots of the Black Dragon":BootsoftheBlackDragon,
"Boots of the Black Pharaoh":BootsoftheBlackPharaoh,
"Boots of the Black Warden":BootsoftheBlackWarden,
"Boots of the Blood Drinker (nm)":BootsoftheBloodDrinkernm,
"Boots of the Blood Drinker":BootsoftheBloodDrinker,
"Boots of the Bloodhunter (nm)":BootsoftheBloodhunternm,
"Boots of the Bloodhunter":BootsoftheBloodhunter,
"Boots of the Bloodmoon":BootsoftheBloodmoon,
"Boots of the Chaos Agent":BootsoftheChaosAgent,
"Boots of the Clay":BootsoftheClay,
"Boots of the Cloudcleaver":BootsoftheCloudcleaver,
"Boots of the Crawling Chaos":BootsoftheCrawlingChaos,
"Boots of the Crimson Fort":BootsoftheCrimsonFort,
"Boots of the Dark Messenger":BootsoftheDarkMessenger,
"Boots of the Dauntless":BootsoftheDauntless,
"Boots of the Death God":BootsoftheDeathGod,
"Boots of the Deathstalker":BootsoftheDeathstalker,
"Boots of the Defiant":BootsoftheDefiant,
"Boots of the Doomsayer":BootsoftheDoomsayer,
"Boots of the Dragon King":BootsoftheDragonKing,
"Boots of the Ecliptic":BootsoftheEcliptic,
"Boots of the Eternal Blaze":BootsoftheEternalBlaze,
"Boots of the Exorcist":BootsoftheExorcist,
"Boots of the Faceless Chaos":BootsoftheFacelessChaos,
"Boots of the Faceless Sphinx":BootsoftheFacelessSphinx,
"Boots of the Farseeker":BootsoftheFarseeker,
"Boots of the Firebrand":BootsoftheFirebrand,
"Boots of the First Circle":BootsoftheFirstCircle,
"Boots of the Furious Swipe":BootsoftheFuriousSwipe,
"Boots of the Grand Monarch":BootsoftheGrandMonarch,
"Boots of the Great Impi":BootsoftheGreatImpi,
"Boots of the Haunter in the Dark":BootsoftheHaunterintheDark,
"Boots of the Hell Walker (nm)":BootsoftheHellWalkernm,
"Boots of the Hell Walker":BootsoftheHellWalker,
"Boots of the Howling Giant":BootsoftheHowlingGiant,
"Boots of the Huntmaster":BootsoftheHuntmaster,
"Boots of the Ichorous":BootsoftheIchorous,
"Boots of the Inconceivable":BootsoftheInconceivable,
"Boots of the Invincible":BootsoftheInvincible,
"Boots of the Judgment Bolt":BootsoftheJudgmentBolt,
"Boots of the Kozak Slayer":BootsoftheKozakSlayer,
"Boots of the Lector":BootsoftheLector,
"Boots of the Living Tarim":BootsoftheLivingTarim,
"Boots of the Martial Paragon":BootsoftheMartialParagon,
"Boots of the Masquer of the Sands":BootsoftheMasqueroftheSands,
"Boots of the Membranous":BootsoftheMembranous,
"Boots of the Milites Templi":BootsoftheMilitesTempli,
"Boots of the Ostiary":BootsoftheOstiary,
"Boots of the Oxmal":BootsoftheOxmal,
"Boots of the Painlegion":BootsofthePainlegion,
"Boots of the Proven Champion":BootsoftheProvenChampion,
"Boots of the Putrescent":BootsofthePutrescent,
"Boots of the Ragereaver":BootsoftheRagereaver,
"Boots of the Ravenflight":BootsoftheRavenflight,
"Boots of the Refectory":BootsoftheRefectory,
"Boots of the Renegade":BootsoftheRenegade,
"Boots of the Revelations of Tarim":BootsoftheRevelationsofTarim,
"Boots of the Revelations":BootsoftheRevelations,
"Boots of the Riftcaller":BootsoftheRiftcaller,
"Boots of the Rippling Lake":BootsoftheRipplingLake,
"Boots of the Sanguine Disciple (nm)":BootsoftheSanguineDisciplenm,
"Boots of the Sanguine Disciple":BootsoftheSanguineDisciple,
"Boots of the Savage Fang":BootsoftheSavageFang,
"Boots of the Savage Slaughter":BootsoftheSavageSlaughter,
"Boots of the Scattered Gods":BootsoftheScatteredGods,
"Boots of the Sepulcher":BootsoftheSepulcher,
"Boots of the Shivering Stars":BootsoftheShiveringStars,
"Boots of the Spheres":BootsoftheSpheres,
"Boots of the Steel Behemoth":BootsoftheSteelBehemoth,
"Boots of the Still Pond":BootsoftheStillPond,
"Boots of the Stormbringer":BootsoftheStormbringer,
"Boots of the Strange Beyond":BootsoftheStrangeBeyond,
"Boots of the Sundered Skies":BootsoftheSunderedSkies,
"Boots of the Swift Talon":BootsoftheSwiftTalon,
"Boots of the Tireless Defender":BootsoftheTirelessDefender,
"Boots of the Tormentor":BootsoftheTormentor,
"Boots of the Triumphant":BootsoftheTriumphant,
"Boots of the Ubah Kan":BootsoftheUbahKan,
"Boots of the Unholy Communion":BootsoftheUnholyCommunion,
"Boots of the Unutterable":BootsoftheUnutterable,
"Boots of the Usurper":BootsoftheUsurper,
"Boots of the Valiant":BootsoftheValiant,
"Boots of the Vanguard":BootsoftheVanguard,
"Boots of the Victorious Elite":BootsoftheVictoriousElite,
"Boots of the Wells of Night":BootsoftheWellsofNight,
"Boots of the Whispering Blade":BootsoftheWhisperingBlade,
"Boots of the Wicked":BootsoftheWicked,
"Boots of the Earth Mother":BootsoftheEarthMother,
"Boots of Tribulation":BootsofTribulation,
"Boots of Unrest":BootsofUnrest,
"Boots of Untamed Violence":BootsofUntamedViolence,
"Boots of Vehement Thunder":BootsofVehementThunder,
"Boots of Vengeful Zeal":BootsofVengefulZeal,
"Boots of Vernant Fury":BootsofVernantFury,
"Boots of Vicious Frenzy":BootsofViciousFrenzy,
"Boots of Vindictive Malice":BootsofVindictiveMalice,
"Boots of Violent Rage":BootsofViolentRage,
"Boots of Wild Furor":BootsofWildFuror,
"Boots of Writhing":BootsofWrithing,
"Border Kingdom Cap":BorderKingdomCap,
"Border Kingdom Headdress":BorderKingdomHeaddress,
"Border Kingdom Headgear":BorderKingdomHeadgear,
"Border Kingdom Helm":BorderKingdomHelm,
"Border Kingdom Helmet":BorderKingdomHelmet,
"Bossonian Bascinet":BossonianBascinet,
"Bossonian Charm":BossonianCharm,
"Bossonian Sovereign Ring":BossonianSovereignRing,
"Bounty Hunter's Crossbow":BountyHuntersCrossbow,
"Bounty Hunter's Dirk":BountyHuntersDirk,
"Bow of the Clay":BowoftheClay,
"Bow of the Haunter in the Dark":BowoftheHaunterintheDark,
"Bow of the Masked Hunter":BowoftheMaskedHunter,
"Bow of the Rhino Rider":BowoftheRhinoRider,
"Bow of the Unseen":BowoftheUnseen,
"Brace of Kuthchemes":BraceofKuthchemes,
"Bracelets of the Primal Spirit":BraceletsofthePrimalSpirit,
"Bracer of the Katari":BraceroftheKatari,
"Bracers of Ardent Fire":BracersofArdentFire,
"Bracers of Bedlam":BracersofBedlam,
"Bracers of Bestial Rage":BracersofBestialRage,
"Bracers of Black Oblivion":BracersofBlackOblivion,
"Bracers of Black Whispers":BracersofBlackWhispers,
"Bracers of Bristling Ire":BracersofBristlingIre,
"Bracers of Brutal Carnage":BracersofBrutalCarnage,
"Bracers of Celestial Radiance":BracersofCelestialRadiance,
"Bracers of Clawing Might":BracersofClawingMight,
"Bracers of Conflagrant Flame":BracersofConflagrantFlame,
"Bracers of Courageous Souls":BracersofCourageousSouls,
"Bracers of Dark Malice":BracersofDarkMalice,
"Bracers of Dark Terror":BracersofDarkTerror,
"Bracers of Deadly Guile":BracersofDeadlyGuile,
"Bracers of Effulgent Devotion":BracersofEffulgentDevotion,
"Bracers of Erlik":BracersofErlik,
"Bracers of Fearless Souls":BracersofFearlessSouls,
"Bracers of Ferine Anger":BracersofFerineAnger,
"Bracers of Haloga":BracersofHaloga,
"Bracers of Illuminant Conviction":BracersofIlluminantConviction,
"Bracers of Infernal Zeal":BracersofInfernalZeal,
"Bracers of Insanity":BracersofInsanity,
"Bracers of Jagged Barbs":BracersofJaggedBarbs,
"Bracers of Lunacy":BracersofLunacy,
"Bracers of Necrotic Dread":BracersofNecroticDread,
"Bracers of Pandemonium":BracersofPandemonium,
"Bracers of Quilled Darts":BracersofQuilledDarts,
"Bracers of Rapturous Battle":BracersofRapturousBattle,
"Bracers of Recklessness":BracersofRecklessness,
"Bracers of Righteous Smiting":BracersofRighteousSmiting,
"Bracers of Swiftstriking":BracersofSwiftstriking,
"Bracers of the Ascension":BracersoftheAscension,
"Bracers of the Berserker's Fury":BracersoftheBerserkersFury,
"Bracers of the Bloodmoon":BracersoftheBloodmoon,
"Bracers of the Clay":BracersoftheClay,
"Bracers of the Cloudcleaver":BracersoftheCloudcleaver,
"Bracers of the Death God":BracersoftheDeathGod,
"Bracers of the Deathstalker":BracersoftheDeathstalker,
"Bracers of the Dragon King":BracersoftheDragonKing,
"Bracers of the Ecliptic":BracersoftheEcliptic,
"Bracers of the Eternal Blaze":BracersoftheEternalBlaze,
"Bracers of the Exorcist":BracersoftheExorcist,
"Bracers of the Farseeker":BracersoftheFarseeker,
"Bracers of the First Circle":BracersoftheFirstCircle,
"Bracers of the Furious Swipe":BracersoftheFuriousSwipe,
"Bracers of the Grand Monarch":BracersoftheGrandMonarch,
"Bracers of the Haunter in the Dark":BracersoftheHaunterintheDark,
"Bracers of the Howling Giant":BracersoftheHowlingGiant,
"Bracers of the Huntmaster":BracersoftheHuntmaster,
"Bracers of the Ichorous":BracersoftheIchorous,
"Bracers of the Inconceivable":BracersoftheInconceivable,
"Bracers of the Judgment Bolt":BracersoftheJudgmentBolt,
"Bracers of the Kozak Slayer":BracersoftheKozakSlayer,
"Bracers of the Lector":BracersoftheLector,
"Bracers of the Living Tarim":BracersoftheLivingTarim,
"Bracers of the Membranous":BracersoftheMembranous,
"Bracers of the Merciless":BracersoftheMerciless,
"Bracers of the Outer Dark":BracersoftheOuterDark,
"Bracers of the Oxmal":BracersoftheOxmal,
"Bracers of the Putrescent":BracersofthePutrescent,
"Bracers of the Ragereaver":BracersoftheRagereaver,
"Bracers of the Ravenflight":BracersoftheRavenflight,
"Bracers of the Refectory":BracersoftheRefectory,
"Bracers of the Renegade":BracersoftheRenegade,
"Bracers of the Revelations of Tarim":BracersoftheRevelationsofTarim,
"Bracers of the Revelations":BracersoftheRevelations,
"Bracers of the Riftcaller":BracersoftheRiftcaller,
"Bracers of the Savage Fang":BracersoftheSavageFang,
"Bracers of the Savage Slaughter":BracersoftheSavageSlaughter,
"Bracers of the Silent Slayer":BracersoftheSilentSlayer,
"Bracers of the Stormbringer":BracersoftheStormbringer,
"Bracers of the Strange Beyond":BracersoftheStrangeBeyond,
"Bracers of the Sundered Skies":BracersoftheSunderedSkies,
"Bracers of the Swift Talon":BracersoftheSwiftTalon,
"Bracers of the Ubah Kan":BracersoftheUbahKan,
"Bracers of the Unholy Communion":BracersoftheUnholyCommunion,
"Bracers of the Usurper":BracersoftheUsurper,
"Bracers of the Wells of Night":BracersoftheWellsofNight,
"Bracers of Tribulation":BracersofTribulation,
"Bracers of Untamed Violence":BracersofUntamedViolence,
"Bracers of Vehement Thunder":BracersofVehementThunder,
"Bracers of Vengeful Zeal":BracersofVengefulZeal,
"Bracers of Vernant Fury":BracersofVernantFury,
"Bracers of Vicious Frenzy":BracersofViciousFrenzy,
"Bracers of Violent Rage":BracersofViolentRage,
"Bracers of Wild Furor":BracersofWildFuror,
"Bracers of Writhing":BracersofWrithing,
"Branch of the Great Tree":BranchoftheGreatTree,
"Brand of Ashur":BrandofAshur,
"Brand of Shaulun":BrandofShaulun,
"Brand of the Black Pharaoh":BrandoftheBlackPharaoh,
"Brassard of Ben Morgh":BrassardofBenMorgh,
"Brassard of the Katari":BrassardoftheKatari,
"Brassart of Vicious Frenzy":BrassartofViciousFrenzy,
"Brassarts of the Ragereaver":BrassartsoftheRagereaver,
"Brassarts of Wild Furor":BrassartsofWildFuror,
"Brawler's Cloak":BrawlersCloak,
"Breast of the Warded Brute":BreastoftheWardedBrute,
"Breastplate of Red Ruin (nm)":BreastplateofRedRuinnm,
"Breastplate of Red Ruin":BreastplateofRedRuin,
"Breastplate of the Living Tarim":BreastplateoftheLivingTarim,
"Breastplate of the Renegade":BreastplateoftheRenegade,
"Breastplate of the Revelations of Tarim":BreastplateoftheRevelationsofTarim,
"Breastplate of the Scattered Gods":BreastplateoftheScatteredGods,
"Breath of the North":BreathoftheNorth,
"Breeches of Haloga":BreechesofHaloga,
"Breeches of Nebthu":BreechesofNebthu,
"Breeches of the Black Pharaoh":BreechesoftheBlackPharaoh,
"Breeches of the Crawling Chaos":BreechesoftheCrawlingChaos,
"Breeches of the Dark Messenger":BreechesoftheDarkMessenger,
"Breeches of the Faceless Chaos":BreechesoftheFacelessChaos,
"Breeches of the Faceless Sphinx":BreechesoftheFacelessSphinx,
"Breeches of the Great Impi":BreechesoftheGreatImpi,
"Breeches of the Haunter in the Dark":BreechesoftheHaunterintheDark,
"Breeches of the Howling Giant":BreechesoftheHowlingGiant,
"Breeches of the Masquer of the Sands":BreechesoftheMasqueroftheSands,
"Breeches of the Oxmal":BreechesoftheOxmal,
"Breeches of the Shivering Stars":BreechesoftheShiveringStars,
"Breeches of the Ubah Kan":BreechesoftheUbahKan,
"Brigand's Armbands of the Bloody Fang":BrigandsArmbandsoftheBloodyFang,
"Brigand's Armbands of the Ritual Flame":BrigandsArmbandsoftheRitualFlame,
"Brigand's Armbands of Woven Clouds":BrigandsArmbandsofWovenClouds,
"Brigand's Armguards of the Khan":BrigandsArmguardsoftheKhan,
"Brigand's Belt of a Hundred Eyes":BrigandsBeltofaHundredEyes,
"Brigand's Belt of the Grasping Wild":BrigandsBeltoftheGraspingWild,
"Brigand's Belt of the Howling Moon":BrigandsBeltoftheHowlingMoon,
"Brigand's Belt of the Howling Wind":BrigandsBeltoftheHowlingWind,
"Brigand's Boots of the Grasslands":BrigandsBootsoftheGrasslands,
"Brigand's Gauntlets of the Howling Moon":BrigandsGauntletsoftheHowlingMoon,
"Brigand's Gloves of a Hundred Eyes":BrigandsGlovesofaHundredEyes,
"Brigand's Gloves of the Grasping Wild":BrigandsGlovesoftheGraspingWild,
"Brigand's Gloves of the Howling Wind":BrigandsGlovesoftheHowlingWind,
"Brigand's Hood of the Wicked Hearth":BrigandsHoodoftheWickedHearth,
"Brigand's Leggings of the Bloody Fang":BrigandsLeggingsoftheBloodyFang,
"Brigand's Leggings of the Ritual Flame":BrigandsLeggingsoftheRitualFlame,
"Brigands Leggings of Woven Clouds":BrigandsLeggingsofWovenClouds,
"Brigand's Legguards of the Khan":BrigandsLegguardsoftheKhan,
"Brigand's Straps of the Wicked Hearth":BrigandsStrapsoftheWickedHearth,
"Brigand's Straps of World's Edge":BrigandsStrapsofWorldsEdge,
"Brigand's Wristbands of the Covert Trail":BrigandsWristbandsoftheCovertTrail,
"Brittle Blade Honormask":BrittleBladeHonormask,
"Broadsword of Okeanos":BroadswordofOkeanos,
"Bronzefury War Wolf":BronzefuryWarWolf,
"Buckler of the Blood God":BuckleroftheBloodGod,
"Bullmight Band":BullmightBand,
"Burned Band of Smoking Cinders":BurnedBandofSmokingCinders,
"Cadaverous Bite":CadaverousBite,
"Cadaverous Vambraces":CadaverousVambraces,
"Cage of the Cackling Marionette":CageoftheCacklingMarionette,
"Caliga Tergus":CaligaTergus,
"Caliginous Girdle":CaliginousGridle,
"Callidus":Callidus,
"Canach Battle Belt":CanachBattleBelt,
"Canach Battle Hood":CanachBattleHood,
"Canach Brassard":CanachBrassards,
"Canach Breeches":CanachBreeches,
"Canach Scales":CanachScales,
"Cane of Decay":CaneofDecay,
"Cang Jei's Assorted Nasties":CangJeisAssortedNasties,
"Cang Jei's Eleven Sacred Obscenities":CangJeisElevenSacredObscenities,
"Cang Jei's Serrated Gibe":CangJeisSerratedGibe,
"Cang-Jei's Grin":CangJeisGrin,
"Cang-Jei's Laugh":CangJeisLaugh,
"Cang-Jei's Smile":CangJeisSmile,
"Cang-Jei's Whisper":CangJeisWhisper,
"Canvas Pack":CanvasPack,
"Cap of a Thousand Blossoms":CapofaThousandBlossoms,
"Cap of the Still Pond":CapoftheStillPond,
"Cap of the Unslaked":CapoftheUnslaked,
"Cape of Atlantis":CapeofAtlantis,
"Cape of Eleven Fallen Heroes":CapeofElevenFallenHeroes,
"Cape of Illusions":CapeofIllusions,
"Cape of Reprisal":CapeofReprisal,
"Cape of the Imperium":CapeoftheImperium,
"Captain's Armguards of Heaven's Pass":CaptainsArmguardsofHeavensPass,
"Captain's Armguards of the Battlements":CaptainsArmguardsoftheBattlements,
"Captain's Armguards of the Watchtowers":CaptainsArmguardsoftheWatchtowers,
"Captain's Belt of Heaven's Pass":CaptainsBeltofHeavensPass,
"Captain's Belt of the Battlements":CaptainsBeltoftheBattlements,
"Captain's Belt of the Watchtowers":CaptainsBeltoftheWatchtowers,
"Captain's Boots of the Eastern Sun":CaptainsBootsoftheEasternSun,
"Captain's Boots of the Golden Sun":CaptainsBootsoftheGoldenSun,
"Captain's Boots of the Shining Sun":CaptainsBootsoftheShiningSun,
"Captain's Chestguard of the Warring States":CaptainsChestguardoftheWarringStates,
"Captain's Chestplate of Dynastic Rule":CaptainsChestplateofDynasticRule,
"Captain's Chestplate of the Ascending Kingdom":CaptainsChestplateoftheAscendingKingdom,
"Captain's Gauntlets of Dynastic Rule":CaptainsGauntletsofDynasticRule,
"Captain's Gauntlets of the Ascending Kingdom":CaptainsGauntletsoftheAscendingKingdom,
"Captain's Gauntlets of the Warring States":CaptainsGauntletsoftheWarringStates,
"Captain's Helm of Heaven's Pass":CaptainsHelmofHeavensPass,
"Captain's Legguards of Heaven's Pass":CaptainsLegguardsofHeavensPass,
"Captain's Legguards of the Battlements":CaptainsLegguardsoftheBattlements,
"Captain's Legguards of the Watchtowers":CaptainsLegguardsoftheWatchtowers,
"Captain's Vambraces of the Eastern Sun":CaptainsVambracesoftheEasternSun,
"Captain's Vambraces of the Golden Sun":CaptainsVambracesoftheGoldenSun,
"Captain's Vambraces of the Shining Sun":CaptainsVambracesoftheShiningSun,
"Caravan Master's Necklace":CaravanMastersNecklace,
"Carbasa Cingulum":CarbasaCingulum,
"Cat's Eye Ring":CatsEyeRing,
"Catacomb Gauntlets":CatacombGauntlets,
"Catacomb Gloves":CatacombGloves,
"Catacomb Legguards":CatacombLegguards,
"Catacomb Tunic":CatacombTunic,
"Censer of Those Who Wait Below":CenserofThoseWhoWaitBelow,
"Chain of Akkaria":ChainofAkkaria,
"Chain of Tartaros":ChainofTartaros,
"Chain of Unbreakable Links":ChainofUnbreakableLinks,
"Chaldean Cloak":ChaldeanCloak,
"Chancellor Cloak":ChancellorCloak,
"Chang":Chang,
"Chaosreaver":Chaosreaver,
"Charm of the Laughing Shadows":CharmoftheLaughingShadows,
"Charmer's Tunic":CharmersTunic,
"Cheng-ho Battle Blade":ChengHoBattleBlade,
"Cheng-ho Battle Dagger":ChengHoBattleDagger,
"Cheng-ho Battle Krys":ChengHoBattleKrys,
"Cheng-ho Battle Mark":ChengHoBattleMark,
"Cheng-ho Battle Staff":ChengHoBattleStaff,
"Cheng-ho Battle Stave":ChengHoBattleStave,
"Cheng-ho Battle Sword":ChengHoBattleSword,
"Cheng-ho Battle Talisman":ChengHoBattleTalisman,
"Chestguard of Baleful Blood":ChestguardofBalefulBlood,
"Chestguard of Black Spite":ChestguardofBlackSpite,
"Chestguard of Heroic Soul":ChestguardofHeroicSoul,
"Chestguard of Indomitable Souls":ChestguardofIndomitableSouls,
"Chestguard of Reckless Challenge":ChestguardofRecklessChallenge,
"Chestguard of the Assailant":ChestguardoftheAssailant,
"Chestguard of the Black Dragon":ChestguardoftheBlackDragon,
"Chestguard of the Black Warden":ChestguardoftheBlackWarden,
"Chestguard of the Chaos Agent":ChestguardoftheChaosAgent,
"Chestguard of the Dauntless":ChestguardoftheDauntless,
"Chestguard of the Defiant":ChestguardoftheDefiant,
"Chestguard of the Invincible":ChestguardoftheInvincible,
"Chestguard of the Martial Paragon":ChestguardoftheMartialParagon,
"Chestguard of the Painlegion":ChestguardofthePainlegion,
"Chestguard of the Proven Champion":ChestguardoftheProvenChampion,
"Chestguard of the Tireless Defender":ChestguardoftheTirelessDefender,
"Chestguard of the Tormentor":ChestguardoftheTormentor,
"Chestguard of the Triumphant":ChestguardoftheTriumphant,
"Chestguard of the Usurper":ChestguardoftheUsurper,
"Chestguard of the Valiant":ChestguardoftheValiant,
"Chestguard of the Vanguard":ChestguardoftheVanguard,
"Chestguard of the Victorious Elite":ChestguardoftheVictoriousElite,
"Chestguard of the Wicked":ChestguardoftheWicked,
"Chestplate of Bloodlust":ChestplateofBloodlust,
"Chestplate of Courageous Souls":ChestplateofCourageousSouls,
"Chestplate of Fearless Souls":ChestplateofFearlessSouls,
"Chestplate of the Atlantean":ChestplateoftheAtlantean,
"Chestplate of the Beyond":ChestplateoftheBeyond,
"Chestplate of the Black Pharaoh":ChestplateoftheBlackPharaoh,
"Chestplate of the Crimson Fort":ChestplateoftheCrimsonFort,
"Chestplate of the Milites Templi":ChestplateoftheMilitesTempli,
"Chestplate of the Ostiary":ChestplateoftheOstiary,
"Chill of Winter's Breath (dexterity)":ChillofWintersBreathdexterity,
"Chill of Winter's Breath":ChillofWintersBreath,
"Chimes of the Black Wind":ChimesoftheBlackWind,
"Chronicle of the Ancestors":ChronicleoftheAncestors,
"Chulainn's Gift":ChulainnsGift,
"Circlet of a Thousand Blossoms":CircletofaThousandBlossoms,
"Circlet of the Nebulous":CircletoftheNebulous,
"Circlet of the Sepulcher":CircletoftheSepulcher,
"Circlet of the Spheres":CircletoftheSpheres,
"Circlet of the Unutterable":CircletoftheUnutterable,
"Circuit of the Void":CircuitoftheVoid,
"Clan Bound Boots of the Four Winds":ClanBoudBootsoftheFourWinds,
"Clan Bound Armbands of the Everlasting Sky":ClanBoundArmbandsoftheEverlastingSky,
"Clan Bound Belt of the Ancestors":ClanBoundBeltoftheAncestors,
"Clan Bound Belt of the Golden Horde":ClanBoundBeltoftheGoldenHorde,
"Clan Bound Belt of the Seven Suns":ClanBoundBeltoftheSevenSuns,
"Clan Bound Boots of the Mound":ClanBoundBootsoftheMound,
"Clan Bound Boots of the Plains":ClanBoundBootsofthePlains,
"Clan Bound Bracers of the Far Horizon":ClanBoundBracersoftheFarHorizon,
"Clan Bound Bracers of the Four Winds":ClanBoundBracersoftheFourWinds,
"Clan Bound Bracers of the Plains":ClanBoundBracersofthePlains,
"Clan Bound Fauld of Passing Spirits":ClanBoundFauldofPassingSpirits,
"Clan Bound Fauld of the Tribes":ClanBoundFauldoftheTribes,
"Clan Bound Girdle of the Greensward":ClanBoundGirdleoftheGreensward,
"Clan Bound Gloves of the Far Horizon":ClanBoundGlovesoftheFarHorizon,
"Clan Bound Gloves of the Mound":ClanBoundGlovesoftheMound,
"Clan Bound Gloves of the Plains":ClanBoundGlovesofthePlains,
"Clan Bound Greaves of the Far Horizon":ClanBoundGreavesoftheFarHorizon,
"Clan Bound Harness of the Four Winds":ClanBoundHarnessoftheFourWinds,
"Clan Bound Hauberk of the Far Horizon":ClanBoundHauberkoftheFarHorizon,
"Clan Bound Helm of the Ancestors":ClanBoundHelmoftheAncestors,
"Clan Bound Helm of the Golden Horde":ClanBoundHelmoftheGoldenHorde,
"Clan Bound Helm of the Greensward":ClanBoundHelmoftheGreensward,
"Clan Bound Helm of the Seven Suns":ClanBoundHelmoftheSevenSuns,
"Clan Bound Leggings of the Everlasting Sky":ClanBoundLeggingsoftheEverlastingSky,
"Clan Bound Legguards of the Clans":ClanBoundLegguardsoftheClans,
"Clan Bound Straps of Passing Spirits":ClanBoundStrapsofPassingSpirits,
"Clan Bound Straps of the Clans":ClanBoundStrapsoftheClans,
"Clan Bound Straps of the Tribes":ClanBoundStrapsoftheTribes,
"Clan Bound Vambraces of the Mound":ClanBoundVambracesoftheMound,
"Clandestine Helm":ClandestineHelm,
"Clandestinus Darkhood":ClandestinusDarkhood,
"Clasp of a Thousand Blossoms":ClaspofaThousandBlossoms,
"Clasp of Revival":ClaspofRevival,
"Clasp of the Amaranthine Drums":ClaspoftheAmaranthineDrums,
"Clasp of the Fallen Empire":ClaspoftheFallenEmpire,
"Clasp of the Haunter in the Dark":ClaspoftheHaunterintheDark,
"Clasp of the Howling Giant":ClaspoftheHowlingGiant,
"Clasp of the Steel Behemoth":ClaspoftheSteelBehemoth,
"Claw of Khan":ClawofKhan,
"Claw of the Death Master":ClawoftheDeathMaster,
"Claw of the Vaaghasan":ClawoftheVaaghasan,
"Claws of the Cackling Marionette":ClawsoftheCacklingMarionette,
"Claymore of the Archaeologian":ClaymoreoftheArchaeologian,
"Claymore of the Crowned Serpent":ClaymoreoftheCrownedSerpent,
"Claymore of the Death Master":ClaymoreoftheDeathMaster,
"Claymore of the Raging Earth":ClaymoreoftheRagingEarth,
"Cleave of the Northern Wastes":CleaveoftheNorthernWastes,
"Cloak of Champions":CloakofChampions,
"Cloak of Equivalence":CloakofEquivalence,
"Cloak of Furor":CloakofFuror,
"Cloak of Hugin":CloakofHugin,
"Cloak of Ibis":CloakofIbis,
"Cloak of Insight":CloakofInsight,
"Cloak of Munin":CloakofMunin,
"Cloak of the Battle Hardened":CloakoftheBattleHardened,
"Cloak of the Black Pharaoh":CloakoftheBlackPharaoh,
"Cloak of the Crawling Chaos":CloakoftheCrawlingChaos,
"Cloak of the Faceless Sphinx":CloakoftheFacelessSphinx,
"Cloak of the Fortified Mind":CloakoftheFortifiedMind,
"Cloak of the Garrison":CloakoftheGarrison,
"Cloak of the Shivering Stars":CloakoftheShiveringStars,
"Cloak of the Ubah Kan":CloakoftheUbahKan,
"Cloak of Wakening Nightmares":CloakofWakeningNightmares,
"Cloudspire":Cloudspire,
"Club of Larsha":ClubofLarsha,
"Club of the Ubah Kan":CluboftheUbahKan,
"Club of the Wolf Rider":CluboftheWolfRider,
"Clutch of Black Terrors":ClutchofBlackTerrors,
"Clutch of the Dragon King":ClutchoftheDragonKing,
"Cobrastrike Band":CobrastrikeBand,
"Coil of the Asp":CoiloftheAsp,
"Coil of the Boa":CoiloftheBoa,
"Coil of the Cobra":CoiloftheCobra,
"Coil of the Jiang Shi":CoiloftheJiangShi,
"Coil of the Python":CoilofthePython,
"Coil of the Viper":CoiloftheViper,
"Coil of Tiandal":CoilofTiandal,
"Coiled Serpent Ring":CoiledSerpentRing,
"Coils of the Brood":CoilsoftheBrood,
"Coils of the Dragon King":CoilsoftheDragonKing,
"Collar of Endurance":CollarofEndurance,
"Collar of Havoc":CollarofHavoc,
"Collar of Vigor":CollarofVigor,
"Collector of Blood":CollectorofBlood,
"Commander's Armguards of the Eastern Sun":CommandersArmguardsoftheEasternSun,
"Commander's Armguards of the Golden Sun":CommandersArmguardsoftheGoldenSun,
"Commander's Armguards of the Shining Sun":CommandersArmguardsoftheShiningSun,
"Commander's Belt of Dynastic Rule":CommandersBeltofDynasticRule,
"Commander's Belt of the Ascending Kingdom":CommandersBeltoftheAscendingKingdom,
"Commander's Belt of the Warring States":CommandersBeltoftheWarringStates,
"Commander's Boots of Heaven's Pass":CommandersBootsofHeavensPass,
"Commander's Boots of the Battlements":CommandersBootsoftheBattlements,
"Commander's Boots of the Watchtowers":CommandersBootsoftheWatchtowers,
"Commander's Chestguard of the Watchtowers":CommandersChestguardoftheWatchtowers,
"Commander's Chestplate of Heaven's Pass":CommandersChestplateofHeavensPass,
"Commander's Chestplate of the Battlements":CommandersChestplateoftheBattlements,
"Commander's Gauntlets of Heaven's Pass":CommandersGauntletsofHeavensPass,
"Commander's Gauntlets of the Battlements":CommandersGauntletsoftheBattlements,
"Commander's Gauntlets of the Watchtowers":CommandersGauntletsoftheWatchtowers,
"Commander's Haversack":CommandersHaversack,
"Commander's Helm of Dynastic Rule":CommandersHelmofDynasticRule,
"Commander's Helm of the Ascending Kingdom":CommandersHelmoftheAscendingKingdom,
"Commander's Helm of the Warring States":CommandersHelmoftheWarringStates,
"Commander's Legguards of the Eastern Sun":CommandersLegguardsoftheEasternSun,
"Commander's Legguards of the Golden Sun":CommandersLegguardsoftheGoldenSun,
"Commander's Legguards of the Shining Sun":CommandersLegguardsoftheShiningSun,
"Commander's Vambraces of Heaven's Pass":CommandersVambracesofHeavensPass,
"Commander's Vambraces of the Battlements":CommandersVambracesoftheBattlements,
"Commander's Vambraces of the Watchtowers":CommandersVambracesoftheWatchtowers,
"Composite Bow of the Blood Drinker":CompositeBowoftheBloodDrinker,
"Concussor":Concussor,
"Conscript's Armguards of Dynastic Rule":ConscriptsArmguardsofDynasticRule,
"Conscript's Armguards of the Ascending Kingdom":ConscriptsArmguardsoftheAscendingKingdom,
"Conscript's Armguards of the Warring States":ConscriptsArmguardsoftheWarringStates,
"Conscript's Belt of the Eastern Sun":ConscriptsBeltoftheEasternSun,
"Conscript's Belt of the Golden Sun":ConscriptsBeltoftheGoldenSun,
"Conscript's Belt of the Shining Sun":ConscriptsBeltoftheShiningSun,
"Conscript's Boots of Heaven's Pass":ConscriptsBootsofHeavensPass,
"Conscript's Boots of the Watchtowers":ConscriptsBootsoftheWatchtowers,
"Conscript's Chestguard of the Watchtowers":ConscriptsChestguardoftheWatchtowers,
"Conscript's Chestplate of Heaven's Pass":ConscriptsChestplateofHeavensPass,
"Conscript's Chestplate of the Battlements":ConscriptsChestplateoftheBattlements,
"Conscript's Gauntlets of the Eastern Sun":ConscriptsGauntletsoftheEasternSun,
"Conscript's Gauntlets of the Golden Sun":ConscriptsGauntletsoftheGoldenSun,
"Conscript's Gauntlets of the Shining Sun":ConscriptsGauntletsoftheShiningSun,
"Conscript's Helm of Heaven's Pass":ConscriptsHelmofHeavensPass,
"Conscript's Helm of the Watchtowers":ConscriptsHelmoftheWatchtowers,
"Conscript's Legguards of Dynastic Rule":ConscriptsLegguardsofDynasticRule,
"Conscript's Legguards of the Ascending Kingdom":ConscriptsLegguardsoftheAscendingKingdom,
"Conscript's Legguards of the Warring States":ConscriptsLegguardsoftheWarringStates,
"Conscript's Vambraces of Heaven's Pass":ConscriptsVambracesofHeavensPass,
"Conscript's Vambraces of the Battlements":ConscriptsVambracesoftheBattlements,
"Consecrated Do Kki":ConsecratedDoKki,
"Consecrated Libram":ConsecratedLibram,
"Consecrated Mace":ConsecratedMace,
"Contemplative Helm":ContemplativeHelm,
"Conversant Mantle of the Living Legend":ConversantMantleoftheLivingLegend,
"Cord of the Cackling Marionette":CordoftheCacklingMarionette,
"Coronal Boots":CoronalBoots,
"Coronal Helm":CoronalHelm,
"Coronal Jerkin":CoronalJerkin,
"Coronal Leggings":CoronalLeggings,
"Corpse-Waker's Band":CorpseWakersBand,
"Corpus Ailette":CorpusAilette,
"Corpus Belt":CorpusBelt,
"Corpus Sandals":CorpusSandals,
"Corruptor's Tasset":CorruptorsTasset,
"Coruscant Ward of Maahes":CoruscantWardofMaahes,
"Coverings of Purification":CoveringsofPurification,
"Coverings of the Grand Monarch":CoveringsoftheGrandMonarch,
"Coverings of the Revelations":CoveringsoftheRevelations,
"Covert Leggings":CovertLeggings,
"Craftsman's Mitts":CraftsmansMitts,
"Crimson Death":CrimsonDeath,
"Crocodile Claw Ring":CrocodileClawRing,
"Crossbow of Ardashir Garrison":CrossbowofArdashirGarrison,
"Crossbow of the Archaeologian":CrossbowoftheArchaeologian,
"Crossbow of the Blood Drinker":CrossbowoftheBloodDrinker,
"Crossbow of the Haunter in the Dark":CrossbowoftheHaunterintheDark,
"Crossbow of the Undefeated":CrossbowoftheUndefeated,
"Crossbow of the Underworld":CrossbowoftheUnderworld,
"Crow Shadow Armbands":CrowShadowArmbands,
"Crow Shadow Gauntlets":CrowShadowGauntlets,
"Crow Shadow Sash":CrowShadowSash,
"Crow Shadow Tasset":CrowShadowTasset,
"Crowcackle Gauntlets":CrowcackleGauntlets,
"Crowcackle Leggings":CrowcackleLeggings,
"Crowfire":Crowfire,
"Crown of the Dragon King":CrownoftheDragonKing,
"Cruciatus":Cruciatus,
"Crusher":Crusher,
"Cry for War":CryforWar,
"Cryptguard":Cryptguard,
"Crystallite":Crystallite,
"Cudgel of the Earth Mother":CudgeloftheEarthMother,
"Cuirass of Conajohara":CuirassofConajohara,
"Cuirass of Faith":CuirassofFaith,
"Cuirass of the Fallen Empire (nm)":CuirassoftheFallenEmpirenm,
"Cuirass of the Fallen Empire":CuirassoftheFallenEmpire,
"Cuirass of the Sanguine Disciple (nm)":CuirassoftheSanguineDisciplenm,
"Cuirass of the Sanguine Disciple":CuirassoftheSanguineDisciple,
"Cuisse of the Blood Drinker (nm)":CuisseoftheBloodDrinkernm,
"Cuisse of the Blood Drinker":CuisseoftheBloodDrinker,
"Cuisse of the Death Master (nm)":CuisseoftheDeathMasternm,
"Cuisse of the Death Master":CuisseoftheDeathMaster,
"Cuisse of the Sanguine Disciple (nm)":CuisseoftheSanguineDisciplenm,
"Cuisse of the Sanguine Disciple":CuisseoftheSanguineDisciple,
"Curio of the Archaeologian":CuriooftheArchaeologian,
"Curio of the White Hand":CuriooftheWhiteHand,
"Custoditus":Custoditus,
"Cyan Yothian War-Mare":CyanYothianWarMare,
"Dagger of Envy's Fury":DaggerofEnvysFury,
"Dagger of Nebthu":DaggerofNebthu,
"Dagger of the Archaeologian":DaggeroftheArchaeologian,
"Dagger of the Bloodhunter":DaggeroftheBloodhunter,
"Dagger of the Faceless Sphinx":DaggeroftheFacelessSphinx,
"Dan Sang Gum":DanSangGum,
"Dang Pa":DangPa,
"Dark Amulet of Severed Souls":DarkAmuletofSeveredSouls,
"Dark Eternal":DarkEternal,
"Dark Heart":DarkHeart,
"Darkband":Darkband,
"Darkblade's Armbands of Consumed Souls":DarkbladesArmbandsofConsumedSouls,
"Darkblade's Armbands of Secret Doors":DarkbladesArmbandsofSecretDoors,
"Darkblade's Belt of Consumed Souls":DarkbladesBeltofConsumedSouls,
"Darkblade's Belt of Secret Doors":DarkbladesBeltofSecretDoors,
"Darkblade's Boots of Supreme Decree":DarkbladesBootsofSupremeDecree,
"Darkblade's Boots of the Dark Pact":DarkbladesBootsoftheDarkPact,
"Darkblade's Bracers of Supreme Decree":DarkbladesBracersofSupremeDecree,
"Darkblade's Bracers of the Dark Pact":DarkbladesBracersoftheDarkPact,
"Darkblade's Gloves of Consumed Souls":DarkbladesGlovesofConsumedSouls,
"Darkblade's Gloves of Secret Doors":DarkbladesGlovesofSecretDoors,
"Darkblade's Hood of the Emissary":DarkbladesHoodoftheEmissary,
"Darkblade's Hood of the Kingmaker":DarkbladesHoodoftheKingmaker,
"Darkblade's Leggings of Consumed Souls":DarkbladesLeggingsofConsumedSouls,
"Darkblade's Leggings of Secret Doors":DarkbladesLeggingsofSecretDoors,
"Darkblade's Robe of the Emissary":DarkbladesRobeoftheEmissary,
"Darkblade's Tunic of the Kingmaker":DarkbladesTunicoftheKingmaker,
"Darkchill":Darkchill,
"Darkcraft Vesture":DarkcraftVesture,
"Darkfury Leggings":DarkfuryLeggings,
"Darkfury Slippers":DarkfurySlippers,
"Darkrend Tunic":DarkrendTunic,
"Darkshear":Darkshear,
"Darkshroud Cloak":DarkshroudCloak,
"Darkslayer Bracers":DarkslayerBracers,
"Darkslayer Hood":DarkslayerHood,
"Darkstorm Sandals":DarkstormSandals,
"Darksun":Darksun,
"Deacon's Armbands of the Earthen Prison":DeaconsArmbandsoftheEarthenPrison,
"Deacon's Belt of the Sacred Mountain":DeaconsBeltoftheSacredMountain,
"Deacon's Boots of the Abyss":DeaconsBootsoftheAbyss,
"Deacon's Boots of the Eighteen Pits":DeaconsBootsoftheEighteenPits,
"Deacon's Bracers of the Abyss":DeaconsBracersoftheAbyss,
"Deacon's Bracers of the Eighteen Pits":DeaconsBracersoftheEighteenPits,
"Deacon's Gauntlets of the Eighteen Pits":DeaconsGauntletsoftheEighteenPits,
"Deacon's Girdle of the Spilling Blood":DeaconsGirdleoftheSpillingBlood,
"Deacon's Gloves of the Abyss":DeaconsGlovesoftheAbyss,
"Deacon's Harness of the Eighteen Pits":DeaconsHarnessoftheEighteenPits,
"Deacon's Helm of the Sacred Mountain":DeaconsHelmoftheSacredMountain,
"Deacon's Helm of the Spilling Blood":DeaconsHelmoftheSpillingBlood,
"Deacon's Leggings of the Earthen Prison":DeaconsLeggingsoftheEarthenPrison,
"Deacon's Legguards of the Hallow Worlds":DeaconsLegguardsoftheHallowWorlds,
"Deacon's Straps of the Hallow Worlds":DeaconsStrapsoftheHallowWorlds,
"Dead Iron Hammer":DeadIronHammer,
"Death Harp of the Nine Stars":DeathHarpoftheNineStars,
"Death's Door":DeathsDoor,
"Death's Ward":DeathsWard,
"Death-bloom Thorn Caster":DeathbloomThornCaster,
"Deathforce Staff":DeathforceStaff,
"Deathgasp Mitts":DeathgaspMitts,
"Deathgird":Deathgird,
"Deathhand Bangles":DeathhandBangles,
"Deathmark":Deathmark,
"Deathmaven Heavy Helm":DeathmavenHeavyHelm,
"Deathpalms Gloves":DeathpalmsGloves,
"Deathsong":Deathsong,
"Deathswoop":Deathswoop,
"Decayer Gloves":DecayerGloves,
"Deceitful Gloves":DeceitfulGloves,
"Deceiver's Armbands of Ushering Twilight":DeceiversArmbandsofUsheringTwilight,
"Deceiver's Belt of Ushering Twilight":DeceiversBeltofUsheringTwilight,
"Deceiver's Boots of Whispered Deeds":DeceiversBootsofWhisperedDeeds,
"Deceiver's Bracers of Whispered Deeds":DeceiversBracersofWhisperedDeeds,
"Deceiver's Gloves of the Dusk Rebellion":DeceiversGlovesoftheDuskRebellion,
"Deceiver's Pants of Ushering Twilight":DeceiversPantsofUsheringTwilight,
"Deceiver's Tunic of the Dusk Rebellion":DeceiversTunicoftheDuskRebellion,
"Deepwound":Deepwound,
"Demise":Demise,
"Demon Mantle of the Living Legend":DemonMantleoftheLivingLegend,
"Demonlink Wristbands":DemonlinkWristbands,
"Demonpiercer":Demonpiercer,
"Demontongue":Demontongue,
"Desecrated Chestguard":DesecratedChestguard,
"Despair":Despair,
"Despoiler's Arm-straps of Whispered Deeds":DespoilersArmstrapsofWhisperedDeeds,
"Despoiler's Belt of the Dusk Rebellion":DespoilersBeltoftheDuskRebellion,
"Despoiler's Boots of Ushering Twilight":DespoilersBootsofUsheringTwilight,
"Despoiler's Bracers of Ushering Twilight":DespoilersBracersofUsheringTwilight,
"Despoiler's Gloves of Ushering Twilight":DespoilersGlovesofUsheringTwilight,
"Despoiler's Hood of the Dusk Rebellion":DespoilersHoodoftheDuskRebellion,
"Despoiler's Leggings of Whispered Deeds":DespoilersLeggingsofWhisperedDeeds,
"Despoiler's Tunic of Ushering Twilight":DespoilersTunicofUsheringTwilight,
"Devourer's Ring of the Abyss":DevourersRingoftheAbyss,
"Devout Shoulders":DevoutShoulders,
"Diabolic Pirate Ring":DiabolicPirateRing,
"Diabolical Opus":DiabolicalOpus,
"Diamond-Etched Girdle":DiamondetchedGirdle,
"Diarmad's Respect":DiarmadsRespect,
"Dictatus Carver":DictatusCarver,
"Dila's Belt":DilasBelt,
"Dimshade Straps":DimshadeStraps,
"Dissolutus Bracers":DissulutusBracers,
"Diviner's Armbands of the Emissary":DivinersArmbandsoftheEmissary,
"Diviner's Armbands of the Kingmaker":DivinersArmbandsoftheKingmaker,
"Diviner's Belt of Supreme Decree":DivinersBeltofSupremeDecree,
"Diviner's Belt of the Dark Pact":DivinersBeltoftheDarkPact,
"Diviner's Bracers of Consumed Souls":DivinersBracersofConsumedSouls,
"Diviner's Bracers of Secret Doors":DivinersBracersofSecretDoors,
"Diviner's Gloves of Consumed Souls":DivinersGlovesofConsumedSouls,
"Diviner's Gloves of Secret Doors":DivinersGlovesofSecretDoors,
"Diviner's Hood of Supreme Decree":DivinersHoodofSupremeDecree,
"Diviner's Hood of the Dark Pact":DivinersHoodoftheDarkPact,
"Diviner's Leggings of the Emissary":DivinersLeggingsoftheEmissary,
"Diviner's Leggings of the Kingmaker":DivinersLeggingsoftheKingmaker,
"Diviner's Robe of Consumed Souls":DivinersRobeofConsumedSouls,
"Diviner's Tunic of Secret Doors":DivinersTunicofSecretDoors,
"Do Kki":DoKki,
"Dogmatist's Tasset":DogmatistsTasset,
"Dominator's Boots":DominatorsBoots,
"Double-curved Hyrkanian Bow":DoublecurvedHyrkanianBow,
"Dragon Scale Mantle of the Living Legend":DragonScaleMantleoftheLivingLegend,
"Dragon Tear":DragonTear,
"Draw of Fangs":DrawofFangs,
"Drazgal's Fabled Shield":DrazgalsFabledShield,
"Dreamer's Keepsake":DreamersKeepsake,
"Dual-band of the Blood God":DualbandoftheBloodGod,
"Dunedancer Shoes":DunedancerShoes,
"Durable Gauntlets":DurableGauntlets,
"Duskfang":Duskfang,
"Earthshock Band":EarthshockBand,
"Earthwrack":Earthwrack,
"East Cleave of the Azure Dragon":EastCleaveoftheAzureDragon,
"Edge of Purgatorial Shadows":EdgeofPurgatorialShadows,
"Edge of Shaulun":EdgeofShaulun,
"Edge of Tartarus":EdgeofTartarus,
"Edge of the Golden Age":EdgeoftheGoldenAge,
"Edge of the Night Spirits":EdgeoftheNightSpirits,
"Edge of the Ubah Kan":EdgeoftheUbahKan,
"Edge-scorn Sabatons":EdgescornSabatons,
"Eidolon Chestguard":EidolonChestguard,
"Eldermind Hood":EldermindHood,
"Eldritch Gem":EldritchGem,
"Elemental Ward":ElementalWard,
"Ell of Torment":EllofTorment,
"Emblem of Ashur":EmblemofAshur,
"Emblem of Dragon's Scales":EmblemofDragonsScales,
"Emblem of Red Ruin":EmblemofRedRuin,
"Emerald Armbands":EmeraldArmbands,
"Emerald Barbs of Subtle Striking":EmeraldBarbsofSubtleStriking,
"Emerald Croc-hide Belt":EmeraldCrochideBelt,
"Emerald Croc-hide Gloves":EmeraldCrochideGloves,
"Emerald Teeth Necklace":EmeraldTeethNecklace,
"Emerald-hide Shoes":EmeraldhideShoes,
"Eminent Girdle":EminentGirdle,
"Empowering Atlantean Catalyst":EmpoweringAtlanteanCatalyst,
"Endless Battle Blade":EndlessBattleBlade,
"Endurance":Endurance,
"Enduring Tasset":EnduringTasset,
"Energetic Band":EnergeticBand,
"Energizing Shoulders":EnergizingShoulders,
"Enforcer's Boon":EnforcersBoon,
"Enforcer's Favor":EnforcersFavor,
"Enlightened Loop":EnlightenedLoop,
"Enlightening Atlantean Catalyst":EnlighteningAtlanteanCatalyst,
"Entropy":Entropy,
"Epithet of Skelos":EpithetofSkelos,
"Eran Spahbed Ajanta":EranSpahbedAjanta,
"Eran Spahbed Lock":EranSpahbedLock,
"Eran Spahbed Spara":EranSpahbedSpara,
"Erlik's Blade of Widows":ErliksBladeofWidows,
"Erlik's Knife of the Afterlife":ErliksKnifeoftheAfterlife,
"Erlik's Ninth Seal of the Underworld":ErliksNinthSealoftheUnderworld,
"Erlik's Ring of the Afterlife":ErliksRingoftheAfterlife,
"Erlik's Ring of the Underworld":ErliksRingoftheUnderworld,
"Erlik's Scythe of the Reaper":ErliksScytheoftheReaper,
"Essence of Courage":EssenceofCourage,
"Etched Kuthcheman Poniard":EtchedKuthchemanPoniard,
"Eternal Faith Belt":EternalFaithBelt,
"Eternal Faith Boots":EternalFaithBoots,
"Eternal Faith Gauntlets":EternalFaithGauntlets,
"Eternal Faith Tasset":EternalFaithTasset,
"Ethersense":Ethersense,
"Exaltate's Armbands":ExaltatesArmbands,
"Exaltate's Boots":ExaltatesBoots,
"Exaltate's Bracers":ExaltatesBracers,
"Exaltate's Girdle":ExaltatesGirdle,
"Exaltate's Gloves":ExaltatesGloves,
"Exaltate's Helm":ExaltatesHelm,
"Exaltate's Jerkin":ExaltatesJerkin,
"Exaltate's Tasset":ExaltatesTasset,
"Extentus":Extentus,
"Eye of the Watcher":EyeoftheWatcher,
"Eye of Zamora":EyeofZamora,
"Eyes of Zug":EyesofZug,
"Face of the Moon":FaceoftheMoon,
"Facemask of the Bloodhunter (nm)":FacemaskoftheBloodhunternm,
"Facemask of the Bloodhunter":FacemaskoftheBloodhunter,
"Faithsteel":Faithsteel,
"Falchion of the Arena Master":FalchionoftheArenaMaster,
"Fallen Leviathan's Mantle of the Living Legend":FallenLeviathansMantleoftheLivingLegend,
"Fang of the Vaaghasan":FangoftheVaaghasan,
"Farmer Norfindir's Necklace":FarmerNorfindirsNecklace,
"Farspire":Farspire,
"Fatal Hyperborean Hierophant Gem":FatalHyperboreanHierophantGem,
"Fatal Hyperborean Sentinel Gem":FatalHyperboreanSentinelGem,
"Fauld of Bone and Horn":FauldofBoneandHorn,
"Fauld of the Black Sarcophagus":FauldoftheBlackSarcophagus,
"Fauld of the Scattered Gods":FauldoftheScatteredGods,
"Fauld of the Steel Behemoth":FauldoftheSteelBehemoth,
"Favor of the Skeleton Concubines":FavoroftheSkeletonConcubines,
"Feather of Ibis":FeatherofIbis,
"Fellblade of Crimson Slaughter":FellbladeofCrimsonSlaughter,
"Fellhammer of the Sanguine Disciple":FellhammeroftheSanguineDisciple,
"Fence's Armbands of the Dusk Rebellion":FencesArmbandsoftheDuskRebellion,
"Fence's Bracers of Ushering Twilight":FencesBracersofUsheringTwilight,
"Fence's Cord of Whispered Deeds":FencesCordofWhisperedDeeds,
"Fence's Cowl of Ushering Twilight":FencesCowlofUsheringTwilight,
"Fence's Gloves of Whispered Deeds":FencesGlovesofWhisperedDeeds,
"Fence's Pants of the Dusk Rebellion":FencesPantsoftheDuskRebellion,
"Fence's Tunic of Ushering Twilight":FencesTunicofUsheringTwilight,
"Fera Balteus":FeraBalteus,
"Feretrum of Mitra":FeretrumofMitra,
"Fetish of Caged Fiends":FetishofCagedFiends,
"Fiercelord Straps":FiercelordStraps,
"Filament of Nightmare":FilamentofNightmare,
"Fireforge Axe":FireforgeAxe,
"Fireguard Mantle":FireguardMantle,
"Firesoul Helm":FiresoulHelm,
"Fist of Siptah":FistofSiptah,
"Flamefuse Helm":FlamefuseHelm,
"Flamelash Gloves":FlamelashGloves,
"Flametemper Arrows":FlametemperArrows,
"Flameweave Sash":FlameweaveSash,
"Flashburst Wristbands":FlashburstWristbands,
"Flawmind Necklace":FlawmindNecklace,
"Fleshcarver":Fleshcarver,
"Fleshflayer Gloves":FleshflayerGloves,
"Fleshmender's Bracers":FleshmendersBracers,
"Fleshstripper Boots":FleshstripperBoots,
"Fleshstripper Leggings":FleshstripperLeggings,
"Foebane":Foebane,
"Footpad's Armbands of the Burning Temple":FootpadsArmbandsoftheBurningTemple,
"Footpad's Armbands of the Final Way":FootpadsArmbandsoftheFinalWay,
"Footpad's Bands of the Tenth Court":FootpadsBandsoftheTenthCourt,
"Footpad's Belt of the Burning Temple":FootpadsBeltoftheBurningTemple,
"Footpad's Belt of the Hidden Palace":FootpadsBeltoftheHiddenPalace,
"Footpad's Boots of Engulfing Twilight":FootpadsBootsofEngulfingTwilight,
"Footpad's Boots of the Nadir":FootpadsBootsoftheNadir,
"Footpad's Boots of the Sundered Crown":FootpadsBootsoftheSunderedCrown,
"Footpad's Boots of the Swift Return":FootpadsBootsoftheSwiftReturn,
"Footpad's Bracers of Engulfing Twilight":FootpadsBracersofEngulfingTwilight,
"Footpad's Bracers of the Nadir":FootpadsBracersoftheNadir,
"Footpad's Bracers of the Swift Return":FootpadsBracersoftheSwiftReturn,
"Footpad's Gloves of the Deceiver":FootpadsGlovesoftheDeceiver,
"Footpad's Gloves of the Fifth Stage":FootpadsGlovesoftheFifthStage,
"Footpad's Gloves of the Smoldering Throne":FootpadsGlovesoftheSmolderingThrone,
"Footpad's Gloves of the Stolen Kingdom":FootpadsGlovesoftheStolenKingdom,
"Footpad's Helm of the Hidden Palace":FootpadsHelmoftheHiddenPalace,
"Footpad's Helm of the Tenth Court":FootpadsHelmoftheTenthCourt,
"Footpad's Jerkin of the Fifth Stage":FootpadsJerkinoftheFifthStage,
"Footpad's Jerkin of the Stolen Kingdom":FootpadsJerkinoftheStolenKingdom,
"Footpad's Leggings of the Burning Temple":FootpadsLeggingsoftheBurningTemple,
"Footpad's Leggings of the Final Way":FootpadsLeggingsoftheFinalWay,
"Footpad's Leggings of the Tenth Court":FootpadsLeggingsoftheTenthCourt,
"Footpad's Legguards of the Hidden Palace":FootpadsLegguardsoftheHiddenPalace,
"Footpad's Mask of the Burning Temple":FootpadsMaskoftheBurningTemple,
"Footpad's Mask of the Final Way":FootpadsMaskoftheFinalWay,
"Footpad's Straps of the Hidden Palace":FootpadsStrapsoftheHiddenPalace,
"Footpad's Tunic of the Deceiver":FootpadsTunicoftheDeceiver,
"Footpad's Tunic of the Smoldering Throne":FootpadsTunicoftheSmolderingThrone,
"Footpad's Wristbands of the Sundered Crown":FootpadsWristbandsoftheSunderedCrown,
"Footsteps of the Void":FootstepsoftheVoid,
"Footwraps of the Darkwretch":FootwrapsoftheDarkwretch,
"Footwraps of the Forsaken":FootwrapsoftheForsaken,
"Footwraps of the Harbinger":FootwrapsoftheHarbinger,
"Footwraps of the Precursor":FootwrapsofthePrecursor,
"Footwraps of the Reanimator":FootwrapsoftheReanimator,
"Forbidden Firestaff":ForbiddenFirestaff,
"Force of the Pillars":ForceofthePillars,
"Forceful Pirate Ring":ForcefulPirateRing,
"Forestwalkers":Forestwalkers,
"Forgehammer":Forgehammer,
"Fortifying Atlantean Catalyst":FortifyingAtlanteanCatalyst,
"Fractalus":Fractalus,
"Freebooter's Arm-straps of Pierced Flesh":FreebootersArmstrapsofPiercedFlesh,
"Freebooter's Armbands of the Untamed":FreebootersArmbandsoftheUntamed,
"Freebooter's Armguards of the Roaring Jungle":FreebootersArmguardoftheRoaringJungle,
"Freebooter's Belt of Crouching Calm":FreebootersBeltofCrouchingCalm,
"Freebooter's Belt of Pierced Flesh":FreebootersBeltofPiercedFlesh,
"Freebooter's Boots of the Primeval":FreebootersBootsofthePrimeval,
"Freebooter's Boots of the Savage Sun":FreebootersBootsoftheSavageSun,
"Freebooter's Boots of the Yellow Spring":FreebootersBootsoftheYellowSpring,
"Freebooter's Bracers of the Primeval":FreebootersBracersofthePrimeval,
"Freebooter's Bracers of the Yellow Spring":FreebootersBracersoftheYellowSpring,
"Freebooter's Chestguard of Stalking Fury":FreebootersChestguardofStalkingFury,
"Freebooter's Gauntlets of Stalking Fury":FreebootersGauntletsofStalkingFury,
"Freebooter's Gauntlets of the Second Caste":FreebootersGauntletsoftheSecondCaste,
"Freebooter's Girdle of the Untamed":FreebootersGirdleoftheUntamed,
"Freebooter's Gloves of Grinning Skulls":FreebootersGlovesofGrinningSkulls,
"Freebooter's Gloves of the Elder Bond":FreebootersGlovesoftheElderBond,
"Freebooter's Harness of the Second Caste":FreebootersHarnessoftheSecondCaste,
"Freebooter's Helm of Crouching Calm":FreebootersHelmofCrouchingCalm,
"Freebooter's Helm of the Roaring Jungle":FreebootersHelmoftheRoaringJungle,
"Freebooter's Helm of the Untamed":FreebootersHelmoftheUntamed,
"Freebooter's Jerkin of the Elder Bond":FreebootersJerkinoftheElderBond,
"Freebooter's Leggings of Pierced Flesh":FreebootersLeggingsofPiercedFlesh,
"Freebooter's Leggings of the Untamed":FreebootersLeggingsoftheUntamed,
"Freebooter's Legguards of Crouching Calm":FreebootersLegguardsofCrouchingCalm,
"Freebooter's Legguards of the Roaring Jungle":FreebootersLegguardsoftheRoaringJungle,
"Freebooter's Straps of Crouching Calm":FreebootersStrapsofCrouchingCalm,
"Freebooter's Straps of the Painted Claw":FreebootersStrapsofthePaintedClaw,
"Freebooter's Treads of the Painted Claw":FreebootersTreadsofthePaintedClaw,
"Freebooter's Vambraces of the Savage Sun":FreebootersVambracesoftheSavageSun,
"Freebooter's Vest of Grinning Skulls":FreebootersVestofGrinningSkulls,
"Frenetic Gloves":FreneticGloves,
"Frostfire Cowl":FrostfireCowl,
"Frostfur":Frostfur,
"Frosthunter Arrows":FrosthunterArrows,
"Frostmaim":Frostmaim,
"Frostmaw Boots":FrostmawBoots,
"Frostmaw Gauntlets":FrostmawGauntlets,
"Frostmaw Helm":FrostmawHelm,
"Frostmaw Vambraces":FrostmawVambraces,
"Frostmist Cloak":FrostmistCloak,
"Frostram":Frostram,
"Frostspike":Frostspike,
"Frostwall":Frostwall,
"Furatus":Furatus,
"Furious Band":FuriousBand,
"Furious Spirit":FuriousSpirit,
"Fury of Jovus":FuryofJovus,
"Fury of the Sleeping Stars":FuryoftheSleepingStars,
"Fury of the Void":FuryoftheVoid,
"Fury of Xotli":FuryofXotli,
"Fury's Aegis":FurysAegis,
"Gale":Gale,
"Garbs of the Earth Mother":GarbsoftheEarthMother,
"Gargantuan Fist":GargantuanFist,
"Gargoyle Master's Demise":GargoyleMastersDemise,
"Gauntlets of Baleful Blood":GauntletsofBalefulBlood,
"Gauntlets of Black Spite":GauntletsofBlackSpite,
"Gauntlets of Bloodlust":GauntletsofBloodlust,
"Gauntlets of Brutal Carnage":GauntletsofBrutalCarnage,
"Gauntlets of Clarity":GauntletsofClarity,
"Gauntlets of Courageous Souls":GauntletsofCourageousSouls,
"Gauntlets of Fearless Souls":GauntletsofFearlessSouls,
"Gauntlets of Heroic Soul":GauntletsofHeroicSoul,
"Gauntlets of Indomitable Souls":GauntletsofIndomitableSouls,
"Gauntlets of Indra":GauntletsofIndra,
"Gauntlets of Reckless Challenge":GauntletsofRecklessChallenge,
"Gauntlets of the Assailant":GauntletsoftheAssailant,
"Gauntlets of the Atlantean":GauntletsoftheAtlantean,
"Gauntlets of the Berserker's Fury":GauntletsoftheBerserkersFury,
"Gauntlets of the Beyond":GauntletsoftheBeyond,
"Gauntlets of the Black Dragon":GauntletsoftheBlackDragon,
"Gauntlets of the Black Pharaoh":GauntletsoftheBlackPharaoh,
"Gauntlets of the Black Warden":GauntletsoftheBlackWarden,
"Gauntlets of the Chaos Agent":GauntletsoftheChaosAgent,
"Gauntlets of the Dark Messenger":GauntletsoftheDarkMessenger,
"Gauntlets of the Dauntless":GauntletsoftheDauntless,
"Gauntlets of the Defiant":GauntletsoftheDefiant,
"Gauntlets of the Fallen Empire (nm)":GauntletsoftheFallenEmpirenm,
"Gauntlets of the Fallen Empire":GauntletsoftheFallenEmpire,
"Gauntlets of the Invincible":GauntletsoftheInvincible,
"Gauntlets of the Living Tarim":GauntletsoftheLivingTarim,
"Gauntlets of the Martial Paragon":GauntletsoftheMartialParagon,
"Gauntlets of the Milites Templi":GauntletsoftheMilitesTempli,
"Gauntlets of the Ostiary":GauntletsoftheOstiary,
"Gauntlets of the Painlegion":GauntletsofthePainlegion,
"Gauntlets of the Proven Champion":GauntletsoftheProvenChampion,
"Gauntlets of the Revelations of Tarim":GauntletsoftheRevelationsofTarim,
"Gauntlets of the Savage Slaughter":GauntletsoftheSavageSlaughter,
"Gauntlets of the Scattered Gods":GauntletsoftheScatteredGods,
"Gauntlets of the Tireless Defender":GauntletsoftheTirelessDefender,
"Gauntlets of the Tormentor":GauntletsoftheTormentor,
"Gauntlets of the Triumphant":GauntletsoftheTriumphant,
"Gauntlets of the Usurper":GauntletsoftheUsurper,
"Gauntlets of the Valiant":GauntletsoftheValiant,
"Gauntlets of the Vanguard":GauntletsoftheVanguard,
"Gauntlets of the Victorious Elite":GauntletsoftheVictoriousElite,
"Gauntlets of the Wicked":GauntletsoftheWicked,
"Gauntlets of Unrest":GauntletsofUnrest,
"Gauntlets of Untamed Violence":GauntletsofUntamedViolence,
"Gauntlets of Violent Rage":GauntletsofViolentRage,
"Gemma of Restoration":GemmaofRestoration,
"General's Armguards of Heaven's Pass":GeneralsArmguardsofHeavensPass,
"General's Armguards of the Battlements":GeneralsArmguardsoftheBattlements,
"General's Armguards of the Watchtowers":GeneralsArmguardsoftheWatchtowers,
"General's Belt of Heaven's Pass":GeneralsBeltofHeavensPass,
"General's Belt of the Battlements":GeneralsBeltoftheBattlements,
"General's Belt of the Watchtowers":GeneralsBeltoftheWatchtowers,
"General's Boots of Dynastic Rule":GeneralsBootsofDynasticRule,
"General's Boots of the Ascending Kingdom":GeneralsBootsoftheAscendingKingdom,
"General's Boots of the Warring States":GeneralsBootsoftheWarringStates,
"General's Chestguard of the Shining Sun":GeneralsChestguardoftheShiningSun,
"General's Chestplate of the Eastern Sun":GeneralsChestplateoftheEasternSun,
"General's Chestplate of the Golden Sun":GeneralsChestplateoftheGoldenSun,
"General's Gauntlets of Heaven's Pass":GeneralsGauntletsofHeavensPass,
"General's Gauntlets of the Battlements":GeneralsGauntletsoftheBattlements,
"General's Gauntlets of the Watchtowers":GeneralsGauntletsoftheWatchtowers,
"General's Helm of the Eastern Sun":GeneralsHelmoftheEasternSun,
"General's Helm of the Golden Sun":GeneralsHelmoftheGoldenSun,
"General's Helm of the Shining Sun":GeneralsHelmoftheShiningSun,
"General's Legguards of Heaven's Pass":GeneralsLegguardsofHeavensPass,
"General's Legguards of the Battlements":GeneralsLegguardsoftheBattlements,
"General's Legguards of the Watchtowers":GeneralsLegguardsoftheWatchtowers,
"General's Vambraces of Dynastic Rule":GeneralsVambracesofDynasticRule,
"General's Vambraces of the Ascending Kingdom":GeneralsVambracesoftheAscendingKingdom,
"General's Vambraces of the Warring States":GeneralsVambracesoftheWarringStates,
"Ghostfang":Ghostfang,
"Ghostflight":Ghostflight,
"Ghostweave Drape (Unchained Version)":GhostweaveDrapeUnchainedVersion,
"Ghostweave Drape":GhostweaveDrape,
"Gida of Black Oblivion":GidaofBlackOblivion,
"Gida of Dark Terror":GidaofDarkTerror,
"Gida of Necrotic Dread":GidaofNecroticDread,
"Gida of Pandemonium":GidaofPandemonium,
"Gida of the Bloodmoon":GidaoftheBloodmoon,
"Gida of the Cloudcleaver":GidaoftheCloudcleaver,
"Gida of the Ecliptic":GidaoftheEcliptic,
"Gida of the First Circle":GidaoftheFirstCircle,
"Gida of the Judgment Bolt":GidaoftheJudgmentBolt,
"Gida of the Riftcaller":GidaoftheRiftcaller,
"Gida of the Sundered Skies":GidaoftheSunderedSkies,
"Gida of the Unholy Communion":GidaoftheUnholyCommunion,
"Girdle of Baleful Blood":GirdleofBalefulBlood,
"Girdle of Black Spite":GirdleofBlackSpite,
"Girdle of Blind Devotion":GirdleofBlindDevotion,
"Girdle of Bone and Horn":GirdleofBoneandHorn,
"Girdle of Brutal Carnage":GirdleofBrutalCarnage,
"Girdle of Celestial Radiance":GirdleofCelestialRadiance,
"Girdle of Clawing Might":GirdleofClawingMight,
"Girdle of Effulgent Devotion":GirdleofEffulgentDevotion,
"Girdle of Erlik":GirdleofErlik,
"Girdle of Heroic Soul":GirdleofHeroicSoul,
"Girdle of Illuminant Conviction":GirdleofIlluminantConviction,
"Girdle of Indomitable Souls":GirdleofIndomitableSouls,
"Girdle of Insanity":GirdleofInsanity,
"Girdle of Jagged Barbs":GirdleofJaggedBarbs,
"Girdle of Pandemonium":GirdleofPandemonium,
"Girdle of Quilled Darts":GirdleofQuilledDarts,
"Girdle of the Ascension":GirdleoftheAscension,
"Girdle of the Berserker's Fury":GirdleoftheBerserkersFury,
"Girdle of the Black Pharaoh":GirdleoftheBlackPharaoh,
"Girdle of the Bloodmoon":GirdleoftheBloodmoon,
"Girdle of the Chaos Agent":GirdleoftheChaosAgent,
"Girdle of the Cloudcleaver":GirdleoftheCloudcleaver,
"Girdle of the Dark Messenger":GirdleoftheDarkMessenger,
"Girdle of the Deathstalker":GirdleoftheDeathstalker,
"Girdle of the Earth Mother":GirdleoftheEarthMother,
"Girdle of the Ecliptic":GirdleoftheEcliptic,
"Girdle of the Endless Sands":GirdleoftheEndlessSands,
"Girdle of the First Circle":GirdleoftheFirstCircle,
"Girdle of the Furious Swipe":GirdleoftheFuriousSwipe,
"Girdle of the Haunter in the Dark":GirdleoftheHaunterintheDark,
"Girdle of the Howling Giant":GirdleoftheHowlingGiant,
"Girdle of the Ichorous":GirdleoftheIchorous,
"Girdle of the Inconceivable":GirdleoftheInconceivable,
"Girdle of the Invincible":GirdleoftheInvincible,
"Girdle of the Judgment Bolt":GirdleoftheJudgmentBolt,
"Girdle of the Kozak Slayer":GirdleoftheKozakSlayer,
"Girdle of the Living Tarim":GirdleoftheLivingTarim,
"Girdle of the Martial Paragon":GirdleoftheMartialParagon,
"Girdle of the Membranous":GirdleoftheMembranous,
"Girdle of the Oxmal":GirdleoftheOxmal,
"Girdle of the Painlegion":GirdleofthePainlegion,
"Girdle of the Proven Champion":GirdleoftheProvenChampion,
"Girdle of the Ravenflight":GirdleoftheRavenflight,
"Girdle of the Refectory":GirdleoftheRefectory,
"Girdle of the Renegade":GirdleoftheRenegade,
"Girdle of the Revelations of Tarim":GirdleoftheRevelationsofTarim,
"Girdle of the Riftcaller":GirdleoftheRiftcaller,
"Girdle of the Savage Fang":GirdleoftheSavageFang,
"Girdle of the Savage Slaughter":GirdleoftheSavageSlaughter,
"Girdle of the Shivering Stars":GirdleoftheShiveringStars,
"Girdle of the Sundered Skies":GirdleoftheSunderedSkies,
"Girdle of the Swift Talon":GirdleoftheSwiftTalon,
"Girdle of the Tireless Defender":GirdleoftheTirelessDefender,
"Girdle of the Triumphant":GirdleoftheTriumphant,
"Girdle of the Ubah Kan":GirdleoftheUbahKan,
"Girdle of the Valiant":GirdleoftheValiant,
"Girdle of the Victorious Elite":GirdleoftheVictoriousElite,
"Girdle of Untamed Violence":GirdleofUntamedViolence,
"Girdle of Vernant Fury":GirdleofVernantFury,
"Girdle of Violent Rage":GirdleofViolentRage,
"Girdle of Writhing":GirdleofWrithing,
"Glaive of Red Ruin":GlaiveofRedRuin,
"Gloomshield":Gloomshield,
"Glove of the Swift Talon":GloveoftheSwiftTalon,
"Gloves of Bedlam":GlovesofBedlam,
"Gloves of Bestial Rage":GlovesofBestialRage,
"Gloves of Black Whispers":GlovesofBlackWhispers,
"Gloves of Bristling Ire":GlovesofBristlingIre,
"Gloves of Celestial Radiance":GlovesofCelestialRadiance,
"Gloves of Concealing Shadows":GlovesofConcealingShadows,
"Gloves of Crimson Slaughter (nm)":GlovesofCrimsonSlaughternm,
"Gloves of Crimson Slaughter":GlovesofCrimsonSlaughter,
"Gloves of Dark Malice":GlovesofDarkMalice,
"Gloves of Deadly Guile":GlovesofDeadlyGuile,
"Gloves of Effulgent Devotion":GlovesofEffulgentDevotion,
"Gloves of Ferine Anger":GlovesofFerineAnger,
"Gloves of Fiendish Invocation":GlovesofFiendishInvocation,
"Gloves of Flowing Water":GlovesofFlowingWater,
"Gloves of Haloga":GlovesofHaloga,
"Gloves of Illuminant Conviction":GlovesofIlluminantConviction,
"Gloves of Intricate Spite":GlovesofIntricateSpite,
"Gloves of Lunacy":GlovesofLunacy,
"Gloves of Pandemonium":GlovesofPandemonium,
"Gloves of Quilled Darts":GlovesofQuilledDarts,
"Gloves of Rapturous Battle":GlovesofRapturousBattle,
"Gloves of Red Ruin (nm)":GlovesofRedRuinnm,
"Gloves of Red Ruin":GlovesofRedRuin,
"Gloves of Righteous Smiting":GlovesofRighteousSmiting,
"Gloves of Swiftstriking":GlovesofSwiftstriking,
"Gloves of the Ascension":GlovesoftheAscension,
"Gloves of the Black Pharaoh":GlovesoftheBlackPharaoh,
"Gloves of the Blood Drinker (nm)":GlovesoftheBloodDrinkernm,
"Gloves of the Blood Drinker":GlovesoftheBloodDrinker,
"Gloves of the Blood God (nm)":GlovesoftheBloodGodnm,
"Gloves of the Blood God":GlovesoftheBloodGod,
"Gloves of the Bloodhunter (nm)":GlovesoftheBloodhunternm,
"Gloves of the Bloodhunter":GlovesoftheBloodhunter,
"Gloves of the Bloodmoon":GlovesoftheBloodmoon,
"Gloves of the Cackling Marionette":GlovesoftheCacklingMarionette,
"Gloves of the Clay":GlovesoftheClay,
"Gloves of the Crawling Chaos":GlovesoftheCrawlingChaos,
"Gloves of the Dark Messenger":GlovesoftheDarkMessenger,
"Gloves of the Darkwretch":GlovesoftheDarkwretch,
"Gloves of the Death God":GlovesoftheDeathGod,
"Gloves of the Death Master (nm)":GlovesoftheDeathMasternm,
"Gloves of the Death Master":GlovesoftheDeathMaster,
"Gloves of the Deathstalker":GlovesoftheDeathstalker,
"Gloves of the Doomsayer":GlovesoftheDoomsayer,
"Gloves of the Earth Mother":GlovesoftheEarthMother,
"Gloves of the Ecliptic":GlovesoftheEcliptic,
"Gloves of the Exorcist":GlovesoftheExorcist,
"Gloves of the Farseeker":GlovesoftheFarseeker,
"Gloves of the Firebrand":GlovesoftheFirebrand,
"Gloves of the First Circle":GlovesoftheFirstCircle,
"Gloves of the Forsaken":GlovesoftheForsaken,
"Gloves of the Harbinger":GlovesoftheHarbinger,
"Gloves of the Hell Walker (nm)":GlovesoftheHellWalkernm,
"Gloves of the Hell Walker":GlovesoftheHellWalker,
"Gloves of the Huntmaster":GlovesoftheHuntmaster,
"Gloves of the Lector":GlovesoftheLector,
"Gloves of the Outer Dark":GlovesoftheOuterDark,
"Gloves of the Oxmal":GlovesoftheOxmal,
"Gloves of the Precursor":GlovesofthePrecursor,
"Gloves of the Ragereaver":GlovesoftheRagereaver,
"Gloves of the Ravenflight":GlovesoftheRavenflight,
"Gloves of the Reanimator":GlovesoftheReanimator,
"Gloves of the Revelations":GlovesoftheRevelations,
"Gloves of the Rippling Lake":GlovesoftheRipplingLake,
"Gloves of the Sanguine Disciple (nm)":GlovesoftheSanguineDisciplenm,
"Gloves of the Sanguine Disciple":GlovesoftheSanguineDisciple,
"Gloves of the Shivering Stars":GlovesoftheShiveringStars,
"Gloves of the Silent Slayer":GlovesoftheSilentSlayer,
"Gloves of the Still Pond":GlovesoftheStillPond,
"Gloves of the Stormbringer":GlovesoftheStormbringer,
"Gloves of the Strange Beyond":GlovesoftheStrangeBeyond,
"Gloves of the Unslaked":GlovesoftheUnslaked,
"Gloves of the Warded Brute":GlovesoftheWardedBrute,
"Gloves of the Wells of Night":GlovesoftheWellsofNight,
"Gloves of the Whispering Blade":GlovesoftheWhisperingBlade,
"Gloves of Tranquility":GlovesofTranquility,
"Gloves of Tribulation":GlovesofTribulation,
"Gloves of Vehement Thunder":GlovesofVehementThunder,
"Gloves of Vengeful Zeal":GlovesofVengefulZeal,
"Gloves of Vicious Frenzy":GlovesofViciousFrenzy,
"Gloves of Vindictive Malice":GlovesofVindictiveMalice,
"Gloves of Wild Furor":GlovesofWildFuror,
"Gold-Stitched Gloves":GoldStitchedGloves,
"Golden Ring of Dexterity":GoldenRingofDexterity,
"Goremonger's Armband":GoremongersArmband,
"Goremonger's Boots":GoremongersBoots,
"Goremonger's Bracers":GoremongersBracers,
"Goremonger's Gauntlets":GoremongersGauntlets,
"Goremonger's Girdle":GoremongersGirdle,
"Goremonger's Harness":GoremongersHarness,
"Goremonger's Helm":GoremongersHelm,
"Goremonger's Leggings":GoremongersLeggings,
"Gorulga's Mark":GorulgasMark,
"Gorulga's Shield":GorulgasShield,
"Gossamer Slippers":GossamerSlippers,
"Grand Elder Jerkin":GrandElderJerkin,
"Grasp of a Thousand Blossoms":GraspofaThousandBlossoms,
"Gravecrypt Wristbands":GravecryptWristbands,
"Great Cloak of Blessed Winds":GreatCloakofBlessedWinds,
"Great Cloak of Tribal Prayers":GreatCloakofTribalPrayers,
"Great Sword of the Warded Brute":GreatSwordoftheWardedBrute,
"Greataxe of the Crimson Sea":GreataxeoftheCrimsonSea,
"Greataxe of the Red Tide":GreataxeoftheRedTide,
"Greatshield of the Fallen Empire":GreatshieldoftheFallenEmpire,
"Greatsword of the Death Master":GreatswordoftheDeathMaster,
"Greatsword of the Faceless Chaos":GreatswordoftheFacelessChaos,
"Greaves of Red Ruin (nm)":GreavesofRedRuinnm,
"Greaves of Red Ruin":GreavesofRedRuin,
"Greaves of the Fallen Empire (nm)":GreavesoftheFallenEmpirenm,
"Greaves of the Fallen Empire":GreavesoftheFallenEmpire,
"Greed of Shevatas":GreedofShevatas,
"Griefscale Boots":GriefscaleBoots,
"Griefscale Harness":GriefscaleHarness,
"Griefscale Helm":GriefscaleHelm,
"Griefscale Leggings":GriefscaleLeggings,
"Grievous Jamadhar":GrievousJamadhar,
"Grimherald Chestguard":GrimheraldChestguard,
"Grimherald Hauberk":GrimheraldHauberk,
"Grimherald Jerkin":GrimheraldJerkin,
"Grimherald Robe":GrimheraldRobe,
"Grimherald Tunic":GrimheraldTunic,
"Grimjaw Bracers":GrimjawBracers,
"Grimjaw Gloves":GrimjawGloves,
"Grimjaw Helm":GrimjawHelm,
"Grimjaw Jerkin":GrimjawJerkin,
"Grimshaker":Grimshaker,
"Grimward":Grimward,
"Grimwrest":Grimwrest,
"Grips of Bone and Horn":GripsofBoneandHorn,
"Grips of Erlik":GripsofErlik,
"Grips of Insanity":GripsofInsanity,
"Grips of the Amaranthine Drums":GripsoftheAmaranthineDrums,
"Grips of the Endless Sands":GripsoftheEndlessSands,
"Grips of the Faceless Sphinx":GripsoftheFacelessSphinx,
"Grips of the Ghost of the Veldt":GripsoftheGhostoftheVeldt,
"Grips of the Great Impi":GripsoftheGreatImpi,
"Grips of the Haunter in the Dark":GripsoftheHaunterintheDark,
"Grips of the Howling Giant":GripsoftheHowlingGiant,
"Grips of the Ichorous":GripsoftheIchorous,
"Grips of the Inconceivable":GripsoftheInconceivable,
"Grips of the Masquer of the Sands":GripsoftheMasqueroftheSands,
"Grips of the Membranous":GripsoftheMembranous,
"Grips of the Primal Spirit":GripsofthePrimalSpirit,
"Grips of the Refectory":GripsoftheRefectory,
"Grips of the Steel Behemoth":GripsoftheSteelBehemoth,
"Grips of the Ubah Kan":GripsoftheUbahKan,
"Grips of Writhing":GripsofWrithing,
"Grizzly Breeches":GrizzlyBreeches,
"Grizzly Brigandine":GrizzlyBrigandine,
"Grizzly Mask":GrizzlyMask,
"Guisarme of the Bastion":GuisarmeoftheBastion,
"Gunderland Belt":GunderlandBelt,
"Gunderland Boots":GunderlandBoots,
"Gunderland Bracers":GunderlandBracers,
"Gunderland Greaves":GunderlandGreaves,
"Gunderland Helm":GunderlandHelm,
"Gung Si":GungSi,
"Gutstrap":Gutstrap,
"Gyas's Conduit":GyassConduit,
"Gyas's Fetters":GyassFetters,
"Gyre of the Cloudcleaver":GyreoftheCloudcleaver,
"Gyre of the Judgment Bolt":GyreoftheJudgmentBolt,
"Gyre of the Riftcaller":GyreoftheRiftcaller,
"Gyre of the Sundered Skies":GyreoftheSunderedSkies,
"Halberd of the Archaeologian":HalberdoftheArchaeologian,
"Halberd of the Ostiary":HalberdoftheOstiary,
"Hallowed Ring of Divine Blessings":HallowedRingofDivineBlessings,
"Hammer of Dreams":HammerofDreams,
"Hammer of Lambent Fervor":HammerofLambentFervor,
"Hammer of Primal Wrath":HammerofPrimalWrath,
"Hammer of Solemn Vows":HammerofSolemnVows,
"Hammer of the Arena Victor":HammeroftheArenaVictor,
"Hammer of the Howling Giant":HammeroftheHowlingGiant,
"Hammer of the Living Tarim":HammeroftheLivingTarim,
"Hammer of the Rhino Rider":HammeroftheRhinoRider,
"Hammer of the Sanguine Disciple":HammeroftheSanguineDisciple,
"Hammer of the Void":HammeroftheVoid,
"Hand-wraps of the Crawling Chaos":HandwrapsoftheCrawlingChaos,
"Hand-wraps of the Faceless Chaos":HandwrapsoftheFacelessChaos,
"Hand-wraps of the Faceless Sphinx":HandwrapsoftheFacelessSphinx,
"Hand-wraps of the Haunter in the Dark":HandwrapsoftheHaunterintheDark,
"Hand-wraps of the Nebulous":HandwrapsoftheNebulous,
"Hand-wraps of the Oxmal":HandwrapsoftheOxmal,
"Hand-wraps of the Sepulcher":HandwrapsoftheSepulcher,
"Hand-wraps of the Shivering Stars":HandwrapsoftheShiveringStars,
"Hand-wraps of the Spheres":HandwrapsoftheSpheres,
"Hand-wraps of the Unutterable":HandwrapsoftheUnutterable,
"Handguard of Jagged Barbs":HandguardofJaggedBarbs,
"Handguards of Ardent Fire":HandguardsofArdentFire,
"Handguards of Clawing Might":HandguardsofClawingMight,
"Handguards of Conflagrant Flame":HandguardsofConflagrantFlame,
"Handguards of Infernal Zeal":HandguardsofInfernalZeal,
"Handguards of the Eternal Blaze":HandguardsoftheEternalBlaze,
"Handguards of the Furious Swipe":HandguardsoftheFuriousSwipe,
"Handguards of the Savage Fang":HandguardsoftheSavageFang,
"Handguards of Vernant Fury":HandguardsofVernantFury,
"Harbinger of Acheron":HarbingerofAcheron,
"Harbinger of Dying Breaths":HarbingerofDyingBreaths,
"Harbinger of Lamentation":HarbingerofLamentation,
"Harlot's Bow":HarlotsBow,
"Harlot's Crossbow":HarlotsCrossbow,
"Harlot's Stiletto":HarlotsStiletto,
"Harness of Bestial Rage":HarnessofBestialRage,
"Harness of Bristling Ire":HarnessofBristlingIre,
"Harness of Brutal Carnage":HarnessofBrutalCarnage,
"Harness of Clarity":HarnessofClarity,
"Harness of Erlik":HarnessofErlik,
"Harness of Ferine Anger":HarnessofFerineAnger,
"Harness of Insanity":HarnessofInsanity,
"Harness of Jagged Barbs":HarnessofJaggedBarbs,
"Harness of Quilled Darts":HarnessofQuilledDarts,
"Harness of Rapturous Battle":HarnessofRapturousBattle,
"Harness of Righteous Smiting":HarnessofRighteousSmiting,
"Harness of the Berserker's Fury":HarnessoftheBerserkersFury,
"Harness of the Blood Drinker (nm)":HarnessoftheBloodDrinkernm,
"Harness of the Blood Drinker":HarnessoftheBloodDrinker,
"Harness of the Deathstalker":HarnessoftheDeathstalker,
"Harness of the Haunter in the Dark":HarnessoftheHaunterintheDark,
"Harness of the Howling Giant":HarnessoftheHowlingGiant,
"Harness of the Ichorous":HarnessoftheIchorus,
"Harness of the Inconceivable":HarnessoftheInconceivable,
"Harness of the Kozak Slayer":HarnessoftheKozakSlayer,
"Harness of the Membranous":HarnessoftheMembranous,
"Harness of the Ragereaver":HarnessoftheRagereaver,
"Harness of the Ravenflight":HarnessoftheRavenflight,
"Harness of the Refectory":HarnessoftheRefectory,
"Harness of the Savage Slaughter":HarnessoftheSavageSlaughter,
"Harness of the Stormbringer":HarnessoftheStormbringer,
"Harness of the Swift Talon":HarnessoftheSwiftTalon,
"Harness of the Ubah Kan":HarnessoftheUbahKan,
"Harness of Tribulation":HarnessofTribulation,
"Harness of Unrest":HarnessofUnrest,
"Harness of Untamed Violence":HarnessofUntamedViolence,
"Harness of Vehement Thunder":HarnessofVehementThunder,
"Harness of Vengeful Zeal":HarnessofVengefulZeal,
"Harness of Vicious Frenzy":HarnessofViciousFrenzy,
"Harness of Violent Rage":HarnessofViolentRage,
"Harness of Wild Furor":HarnessofWildFuror,
"Harness of Writhing":HarnessofWrithing,
"Harrow":Harrow,
"Hat of the Rippling Lake":HatoftheRipplingLake,
"Hatefreeze Ring":HatefreezeRing,
"Hateless Strikes":HatelessStrikes,
"Hauberk of Swiftstriking":HauberkofSwiftstriking,
"Hauberk of the Farseeker":HauberkoftheFarseeker,
"Hauberk of the Huntmaster":HauberkoftheHuntmaster,
"Hawksight":Hawksight,
"Headband of the Kozak Slayer":HeadbandoftheKozakSlayer,
"Headdress of Bedlam":HeaddressofBedlam,
"Headdress of Lunacy":HeaddressofLunacy,
"Headress of the Amaranthine Drums":HeaddressoftheAmaranthineDrums,
"Headdress of the Blood God (nm)":HeaddressoftheBloodGodnm,
"Headdress of the Blood God":HeaddressoftheBloodGod,
"Headdress of the Blue Sea":HeaddressoftheBlueSeaMaleVersion,
"Headdress of the Crawling Chaos":HeaddressoftheCrawlingChaos,
"Headress of the Earth Mother":HeaddressoftheEarthMother,
"Headdress of the Grand Monarch":HeaddressoftheGrandMonarch,
"Headdress of the Hell Walker (nm)":HeaddressoftheHellWalkernm,
"Headdress of the Hell Walker":HeaddressoftheHellWalker,
"Headdress of the Revelations":HeaddressoftheRevelations,
"Headdress of the Sanguine Disciple (nm)":HeaddressoftheSanguineDisciplenm,
"Headdress of the Sanguine Disciple":HeaddressoftheSanguineDisciple,
"Headdress of the Wells of Night":HeaddressoftheWellsofNight,
"Heart of Atali":HeartofAtali,
"Heart of Pashtun":HeartofPashtun,
"Heartcrusher Grips":HeartcrusherGrips,
"Heartgirth Girdle":HeartgirthGirdle,
"Heartstrike Arrows":HeartstrikeArrows,
"Heater-Shield of the Fallen Empire":HeaterShieldoftheFallenEmpire,
"Heaven Cracker Earth Breaker":HeavenCrackerEarthBreaker,
"Heaven Cracker Soul Sunderer":HeavenCrackerSoulSunderer,
"Heaven's Buchae":HeavensBuchae,
"Heaven's Chang":HeavensChang,
"Heaven's Dan Sang Gum":HeavensDanSangGum,
"Heaven's Dang Pa":HeavensDangPa,
"Heaven's Do Kki":HeavensDoKki,
"Heaven's Gung Si":HeavensGungSi,
"Heaven's Jang Bong":HeavensJangBong,
"Heaven's Jang Gum":HeavensJangGum,
"Heaven's Jang Ssang Gum":HeavensJangSsangGum,
"Heaven's Ji Pang-Ee":HeavensJiPangEe,
"Heaven's Kal Gum":HeavensKalGum,
"Heaven's Torment":HeavensTorment,
"Heaven's Wol Do":HeavensWolDo,
"Heavenly Rain":HeavenlyRain,
"Heavenly Repeater":HeavenlyRepeater,
"Heavy Jovian Cape":HeavyJovianCape,
"Hek'lar's Accurst Dagger":HeklarsAccurstDagger,
"Hek'lar's Cloak":HeklarsCloak,
"Hellfire":Hellfire,
"Hellfury Armbands":HellfuryArmbands,
"Hellfury Robe":HellfuryRobe,
"Hellfury Wristbands":HellfuryWristbands,
"Hellspawned Wristguard":HellspawnedWristguard,
"Helm of Ardent Fire":HelmofArdentFire,
"Helm of Baleful Blood":HelmofBalefulBlood,
"Helm of Black Oblivion":HelmofBlackOblivion,
"Helm of Black Spite":HelmofBlackSpite,
"Helm of Bloodlust":HelmofBloodlust,
"Helm of Brutal Carnage":HelmofBrutalCarnage,
"Helm of Celestial Radiance":HelmofCelestialRadiance,
"Helm of Clarity":HelmofClarity,
"Helm of Clawing Might":HelmofClawingMight,
"Helm of Conflagrant Flame":HelmofConflagrantFlame,
"Helm of Courageous Souls":HelmofCourageousSouls,
"Helm of Dark Terror":HelmofDarkTerror,
"Helm of Effulgent Devotion":HelmofEffulgentDevotion,
"Helm of Erlik":HelmofErlik,
"Helm of Fearless Souls":HelmofFearlessSouls,
"Helm of Ferine Anger":HelmofFerineAnger,
"Helm of Flowing Water":HelmofFlowingWater,
"Helm of Heroic Soul":HelmofHeroicSoul,
"Helm of Illuminant Conviction":HelmofIlluminantConviction,
"Helm of Indomitable Souls":HelmofIndomitableSouls,
"Helm of Indra":HelmofIndra,
"Helm of Infernal Zeal":HelmofInfernalZeal,
"Helm of Insanity":HelmofInsanity,
"Helm of Intricate Spite":HelmofIntricateSpite,
"Helm of Necrotic Dread":HelmofNecroticDread,
"Helm of Pandemonium":HelmofPandemonium,
"Helm of Rapturous Battle":HelmofRapturousBattle,
"Helm of Reckless Challenge":HelmofRecklessChallenge,
"Helm of Righteous Smiting":HelmofRighteousSmiting,
"Helm of Shattered Existance":HelmofShatteredExistance,
"Helm of Swiftstriking":HelmofSwiftstriking,
"Helm of the Ascension":HelmoftheAscension,
"Helm of the Assailant":HelmoftheAssailant,
"Helm of the Atlantean":HelmoftheAtlantean,
"Helm of the Berserker's Fury":HelmoftheBerserkersFury,
"Helm of the Beyond":HelmoftheBeyond,
"Helm of the Black Dragon":HelmoftheBlackDragon,
"Helm of the Black Pharaoh":HelmoftheBlackPharaoh,
"Helm of the Black Warden":HelmoftheBlackWarden,
"Helm of the Blood Drinker (nm)":HelmoftheBloodDrinkernm,
"Helm of the Blood Drinker":HelmoftheBloodDrinker,
"Helm of the Bloodmoon":HelmoftheBloodmoon,
"Helm of the Chaos Agent":HelmoftheChaosAgent,
"Helm of the Crimson Fort":HelmoftheCrimsonFort,
"Helm of the Dark Messenger":HelmoftheDarkMessenger,
"Helm of the Dauntless":HelmoftheDauntless,
"Helm of the Deathstalker":HelmoftheDeathstalker,
"Helm of the Defiant":HelmoftheDefiant,
"Helm of the Ecliptic":HelmoftheEcliptic,
"Helm of the Eternal Blaze":HelmoftheEternalBlaze,
"Helm of the Fallen Empire (nm)":HelmoftheFallenEmpirenm,
"Helm of the Fallen Empire":HelmoftheFallenEmpire,
"Helm of the Farseeker":HelmoftheFarseeker,
"Helm of the Firebrand":HelmoftheFirebrand,
"Helm of the First Circle":HelmoftheFirstCircle,
"Helm of the Forsaken":HelmoftheForsaken,
"Helm of the Furious Swipe":HelmoftheFuriousSwipe,
"Helm of the Howling Giant":HelmoftheHowlingGiant,
"Helm of the Huntmaster":HelmoftheHuntmaster,
"Helm of the Ichorous":HelmoftheIchorous,
"Helm of the Inconceivable":HelmoftheInconceivable,
"Helm of the Invincible":HelmoftheInvincible,
"Helm of the Living Tarim":HelmoftheLivingTarim,
"Helm of the Martial Paragon":HelmoftheMartialParagon,
"Helm of the Membranous":HelmoftheMembranous,
"Helm of the Milites Templi":HelmoftheMilitesTempli,
"Helm of the Ostiary":HelmoftheOstiary,
"Helm of the Oxmal":HelmoftheOxmal,
"Helm of the Painlegion":HelmofthePainlegion,
"Helm of the Primal Spirit":HelmofthePrimalSpirit,
"Helm of the Proven Champion":HelmoftheProvenChampion,
"Helm of the Ragereaver":HelmoftheRagereaver,
"Helm of the Refectory":HelmoftheRefectory,
"Helm of the Renegade":HelmoftheRenegade,
"Helm of the Revelations of Tarim":HelmoftheRevelationsofTarim,
"Helm of the Savage Fang":HelmoftheSavageFang,
"Helm of the Savage Slaughter":HelmoftheSavageSlaughter,
"Helm of the Scattered Gods":HelmoftheScatteredGods,
"Helm of the Shivering Stars":HelmoftheShiveringStars,
"Helm of the Steel Behemoth":HelmoftheSteelBehemoth,
"Helm of the Stormbringer":HelmoftheStormbringer,
"Helm of the Tireless Defender":HelmoftheTirelessDefender,
"Helm of the Tormentor":HelmoftheTormentor,
"Helm of the Triumphant":HelmoftheTriumphant,
"Helm of the Ubah Kan":HelmoftheUbahKan,
"Helm of the Unholy Communion":HelmoftheUnholyCommunion,
"Helm of the Usurper":HelmoftheUsurper,
"Helm of the Valiant":HelmoftheValiant,
"Helm of the Vanguard":HelmoftheVanguard,
"Helm of the Victorious Elite":HelmoftheVictoriousElite,
"Helm of the Wailing":HelmoftheWailing,
"Helm of the Wicked":HelmoftheWicked,
"Helm of Tranquility":HelmofTranquility,
"Helm of Tribulation":HelmofTribulation,
"Helm of Unrest":HelmofUnrest,
"Helm of Untamed Violence":HelmofUntamedViolence,
"Helm of Vehement Thunder":HelmofVehementThunder,
"Helm of Vengeful Zeal":HelmofVengefulZeal,
"Helm of Vernant Fury":HelmofVernantFury,
"Helm of Vicious Frenzy":HelmofViciousFrenzy,
"Helm of Violent Rage":HelmofViolentRage,
"Helm of Wild Furor":HelmofWildFuror,
"Helm of Writhing":HelmofWrithing,
"Hero's Chestguard":HerosChestguard,
"Hero's Clan Blade":HerosClanBlade,
"Hero's Hauberk":HerosHauberk,
"Hero's Hellglaive":HerosHellglaive,
"Hero's Jerkin":HerosJerkin,
"Hero's Tunic":HerosTunic,
"Heroking's Breastplate":HerokingsBreastplate,
"High Priest's Necklace":HighPriestsNecklace,
"High Priest's Ring of Dexterity":HighPriestsRingofDexterity,
"High Priest's Ring of Intelligence":HighPriestsRingofIntelligence,
"High Priest's Ring of Strength":HighPriestsRingofStrength,
"High Priest's Ring of Wisdom":HighPriestsRingofWisdom,
"High Protector's Tasset":HighProtectorsTasset,
"Highlord's Arrows":HighlordsArrows,
"Highlord's Axe":HighlordsAxe,
"Highlord's Band of Force":HighlordsBandofForce,
"Highlord's Band of Power":HighlordsBandofPower,
"Highlord's Band of Slaughter":HighlordsBandofSlaughter,
"Highlord's Band of Swirling Mist":HighlordsBandofSwirlingMist,
"Highlord's Blade":HighlordsBlade,
"Highlord's Bolts":HighlordsBolts,
"Highlord's Clasp of Force":HighlordsClaspofForce,
"Highlord's Cloak of Cinders":HighlordsCloakofCinders,
"Highlord's Cloak of Force":HighlordsCloakofForce,
"Highlord's Cloak of Power":HighlordsCloakofPower,
"Highlord's Cloak of Shielding":HighlordsCloakofShielding,
"Highlord's Cloak of Swirling Mist":HighlordsCloakofSwirlingMist,
"Imbued Highlord's Clasp of Force":HighlordsClaspofForce,
"Imbued Highlord's Cloak of Cinders":HighlordsCloakofCinders,
"Imbued Highlord's Cloak of Force":HighlordsCloakofForce,
"Imbued Highlord's Cloak of Power":HighlordsCloakofPower,
"Imbued Highlord's Cloak of Shielding":HighlordsCloakofShielding,
"Imbued Highlord's Cloak of Swirling Mist":HighlordsCloakofSwirlingMist,
"Highlord's Crossbow":HighlordsCrossbow,
"Highlord's Dirk":HighlordsDirk,
"Highlord's Great Shield":HighlordsGreatShield,
"Highlord's Greatbow":HighlordsGreatbow,
"Highlord's Greatsword":HighlordsGreatsword,
"Highlord's Krys":HighlordsKrys,
"Highlord's Mace":HighlordsMace,
"Highlord's Mark of Abhorrence":HighlordsMarkofAbhorrence,
"Highlord's Maxim of Entropy":HighlordsMaximofEntropy,
"Highlord's Pendant of Fluidity":HighlordsPendantofFluidity,
"Highlord's Pendant of Power":HighlordsPendantofPower,
"Highlord's Pendant of Shielding":HighlordsPendantofShielding,
"Highlord's Pendant of Wisdom":HighlordsPendantofWisdom,
"Highlord's Sanctum":HighlordsSanctum,
"Highlord's Scepter":HighlordsScepter,
"Highlord's Spell Glaive":HighlordsSpellGlaive,
"Highlord's Spellsword":HighlordsSpellsword,
"Highlord's Staff":HighlordsStaff,
"Highlord's War Glaive":HighlordsWarGlaive,
"Highlord's War Maul":HighlordsWarMaul,
"Hive Bludgeon":HiveBludgeon,
"Hive Hammer":HiveHammer,
"Hive Hasta":HiveHasta,
"Hive Khopesh":HiveKhopesh,
"Honor's Focus":HonorsFocus,
"Honored Armbands of the Four Winds":HonoredArmbandsoftheFourWinds,
"Honored Belt of the Far Horizon":HonoredBeltoftheFarHorizon,
"Honored Belt of the Mound":HonoredBeltoftheMound,
"Honored Belt of the Plains":HonoredBeltofthePlains,
"Honored Boots of the Ancestors":HonoredBootsoftheAncestors,
"Honored Boots of the Golden Horde":HonoredBootsoftheGoldenHorde,
"Honored Boots of the Greensward":HonoredBootsoftheGreensward,
"Honored Bracers of the Golden Horde":HonoredBracersoftheGoldenHorde,
"Honored Bracers of the Greensward":HonoredBracersoftheGreensward,
"Honored Fauld of the Far Horizon":HonoredFauldoftheFarHorizon,
"Honored Fauld of the Mound":HonoredFauldoftheMound,
"Honored Gauntlets of the Far Horizon":HonoredGauntletsoftheFarHorizon,
"Honored Gauntlets of the Four Winds":HonoredGauntletsoftheFourWinds,
"Honored Girdle of the Four Winds":HonoredGirdleoftheFourWinds,
"Honored Gloves of the Mound":HonoredGlovesoftheMound,
"Honored Gloves of the Plains":HonoredGlovesofthePlains,
"Honored Greaves of the Seven Suns":HonoredGreavesoftheSevenSuns,
"Honored Harness of the Everlasting Sky":HonoredHarnessoftheEverlastingSky,
"Honored Hauberk of Passing Spirits":HonoredHauberkofPassingSpirits,
"Honored Helm of Passing Spirits":HonoredHelmofPassingSpirits,
"Honored Helm of the Clans":HonoredHelmoftheClans,
"Honored Helm of the Everlasting Sky":HonoredHelmoftheEverlastingSky,
"Honored Helm of the Tribes":HonoredHelmoftheTribes,
"Honored Jerkin of the Clans":HonoredJerkinoftheClans,
"Honored Jerkin of the Tribes":HonoredJerkinoftheTribes,
"Honored Leggings of the Four Winds":HonoredLeggingsoftheFourWinds,
"Honored Legguards of the Plains":HonoredLegguardsofthePlains,
"Honored Straps of the Far Horizon":HonoredStrapsoftheFarHorizon,
"Honored Straps of the Mound":HonoredStrapsoftheMound,
"Honored Straps of the Plains":HonoredStrapsofthePlains,
"Honored Vambraces of the Ancestors":HonoredVambracesoftheAncestors,
"Honored Vambraces of the Seven Suns":HonoredVambracesoftheSevenSuns,
"Hood of Black Whispers":HoodofBlackWhispers,
"Hood of Concealing Shadows":HoodofConcealingShadows,
"Hood of Dark Malice":HoodofDarkMalice,
"Hood of Deadly Guile":HoodofDeadlyGuile,
"Hood of Endless Night":HoodofEndlessNight,
"Hood of Fiendish Invocation":HoodofFiendishInvocation,
"Hood of Haloga":HoodofHaloga,
"Hood of Jagged Barbs":HoodofJaggedBarbs,
"Hood of Quilled Darts":HoodofQuilledDarts,
"Hood of the Clay":HoodoftheClay,
"Hood of the Doomsayer":HoodoftheDoomsayer,
"Hood of the Exorcist":HoodoftheExorcist,
"Hood of the Faceless Chaos":HoodoftheFacelessChaos,
"Hood of the Faceless Sphinx":HoodoftheFacelessSphinx,
"Hood of the Lector":HoodoftheLector,
"Hood of the Merciless":HoodoftheMerciless,
"Hood of the Putrescent":HoodofthePutrescent,
"Hood of the Ravenflight":HoodoftheRavenflight,
"Hood of the Silent Slayer":HoodoftheSilentSlayer,
"Hood of the Swift Talon":HoodoftheSwiftTalon,
"Hood of the Usurper":HoodoftheUsurper,
"Hood of the Whispering Blade":HoodoftheWhisperingBlade,
"Hood of Vindictive Malice":HoodofVindictiveMalice,
"Hooves of the Warded Brute":HoovesoftheWardedBrute,
"Horn of the Warded Brute":HornoftheWardedBrute,
"Horns of the Darkwretch":HornsoftheDarkwretch,
"Horns of the Endless Sands":HornsoftheEndlessSands,
"Horns of the Reanimator":HornsoftheReanimator,
"Horsehair Blanket":HorsehairBlanket,
"Housekarl's Pledge":HousekarlsPledge,
"Howl of the Pack":HowlofthePack,
"Howler":Howler,
"Hunger":Hunger,
"Hyrkanian Bitter Wind-Biter":HyrkanianBitterWindBiter,
"Hyrkanian Dread Ash-Tramper":HyrkanianDreadAshTramper,
"Hyrkanian Fleet Scream-Catcher":HyrkanianFleetScreamCatcher,
"Hyrkanian Grim Skull-Treader":HyrkanianGrimSkullTreader,
"Hyrkanian Pale Ghost-Chaser":HyrkanianPaleGhostChaser,
"Hyrkanian Resplendent Sun-Strider":HyrkanianResplendentSunStrider,
"Hyrkanian Sable Shadow-Dasher":HyrkanianSableShadowDasher,
"Hyrkanian Twilight Void-Racer":HyrkanianTwilightVoidRacer,
"Hyrkanian Wicked Chaos-Clapper":HyrkanianWickedChaosClapper,
"Icestrike":Icestrike,
"Icethorn":Icethorn,
"Icon of the Blood God":IconoftheBloodGod,
"Iconoclast's Crown":IconoclastsCrown,
"Ieb":Ieb,
"Illuminating Atlantean Catalyst":IlluminatingAtlanteanCatalyst,
"Illusionist's Longsword":IllusionistsLongsword,
"Illusionist's Staff":IllusionistsStaff,
"Immemorial Chain":ImmemorialChain,
"Impenetrable Legguards":ImpenetrableLegguards,
"Impenetrable Word of Valka":ImpenetrableWordofValka,
"Imperial Acheronian Halberd":ImperialAcheronianHalberd,
"Imperial Bluesteel Slaughter Steed":ImperialBluesteelSlaughterSteed,
"Imperial Bronzesteel Slaughter Steed":ImperialBronzesteelSlaughterSteed,
"Imperial Redsteel Slaughter Steed":ImperialRedsteelSlaughterSteed,
"Impervious Tasset":ImperviousTasset,
"Impious Wristbands":ImpiousWristbands,
"Incandescent Cane":IncandescentCane,
"Incursion Shroud":IncursionShroud,
"Infernal Mantle of the Living Legend":InfernalMantleoftheLivingLegend,
"Iniquitous Skullcap":IniquitousSkullcap,
"Initiate's Arm-straps of the Heavens":InitiatesArmstrapsoftheHeavens,
"Initiate's Arm-straps of the Waning Moon":InitiatesArmstrapsoftheWaningMoon,
"Initiate's Armbands of the Eternal Eclipse":InitiatesArmbandsoftheEternalEclipse,
"Initiate's Armbands of the Forbidden Art":InitiatesArmbandsoftheForbiddenArt,
"Initiate's Bands of the Moon":InitiatesBandsoftheMoon,
"Initiate's Belt of the Celestial Hilt":InitiatesBeltoftheCelestialHilt,
"Initiate's Belt of the Exiled":InitiatesBeltoftheExiled,
"Initiate's Belt of Twining Smoke":InitiatesBeltofTwiningSmoke,
"Initiate's Boots of the Burning Disc":InitiatesBootsoftheBurningDisc,
"Initiate's Boots of the Effulgent Blade":InitiatesBootsoftheEffulgentBlade,
"Initiate's Boots of the Moon":InitiatesBootsoftheMoon,
"Initiate's Bracers of the Burning Disc":InitiatesBracersoftheBurningDisc,
"Initiate's Cord of Awakening":InitiatesCordofAwakening,
"Initiate's Cowl of the Moon":InitiatesCowloftheMoon,
"Initiate's Gloves of Awakening":InitiatesGlovesofAwakening,
"Initiate's Gloves of the Celestial Hilt":InitiatesGlovesoftheCelestialHilt,
"Initiate's Gloves of the Exiled":InitiatesGlovesoftheExiled,
"Initiate's Gloves of Twining Smoke":InitiatesGlovesofTwiningSmoke,
"Initiate's Hood of the Crescent":InitiatesHoodoftheCrescent,
"Initiate's Hood":InitiatesHood,
"Initiate's Leggings of the Eternal Eclipse":InitiatesLeggingsoftheEternalEclipse,
"Initiate's Leggings of the Forbidden Art":InitiatesLeggingsoftheForbiddenArt,
"Initiate's Leggings of the Heavens":InitiatesLeggingsoftheHeavens,
"Initiate's Pants of the Waning Moon":InitiatesPantsoftheWaningMoon,
"Initiate's Robes of the Crescent":InitiatesRobesoftheCrescent,
"Initiate's Robes of the Moon":InitiatesRobesoftheMoon,
"Initiate's Sandals of the Crescent":InitiatesSandalsoftheCrescent,
"Initiate's Tunic of the Burning Disc":InitiatesTunicoftheBurningDisc,
"Initiate's Wraps of the Crescent":InitiatesWrapsoftheCrescent,
"Initiate's Wristbands of the Effulgent Blade":InitiatesWristbandsoftheEffulgentBlade,
"Invigorating Shoulders":InvigoratingShoulders,
"Iron Band of Constitution":IronBandofConstitution,
"Ironclad Trinket of Eternal Resilience":IroncladTrinketofEternalResilience,
"Ironsmiter":Ironsmiter,
"Iziel's Hate":IzielsHate,
"Iziel's Spite":IzielsSpite,
"Jagged Cut":JaggedCut,
"Jang Bong":JangBong,
"Jang Gum":JangGum,
"Jang Ssang Gum":JangSsangGum,
"Jawsnapper's Hide":JawsnappersHide,
"Jerkin of Clawing Might":JerkinofClawingMight,
"Jerkin of Flowing Water":JerkinofFlowingWater,
"Jerkin of the Amaranthine Drums":JerkinoftheAmaranthineDrums,
"Jerkin of the Death Master (nm)":JerkinoftheDeathMasternm,
"Jerkin of the Death Master":JerkinoftheDeathMaster,
"Jerkin of the Furious Swipe":JerkinoftheFuriousSwipe,
"Jerkin of the Masquer of the Sands":JerkinoftheMasqueroftheSands,
"Jerkin of the Primal Spirit":JerkinofthePrimalSpirit,
"Jerkin of the Savage Fang":JerkinoftheSavageFang,
"Jerkin of Vernant Fury":JerkinofVernantFury,
"Ji Pang-Ee":JiPangEe,
"Jovian Battle Cape":JovianBattleCape,
"Jovian Faith Cape":JovianFaithCape,
"Jovian Spirit Cape":JovianSpiritCape,
"Judgement":Judgement,
"Judicator Arcus":JudicatorArcus,
"Ka-Pusement's Token":KaPusementsToken,
"Kakaba Guide":KakabaGuide,
"Kal Gum":KalGum,
"Keening Edge":KeeningEdge,
"Kefmeh":Kefmeh,
"Keg of Asgardian Stout":KegofAsgardianStout,
"Keg of Hyrkanian Tonic":KegofHyrkanianTonic,
"Kel'Avashk Cap":KelAvashkCap,
"Kel'Avashk Robes":KelAvashkRobes,
"Kel'Avashk Sandals":KelAvashkSandals,
"Kel'Avashk Schenti":KelAvashkSchenti,
"Kerim's Blessing":KerimsBlessing,
"Kesht":Kesht,
"Khanjar of the Faceless Man":KhanjaroftheFacelessMan,
"Khemit":Khemit,
"Khorajan Agha Quiver":KhorajanAghaQuiver,
"Kiara's Gratitude":KiarasGratitude,
"Killer Rhino":KillerRhino,
"Kilt of the Amaranthine Drums":KiltoftheAmaranthineDrums,
"Kilt of the Primal Spirit":KiltofthePrimalSpirit,
"King Conan's Esteem":KingConansEsteem,
"King Conan's Tribute":KingConansTribute,
"Kiss of the White Hand":KissoftheWhiteHand,
"Knife of Dessication":KnifeofDessication,
"Knife of the Crawling Chaos":KnifeoftheCrawlingChaos,
"Knight of the Silver Twilight Token":KnightoftheSilverTwilightToken,
"Kopas of the Dunes":KopasoftheDunes,
"Kosalan Endurance":KosalanEndurance,
"Kosalan Enruned":KosalanEnruned,
"Kosalan Grace":KosalanGrace,
"Kosalan Might":KosalanMight,
"Kothian Battle Bracers":KothianBattleBracers,
"Kothian Battle Gauntlets":KothianBattleGauntlets,
"Kothian Battle Greaves":KothianBattleGreaves,
"Kothian Battle Helm":KothianBattleHelm,
"Kothian Breastplate":KothianBreastplate,
"Krakensbane":Krakensbane,
"Kris of the Star Coffin":KrisoftheStarCoffin,
"Kubri":Kubri,
"Kuthcheman Claymore":KuthchemanClaymore,
"Kuthchemen Cultist Shield":KuthchemanCultistShield,
"Kuthcheman Flamberge":KuthchemanFlamberge,
"Kuthcheman Great Hammer":KuthchemanGreatHammer,
"Kuthcheman Greatsword":KuthchemanGreatsword,
"Kuthcheman Guardsman Pike":KuthchemanGuardsmanPike,
"Kuthcheman Impaler":KuthchemanImpaler,
"Kuthcheman Longbow":KuthchemanLongbow,
"Kuthcheman Longsword":KuthchemanLongsword,
"Kuthcheman Pernach":KuthchemanPernach,
"Kuthcheman Sagaris":KuthchemanSagaris,
"Kuthcheman Tower Shield":KuthchemanTowerShield,
"Kuthcheman War Axe":KuthchemanWarAxe,
"Kuthcheman War Blade":KuthchemanWarBlade,
"Kuthcheman Zugite Staff":KuthchemanZugiteStaff,
"Lacunal Nexus":LacunalNexus,
"Lamentatus":Lamentatus,
"Lasting Faith Belt":LastingFaithBelt,
"Lasting Faith Boots":LastingFaithBoots,
"Lasting Faith Gauntlets":LastingFaithGauntlets,
"Lasting Faith Tasset":LastingFaithTasset,
"Lathe of Stars":LatheofStars,
"Lauded Curatic Band":LaudedCuraticBand,
"Laughing Auspices of the Celestials":LaughingAuspicesoftheCelestial,
"Left Hand of Nergal":LeftHandofNergal,
"Legend of Shevatas":LegendofShevatas,
"Leggings of a Thousand Blossoms":LeggingsofaThousandBlossoms,
"Leggings of Bedlam":LeggingsofBedlam,
"Leggings of Bestial Rage":LeggingsofBestialRage,
"Leggings of Black Whispers":LeggingsofBlackWhispers,
"Leggings of Bristling Ire":LeggingsofBristlingIre,
"Leggings of Clawing Might":LeggingsofClawingMight,
"Leggings of Concealing Shadows":LeggingsofConcealingShadows,
"Leggings of Dark Malice":LeggingsofDarkMalice,
"Leggings of Deadly Guile":LeggingsofDeadlyGuile,
"Leggings of Erlik":LeggingsofErlik,
"Leggings of Ferine Anger":LeggingsofFerineAnger,
"Leggings of Fiendish Invocation":LeggingsofFiendishInvocation,
"Leggings of Insanity":LeggingsofInsanity,
"Leggings of Intricate Spite":LeggingsofIntricateSpite,
"Leggings of Jagged Barbs":LeggingsofJaggedBarbs,
"Leggings of Light Unpresent":LeggingsofLightUnpresent,
"Leggings of Lunacy":LeggingsofLunacy,
"Leggings of Mirrored Heaven":LeggingsofMirroredHeaven,
"Leggings of Quilled Darts":LeggingsofQuilledDarts,
"Leggings of Reflection":LeggingsofReflection,
"Leggings of Swiftstriking":LeggingsofSwiftstriking,
"Leggings of the Blood God (nm)":LeggingsoftheBloodGodnm,
"Leggings of the Blood God":LeggingsoftheBloodGod,
"Leggings of the Clay":LeggingsoftheClay,
"Leggings of the Crawling Chaos":LeggingsoftheCrawlingChaos,
"Leggings of the Death God":LeggingsoftheDeathGod,
"Leggings of the Deathstalker":LeggingsoftheDeathstalker,
"Leggings of the Exorcist":LeggingsoftheExorcist,
"Leggings of the Faceless Chaos":LeggingsoftheFacelessChaos,
"Leggings of the Faceless Sphinx":LeggingsoftheFacelessSpinx,
"Leggings of the Farseeker":LeggingsoftheFarseeker,
"Leggings of the Firebrand":LeggingsoftheFirebrand,
"Leggings of the Furious Swipe":LeggingsoftheFuriousSwipe,
"Leggings of the Harbinger":LeggingsoftheHarbinger,
"Leggings of the Haunter in the Dark":LeggingsoftheHaunterintheDark,
"Leggings of the Howling Giant":LeggingsoftheHowlingGiant,
"Leggings of the Huntmaster":LeggingsoftheHuntmaster,
"Leggings of the Ichorous":LeggingsoftheIchorous,
"Leggings of the Kozak Slayer":LeggingsoftheKozakSlayer,
"Leggings of the Lector":LeggingsoftheLector,
"Leggings of the Nebulous":LeggingsoftheNebulous,
"Leggings of the Outer Dark":LeggingsoftheOuterDark,
"Leggings of the Oxmal":LeggingsoftheOxmal,
"Leggings of the Precursor":LeggingsofthePrecursor,
"Leggings of the Putrescent":LeggingsofthePutrescent,
"Leggings of the Ragereaver":LeggingsoftheRagereaver,
"Leggings of the Ravenflight":LeggingsoftheRavenflight,
"Leggings of the Refectory":LeggingsoftheRefectory,
"Leggings of the Rippling Lake":LeggingsoftheRipplingLake,
"Leggings of the Savage Fang":LeggingsoftheSavageFang,
"Leggings of the Sepulcher":LeggingsoftheSepulcher,
"Leggings of the Shivering Stars":LeggingsoftheShiveringStars,
"Leggings of the Silent Slayer":LeggingsoftheSilentSlayer,
"Leggings of the Spheres":LeggingsoftheSpheres,
"Leggings of the Starless Night":LeggingsoftheStarlessNight,
"Leggings of the Still Pond":LeggingsoftheStillPond,
"Leggings of the Strange Beyond":LeggingsoftheStrangeBeyond,
"Leggings of the Swift Talon":LeggingsoftheSwiftTalon,
"Leggings of the Ubah Kan":LeggingsoftheUbahKan,
"Leggings of the Unslaked":LeggingsoftheUnslaked,
"Leggings of the Unutterable":LeggingsoftheUnutterable,
"Leggings of the Usurper":LeggingsoftheUsurper,
"Leggings of the Wells of Night":LeggingsoftheWellsofNight,
"Leggings of Tranquility":LeggingsofTranquility,
"Leggings of Unrest":LeggingsofUnrest,
"Leggings of Untamed Violence":LeggingsofUntamedViolence,
"Leggings of Vernant Fury":LeggingsofVernantFury,
"Leggings of Vicious Frenzy":LeggingsofViciousFrenzy,
"Leggings of Vindictive Malice":LeggingsofVindictiveMalice,
"Leggings of Wild Furor":LeggingsofWildFuror,
"Legguards of Clarity":LegguardsofClarity,
"Legguards of Flowing Water":LegguardsofFlowingWater,
"Legguards of Reckless Challenge":LegguardsofRecklessChallenge,
"Legguards of the Anguished Heart":LegguardsoftheAnguishedHeart,
"Legguards of the Assailant":LegguardsoftheAssailant,
"Legguards of the Atlantean":LegguardsoftheAtlantean,
"Legguards of the Beyond":LegguardsoftheBeyond,
"Legguards of the Black Dragon":LegguardsoftheBlackDragon,
"Legguards of the Black Pharaoh":LegguardsoftheBlackPharaoh,
"Legguards of the Black Warden":LegguardsoftheBlackWarden,
"Legguards of Bloodlust":LegguardsoftheBloodlust,
"Legguards of the Crimson Fort":LegguardsoftheCrimsonFort,
"Legguards of the Dark Messenger":LegguardsoftheDarkMessenger,
"Legguards of the Dauntless":LegguardsoftheDauntless,
"Legguards of the Defiant":LegguardsoftheDefiant,
"Legguards of the Inconceivable":LegguardsoftheInconceivable,
"Legguards of the Living Tarim":LegguardsoftheLivingTarim,
"Legguards of the Membranous":LegguardsoftheMembranous,
"Legguards of the Milites Templi":LegguardsoftheMilitesTempli,
"Legguards of the Ostiary":LegguardsoftheOstiary,
"Legguards of the Renegade":LegguardsoftheRenegade,
"Legguards of the Revelations of Tarim":LegguardsoftheRevelationsofTarim,
"Legguards of the Tormentor":LegguardsoftheTormentor,
"Legguards of the Usurper":LegguardsoftheUsurper,
"Legguards of the Vanguard":LegguardsoftheVanguard,
"Legguards of the Wicked":LegguardsoftheWicked,
"Legguards of Writhing":LegguardsofWrithing,
"Legion Fighters Ring":LegionFightersRing,
"Legion Necklace":LegionNecklace,
"Legion Spellwarders Ring":LegionSpellwardersRing,
"Liberator's Greatsword":LiberatorsGreatsword,
"Liberator's Halberd":LiberatorsHalberd,
"Liberator's Trinket":LiberatorsTrinket,
"Lifebringer":Lifebringer,
"Lilting Bone Flute":LiltingBoneFlute,
"Link of the Other World":LinkoftheOtherWorld,
"Links of Cetriss":LinksofCetriss,
"Literatus Hood":LiteratusHood,
"Livery of the Dragon King":LiveryoftheDragonKing,
"Loincloth of the Darkwretch":LoinclothoftheDarkwretch,
"Loincloth of the Forsaken":LoinclothoftheForsaken,
"Loincloth of the Reanimator":LoinclothoftheReanimator,
"Longblade of the Sea":LongbladeoftheSea,
"Longspire":Longspire,
"Loop of the Hell Walker":LoopoftheHellWalker,
"Lord Atum-Keket's Cape":LordAtumKeketsCape,
"Lost Soul of Jovus":LostSoulofJovus,
"Lotus Talisman":LotusTalisman,
"Lucis":Lucis,
"Luctus":Luctus,
"Maahes' Crackling Spite":MaahesCracklingSpite,
"Mace of the Blood God":MaceoftheBloodGod,
"Mace of the Champion":MaceoftheChampion,
"Mace of the Cloudseer":MaceoftheCloudseer,
"Madfang":Madfang,
"Magewalk Slippers":MagewalkSlippers,
"Majestic Gloves":MajesticGloves,
"Malefactor's Claymore":MalefactorsClaymore,
"Malefactor's Quarterstaff":MalefactorsQuarterstaff,
"Malevolent Gauntlets":MalevolentGauntlets,
"Malice Band":MaliceBand,
"Mammuthus Shield":MammuthusShield,
"Manacles of the Endless Sands":ManaclesoftheEndlessSands,
"Maniacal Harm":ManiacalHarm,
"Manslayer":Manslayer,
"Mantle of Eleven Resplendent Prayers":MantleofElevenResplendentPrayers,
"Mantle of Valka's Wrath":MantleofValkasWrath,
"Marcelin Family Signum":MarcelinFamilySignum,
"Marcelin Pike":MarcelinPike,
"Marique's Bitchmage Cache":MariquesBitchmageCache,
"Marique's Goldscale Cache":MariquesGoldscaleCache,
"Marique's Black Leather Cache":MariquesBlackLeatherCache,
"Mark of Deception":MarkofDeception,
"Mark of Lightning":MarkofLightning,
"Mark of Metamorphosis":MarkofMetamorphosis,
"Mark of Suspicion":MarkofSuspicion,
"Mark of the Ancient Sands":MarkoftheAncientSands,
"Mark of the Endless Sands":MarkoftheEndlessSands,
"Mark of the Serpent King":MarkoftheSerpentKing,
"Marked Serpentweave":MarkedSerpentweave,
"Martial Cloak":MartialCloak,
"Mask of Acheron":MaskofAcheron,
"Mask of Ben Morgh":MaskofBenMorgh,
"Mask of Bestial Rage":MaskofBestialRage,
"Mask of Bristling Ire":MaskofBristlingIre,
"Mask of Conajohara":MaskofConajohara,
"Mask of Crimson Slaughter (nm)":MaskofCrimsonSlaughternm,
"Mask of Crimson Slaughter":MaskofCrimsonSlaughter,
"Mask of Red Ruin (nm)":MaskofRedRuinnm,
"Mask of Red Ruin":MaskofRedRuin,
"Mask of the Death God":MaskoftheDeathGod,
"Mask of the Death Master (nm)":MaskoftheDeathMasternm,
"Mask of the Death Master":MaskoftheDeathMaster,
"Mask of the Ghost of the Veldt":MaskoftheGhostoftheVeldt,
"Mask of the Great Impi":MaskoftheGreatImpi,
"Mask of the Harbinger":MaskoftheHarbinger,
"Mask of the Outer Dark":MaskoftheOuterDark,
"Mask of the Precursor":MaskofthePrecursor,
"Mask of the Starless Night":MaskoftheStarlessNight,
"Mask of the Strange Beyond":MaskoftheStrangeBeyond,
"Mask of Unsettled Minds":MaskofUnsettledMinds,
"Massacre":Massacre,
"Maul of Conajohara":MaulofConajohara,
"Maul of the Raging Earth":MauloftheRagingEarth,
"Maul of the Veiled Moon":MauloftheVeiledMoon,
"Mediator's Cloak":MediatorsCloak,
"Meditation Rod":MeditationRod,
"Medium's Armbands of Consumed Souls":MediumsArmbandsofConsumedSouls,
"Medium's Armbands of Secret Doors":MediumsArmbandsofSecretDoors,
"Medium's Belt of Consumed Souls":MediumsBeltofConsumedSouls,
"Medium's Belt of Secret Doors":MediumsBeltofSecretDoors,
"Medium's Boots of the Emissary":MediumsBootsoftheEmissary,
"Medium's Boots of the Kingmaker":MediumsBootsoftheKingmaker,
"Medium's Bracers of the Emissary":MediumsBracersoftheEmissary,
"Medium's Bracers of the Kingmaker":MediumsBracersoftheKingmaker,
"Medium's Gloves of Supreme Decree":MediumsGlovesofSupremeDecree,
"Medium's Gloves of the Dark Pact":MediumsGlovesoftheDarkPact,
"Medium's Hood of Consumed Souls":MediumsHoodofConsumedSouls,
"Medium's Hood of Secret Doors":MediumsHoodofSecretDoors,
"Medium's Leggings of Consumed Souls":MediumsLeggingsofConsumedSouls,
"Medium's Leggings of Secret Doors":MediumsLeggingsofSecretDoors,
"Medium's Robe of the Dark Pact":MediumsRobeoftheDarkPact,
"Medium's Tunic of Supreme Decree":MediumsTunicofSupremeDecree,
"Mercenary's Arm-straps of the Painted Claw":MercenarysArmstrapsofthePaintedClaw,
"Mercenary's Armbands of the Primeval":MercenarysArmbandsofthePrimeval,
"Mercenary's Armguards of the Savage Sun":MercenarysArmguardsoftheSavageSun,
"Mercenary's Belt of Grinning Skulls":MercenarysBeltofGrinningSkulls,
"Mercenary's Belt of Stalking Fury":MercenarysBeltofStalkingFury,
"Mercenary's Belt of the Elder Bond":MercenarysBeltoftheElderBond,
"Mercenary's Boots of Pierced Flesh":MercenarysBootsofPiercedFlesh,
"Mercenary's Boots of the Roaring Jungle":MercenarysBootsoftheRoaringJungle,
"Mercenary's Bracers of Crouching Calm":MercenarysBracersofCrouchingCalm,
"Mercenary's Bracers of the Untamed":MercenarysBracersoftheUntamed,
"Mercenary's Chestguard of the Roaring Jungle":MercenarysChestguardoftheRoaringJungle,
"Mercenary's Gauntlets of the Roaring Jungle":MercenarysGauntletsoftheRoaringJungle,
"Mercenary's Gauntlets of the Untamed":MercenarysGauntletsoftheUntamed,
"Mercenary's Girdle of the Second Caste":MercenarysGirdleoftheSecondCaste,
"Mercenary's Gloves of Crouching Calm":MercenarysGlovesofCrouchingCalm,
"Mercenary's Harness of the Untamed":MercenarysHarnessoftheUntamed,
"Mercenary's Helm of Grinning Skulls":MercenarysHelmofGrinningSkulls,
"Mercenary's Helm of Stalking Fury":MercenarysHelmofStalkingFury,
"Mercenary's Helm of the Elder Bond":MercenarysHelmoftheElderBond,
"Mercenary's Helm of the Second Caste":MercenarysHelmoftheSecondCaste,
"Mercenary's Jerkin of Crouching Calm":MercenarysJerkinofCrouchingCalm,
"Mercenary's Leggings of the Painted Claw":MercenarysLeggingsofthePaintedClaw,
"Mercenary's Leggings of the Primeval":MercenarysLeggingsofthePrimeval,
"Mercenary's Legguards of the Savage Sun":MercenarysLegguardsoftheSavageSun,
"Mercenary's Legguards of the Yellow Spring":MercenarysLegguardsoftheYellowSpring,
"Mercenary's Straps of Pierced Flesh":MercenarysStrapsofPiercedFlesh,
"Mercenary's Straps of the Yellow Spring":MercenarysStrapsoftheYellowSpring,
"Mercenary's Vambraces of the Roaring Jungle":MercenarysVambracesoftheRoaringJungle,
"Mercenary's Vest of Pierced Flesh":MercenarysVestofPiercedFlesh,
"Meru's Grand Staff":MerusGrandStaff,
"Miasmacies":Miasmacies,
"Might of the Serpent Men":MightoftheSerpentMen,
"Might of the Wrathful":MightoftheWrathful,
"Mind's Ire":MindsIre,
"Mindblaze Ring":MindblazeRing,
"Mindcurse Staff":MindcurseStaff,
"Mindwreath Cap":MindwreathCap,
"Mining Axe of the Oxmal":MiningAxeoftheOxmal,
"Mirror of Shadow":MirrorofShadow,
"Misery (blunt)":Miseryblunt,
"Misery":Misery,
"Missionary's Boots":MissionarysBoots,
"Missionary's Bracers":MissionarysBracers,
"Missionary's Rerebrace":MissionarysRerebrace,
"Missionary's Shield":MissionarysShield,
"Miter of the Cloudcleaver":MiteroftheCloudcleaver,
"Miter of the Judgment Bolt":MiteroftheJudgmentBolt,
"Miter of the Riftcaller":MiteroftheRiftcaller,
"Miter of the Sundered Skies":MiteroftheSunderedSkies,
"Mitra's Mark of Divine Blessings":MitrasMarkofDivineBlessings,
"Monk's Arm-straps of the Underworld":MonksArmstrapsoftheUnderworld,
"Monk's Armbands of the Eighteen Pits":MonksArmbandsoftheEighteenPits,
"Monk's Belt of the Nine Springs":MonksBeltoftheNineSprings,
"Monk's Belt of the Underworld":MonksBeltoftheUnderworld,
"Monk's Boots of Sacrifice":MonksBootsofSacrifice,
"Monk's Boots of the Earthen Prison":MonksBootsoftheEarthenPrison,
"Monk's Boots of the Hallow Worlds":MonksBootsoftheHallowWorlds,
"Monk's Boots of the Limitless Cipher":MonksBootsoftheLimitlessCipher,
"Monk's Bracers of the Earthen Prison":MonksBracersoftheEarthenPrison,
"Monk's Bracers of the Hallow Worlds":MonksBracersoftheHallowWorlds,
"Monk's Bracers of the Limitless Cipher":MonksBracersoftheLimitlessCipher,
"Monk's Gauntlets of the Spilling Blood":MonksGauntletsoftheSpillingBlood,
"Monk's Girdle of the Eighteen Pits":MonksGirdleoftheEighteenPits,
"Monk's Gloves of Balance":MonksGlovesofBalance,
"Monk's Gloves of the Black Thread":MonksGlovesoftheBlackThread,
"Monk's Gloves of the Sacred Mountain":MonksGlovesoftheSacredMountain,
"Monk's Harness of the Spilling Blood":MonksHarnessoftheSpillingBlood,
"Monk's Helm of the Abyss":MonksHelmoftheAbyss,
"Monk's Helm of the Eighteen Pits":MonksHelmoftheEighteenPits,
"Monk's Hood of the Underworld":MonksHoodoftheUnderworld,
"Monk's Jerkin of the Sacred Mountain":MonksJerkinoftheSacredMountain,
"Monk's Leggings of the Nine Springs":MonksLeggingsoftheNineSprings,
"Monk's Legguards of the Abyss":MonksLegguardsoftheAbyss,
"Monk's Mask of the Nine Springs":MonksMaskoftheNineSprings,
"Monk's Robes of Balance":MonksRobesofBalance,
"Monk's Straps of Sacrifice":MonksStrapsofSacrifice,
"Monk's Straps of the Abyss":MonksStrapsoftheAbyss,
"Monk's Straps of the Nine Springs":MonksStrapsoftheNineSprings,
"Monk's Threads of the Underworld":MonksThreadsoftheUnderworld,
"Monk's Tunic of the Black Thread":MonksTunicoftheBlackThread,
"Mordec Belt":MordecBelt,
"Mordec Blade":MordecBlade,
"Mordec Boots":MordecBoots,
"Mordec Gauntlets":MordecGauntlets,
"Mordec Greaves":MordecGreaves,
"Mordec Hammer":MordecHammer,
"Mortiferous Boots":MortiferousBoots,
"Mortiferous Chestguard":MortiferousChestguard,
"Mortiferous Helm":MortiferousHelm,
"Mortiferous Tasset":MortiferousTasset,
"Mystic's Armbands of the Soaring Heart":MysticsArmbandsoftheSoaringHeart,
"Mystic's Bands of the Three Clarities":MysticsBandsoftheThreeClarities,
"Mystic's Belt of the Exalted Spirit":MysticsBeltoftheExaltedSpirit,
"Mystic's Belt of the Soaring God":MysticsBeltoftheSoaringGod,
"Mystic's Boots of the Crumbling Tower":MysticsBootsoftheCrumblingTower,
"Mystic's Boots of the Purple Sun":MysticsBootsofthePurpleSun,
"Mystic's Bracers of the Crumbling Tower":MysticsBracersoftheCrumblingTower,
"Mystic's Bracers of the Purple Sun":MysticsBracersofthePurpleSun,
"Mystic's Braid of Shimmering Light":MysticsBraidofShimmeringLight,
"Mystic's Breastplate of the Aureate":MysticsBreastplateoftheAureate,
"Mystic's Cover of Yag":MysticsCoverofYag,
"Mystic's Coverings of Shimmering Light":MysticsCoveringsofShimmeringLight,
"Mystic's Delight":MysticsDelight,
"Mystic's Gauntlets of the Crumbling Tower":MysticsGauntletsoftheCrumblingTower,
"Mystic's Girdle of the Bloody Stone":MysticsGirdleoftheBloodyStone,
"Mystic's Gloves of the Eldritch":MysticsGlovesoftheEldritch,
"Mystic's Gloves of the Purple Sun":MysticsGlovesofthePurpleSun,
"Mystic's Hand-wraps of the Aureate":MysticsHandwrapsoftheAureate,
"Mystic's Harness of the Crumbling Tower":MysticsHarnessoftheCrumblingTower,
"Mystic's Helm of the Bloody Stone":MysticsHelmoftheBloodyStone,
"Mystic's Helm of the Soaring God":MysticsHelmoftheSoaringGod,
"Mystic's Leggings of the Soaring Heart":MysticsLeggingsoftheSoaringHeart,
"Mystic's Leggings of the Three Clarities":MysticsLeggingsoftheThreeClarities,
"Mystic's Legguards of the Green Ones":MysticsLegguardsoftheGreenOnes,
"Mystic's Mask of the Exalted Spirit":MysticsMaskoftheExaltedSpirit,
"Mystic's Sash of Yag":MysticsSashofYag,
"Mystic's Shoes of the Aureate":MysticsShoesoftheAureate,
"Mystic's Straps of the Aureate":MysticsStrapsoftheAureate,
"Mystic's Straps of the Green Ones":MysticsStrapsoftheGreenOnes,
"Mystic's Vestment of the Eldritch":MysticsVestmentoftheEldritch,
"Mystic's Wrist-straps of the Eldritch":MysticsWriststrapsoftheEldritch,
"Nakush":Nakush,
"Nakuum":Nakuum,
"Nameless Glaive":NamelessGlaive,
"Necklace of the Freezing Gale":NecklaceofFreezingGale,
"Necklace of Relentless Bellicosity":NecklaceofRelentlessBellicosity,
"Necklace of the Manic Haze":NecklaceoftheManicHaze,
"Necklace of the Primal Spirit":NecklaceofthePrimalSpirit,
"Necklace of Thousand Souls":NecklaceofThousandSouls,
"Necklace of Tireless Sagacity":NecklaceofTirelessSagacity,
"Necklace of Wormfire":NecklaceofWormfire,
"Needlebag":Needlebag,
"Needles of Bone and Horn":NeedlesofBoneandHorn,
"Needles of the Freezing Gale":NeedlesoftheFreezingGale,
"Nefarious Chest":NefariousChest,
"Nehfu":Nehfu,
"Neith":Neith,
"Nemedian Skinning Knife":NemedianSkinningKnife,
"Nemesis":Nemesis,
"Neophyte's Armbands of Sovereign Rule":NeophytesArmbandsofSovereignRule,
"Neophyte's Armbands of Supreme Decree":NeophytesArmbandsofSupremeDecree,
"Neophyte's Armbands of the Dark Pact":NeophytesArmbandsoftheDarkPact,
"Neophyte's Armbands of the Mandate":NeophytesArmbandsoftheMandate,
"Neophyte's Belt of Regal Might":NeophytesBeltofRegalMight,
"Neophyte's Belt of the Emissary":NeophytesBeltoftheEmissary,
"Neophyte's Belt of the Kingmaker":NeophytesBeltoftheKingmaker,
"Neophyte's Boots of Consumed Souls":NeophytesBootsofConsumedSouls,
"Neophyte's Boots of Imperial Assent":NeophytesBootsofImperialAssent,
"Neophyte's Boots of Secret Doors":NeophytesBootsofSecretDoors,
"Neophyte's Bracers of Consumed Souls":NeophytesBracersofConsumedSouls,
"Neophyte's Bracers of Imperial Assent":NeophytesBracersofImperialAssent,
"Neophyte's Bracers of Prestige":NeophytesBracersofPrestige,
"Neophyte's Bracers of Secret Doors":NeophytesBracersofSecretDoors,
"Neophyte's Gauntlets of the Emperor's Favor":NeophytesGauntletsoftheEmperorsFavor,
"Neophyte's Girdle of the Emperor's Favor":NeophytesGirdleoftheEmperorsFavor,
"Neophyte's Gloves of Regal Might":NeophytesGlovesofRegalMight,
"Neophyte's Gloves of the Emissary":NeophytesGlovesoftheEmissary,
"Neophyte's Gloves of the Kingmaker":NeophytesGlovesoftheKingmaker,
"Neophyte's Hood of Consumed Souls":NeophytesHoodofConsumedSouls,
"Neophyte's Hood of Prestige":NeophytesHoodofPrestige,
"Neophyte's Hood of Secret Doors":NeophytesHoodofSecretDoors,
"Neophyte's Leggings of Supreme Decree":NeophytesLeggingsofSupremeDecree,
"Neophyte's Leggings of the Dark Pact":NeophytesLeggingsoftheDarkPact,
"Neophyte's Leggings of the Mandate":NeophytesLeggingsoftheMandate,
"Neophyte's Pants of Sovereign Rule":NeophytesPantsofSovereignRule,
"Neophyte's Robe of Consumed Souls":NeophytesRobeofConsumedSouls,
"Neophyte's Robes of Imperial Assent":NeophytesRobesofImperialAssent,
"Neophyte's Tunic of Secret Doors":NeophytesTunicofSecretDoors,
"Nergal's Bludgeon of Agonizing Wounds":NergalsBludgeonofAgonizingWounds,
"Nergal's Lantern of the Burning Sky":NergalsLanternoftheBurningSky,
"Nergal's Ring of the Burning Sky":NergalsRingoftheBurningSky,
"Nergal's Ring of the Eternal Storm":NergalsRingoftheEternalStorm,
"Nergal's Scimiter of the Burning Sky":NergalsScimiteroftheBurningSky,
"Nergal's Trident of the Eternal Storm":NergalsTridentoftheEternalStorm,
"Nescient Helm":NescientHelm,
"Neter":Neter,
"Nggoth":Nggoth,
"Night's Shroud":NightsShroud,
"Nightlord Bracers":NightlordBracers,
"Nihilistic Armbands":NihilisticArmbands,
"Nihilistic Cowl":NihilisticCowl,
"Nihilistic Gloves":NihilisticGloves,
"Nihilistic Pants":NihilisticPants,
"Nihilistic Robe":NihilisticRobe,
"Nihilistic Sash":NihilisticSash,
"Nihilistic Slippers":NihilisticSlippers,
"Nihilistic Wristbands":NihilisticWristbands,
"Nilus the Blood Wake":NilustheBloodWake,
"Nimbus":Nimbus,
"Nithing Beheader":NithingBeheader,
"Nithing Crossbow":NithingCrossbow,
"Nithing Fang":NithingFang,
"Nogg's Club of Hate":NoggsClubofHate,
"Nogg's Needle":NoggsNeedle,
"North Cleave of the Black Tortoise":NorthCleaveoftheBlackTortoise,
"Northern Frostcape":NorthernFrostcape,
"Nourishing Thoughts":NourishingThoughts,
"Obdurate Mace":ObdurateMace,
"Obliteratus":Obliteratus,
"Occult Gem of Dexterity":OccultGemofDexterity,
"Occult Gem of Strength":OccultGemofStrength,
"Okush":Okush,
"Ophidian Band":OphidianBand,
"Opus Adnullatus":OpusAdnullatus,
"Opus Ignis":OpusIgnis,
"Opus of Ash and Blood":OpusofAshandBlood,
"Orastes's Robe":OrastessRobe,
"Orb Shard":OrbShard,
"Otherworldly Flute":OtherworldlyFlute,
"Ouroboros Ring":OuroborosRing,
"Outcast Mage's Cache":OutcastMagesCache,
"Oxleg":Oxleg,
"Packleader Jerkin":PackleaderJerkin,
"Padsoles of Black Whispers":PadsolesofBlackWhispers,
"Padsoles of Dark Malice":PadsolesofDarkMalice,
"Padsoles of Deadly Guile":PadsolesofDeadlyGuile,
"Padsoles of the Silent Slayer":PadsolesoftheSilentSlayer,
"Pain of the Damned":PainoftheDamned,
"Pain's Edge":PainsEdge,
"Paladin's Baneblade":PaladinsBaneblade,
"Paladin's Siege Shield":PaladinsSiegeShield,
"Paladin's Widowmaker":PaladinsWidowmaker,
"Pallid Engraver":PallidEngraver,
"Pallidus Libram":PallidusLibram,
"Panoptic Pirate Ring":PanopticPirateRing,
"Parched Blade of Slaughter Wine":ParchedBladeofSlaughterWine,
"Partizan of Red Ruin":PartizanofRedRuin,
"Path of Ahriman":PathofAhriman,
"Path of the Enlightened":PathoftheEnlightened,
"Pathfinder's Loop":PathfindersLoop,
"Patron Vambraces":PatronVambraces,
"Patronage of the Four Fiends":PatronageoftheFourFiends,
"Pauldron of the Steel Behemoth":PauldronoftheSteelBehemoth,
"Pauldrons of Indra":PauldronsofIndra,
"Pavis of Fealty":PavisofFealty,
"Pearl of Heaven":PearlofHeaven,
"Pearl Ring of Assault":PearlRingofAssault,
"Pendant of Blessing":PendantofBlessing,
"Pendant of Contention":PendantofContention,
"Pendant of Preservation":PendantofPreservation,
"Pendant of Shielding":PendantofShielding,
"Pendant of the Legion Commander":PendantoftheLegionCommander,
"Pendant of the Penitent Pilgrim":PendantofthePenitentPilgrim,
"Pendant of Tribulations Everlasting":PendantofTribulationsEverlasting,
"Perennial Girdle":PerennialGirdle,
"Permanent Travelling Merchant Contract":PermanentTravellingMerchantContract,
"Petals of Lilium":PetalsofLilium,
"Phantom Ward":PhantomWard,
"Pharaoh's Guard Cache":PharohsGuardCache,
"Phial of Heavenly Knowledge":PhialofHeavenlyKnowledge,
"Philosopher Armbands":PhilosopherArmbands,
"Phortahz Crossbow":PhortahzCrossbow,
"Pickaxe of the Ubah Kan":PickaxeoftheUbahKan,
"Pickpocket's Armbands of the Deceiver":PickpocketsArmbandsoftheDeceiver,
"Pickpocket's Armbands of the Smoldering Throne":PickpocketsArmbandsoftheSmolderingThrone,
"Pickpocket's Bands of the Fifth Stage":PickpocketsBandsoftheFifthStage,
"Pickpocket's Belt of Engulfing Twilight":PickpocketsBeltofEngulfingTwilight,
"Pickpocket's Belt of the Nadir":PickpocketsBeltoftheNadir,
"Pickpocket's Belt of the Sundered Crown":PickpocketsBeltoftheSunderedCrown,
"Pickpocket's Belt of the Swift Return":PickpocketsBeltoftheSwiftReturn,
"Pickpocket's Boots of the Burning Temple":PickpocketsBootsoftheBurningTemple,
"Pickpocket's Boots of the Final Way":PickpocketsBootsoftheFinalWay,
"Pickpocket's Bracers of the Burning Temple":PickpocketsBracersoftheBurningTemple,
"Pickpocket's Bracers of the Hidden Palace":PickpocketsBracersoftheHiddenPalace,
"Pickpocket's Bracers of the Tenth Court":PickpocketsBracersoftheTenthCourt,
"Pickpocket's Gloves of Engulfing Twilight":PickpocketsGlovesofEngulfingTwilight,
"Pickpocket's Gloves of the Nadir":PickpocketsGlovesoftheNadir,
"Pickpocket's Gloves of the Sundered Crown":PickpocketsGlovesoftheSunderedCrown,
"Pickpocket's Gloves of the Swift Return":PickpocketsGlovesoftheSwiftReturn,
"Pickpocket's Helm of the Hidden Palace":PickpocketsHelmoftheHiddenPalace,
"Pickpocket's Jerkin of the Hidden Palace":PickpocketsJerkinoftheHiddenPalace,
"Pickpocket's Jerkin of the Tenth Court":PickpocketsJerkinoftheTenthCourt,
"Pickpocket's Leggings of the Deceiver":PickpocketsLeggingsoftheDeceiver,
"Pickpocket's Leggings of the Fifth Stage":PickpocketsLeggingsoftheFifthStage,
"Pickpocket's Leggings of the Smoldering Throne":PickpocketsLeggingsoftheSmolderingThrone,
"Pickpocket's Legguards of the Stolen Kingdom":PickpocketsLegguardsoftheStolenKingdom,
"Pickpocket's Mask of the Burning Temple":PickpocketsMaskoftheBurningTemple,
"Pickpocket's Mask of the Final Way":PickpocketsMaskoftheFinalWay,
"Pickpocket's Straps of the Stolen Kingdom":PickpocketsStrapsoftheStolenKingdom,
"Pickpocket's Tunic of the Final Way":PickpocketsTunicoftheFinalWay,
"Pickpocket's Wristbands of the Final Way":PickpocketsWristbandsoftheFinalway,
"Pilgrim's Armbands of the Bloody Stone":PilgrimsArmbandsoftheBloodyStone,
"Pilgrim's Bands of the Exalted Spirit":PilgrimsBandsoftheExaltedSpirit,
"Pilgrim's Belt of Shimmering Light":PilgrimsBeltofShimmeringLight,
"Pilgrim's Belt of the Green Ones":PilgrimsBeltoftheGreenOnes,
"Pilgrim's Belt of the Three Clarities":PilgrimsBeltoftheThreeClarities,
"Pilgrim's Boots of the Crumbling Tower":PilgrimsBootsoftheCrumblingTower,
"Pilgrim's Boots of the Purple Sun":PilgrimsBootsofthePurpleSun,
"Pilgrim's Bracers of the Purple Sun":PilgrimsBracersofthePurpleSun,
"Pilgrim's Braid of Yag":PilgrimsBraidofYag,
"Pilgrim's Cloth of Yag":PilgrimsClothofYag,
"Pilgrim's Gauntlets of the Soaring Heart":PilgrimsGauntletsoftheSoaringHeart,
"Pilgrim's Girdle of the Soaring Heart":PilgrimsGirdleoftheSoaringHeart,
"Pilgrim's Gloves of Shimmering Light":PilgrimsGlovesofShimmeringLight,
"Pilgrim's Gloves of the Green Ones":PilgrimsGlovesoftheGreenOnes,
"Pilgrim's Harness of the Crumbling Tower":PilgrimsHarnessoftheCrumblingTower,
"Pilgrim's Headband":PilgrimsHeadband,
"Pilgrim's Headress":PilgrimsHeaddress,
"Pilgrim's Helm of the Crumbling Tower":PilgrimsHelmoftheCrumblingTower,
"Pilgrim's Helm of the Purple Sun":PilgrimsHelmofthePurpleSun,
"Pilgrim's Helmet":PilgrimsHelmet,
"Pilgrim's Hood of the Aureate":PilgrimsHoodoftheAureate,
"Pilgrims Hood of the Eldritch":PilgrimsHoodoftheEldritch,
"Pilgrim's Jerkin of the Aureate":PilgrimsJerkinoftheAureate,
"Pilgrim's Jerkin of the Purple Sun":PilgrimsJerkinofthePurpleSun,
"Pilgrim's Leather Helm":PilgrimsLeatherHelm,
"Pilgrim's Leggings of the Bloody Stone":PilgrimsLeggingsoftheBloodyStone,
"Pilgrim's Leggings of the Exalted Spirit":PilgrimsLeggingsoftheExaltedSpirit,
"Pilgrim's Legguards of the Soaring God":PilgrimsLegguardsoftheSoaringGod,
"Pilgrim's Robes of the Eldritch":PilgrimsRobesoftheEldritch,
"Pilgrim's Sandals of the Eldritch":PilgrimsSandalsoftheEldritch,
"Pilgrim's Straps of the Aureate":PilgrimsStrapsoftheAureate,
"Pilgrim's Straps of the Soaring God":PilgrimsStrapsoftheSoaringGod,
"Pilgrim's Wraps of the Three Clarities":PilgrimsWrapsoftheThreeClarities,
"Pilgrim's Wrist-straps of the Eldritch":PilgrimsWriststrapsoftheEldritch,
"Pit Fighter's Clawed Cord":PitFightersClawedCord,
"Pit Fighter's Frayed Choker":PitFightersFrayedChoker,
"Pit Fighter's Gorget":PitFightersGorget,
"Pit Fighter's Heretical Eye":PitFightersHereticalEye,
"Pit Fighter's Icon of Rapture":PitFightersIconofRapture,
"Pit Fighter's Remembrance":PitFightersRemembrance,
"Pit Fighter's Tattered Choker":PitFightersTatteredChoker,
"Imbued Pit Fighter's Clawed Cord":PitFightersClawedCord,
"Imbued Pit Fighter's Frayed Choker":PitFightersFrayedChoker,
"Imbued Pit Fighter's Gorget":PitFightersGorget,
"Imbued Pit Fighter's Heretical Eye":PitFightersHereticalEye,
"Imbued Pit Fighter's Icon of Rapture":PitFightersIconofRapture,
"Imbued Pit Fighter's Remembrance":PitFightersRemembrance,
"Imbued Pit Fighter's Tattered Choker":PitFightersTatteredChoker,
"Pitfighter's Battle Cache":PitfightersBattleCache,
"Pitiless Arm-strap":PitilessArmstrap,
"Plackart of the Steel Behemoth":PlackartoftheSteelBehemoth,
"Plumed Helm of Divinity":PlumedHelmofDivinity,
"Po-Sha Longsword":PoShaLongsword,
"Poderes of Celestial Radiance":PoderesofCelestialRadiance,
"Poderes of Effulgent Devotion":PoderesofEffulgentDevotion,
"Poderes of Illuminant Conviction":PoderesofIlluminantConviction,
"Poderes of the Ascension":PoderesoftheAscension,
"Polearm of the Black Pharaoh":PolearmoftheBlackPharaoh,
"Praeceptum Bands":PraeceptumBands,
"Praetoric Arbitrator":PraetoricArbitrator,
"Priest's Belt of the Black Thread":PriestsBeltoftheBlackThread,
"Priest's Boots of the Nine Springs":PriestsBootsoftheNineSprings,
"Priest's Boots of the Underworld":PriestsBootsoftheUnderworld,
"Priest's Bracers of the Nine Springs":PriestsBracersoftheNineSprings,
"Priest's Coils of Sacrifice":PriestsCoilsofSacrifice,
"Priest's Cord of Balance":PriestsCordofBalance,
"Priest's Crest of Balance":PriestsCrestofBalance,
"Priest's Fauld of the Limitless Cipher":PriestsFauldoftheLimitlessCipher,
"Priest's Gloves of the Underworld":PriestsGlovesoftheUnderworld,
"Priest's Raiment of the Underworld":PriestsRaimentoftheUnderworld,
"Priest's Straps of the Limitless Cipher":PriestsStrapsoftheLimitlessCipher,
"Priest's Straps of the Underworld":PriestsStrapsoftheUnderworld,
"Priest's Threads of Sacrifice":PriestsThreadsofSacrifice,
"Priest's Visage of the Black Thread":PriestsVisageoftheBlackThread,
"Prize of Zamora":PrizeofZamora,
"Profane Opus":ProfaneOpus,
"Projectiles of the Blood Drinker":ProjectilesoftheBloodDrinker,
"Prophet's Cache of Oblivion":ProphetsCacheofOblivion,
"Proselite Armbands":ProseliteArmbands,
"Pungent Absorber":PungentAbsorber,
"Pureblood Girdle":PurebloodGirdle,
"Putharjath's Legacy":PutharjathsLegacy,
"Putrescent Blade":PutrescentBlade,
"Quartermaster's Band":QuartermastersBand,
"Quartermaster's Remedial Band":QuartermastersRemedialBand,
"Quartermaster's War Band":QuartermastersWarBand,
"Queen Blade":QueenBlade,
"Quickening Atlantean Catalyst":QuickeningAtlanteanCatalyst,
"Quickness of the Katari":QuicknessoftheKatari,
"Quicksense Ring":QuicksenseRing,
"Quicksilver":Quicksilver,
"Quicksilvered Leggings":QuicksilveredLeggings,
"Quill of Ibis":QuillofIbis,
"Quiver of Barbed Tongues":QuiverofBarbedTongues,
"Quiver of Black Asps":QuiverofBlackAsps,
"Quiver of Raked Flesh":QuiverofRakedFlesh,
"Radiant Charm of Fury":RadiantCharmofFury,
"Rage of Xotli":RageofXotli,
"Raider's Armbands of the Covert Trail":RaidersArmbandsoftheCovertTrail,
"Raider's Armbands of World's Edge":RaidersArmbandsofWorldsEdge,
"Raider's Belt of the Covert Trail":RaidersBeltoftheCovertTrail,
"Raider's Belt of the Grasslands":RaidersBeltoftheGrasslands,
"Raider's Belt of the Wicked Hearth":RaidersBeltoftheWickedHearth,
"Raider's Belt of World's Edge":RaidersBeltofWorldsEdge,
"Raider's Boots of a Hundred Eyes":RaidersBootsofaHundredEyes,
"Raider's Boots of the Grasping Wild":RaidersBootsoftheGraspingWild,
"Raider's Boots of the Howling Moon":RaidersBootsoftheHowlingMoon,
"Raider's Boots of the Howling Wind":RaidersBootsoftheHowlingWind,
"Raider's Chestguard of the Khan":RaidersChestguardoftheKhan,
"Raider's Feral War Ring":RaidersFeralWarRing,
"Raider's Gauntlets of the Khan":RaidersGauntletsoftheKhan,
"Raider's Gloves of the Bloody Fang":RaidersGlovesoftheBloodyFang,
"Raider's Gloves of the Ritual Flame":RaidersGlovesoftheRitualFlame,
"Raider's Gloves of Woven Clouds":RaidersGlovesofWovenClouds,
"Raider's Helm of the Grasslands":RaidersHelmoftheGrasslands,
"Raider's Hood of World's Edge":RaidersHoodofWorldsEdge,
"Raider's Jerkin of the Ritual Flame":RaidersJerkinoftheRitualFlame,
"Raider's Jerkin of Woven Clouds":RaidersJerkinofWovenClouds,
"Raider's Leggings of the Covert Trail":RaidersLeggingsoftheCovertTrail,
"Raider's Leggings of the Wicked Hearth":RaidersLeggingsoftheWickedHearth,
"Raider's Leggings of World's Edge":RaidersLeggingsofWorldsEdge,
"Raider's Mask of the Covert Trail":RaidersMaskoftheCovertTrail,
"Raider's Straps of a Hundred Eyes":RaidersStrapsofaHundredEyes,
"Raider's Straps of the Grasping Wild":RaidersStrapsoftheGraspingWild,
"Raider's Tunic of the Bloody Fang":RaidersTunicoftheBloodyFang,
"Raider's Vambraces of the Howling Moon":RaidersVambracesoftheHowlingMoon,
"Raider's Wristbands of the Howling Wind":RaidersWristbandsoftheHowlingWind,
"Rain of the Responding Dragon":RainofRespondingDragon,
"Ramnyr":Ramnyr,
"Rare Relic":RareRelic,
"Rattlecurse":Rattlecurse,
"Raven's Feast":RavensFeast,
"Ravenbone Pauldrons":RavenbonePauldrons,
"Ravenclaw Armbands":RavenclawArmbands,
"Ravenclaw Bracers":RavenclawBracers,
"Ravenclaw Helm":RavenclawHelm,
"Ravenclaw Tasset":RavenclawTasset,
"Ravenkin Gloves":RavenkinGloves,
"Ravenkin Hood":RavenkinHood,
"Ravensilk Leggings":RavensilkLeggings,
"Ravensilk Vest":RavensilkVest,
"Razhar":Razhar,
"Razor of the Divinity Serpent":RazoroftheDivinitySerpent,
"Reader's Arm-straps of the Crescent":ReadersArmstrapsoftheCrescent,
"Reader's Arm-straps of the Moon":ReadersArmstrapsoftheMoon,
"Reader's Armbands of the Burning Disc":ReadersArmbandsoftheBurningDisc,
"Reader's Armbands of the Effulgent Blade":ReadersArmbandsoftheEffulgentBlade,
"Reader's Bands of the Exiled":ReadersBandsoftheExiled,
"Reader's Belt of the Burning Disc":ReadersBeltoftheBurningDisc,
"Reader's Belt of the Crescent":ReadersBeltoftheCrescent,
"Reader's Belt of the Effulgent Blade":ReadersBeltoftheEffulgentBlade,
"Reader's Belt of the Moon":ReadersBeltoftheMoon,
"Reader's Boots of the Celestial Hilt":ReadersBootsoftheCelestialHilt,
"Reader's Boots of the Exiled":ReadersBootsoftheExiled,
"Reader's Boots of Twining Smoke":ReadersBootsofTwiningSmoke,
"Reader's Bracelets of Awakening":ReadersBraceletsofAwakening,
"Reader's Bracers of Twining Smoke":ReadersBracersofTwiningSmoke,
"Reader's Cowl of the Crescent":ReadersCowloftheCrescent,
"Reader's Cowl of the Effulgent Blade":ReadersCowloftheEffulgentBlade,
"Reader's Gloves of the Eternal Eclipse":ReadersGlovesoftheEternalEclipse,
"Reader's Gloves of the Forbidden Art":ReadersGlovesoftheForbiddenArt,
"Reader's Gloves of the Heavens":ReadersGlovesoftheHeavens,
"Reader's Gloves of the Waning Moon":ReadersGlovesoftheWaningMoon,
"Reader's Hood of the Burning Disc":ReadersHoodoftheBurningDisc,
"Reader's Leggings of the Effulgent Blade":ReadersLeggingsoftheEffulgentBlade,
"Reader's Leggings of the Moon":ReadersLeggingsoftheMoon,
"Reader's Robes of the Heavens":ReadersRobesoftheHeavens,
"Reader's Robes of the Waning Moon":ReadersRobesoftheWaningMoon,
"Reader's Sandals of Awakening":ReadersSandalsofAwakening,
"Reader's Tunic of the Eternal Eclipse":ReadersTunicoftheEternalEclipse,
"Reader's Tunic of the Forbidden Art":ReadersTunicoftheForbiddenArt,
"Reader's Wristbands of the Celestial Hilt":ReadersWristbandsoftheCelestialHilt,
"Reaper":Reaper,
"Rebel's Battleaxe":RebelsBattleaxe,
"Rebel's Dagger":RebelsDagger,
"Rebel's Longbow":RebelsLongbow,
"Recruit's Agility":RecruitsAgility,
"Recruit's Cloak":RecruitsCloak,
"Recruit's Intellect":RecruitsIntellect,
"Recruit's Potency":RecruitsPotency,
"Recruit's Strength":RecruitsStrength,
"Recruit's Vigor":RecruitsVigor,
"Recurve Bow of Impossible Vines":RecurveBowofImpossibleVines,
"Redblood Cloak":RedbloodCloak,
"Reddened Lacerator":ReddenedLacerator,
"Redfang":Redfang,
"Redfury War Wolf":RedfuryWarWolf,
"Redspray":Redspray,
"Redtalon Gauntlets":RedtalonGauntlets,
"Rejuvinating Shoulders":RejuvinatingShoulders,
"Relic of Dark Blessings":RelicofDarkBlessings,
"Relic of Fallen Stars":RelicofFallenStars,
"Relic of the Ancient Sands":RelicoftheAncientSands,
"Relic of the Hell Walker":RelicoftheHellWalker,
"Relic of the Oyster Mucus":RelicoftheOysterMucus,
"Reliving Mantram":RelivingMantram,
"Remorse":Remorse,
"Renato's Bow":RenatosBow,
"Renato's Crossbow":RenatosCrossbow,
"Repressor's Codex":RepressorsCodex,
"Repressor's Dagger":RepressorsDagger,
"Repressor's Flamebrand":RepressorsFlamebrand,
"Repressor's Trident":RepressorsTrident,
"Requiem of Pain":RequiemofPain,
"Rerebrace of Red Ruin (nm)":RerebraceofRedRuinnm,
"Rerebrace of Red Ruin":RerebraceofRedRuin,
"Rerebrace of the Blood Drinker (nm)":RerebraceoftheBloodDrinkernm,
"Rerebrace of the Blood Drinker":RerebraceoftheBloodDrinker,
"Rerebrace of the Death Master (nm)":RerebraceoftheDeathMasternm,
"Rerebrace of the Death Master":RerebraceoftheDeathMaster,
"Rerebrace of the Fallen Empire (nm)":RerebraceoftheFallenEmpirenm,
"Rerebrace of the Fallen Empire":RerebraceoftheFallenEmpire,
"Rerebrace of the Sanguine Disciple (nm)":RerebraceoftheSanguineDisciplenm,
"Rerebrace of the Sanguine Disciple":RerebraceoftheSanguineDisciple,
"Restorative Ring":RestorativeRing,
"Retribution":Retribution,
"Revenant Ring":RevenantRing,
"Revivifying Atlantean Catalyst":RevivfyingAtlanteanCatalyst,
"Right Hand of Nergal":RightHandofNergal,
"Ring of Amra the Lion":RingofAmratheLion,
"Ring of Anarchy":RingofAnarchy,
"Ring of Ancient Python":RingofAncientPython,
"Ring of Broken Promises":RingofBrokenPromises,
"Ring of Chthonic Nightmares":RingofChthonicNightmares,
"Ring of Conservation":RingofConservation,
"Ring of Corruption":RingofCorruption,
"Ring of Dagon":RingofDagon,
"Ring of Flaming Fury":RingofFlamingFury,
"Ring of Grounding":RingofGrounding,
"Ring of Impossible Secrets":RingofImpossibleSecrets,
"Ring of Insightful Action":RingofInsightfulAction,
"Ring of Intent":RingofIntent,
"Ring of Iron Skin":RingofIronSkin,
"Ring of Katar":RingofKatar,
"Ring of Memory":RingofMemory,
"Ring of Mordec":RingofMordec,
"Ring of Old Acheron":RingofOldAcheron,
"Ring of Profane Knowledge":RingofProfaneKnowledge,
"Ring of Protection":RingofProtection,
"Ring of Resolve":RingofResolve,
"Ring of Scalding":RingofScalding,
"Ring of Skelos":RingofSkelos,
"Ring of Swift Storms":RingofSwiftStorms,
"Ring of the Arsonist":RingoftheArsonist,
"Ring of the Astral Step":RingoftheAstralStep,
"Ring of the Burning Beacon":RingoftheBurningBeacon,
"Ring of the Excavator":RingoftheExcavator,
"Ring of the Fallen Empire":RingoftheFallenEmpire,
"Ring of the Hierophant":RingoftheHierophant,
"Ring of the Jungle Cat":RingoftheJungleCat,
"Ring of the Ponderous Lady":RingofthePonderousLady,
"Ring of the Serpent Father":RingoftheSerpentFather,
"Ring of the Vampire Squid":RingoftheVampireSquid,
"Ring of Warmaster's Wrath":RingofWarmastersWrath,
"Ring of Yimsha":RingofYimsha,
"Ripper of the Faceless Chaos":RipperoftheFacelessChaos,
"Ritualistic Armguards":RitualisticArmguards,
"Robe of Fiendish Invocation":RobeofFiendishInvocation,
"Robes of a Thousand Blossoms":RobesofaThousandBlossoms,
"Rod of Righteous Might":RodofRighteousMight,
"Rod of the Resplendent Phoenix":RodoftheResplendentPhoenix,
"Rook's Cunning":RooksCunning,
"Rooktalon Bolts":RooktalonBolts,
"Rookwarden's Chestguard":RookwardensChestguard,
"Rookwarden's Helm":RookwardensHelm,
"Root of Death":RootofDeath,
"Rotbolter":Rotbolter,
"Royal Aquilonian Brandy":RoyalAquilonianBrandy,
"Royal Atlantean Dagger":RoyalAtlanteanDagger,
"Royal Atlantean Gown":RoyalAtlanteanGown,
"Royal Dragon Elite Belt":RoyalDragonEliteBelt,
"Royal Dragon Elite Boots":RoyalDragonEliteBoots,
"Royal Dragon Elite Cloak":RoyalDragonEliteCloak,
"Royal Dragon Elite Cuirass":RoyalDragonEliteCuirass,
"Royal Dragon Elite Helm":RoyalDragonEliteHelm,
"Royal Dragon Elite Legguards":RoyalDragonEliteLegguards,
"Royal Dragon Elite Vambraces":RoyalDragonEliteVambraces,
"Royal Signet":RoyalSignet,
"Royal War Steed":RoyalWarSteed,
"Royal Zingaran Blade":RoyalZingaranBlade,
"Royal Zingaran Sabre":RoyalZingaranSabre,
"Ruby Ring of Strength":RubyRingofStrength,
"Runic Band of Inherent Hatred":RunicBandofInherentHatred,
"Rustic Fauld":RusticFauld,
"Ruthless Blade":RuthlessBlade,
"Saboteur Ring":SaboteurRing,
"Sadistic Probe":SadisticProbe,
"Sagaris of the Twelfth Dynasty":SagarisoftheTwelfthDynasty,
"Sage's Armbands of the Crumbling Tower":SagesArmbandsoftheCrumblingTower,
"Sage's Belt of the Aureate":SagesBeltoftheAureate,
"Sage's Belt of the Purple Sun":SagesBeltofthePurpleSun,
"Sage's Boots of the Bloody Stone":SagesBootsoftheBloodyStone,
"Sage's Boots of the Soaring God":SagesBootsoftheSoaringGod,
"Sage's Bracers of the Bloody Stone":SagesBracersoftheBloodyStone,
"Sage's Bracers of the Soaring God":SagesBracersoftheSoaringGod,
"Sage's Braid of the Eldritch":SagesBraidoftheEldritch,
"Sage's Breastplate of the Three Clarities":SagesBreastplateoftheThreeClarities,
"Sage's Cover of Shimmering Light":SagesCoverofShimmeringLight,
"Sage's Coverings of the Eldritch":SagesCoveringsoftheEldritch,
"Sage's Gauntlets of the Crumbling Tower":SagesGauntletsoftheCrumblingTower,
"Sage's Girdle of the Crumbling Tower":SagesGirdleoftheCrumblingTower,
"Sage's Gloves of the Eldritch":SagesGlovesoftheEldritch,
"Sage's Gloves of the Purple Sun":SagesGlovesofthePurpleSun,
"Sage's Hand-wraps of the Aureate":SagesHandwrapsoftheAureate,
"Sage's Harness of the Soaring Heart":SagesHarnessoftheSoaringHeart,
"Sage's Helm of the Green Ones":SagesHelmoftheGreenOnes,
"Sage's Helm of the Soaring Heart":SagesHelmoftheSoaringHeart,
"Sage's Jerkin of the Green Ones":SagesJerkinoftheGreenOnes,
"Sage's Leggings of the Aureate":SagesLeggingsoftheAureate,
"Sage's Leggings of the Crumbling Tower":SagesLeggingsoftheCrumblingTower,
"Sage's Legguards of the Purple Sun":SagesLegguardsofthePurpleSun,
"Sage's Mask of the Three Clarities":SagesMaskoftheThreeClarities,
"Sage's Pauldrons of the Aureate":SagesPauldronsoftheAureate,
"Sage's Sandals of Yag":SagesSandalsofYag,
"Sage's Sash of the Eldritch":SagesSashoftheEldritch,
"Sage's Shoes of the Exalted Spirit":SagesShoesoftheExaltedSpirit,
"Sage's Straps of the Exalted Spirit":SagesStrapsoftheExaltedSpirit,
"Sage's Straps of the Purple Sun":SagesStrapsofthePurpleSun,
"Sage's Vestment of Shimmering Light":SagesVestmentofShimmeringLight,
"Sage's Wrist-straps of Yag":SagesWriststrapsofYag,
"Sagewrath":Sagewrath,
"Saintly Protector":SaintlyProtector,
"Samoore's Radiant Scripture":SamooresRadiantScripture,
"Samoore's Staff of Divinity":SamooresStaffofDivinity,
"Sanctimonious Helm":SanctimoniousHelm,
"Sandals of Indomitable Souls":SandalsofIndomitableSouls,
"Sandals of the Crawling Chaos":SandalsoftheCrawlingChaos,
"Sandals of the Faceless Chaos":SandalsoftheFacelessChaos,
"Sandals of the Faceless Sphinx":SandalsoftheFacelessSphinx,
"Sandals of the Haunter in the Dark":SandalsoftheHaunterintheDark,
"Sandals of the Howling Giant":SandalsoftheHowlingGiant,
"Sandals of the Oxmal":SandalsoftheOxmal,
"Sandals of the Primal Spirit":SandalsofthePrimalSpirit,
"Sandals of the Shivering Stars":SandalsoftheShiveringStars,
"Sandals of the Ubah Kan":SandalsoftheUbahKan,
"Sash of a Thousand Blossoms":SashofaThousandBlossoms,
"Sash of the Amaranthine Drums":SashoftheAmaranthineDrums,
"Sash of the Blood God (nm)":SashoftheBloodGodnm,
"Sash of the Blood God":SashoftheBloodGod,
"Sash of the Bloodhunter (nm)":SashoftheBloodhunternm,
"Sash of the Bloodhunter":SashoftheBloodhunter,
"Sash of the Faceless Sphinx":SashoftheFacelessSphinx,
"Sash of the Revelations":SashoftheRevelations,
"Savage Death Belt":SavageDeathBelt,
"Savage Death Boots":SavageDeathBoots,
"Savage Death Bracers":SavageDeathBracers,
"Savage Death Pantaloons":SavageDeathPantaloons,
"Savage Leggings":SavageLeggings,
"Savant's Ancient Scripts":SavantSAncientScripts,
"Savant's Armbands of Awakening":SavantsArmbandsofAwakening,
"Savant's Armbands of the Celestial Hilt":SavantsArmbandsoftheCelestialHilt,
"Savant's Armbands of Twining Smoke":SavantsArmbandsofTwiningSmoke,
"Savant's Bands of the Moon":SavantsBandsoftheMoon,
"Savant's Belt of the Eternal Eclipse":SavantsBeltoftheEternalEclipse,
"Savant's Belt of the Forbidden Art":SavantsBeltoftheForbiddenArt,
"Savant's Belt of the Waning Moon":SavantsBeltoftheWaningMoon,
"Savant's Boots of the Effulgent Blade":SavantsBootsoftheEffulgentBlade,
"Savant's Boots of the Moon":SavantsBootsoftheMoon,
"Savant's Bracers of the Burning Disc":SavantsBracersoftheBurningDisc,
"Savant's Cowl of the Eternal Eclipse":SavantsCowloftheEternalEclipse,
"Savant's Cowl of the Waning Moon":SavantsCowloftheWaningMoon,
"Savant's Gloves of the Burning Disc":SavantsGlovesoftheBurningDisc,
"Savant's Gloves of the Crescent":SavantsGlovesoftheCrescent,
"Savant's Gloves of the Effulgent Blade":SavantsGlovesoftheEffulgentBlade,
"Savant's Hood of the Forbidden Art":SavantsHoodoftheForbiddenArt,
"Savant's Leggings of the Celestial Hilt":SavantsLeggingsoftheCelestialHilt,
"Savant's Leggings of the Exiled":SavantsLeggingsoftheExiled,
"Savant's Leggings of Twining Smoke":SavantsLeggingsofTwiningSmoke,
"Savant's Mantle of the Heavens":SavantsMantleoftheHeavens,
"Savant's Pants of Awakening":SavantsPantsofAwakening,
"Savant's Regalia of the Moon":SavantsRegaliaoftheMoon,
"Savant's Robes of the Crescent":SavantsRobesoftheCrescent,
"Savant's Sandals of the Crescent":SavantsSandalsoftheCrescent,
"Savant's Sash of the Heavens":SavantsSashoftheHeavens,
"Savant's Straps of the Exiled":SavantsStrapsoftheExiled,
"Savant's Tunic of the Burning Disc":SavantsTunicoftheBurningDisc,
"Savant's Tunic of the Effulgent Blade":SavantsTunicoftheEffulgentBlade,
"Savant's Wristbands of the Effulgent Blade":SavantsWristbandsoftheEffulgentBlade,
"Savant's Wrists of the Crescent":SavantsWristsoftheCrescent,
"Savior's Mace":SaviorsMace,
"Savior's Mantle of the Living Legend":SaviorsMantleoftheLivingLegend,
"Savior's Shield Eternal":SaviorsShieldEternal,
"Savior's Sky Piercer":SaviorsSkyPiercer,
"Savior's Spetum":SaviorsSpetum,
"Savior's Spite Hammer":SaviorsSpiteHammer,
"Savior's Totem Pole":SaviorsTotemPole,
"Savior's Warhammer":SaviorsWarhammer,
"Scales of Hardiness":ScalesofHardiness,
"Scarab Horn Ring":ScarabHornRing,
"Scarclaw Boots":ScarclawBoots,
"Scarclaw Hauberk":ScarclawHauberk,
"Scarclaw Helm":ScarclawHelm,
"Scarclaw Leggings":ScarclawLeggings,
"Scarhide Belt":ScarhideBelt,
"Scarhide Boots":ScarhideBoots,
"Scarhide Bracers":ScarhideBracers,
"Scarhide Helm":ScarhideHelm,
"Scarlet Fighters Ring":ScarletFightersRing,
"Scarlet Mark of Manipulation":ScarletMarkofManipulation,
"Scarlet Necklace":ScarletNecklace,
"Scarlet Spellwarders Ring":ScarletSpellwardersRing,
"Scepter of Return":ScepterofReturn,
"Scepter of Ten Thousand Hells":ScepterofTenThousandHells,
"Scepter of the August Ones":ScepteroftheAugustOnes,
"Scholar's Armbands of the Burning Disc":ScholarsArmbandsoftheBurningDisc,
"Scholar's Armbands of the Effulgent Blade":ScholarsArmbandsoftheEffulgentBlade,
"Scholar's Band of the Crescent":ScholarsBandoftheCrescent,
"Scholar's Bands of the Heavens":ScholarsBandsoftheHeavens,
"Scholar's Belt of the Burning Disc":ScholarsBeltoftheBurningDisc,
"Scholar's Belt of the Crescent":ScholarsBeltoftheCrescent,
"Scholar's Belt of the Effulgent Blade":ScholarsBeltoftheEffulgentBlade,
"Scholar's Boots of the Eternal Eclipse":ScholarsBootsoftheEternalEclipse,
"Scholar's Boots of the Forbidden Art":ScholarsBootsoftheForbiddenArt,
"Scholar's Boots of the Heavens":ScholarsBootsoftheHeavens,
"Scholar's Bracelet of the Waning Moon":ScholarsBraceletoftheWaningMoon,
"Scholar's Bracers of the Forbidden Art":ScholarsBracersoftheForbiddenArt,
"Scholar's Cowl of the Celestial Hilt":ScholarsCowloftheCelestialHilt,
"Scholar's Doublet of Awakening":ScholarsDoubletofAwakening,
"Scholar's Gloves of the Burning Disc":ScholarsGlovesoftheBurningDisc,
"Scholar's Gloves of the Effulgent Blade":ScholarsGlovesoftheEffulgentBlade,
"Scholar's Gloves of the Moon":ScholarsGlovesoftheMoon,
"Scholar's Grasp of the Crescent":ScholarsGraspoftheCrescent,
"Scholar's Hood of Awakening":ScholarsHoodofAwakening,
"Scholar's Hood of Twining Smoke":ScholarsHoodofTwiningSmoke,
"Scholar's Leggings of the Burning Disc":ScholarsLeggingsoftheBurningDisc,
"Scholar's Leggings of the Effulgent Blade":ScholarsLeggingsoftheEffulgentBlade,
"Scholar's Leggings of the Moon":ScholarsLeggingsoftheMoon,
"Scholar's Mantle of the Exiled":ScholarsMantleoftheExiled,
"Scholar's Pants of the Crescent":ScholarsPantsoftheCrescent,
"Scholar's Regalia of the Exiled":ScholarsRegaliaoftheExiled,
"Scholar's Sandals of the Waning Moon":ScholarsSandalsoftheWaningMoon,
"Scholar's Sash of the Moon":ScholarsSashoftheMoon,
"Scholar's Straps of the Moon":ScholarsStrapsoftheMoon,
"Scholar's Tunic of the Celestial Hilt":ScholarsTunicoftheCelestialHilt,
"Scholar's Tunic of Twining Smoke":ScholarsTunicofTwiningSmoke,
"Scholar's Wristbands of the Eternal Eclipse":ScholarsWristbandsoftheEternalEclipse,
"Scholaris Chain":ScholarisChain,
"Scimitar of Red Ruin":ScimitarofRedRuin,
"Scipio's Necklace of Protection":ScipiosNecklaceofProtection,
"Scorched Band of the Inferno":ScorchedBandoftheInferno,
"Scoriaceous Cache of Oblivion":ScoriaceousCacheofOblivion,
"Scourge":Scourge,
"Scribe's Staff":ScribesStaff,
"Scripture of Coronal Skies":ScriptureofCoronalSkies,
"Scroll of Snow and Sorrow":ScrollofSnowandSorrow,
"Seal of Anarchy":SealofAnarchy,
"Seal of Deepest Tartaros":SealofDeepestTartaros,
"Seal of Divertion":SealofDivertion,
"Seal of Privilege":SealofPrivilege,
"Seal of the Black Wind":SealoftheBlackWind,
"Searing Sword":SearingSword,
"Second Wind":SecondWind,
"Sekhmet":Sekhmet,
"Sepulcher's Ward":SepulchersWard,
"Sepulcher":Sepulcher,
"Serenity":Serenity,
"Serpent's Scale":SerpentsScale,
"Serpentscale Belt":SerpentscaleBelt,
"Servatus":Servatus,
"Set's Judgement":SetsJudgement,
"Set's Perversion":SetsPerversion,
"Set's Potency":SetsPotency,
"Set's Power":SetsPower,
"Set's Scrutiny":SetsScrutiny,
"Sewer King's Regalia":SewerKingsRegalia,
"Shadow of Zath":ShadowofZath,
"Shadow's Arm-straps of Ushering Twilight":ShadowsArmstrapsofUsheringTwilight,
"Shadow's Armbands of the Burning Temple":ShadowsArmbandsoftheBurningTemple,
"Shadow's Armbands of the Final Way":ShadowsArmbandsoftheFinalWay,
"Shadow's Bands of the Tenth Court":ShadowsBandsoftheTenthCourt,
"Shadow's Bane":ShadowsBane,
"Shadow's Belt of the Burning Temple":ShadowsBeltoftheBurningTemple,
"Shadow's Belt of the Final Way":ShadowsBeltoftheFinalWay,
"Shadow's Belt of the Hidden Palace":ShadowsBeltoftheHiddenPalace,
"Shadow's Belt of the Tenth Court":ShadowsBeltoftheTenthCourt,
"Shadow's Boots of the Deceiver":ShadowsBootsoftheDeceiver,
"Shadow's Boots of the Dusk Rebellion":ShadowsBootsoftheDuskRebellion,
"Shadow's Boots of the Fifth Stage":ShadowsBootsoftheFifthStage,
"Shadow's Boots of the Smoldering Throne":ShadowsBootsoftheSmolderingThrone,
"Shadow's Boots of the Stolen Kingdom":ShadowsBootsoftheStolenKingdom,
"Shadow's Bracers of the Dusk Rebellion":ShadowsBracersoftheDuskRebellion,
"Shadow's Bracers of the Fifth Stage":ShadowsBracersoftheFifthStage,
"Shadow's Bracers of the Smoldering Throne":ShadowsBracersoftheSmolderingThrone,
"Shadow's Bracers of the Stolen Kingdom":ShadowsBracersoftheStolenKingdom,
"Shadow's Breeches of Ushering Twilight":ShadowsBreechesofUsheringTwilight,
"Shadow's Cord of Ushering Twilight":ShadowsCordofUsheringTwilight,
"Shadow's Edge":ShadowsEdge,
"Shadow's Fauld of the Tenth Court":ShadowsFauldoftheTenthCourt,
"Shadow's Gloves of the Burning Temple":ShadowsGlovesoftheBurningTemple,
"Shadow's Gloves of the Final Way":ShadowsGlovesoftheFinalWay,
"Shadow's Gloves of the Hidden Palace":ShadowsGlovesoftheHiddenPalace,
"Shadow's Gloves of the Tenth Court":ShadowsGlovesoftheTenthCourt,
"Shadow's Gloves of Ushering Twilight":ShadowsGlovesofUsheringTwilight,
"Shadow's Helm of the Nadir":ShadowsHelmoftheNadir,
"Shadow's Helm of the Swift Return":ShadowsHelmoftheSwiftReturn,
"Shadow's Hood of Whispered Deeds":ShadowsHoodofWhisperedDeeds,
"Shadow's Jerkin of the Nadir":ShadowsJerkinoftheNadir,
"Shadow's Jerkin of the Swift Return":ShadowsJerkinoftheSwiftReturn,
"Shadow's Leggings of the Burning Temple":ShadowsLeggingsoftheBurningTemple,
"Shadow's Leggings of the Final Way":ShadowsLeggingsoftheFinalWay,
"Shadow's Legguards of the Hidden Palace":ShadowsLegguardsoftheHiddenPalace,
"Shadow's Mask of Engulfing Twilight":ShadowsMaskofEngulfingTwilight,
"Shadow's Mask of the Sundered Crown":ShadowsMaskoftheSunderedCrown,
"Shadow's Straps of the Hidden Palace":ShadowsStrapsoftheHiddenPalace,
"Shadow's Tunic of Engulfing Twilight":ShadowsTunicofEngulfingTwilight,
"Shadow's Tunic of the Sundered Crown":ShadowsTunicoftheSunderedCrown,
"Shadow's Tunic of Whispered Deeds":ShadowsTunicofWhisperedDeeds,
"Shadow's Wristbands of the Deceiver":ShadowsWristbandsoftheDeceiver,
"Shadowbrood Gloves":ShadowbroodGloves,
"Shadowcord":Shadowcord,
"Shadowdrinker":Shadowdrinker,
"Shadowy Bracers":ShadowyBracers,
"Shah Stinger":ShahStinger,
"Shard of Tartaros":ShardofTartarosintelligence,
"Shard-Blade of Wraal":ShardBladeofWraal,
"Shatterfist":Shatterfist,
"Shatush of Pandemonium":ShatushofPandemonium,
"Shatush of the Bloodmoon":ShatushoftheBloodmoon,
"Shatush of the Ecliptic":ShatushoftheEcliptic,
"Shatush of the First Circle":ShatushoftheFirstCircle,
"Shau's Reflection":ShausReflection,
"Shawabti":Shawabti,
"Shawl of the Departed":ShawloftheDeparted,
"Shedu of Arcing Skies":SheduofArcingSkies,
"Shemite Exile Cache":ShemiteExileCache,
"Shemite Exile Tunic":ShemiteExileTunic,
"Shemite Exile Wristguards":ShemiteExileWristguards,
"Shemite Mercenary Armbands":ShemiteMercenaryArmbands,
"Shemite Mercenary Boots":ShemiteMercenaryBoots,
"Shemite Mercenary Grips":ShemiteMercenaryGrips,
"Shemite Mercenary Leggings":ShemiteMercenaryLeggings,
"Shemite Mercenary Tunic":ShemiteMercenaryTunic,
"Shemite Mercenary Turban":ShemiteMercenaryTurban,
"Shemite Mercenary Wristbands":ShemiteMercenaryWristbands,
"Shemite Wayfarer Armbands":ShemiteWayfarerArmbands,
"Shemite Wayfarer Belt":ShemiteWayfarerBelt,
"Shemite Wayfarer Boots":ShemiteWayfarerBoots,
"Shemite Wayfarer Leggings":ShemiteWayfarerLeggings,
"Shemite Wayfarer Tunic":ShemiteWayfarerTunic,
"Shemite Wayfarer Wristbands":ShemiteWayfarerWristbands,
"Shemmu":Shemmu,
"Shendoh of Ardent Fire":ShendohofArdentFire,
"Shendoh of Conflagrant Flame":ShendohofConflagrantFlame,
"Shendoh of Infernal Zeal":ShendohofInfernalZeal,
"Shendoh of the Eternal Blaze":ShendohoftheEternalBlaze,
"Shendoh of the Whispering Blade":ShendohoftheWhisperingBlade,
"Shevatas Jewel-Hiked Blade":ShevatasJewelHikedBlade,
"Shield of Amra":ShieldofAmra,
"Shield of Tears Unshed":ShieldofTearsUnshed,
"Shield of the Black Pharaoh":ShieldoftheBlackPharaoh,
"Shield of the Fallen Empire":ShieldoftheFallenEmpire,
"Shield of the Kozak Slayer":ShieldoftheKozakSlayer,
"Shield of the Shivering Stars":ShieldoftheShiveringStars,
"Shield of the Soul Eater":ShieldoftheSoulEater,
"Shield of Yag":ShieldofYag,
"Shillelagh of Sogoth":ShillelaghofSogoth,
"Shin-pads of the Black Pharaoh":ShinpadsoftheBlackPharaoh,
"Shin-pads of the Dark Messenger":ShinpadsoftheDarkMessenger,
"Shin-straps of the Blood God (nm)":ShinstrapsoftheBloodGodnm,
"Shin-straps of the Blood God":ShinstrapsoftheBloodGod,
"Shin-straps of the Death Master (nm)":ShinstrapsoftheDeathMasternm,
"Shin-straps of the Death Master":ShinstrapsoftheDeathMaster,
"Shiv of the Autumn Night":ShivoftheAutumnNight,
"Shiv of the Triumphant":ShivoftheTriumphant,
"Shocksand Belt":ShocksandBelt,
"Shoulder Pad of the Cackling Marionette":ShoulderPadoftheCacklingMarionette,
"Shoulder Strap of Bone and Horn":ShoulderStrapofBoneandHorn,
"Shoulder Strap of the Great Impi":ShoulderStrapoftheGreatImpi,
"Shovel of the Dark Messenger":ShoveloftheDarkMessenger,
"Shrieking Wind":ShriekingWind,
"Shrill Bone Flute":ShrillBoneFlute,
"Shroud of Eleven Forbidden Names":ShroudofElevenForbiddenNames,
"Shroud of the Ghost Crows' Spite":ShroudoftheGhostCrowsSpite,
"Shroud of the Outer Dark":ShroudoftheOuterDark,
"Shroud of Zath":ShroudofZath,
"Shu'kusht":Shukusht,
"Siegebreaker":Siegebreaker,
"Sigil of Funeral Flames":SigilofFuneralFlames,
"Sigil of Yig's Dominion":SigilofYigsDominion,
"Signet of Anarchy":SignetofAnarchy,
"Sinister Tunic":SinisterTunic,
"Sinstrike":Sinstrike,
"Sirocco's Lament":SiroccosLament,
"Skirmisher's Arrows":SkirmishersArrows,
"Skirmisher's Blade":SkirmishersBlade,
"Skirmisher's Bolts":SkirmishersBolts,
"Skirmisher's Crossbow":SkirmishersCrossbow,
"Skirmisher's Dirk":SkirmishersDirk,
"Skirmisher's Great Shield":SkirmishersGreatShield,
"Skirmisher's Greatbow":SkirmishersGreatbow,
"Skirmisher's Greatsword":SkirmishersGreatsword,
"Skirmisher's Krys":SkirmishersKrys,
"Skirmisher's Mark of Abhorrence":SkirmishersMarkofAbhorrence,
"Skirmisher's Maxim of Entropy":SkirmishersMaximofEntropy,
"Skirmisher's Sanctum":SkirmishersSanctum,
"Skirmisher's Scepter":SkirmishersScepter,
"Skirmisher's Spell Glaive":SkirmishersSpellGlaive,
"Skirmisher's Spellsword":SkirmishersSpellsword,
"Skirmisher's Staff":SkirmishersStaff,
"Skirmisher's War Fist":SkirmishersWarFist,
"Skirmisher's War Glaive":SkirmishersWarGlaive,
"Skirmisher's War Maul":SkirmishersWarMaul,
"Skirt of the Cackling Marionette":SkirtoftheCacklingMarionette,
"Skirt of the Dragon King":SkirtoftheDragonKing,
"Skirt of the Ghost of the Veldt":SkirtoftheGhostoftheVeldt,
"Skirt of the Hell Walker (nm)":SkirtoftheHellWalkernm,
"Skirt of the Hell Walker":SkirtoftheHellWalker,
"Skrymir":Skrymir,
"Skull Clasp of Bloody Carnage":SkullClaspofBloodyCarnage,
"Skull Gate Gauntlets":SkullGateGauntlets,
"Skull Gate Pauldrons":SkullGatePauldrons,
"Skull Gate Sabatons":SkullGateSabatons,
"Skullcracker":Skullcracker,
"Skyfire":Skyfire,
"Skyhawk's Edge":SkyhawksEdge,
"Skylance":Skylance,
"Skyshear Armbands":SkyshearArmbands,
"Skyshear Boots":SkyshearBoots,
"Skyshear Bracers":SkyshearBracers,
"Skyshear Gauntlets":SkyshearGauntlets,
"Skyshear Girdle":SkyshearGirdle,
"Skyshear Helm":SkyshearHelm,
"Skyshear Jerkin":SkyshearJerkin,
"Skyshear Tasset":SkyshearTasset,
"Skystorm":Skystorm,
"Slayer's Mantle of the Living Legend":SlayersMantleoftheLivingLegend,
"Sleightcraft Mitts":SleightcraftMitts,
"Sliver of Pure Ice (dexterity)":SliverofPureIcedexterity,
"Sliver of Pure Ice (wisdom)":SliverofPureIcewisdom,
"Smile of Tartaros":SmileofTartaros,
"Smite of the Northern Wastes":SmiteoftheNorthernWastes,
"Snakehead of Intelligence":SnakeheadofIntelligence,
"Snakeswift Padsoles":SnakeswiftPadsoles,
"Snaketooth Dagger":SnaketoothDagger,
"Snowcloud Cloak":SnowcloudCloak,
"Solace":Solace,
"Soles of the Endless Sands":SolesoftheEndlessSands,
"Soles of the Ghost of the Veldt":SolesoftheGhostoftheVeldt,
"Song of Demise":SongofDemise,
"Song of the Four Wailing Elohim":SongoftheFourWailingElohim,
"Sorcerer's Armbands of Regal Might":SorcerersArmbandsofRegalMight,
"Sorcerer's Armbands of the Emperor's Favor":SorcerersArmbandsoftheEmperorsFavor,
"Sorcerer's Belt of Sovereign Rule":SorcerersBeltofSovereignRule,
"Sorcerer's Boots of Prestige":SorcerersBootsofPrestige,
"Sorcerer's Bracers of Imperial Assent":SorcerersBracersofImperialAssent,
"Sorcerer's Bracers of Prestige":SorcerersBracersofPrestige,
"Sorcerer's Dread":SorcerersDread,
"Sorcerer's Gauntlets of Imperial Assent":SorcerersGauntletsofImperialAssent,
"Sorcerer's Girdle of the Mandate":SorcerersGirdleoftheMandate,
"Sorcerer's Gloves of Prestige":SorcerersGlovesofPrestige,
"Sorcerer's Helm of the Mandate":SorcerersHelmoftheMandate,
"Sorcerer's Hood of Sovereign Rule":SorcerersHoodofSovereignRule,
"Sorcerer's Leggings of Regal Might":SorcerersLeggingsofRegalMight,
"Sorcerer's Leggings of the Emperor's Favor":SorcerersLeggingsoftheEmperorsFavor,
"Sorcerer's Robe of Prestige":SorcerersRobeofPrestige,
"Sorcerer's Robes of Imperial Assent":SorcerersRobesofImperialAssent,
"Sosun Pattah of the Endless Sands":SosunPattahoftheEndlessSands,
"Soul of Atali":SoulofAtali,
"Soul of Pashtun":SoulofPashtun,
"Soulbearer":Soulbearer,
"Soulblessed Rod":SoulblessedRod,
"Soulcleaver":Soulcleaver,
"Soulcrush":Soulcrush,
"Souldrinker":Souldrinker,
"Soulgrist":Soulgrist,
"Soulguard":Soulguard,
"Soulharrow":Soulharrow,
"Soulmark Belt":SoulmarkBelt,
"Soulrender's Mark":SoulrendersMark,
"Soulscream Necklace":SoulscreamNecklace,
"Soulsplitter":Soulsplitter,
"Soulstorm":Soulstorm,
"Soulthief":Soulthief,
"Soulthunder Spangenhelm":SoulthunderSpangenhelm,
"Soulwatch Hood":SoulwatchHood,
"Soulwound Gloves":SoulwoundGloves,
"South Cleave of the Vermilion Bird":SouthCleaveoftheVermillionBird,
"Sovereign Battleblade":SovereignBattleblade,
"Sovereign of Anarchy":SovereignofAnarchy,
"Spear of Aratus":SpearofAratus,
"Spear of Ishti":SpearofIshti,
"Spear of Nephren-Ka":SpearofNephrenKa,
"Spear of the Dark Sun":SpearoftheDarkSun,
"Spear of the Pagoda":SpearofthePagoda,
"Spear of the Pillars":SpearofthePillars,
"Spectral Cape":SpectralCape,
"Spellbane Mantle":SpellbaneMantle,
"Spellguard Helm":SpellguardHelm,
"Spiderward Breastplate":SpiderwardBreastplate,
"Spike Shield":SpikeShield,
"Spine of Dagon":SpineofDagon,
"Spinebreaker":Spinebreaker,
"Spineduster":Spineduster,
"Spinegrist":Spinegrist,
"Spines of Repose":SpinesofRepose,
"Spire of the Firmament":SpireoftheFirmament,
"Spirit of Jovus":SpiritofJovus,
"Spiritark Gloves":SpiritarkGloves,
"Spiritguard":Spiritguard,
"Spiritual Ring":SpiritualRing,
"Spiritual Ward":SpiritualWard,
"Spiteful Gauntlets":SpitefulGauntlets,
"Sprightly Pirate Pendant":SprightlyPiratePendant,
"Square Shield of the Ziggurat":SquareShieldoftheZiggurat,
"Staff of Devout Piety":StaffofDevoutPiety,
"Staff of Erlik":StaffofErlik,
"Staff of Eternal Confluence":StaffofEternalConfluence,
"Staff of Kwan":StaffofKwan,
"Staff of Souls":StaffofSouls,
"Staff of the Crustacean":StaffoftheCrustacean,
"Staff of the Gladiator":StaffoftheGladiator,
"Staff of the Primal Spirit":StaffofthePrimalSpirit,
"Staff of the Shivering Stars":StaffoftheShiveringStars,
"Stalker's Arm-straps of the Battlethrall":StalkersArmstrapsoftheBattlethrall,
"Stalker's Armbands of Arcane Death":StalkersArmbandsofArcaneDeath,
"Stalker's Armbands of the Silent Kill":StalkersArmbandsoftheSilentKill,
"Stalker's Belt of Shattered Souls":StalkersBeltofShatteredSouls,
"Stalker's Belt of the Black Arts":StalkersBeltoftheBlackArts,
"Stalker's Belt of the Firebringer":StalkersBeltoftheFirebringer,
"Stalker's Boots of Charred Earth":StalkersBootsofCharredEarth,
"Stalker's Boots of the Hidden Tomb":StalkersBootsoftheHiddenTomb,
"Stalker's Boots of Waning Dusk":StalkersBootsofWaningDusk,
"Stalker's Bracers of Charred Earth":StalkersBracersofCharredEarth,
"Stalker's Bracers of the Grim Cabal":StalkersBracersoftheGrimCabal,
"Stalker's Bracers of the Hidden Tomb":StalkersBracersoftheHiddenTomb,
"Stalker's Cord of Creeping Death":StalkersCordofCreepingDeath,
"Stalker's Deathmask of Creeping Death":StalkersDeathmaskofCreepingDeath,
"Stalker's Fauld of Malice":StalkersFauldofMalice,
"Stalker's Gloves of Charred Earth":StalkersGlovesofCharredEarth,
"Stalker's Gloves of the Grim Cabal":StalkersGlovesoftheGrimCabal,
"Stalker's Gloves of the Hidden Tomb":StalkersGlovesoftheHiddenTomb,
"Stalker's Grips of Waning Dusk":StalkersGripsofWaningDusk,
"Stalker's Jerkin of Waning Dusk":StalkersJerkinofWaningDusk,
"Stalker's Leggings of Arcane Death":StalkersLeggingsofArcaneDeath,
"Stalker's Leggings of the Battlethrall":StalkersLeggingsoftheBattlethrall,
"Stalker's Leggings of the Silent Kill":StalkersLeggingsoftheSilentKill,
"Stalker's Mask of Shattered Souls":StalkersMaskofShatteredSouls,
"Stalker's Mask of the Firebringer":StalkersMaskoftheFirebringer,
"Stalker's Spauld of Malice":StalkersSpauldofMalice,
"Stalker's Tunic of Charred Earth":StalkersTunicofCharredEarth,
"Stalker's Tunic of the Grim Cabal":StalkersTunicoftheGrimCabal,
"Stalker's Tunic of the Hidden Tomb":StalkersTunicoftheHiddenTomb,
"Stalker's Veil of the Black Arts":StalkersVeiloftheBlackArts,
"Stalker's Wristbands of Waning Dusk":StalkersWristbandsofWaningDusk,
"Stalwart Ring":StalwartRing,
"Stamina of the Wolf":StaminaoftheWolf,
"Star Touched Mantle of the Living Legend":StarTouchedMantleoftheLivingLegend,
"Staunchguard Plate Boots":StaunchguardPlateBoots,
"Stave of Malefic Rites":StaveofMaleficRites,
"Stave of the Hell Walker (nm)":StaveoftheHellWalkernm,
"Stave of the Hell Walker":StaveoftheHellWalker,
"Steadfast Armguards":SteadfastArmguards,
"Steadfastness of Jovus":SteadfastnessofJovus,
"Steelforged Salvation of the Undying Atlantis":SteelforgedSalvationoftheUndyingAtlantis,
"Steelspirit Legguards":SteelspirirtLegguards,
"Steelspirit Armguards":SteelspiritArmguards,
"Steelspirit Boots":SteelspiritBoots,
"Steelspirit Chestguard":SteelspiritChestguard,
"Steelspirit Gauntlets":SteelspiritGauntlets,
"Steelspirit Girdle":SteelspiritGirdle,
"Steelspirit Helm":SteelspiritHelm,
"Steelspirit Vambraces":SteelspiritVambraces,
"Sting of the Repugnant":StingoftheRepugnant,
"Stonesplitter":Stonesplitter,
"Stormpike":Stormpike,
"Stormrend Gauntlets":StormrendGauntlets,
"Stormslash":Stormslash,
"Stragis":Stragis,
"Strangler's Armbands of the Hidden Tomb":StranglersArmbandsoftheHiddenTomb,
"Strangler's Belt of Charred Earth":StranglersBeltofCharredEarth,
"Strangler's Belt of the Grim Cabal":StranglersBeltoftheGrimCabal,
"Strangler's Belt of the Hidden Tomb":StranglersBeltoftheHiddenTomb,
"Strangler's Boots of Arcane Death":StranglersBootsofArcaneDeath,
"Strangler's Boots of Malice":StranglersBootsofMalice,
"Strangler's Boots of the Battlethrall":StranglersBootsoftheBattlethrall,
"Strangler's Boots of the Silent Kill":StranglersBootsoftheSilentKill,
"Strangler's Bracers of Arcane Death":StranglersBracersofArcaneDeath,
"Strangler's Bracers of the Battlethrall":StranglersBracersoftheBattlethrall,
"Strangler's Bracers of the Silent Kill":StranglersBracersoftheSilentKill,
"Strangler's Cord of Waning Dusk":StranglersCordofWaningDusk,
"Strangler's Fauld of Waning Dusk":StranglersFauldofWaningDusk,
"Strangler's Gloves of Creeping Death":StranglersGlovesofCreepingDeath,
"Strangler's Gloves of Shattered Souls":StranglersGlovesofShatteredSouls,
"Strangler's Gloves of the Black Arts":StranglersGlovesoftheBlackArts,
"Strangler's Gloves of the Firebringer":StranglersGlovesoftheFirebringer,
"Strangler's Leggings of Charred Earth":StranglersLeggingsofCharredEarth,
"Strangler's Leggings of the Grim Cabal":StranglersLeggingsoftheGrimCabal,
"Strangler's Leggings of the Hidden Tomb":StranglersLeggingsoftheHiddenTomb,
"Strangler's Mask of the Hidden Tomb":StranglersMaskoftheHiddenTomb,
"Strangler's Mask of Waning Dusk":StranglersMaskofWaningDusk,
"Strangler's Straps of Waning Dusk":StranglersStrapsofWaningDusk,
"Strangler's Tunic of Creeping Death":StranglersTunicofCreepingDeath,
"Strangler's Tunic of Shattered Souls":StranglersTunicofShatteredSouls,
"Strangler's Tunic of the Black Arts":StranglersTunicoftheBlackArts,
"Strangler's Tunic of the Firebringer":StranglersTunicoftheFirebringer,
"Strangler's Veil of the Grim Cabal":StranglersVeiloftheGrimCabal,
"Strangler's Wristbands of Malice":StranglersWristbandsofMalice,
"Strangler's Arm-straps of Charred Earth":StranglersArmstrapsofCharredEarth,
"Straps of the Grand Monarch":StrapsoftheGrandMonarch,
"Straps of the Revelations":StrapsoftheRevelations,
"Strifescar Armbands":StrifescarArmbands,
"Strifescar Boots":StrifescarBoots,
"Strifescar Bracers":StrifescarBracers,
"Strifescar Gauntlets":StrifescarGauntlets,
"Strifescar Girdle":StrifescarGirdle,
"Strifescar Harness":StrifescarHarness,
"Strifescar Helm":StrifescarHelm,
"Strifescar Tasset":StrifescarTasset,
"Strom's Sabre":StromsSabre,
"Sturdy Pirate Ring":SturdyPirateRing,
"Subjugator Axe":SubjugatorAxe,
"Subjugator Blade":SubjugatorBlade,
"Subjugator Dagger":SubjugatorDagger,
"Subjugator Staff":SubjugatorStaff,
"Subjugator Sword":SubjugatorSword,
"Summoner's Armbands of Imperial Assent":SummonersArmbandsofImperialAssent,
"Summoner's Bands of Sovereign Rule":SummonersBandsofSovereignRule,
"Summoner's Boots of Sovereign Rule":SummonersBootsofSovereignRule,
"Summoner's Boots of the Mandate":SummonersBootsoftheMandate,
"Summoner's Bracers of the Mandate":SummonersBracersoftheMandate,
"Summoner's Cincture of Prestige":SummonersCinctureofPrestige,
"Summoner's Crown of Regal Might":SummonersCrownofRegalMight,
"Summoner's Gauntlets of Imperial Assent":SummonersGauntletsofImperialAssent,
"Summoner's Girdle of Imperial Assent":SummonersGirdleofImperialAssent,
"Summoner's Gloves of Prestige":SummonersGlovesofPrestige,
"Summoner's Helm of the Emperor's Favor":SummonersHelmoftheEmperorsFavor,
"Summoner's Leggings of Imperial Assent":SummonersLeggingsofImperialAssent,
"Summoner's Leggings of Prestige":SummonersLeggingsofPrestige,
"Summoner's Robes of Regal Might":SummonersRobesofRegalMight,
"Summoner's Robes of the Emperor's Favor":SummonersRobesoftheEmperorsFavor,
"Summoner's Straps of Prestige":SummonersStrapsofPrestige,
"Sunspark":Sunspark,
"Sunward":Sunward,
"Surberec's Collar":SurberecsCollar,
"Swift Stygian Festival Stallion":SwiftStygianFestivalStallion,
"Swiftshank Treads":SwiftshankTreads,
"Sword of Ashur":SwordofAshur,
"Sword of Scarlet Fire":SwordofScarletFire,
"Sword of the Crimson Fort":SwordoftheCrimsonFort,
"Sword of the Death Master":SwordoftheDeathMaster,
"Sword of the Old Commander":SwordoftheOldCommander,
"Sword of the Yellow Hand":SwordoftheYellowHand,
"Sylphlike Sash":SylphlikeSash,
"Tactician's Gauntlets":TacticiansGauntlets,
"Taerra":Taerra,
"Tail of the Vaaghasan":TailoftheVaaghasan,
"Talion":Talion,
"Talisman of Death":TalismanofDeath,
"Talisman of the Ziggurat":TalismanoftheZiggurat,
"Talons of Black Oblivion":TalonsofBlackOblivion,
"Talons of Dark Terror":TalonsofDarkTerror,
"Talons of Necrotic Dread":TalonsofNecroticDread,
"Talons of the Cackling Marionette":TalonsoftheCacklingMarionette,
"Talons of the Unholy Communion":TalonsoftheUnholyCommunion,
"Talonthrust":Talonthrust,
"Tamara's Corsair Cache":TamarasCorsairCache,
"Tamarin Battle Bow":TamarinBattleBow,
"Tamarin Battle Crossbow":TamarinBattleCrossbow,
"Tamarin Battle Scimitar":TamarinBattleScimitar,
"Tamarin Battle Shield":TamarinBattleShield,
"Tamarin Battle Spire":TamarinBattleSpire,
"Tamarin Battle Staff":TamarinBattleStaff,
"Tamarin Battle Ward":TamarinBattleWard,
"Tarim's Blade of Sanctity":TarimsBladeofSanctity,
"Tarim's Emblem of Sanctity":TarimsEmblemofSanctity,
"Tarim's Ring of the Holy Word":TarimsRingoftheHolyWord,
"Tarim's Shield of Sanctity":TarimsShieldofSanctity,
"Tarim's Twin-axe of Sanctity":TarimsTwinaxeofSanctity,
"Tasset of Baleful Blood":TassetofBalefulBlood,
"Tasset of Black Spite":TassetofBlackSpite,
"Tasset of Brutal Carnage":TassetofBrutalCarnage,
"Tasset of Courageous Souls":TassetofCourageousSouls,
"Tasset of Crimson Slaughter (nm)":TassetofCrimsonSlaughternm,
"Tasset of Crimson Slaughter":TassetofCrimsonSlaughter,
"Tasset of Fearless Souls":TassetofFearlessSouls,
"Tasset of Heroic Soul":TassetofHeroicSoul,
"Tasset of Indomitable Souls":TassetofIndomitableSouls,
"Tasset of Rapturous Battle":TassetofRapturousBattle,
"Tasset of Red Ruin (nm)":TassetofRedRuinnm,
"Tasset of Red Ruin":TassetofRedRuin,
"Tasset of Righteous Smiting":TassetofRighteousSmiting,
"Tasset of the Berserker's Fury":TassetoftheBerserkersFury,
"Tasset of the Bloodhunter (nm)":TassetoftheBloodhunternm,
"Tasset of the Bloodhunter":TassetoftheBloodhunter,
"Tasset of the Chaos Agent":TassetoftheChaosAgent,
"Tasset of the Doomsayer":TassetoftheDoomsayer,
"Tasset of the Fallen Empire (nm)":TassetoftheFallenEmpirenm,
"Tasset of the Fallen Empire":TassetoftheFallenEmpire,
"Tasset of the Invincible":TassetoftheInvincible,
"Tasset of the Martial Paragon":TassetoftheMartialParagon,
"Tasset of the Painlegion":TassetofthePainlegion,
"Tasset of the Proven Champion":TassetoftheProvenChampion,
"Tasset of the Savage Slaughter":TassetoftheSavageSlaughter,
"Tasset of the Stormbringer":TassetoftheStormbringer,
"Tasset of the Tireless Defender":TassetoftheTirelessDefender,
"Tasset of the Triumphant":TassetoftheTriumphant,
"Tasset of the Valiant":TassetoftheValiant,
"Tasset of the Victorious Elite":TassetoftheVictoriousElite,
"Tasset of the Warded Brute":TassetoftheWardedBrute,
"Tasset of Tribulation":TassetofTribulation,
"Tasset of Vehement Thunder":TassetofVehementThunder,
"Tasset of Vengeful Zeal":TassetofVengefulZeal,
"Tasset of Violent Rage":TassetofViolentRage,
"Tear of the Sadist":TearoftheSadist,
"Tectus":Tectus,
"Teeth of the Drowned":TeethoftheDrowned,
"Tekesh":Tekesh,
"Telkari of the Cloudcleaver":TelkarioftheCloudcleaver,
"Telkari of the Judgment Bolt":TelkarioftheJudgmentBolt,
"Telkari of the Riftcaller":TelkarioftheRiftcaller,
"Telkari of the Sundered Skies":TelkarioftheSunderedSkies,
"Tenebrous Girdle":TenebrousGirdle,
"Teremsefi's Design":TeremsefisDesign,
"Terminator's Diremaul":TerminatorsDiremaul,
"Terminator's Dreadmaul":TerminatorsDreadmaul,
"Terminator's Mantle of the Living Legend":TerminatorsMantleoftheLivingLegend,
"Terminus":Terminus,
"Tesso's Glory":TessosGlory,
"Tesso's Honor":TessosHonor,
"Tesso's Pride":TessosPride,
"Tesso's Strife":TessosStrife,
"Thaumaturge's Armbands of Imperial Assent":ThaumaturgesArmbandsofImperialAssent,
"Thaumaturge's Armbands of Prestige":ThaumaturgesArmbandsofPrestige,
"Thaumaturge's Belt of Prestige":ThaumaturgesBeltofPrestige,
"Thaumaturge's Boots of Regal Might":ThaumaturgesBootsofRegalMight,
"Thaumaturge's Boots of the Emperor's Favor":ThaumaturgesBootsoftheEmperorsFavor,
"Thaumaturge's Bracers of Regal Might":ThaumaturgesBracersofRegalMight,
"Thaumaturge's Bracers of the Emperor's Favor":ThaumaturgesBracersoftheEmperorsFavor,
"Thaumaturge's Gauntlets of the Mandate":ThaumaturgesGauntletsoftheMandate,
"Thaumaturge's Girdle of Imperial Assent":ThaumaturgesGirdleofImperialAssent,
"Thaumaturge's Gloves of Sovereign Rule":ThaumaturgesGlovesofSovereignRule,
"Thaumaturge's Helm of Imperial Assent":ThaumaturgesHelmofImperialAssent,
"Thaumaturge's Leggings of Imperial Assent":ThaumaturgesLeggingsofImperialAssent,
"Thaumaturge's Leggings of Prestige":ThaumaturgesLeggingsofPrestige,
"Thaumaturge's Robes of the Mandate":ThaumaturgesRobesoftheMandate,
"Thaumaturge's Tunic of Sovereign Rule":ThaumaturgesTunicofSovereignRule,
"The Agony of Ages":TheAgonyofAges,
"The Art of Eastern Riding":TheArtofEasternRiding,
"The August Ones' Impassible Grin":TheAugustOnesImpassibleGrin,
"The Baleful Blade":TheBalefulBlade,
"The Castle":TheCastle,
"The Circle's Notch":TheCirclesNotch,
"The Cloudscar":TheCloudscar,
"The Conqueror's Crown":TheConquerorsCrown,
"The Conviction of Will":TheConvictionofWill,
"The Crescent of Blood":TheCrescentofBlood,
"The Death of Innocents":TheDeathofInnocents,
"The End of Kings":TheEndofKings,
"The Enduring Hate":TheEnduringHate,
"The Eye of the Bretheren":TheEyeoftheBretheren,
"The Fleeted Wing":TheFleetedWing,
"The Frostflight":TheFrostflight,
"The Fury of Iziel":TheFuryofIziel,
"The Gilded Grave":TheGildedGrave,
"The Haven of War":TheHavenofWar,
"The Heart of Atlantis":TheHeartofAtlantis,
"The Helot of Sacrilege":TheHelotofSacrilege,
"The Horizon's Severing Divide":TheHorizonsSeveringDivide,
"The Immortal Edge":TheImmortalEdge,
"The Infernus of Dagon":TheInfernusofDagon,
"The Jackdaw's Tithe":TheJackdawsTithe,
"The Lost Soul":TheLostSoul,
"The Mark of Gwahlur":TheMarkofGwahlur,
"The Might of Arctos":TheMightofArctos,
"The Mouth of Barbed Promises":TheMouthofBarbedPromises,
"The Narthex of Hell":TheNarthexofHell,
"The Necros of Dagon":TheNecrosofDagon,
"The Rock":TheRock,
"The Scimitar of Dunes":TheScimitarofDunes,
"The Serpent's Pull":TheSerpentsPull,
"The Shield of Alkmeenon":TheShieldofAlkmeenon,
"The Shield of Chaos":TheShieldofChaos,
"The Shield of Entropy":TheShieldofEntropy,
"The Silent Knell":TheSilentKnell,
"The Silent Lullaby":TheSilentLullaby,
"The Storm Harbor":TheStormHarbor,
"The Strangler's Hand":TheStranglersHand,
"The Subtle Disguise":TheSubtleDisguise,
"The Three Fangs of Reckoning":TheThreeFangsofReckoning,
"The Tiger's Will":TheTigersWill,
"The Tome of Storms":TheTomeofStorms,
"The Twinned Moons":TheTwinnedMoons,
"The Unconquerable Riddle of Steel":TheUnconquerableRiddleofSteel,
"The Water's Edge":TheWatersEdge,
"Theurgic Dagger":TheurgicDagger,
"Thief's Armbands of Engulfing Twilight":ThiefsArmbandsofEngulfingTwilight,
"Thief's Armbands of the Sundered Crown":ThiefsArmbandsoftheSunderedCrown,
"Thief's Bands of the Nadir":ThiefsBandsoftheNadir,
"Thief's Belt of the Deceiver":ThiefsBeltoftheDeceiver,
"Thief's Belt of the Fifth Stage":ThiefsBeltoftheFifthStage,
"Thief's Belt of the Smoldering Throne":ThiefsBeltoftheSmolderingThrone,
"Thief's Belt of the Stolen Kingdom":ThiefsBeltoftheStolenKingdom,
"Thief's Boots of the Burning Temple":ThiefsBootsoftheBurningTemple,
"Thief's Bracers of the Burning Temple":ThiefsBracersoftheBurningTemple,
"Thief's Bracers of the Tenth Court":ThiefsBracersoftheTenthCourt,
"Thief's Fauld of the Nadir":ThiefsFauldoftheNadir,
"Thief's Gloves of the Burning Temple":ThiefsGlovesoftheBurningTemple,
"Thief's Gloves of the Hidden Palace":ThiefsGlovesoftheHiddenPalace,
"Thief's Gloves of the Tenth Court":ThiefsGlovesoftheTenthCourt,
"Thief's Helm of the Fifth Stage":ThiefsHelmoftheFifthStage,
"Thief's Helm of the Stolen Kingdom":ThiefsHelmoftheStolenKingdom,
"Thief's Jerkin of the Hidden Palace":ThiefsJerkinoftheHiddenPalace,
"Thief's Jerkin of the Tenth Court":ThiefsJerkinoftheTenthCourt,
"Thief's Leggings of Engulfing Twilight":ThiefsLeggingsofEngulfingTwilight,
"Thief's Leggings of the Sundered Crown":ThiefsLeggingsoftheSunderedCrown,
"Thief's Legguards of the Swift Return":ThiefsLegguardsoftheSwiftReturn,
"Thief's Mask of the Deceiver":ThiefsMaskoftheDeceiver,
"Thief's Mask of the Smoldering Throne":ThiefsMaskoftheSmolderingThrone,
"Thief's Straps of the Swift Return":ThiefsStrapsoftheSwiftReturn,
"Thief's Tunic of the Burning Temple":ThiefsTunicoftheBurningTemple,
"Thief's Wristbands of the Final Way":ThiefsWristbandsoftheFinalWay,
"Thirst":Thirst,
"Thrice-Howled Edge of Frenzy":ThriceHowledEdgeofFrenzy,
"Throwing Axe of the Ziggurat":ThrowingAxeoftheZiggurat,
"Thug's Arm-straps of the Firebringer":ThugsArmstrapsoftheFirebringer,
"Thug's Armbands of Shattered Souls":ThugsArmbandsofShatteredSouls,
"Thug's Armbands of the Black Arts":ThugsArmbandsoftheBlackArts,
"Thug's Belt of Arcane Death":ThugsBeltofArcaneDeath,
"Thug's Belt of Malice":ThugsBeltofMalice,
"Thug's Belt of the Battlethrall":ThugsBeltoftheBattlethrall,
"Thug's Belt of the Silent Kill":ThugsBeltoftheSilentKill,
"Thug's Boots of Charred Earth":ThugsBootsofCharredEarth,
"Thug's Boots of the Grim Cabal":ThugsBootsoftheGrimCabal,
"Thug's Boots of the Hidden Tomb":ThugsBootsoftheHiddenTomb,
"Thug's Boots of Waning Dusk":ThugsBootsofWaningDusk,
"Thug's Bracers of Charred Earth":ThugsBracersofCharredEarth,
"Thug's Bracers of the Grim Cabal":ThugsBracersoftheGrimCabal,
"Thug's Bracers of the Hidden Tomb":ThugsBracersoftheHiddenTomb,
"Thug's Fauld of Creeping Death":ThugsFauldofCreepingDeath,
"Thug's Gloves of Arcane Death":ThugsGlovesofArcaneDeath,
"Thug's Gloves of Malice":ThugsGlovesofMalice,
"Thug's Gloves of the Battlethrall":ThugsGlovesoftheBattlethrall,
"Thug's Gloves of the Silent Kill":ThugsGlovesoftheSilentKill,
"Thug's Leggings of Shattered Souls":ThugsLeggingsofShatteredSouls,
"Thug's Leggings of the Black Arts":ThugsLeggingsoftheBlackArts,
"Thug's Leggings of the Firebringer":ThugsLeggingsoftheFirebringer,
"Thug's Mask of Charred Earth":ThugsMaskofCharredEarth,
"Thug's Mask of the Hidden Tomb":ThugsMaskoftheHiddenTomb,
"Thug's Mask of Waning Dusk":ThugsMaskofWaningDusk,
"Thug's Straps of Creeping Death":ThugsStrapsofCreepingDeath,
"Thug's Tunic of Charred Earth":ThugsTunicofCharredEarth,
"Thug's Tunic of the Grim Cabal":ThugsTunicoftheGrimCabal,
"Thug's Tunic of the Hidden Tomb":ThugsTunicoftheHiddenTomb,
"Thug's Tunic of Waning Dusk":ThugsTunicofWaningDusk,
"Thug's Veil of the Grim Cabal":ThugsVeiloftheGrimCabal,
"Thug's Wristbands of Waning Dusk":ThugsWristbandsofWaningDusk,
"Thunder Mantle of the Living Legend":ThunderMantleoftheLivingLegend,
"Thunder River Helm":ThunderRiverHelm,
"Thundering Glaive":ThunderingGlaive,
"Thunderskin Bracers":ThunderskinBracers,
"Tickler of the Autumn Night":TickleroftheAutumnNight,
"Tiger's Arm-straps of Pierced Flesh":TigersArmstrapsofPiercedFlesh,
"Tiger's Armbands of the Untamed":TigersArmbandsoftheUntamed,
"Tiger's Armguards of the Roaring Jungle":TigersArmguardsoftheRoaringJungle,
"Tiger's Belt of Crouching Calm":TigersBeltofCrouchingCalm,
"Tiger's Belt of Pierced Flesh":TigersBeltofPiercedFlesh,
"Tiger's Belt of the Roaring Jungle":TigersBeltoftheRoaringJungle,
"Tiger's Boots of Grinning Skulls":TigersBootsofGrinningSkulls,
"Tiger's Boots of Stalking Fury":TigersBootsofStalkingFury,
"Tiger's Boots of the Elder Bond":TigersBootsoftheElderBond,
"Tiger's Boots of the Second Caste":TigersBootsoftheSecondCaste,
"Tiger's Bracers of the Elder Bond":TigersBracersoftheElderBond,
"Tiger's Bracers of the Second Caste":TigersBracersoftheSecondCaste,
"Tiger's Chestguard of the Savage Sun":TigersChestguardoftheSavageSun,
"Tiger's Gauntlets of the Roaring Jungle":TigersGauntletsoftheRoaringJungle,
"Tiger's Gauntlets of the Untamed":TigersGauntletsoftheUntamed,
"Tiger's Girdle of the Untamed":TigersGirdleoftheUntamed,
"Tiger's Gloves of Crouching Calm":TigersGlovesofCrouchingCalm,
"Tiger's Gloves of Pierced Flesh":TigersGlovesofPiercedFlesh,
"Tiger's Harness of the Primeval":TigersHarnessofthePrimeval,
"Tiger's Helm of the Painted Claw":TigersHelmofthePaintedClaw,
"Tiger's Helm of the Primeval":TigersHelmofthePrimeval,
"Tiger's Helm of the Savage Sun":TigersHelmoftheSavageSun,
"Tiger's Helm of the Yellow Spring":TigersHelmoftheYellowSpring,
"Tiger's Jerkin of the Yellow Spring":TigersJerkinoftheYellowSpring,
"Tiger's Leggings of Pierced Flesh":TigersLeggingsofPiercedFlesh,
"Tiger's Leggings of the Untamed":TigersLeggingsoftheUntamed,
"Tiger's Legguards of Crouching Calm":TigersLegguardsofCrouchingCalm,
"Tiger's Legguards of the Roaring Jungle":TigersLegguardsoftheRoaringJungle,
"Tiger's Straps of Crouching Calm":TigersStrapsofCrouchingCalm,
"Tiger's Straps of Grinning Skulls":TigersStrapsofGrinningSkulls,
"Tiger's Vambraces of Stalking Fury":TigersVambracesofStalkingFury,
"Tiger's Vest of the Painted Claw":TigersVestofthePaintedClaw,
"Tigerstrike":Tigerstrike,
"Tigerswipe":Tigerswipe,
"Timeworn Gloves":TimewornGloves,
"Titanslayer Cloak":TitanslayerCloak,
"Toil of Woes":ToilofWoes,
"Toirdealbach's Seal":ToirdealbachsSeal,
"Token of Terror":TokenofTerror,
"Token of the Divinity Serpent":TokenoftheDivinitySerpent,
"Token of Torment":TokenofTorment,
"Tokens of Frozen Earth":TokensofFrozenEarth,
"Tokens of the Great Impi":TokensoftheGreatImpi,
"Tome of Deific Reverence":TomeofDeificReverence,
"Tome of Holy Obeisance":TomeofHolyObeisance,
"Tome of the Black Gale":TomeoftheBlackGale,
"Tome of the Undying":TomeoftheUndying,
"Tongue of the Eight-Way Wyrm":TongueoftheEightWayWyrm,
"Tongue of the Vengeful Serpent":TongueoftheVengefulSerpent,
"Torment":Torment,
"Totem of Origins":TotemofOrigins,
"Totem of the Blood God":TotemoftheBloodGod,
"Totem of the Eternal Winter":TotemoftheEternalWinter,
"Totem of the Faceless Sphinx":TotemoftheFacelessSphinx,
"Trapper's Bolts":TrappersBolts,
"Trapper's Hook":TrappersHook,
"Trapper's Knife":TrappersKnife,
"Trapper's Sword":TrappersSword,
"Traumatic Reflection":TraumaticReflection,
"Treadlight Boots":TreadlightBoots,
"Treads of the Outer Dark":TreadsoftheOuterDark,
"Tri-Glave of the Demon's Roar":TriGlaveoftheDemonsRoar,
"Trial of Flame":TrialofFlame,
"Tribal Necklace of Bloody Carnage":TribalNecklaceofBloodyCarnage,
"Trickster's Charm":TrickstersCharm,
"Trident of Okeanos":TridentofOkeanos,
"Trident of the Gathering Storm":TridentoftheGatheringStorm,
"Trinket of Bone and Horn":TrinketofBoneandHorn,
"Trinket of Old Acheron":TrinketofOldAcheron,
"Trinket of Sharpened Blades":TrinketofSharpenedBlades,
"Trinket of the Earth Mother":TrinketoftheEarthMother,
"Triton's Depths":TritonsDepths,
"Trophies of the Hunt":TrophiesoftheHunt,
"Truestrike Armbands":TruestrikeArmbands,
"Tumult's Veil":TumultsVeil,
"Tumultuous Thunder":TumultuousThunder,
"Tunic of Bedlam":TunicofBedlam,
"Tunic of Benevolence":TunicofBenevolence,
"Tunic of Black Whispers":TunicofBlackWhispers,
"Tunic of Concealing Shadows":TunicofConcealingShadows,
"Tunic of Crimson Slaughter (nm)":TunicofCrimsonSlaughternm,
"Tunic of Crimson Slaughter":TunicofCrimsonSlaughter,
"Tunic of Dark Malice":TunicofDarkMalice,
"Tunic of Deadly Guile":TunicofDeadlyGuile,
"Tunic of Haloga":TunicofHaloga,
"Tunic of Intricate Spite":TunicofIntricateSpite,
"Tunic of Lunacy":TunicofLunacy,
"Tunic of the Clay":TunicoftheClay,
"Tunic of the Crawling Chaos":TunicoftheCrawlingChaos,
"Tunic of the Death God":TunicoftheDeathGod,
"Tunic of the Doomsayer":TunicoftheDoomsayer,
"Tunic of the Exorcist":TunicoftheExorcist,
"Tunic of the Faceless Chaos":TunicoftheFacelessChaos,
"Tunic of the Faceless Sphinx":TunicoftheFacelessSphinx,
"Tunic of the Firebrand":TunicoftheFirebrand,
"Tunic of the Harbinger":TunicoftheHarbinger,
"Tunic of the Lector":TunicoftheLector,
"Tunic of the Nebulous":TunicoftheNebulous,
"Tunic of the Oxmal":TunicoftheOxmal,
"Tunic of the Precursor":TunicofthePrecursor,
"Tunic of the Putrescent":TunicofthePutrescent,
"Tunic of the Rippling Lake":TunicoftheRipplingLake,
"Tunic of the Sepulcher":TunicoftheSepulcher,
"Tunic of the Shivering Stars":TunicoftheShiveringStars,
"Tunic of the Silent Slayer":TunicoftheSilentSlayer,
"Tunic of the Spheres":TunicoftheSpheres,
"Tunic of the Still Pond":TunicoftheStillPond,
"Tunic of the Strange Beyond":TunicoftheStrangeBeyond,
"Tunic of the Unslaked":TunicoftheUnslaked,
"Tunic of the Unutterable":TunicoftheUnutterable,
"Tunic of the Usurper":TunicoftheUsurper,
"Tunic of the Wells of Night":TunicoftheWellsofNight,
"Tunic of Tranquility":TunicofTranquility,
"Tunic of Vindictive Malice":TunicofVindictiveMalice,
"Tunsus":Tunsus,
"Turbulent Warhack":TurbulentWarhack,
"Twigs of the Ocean":TwigsoftheOcean,
"Tyranny":Tyranny,
"Underdweller's Spear":UnderdwellersSpear,
"Undulating Band of Yig":UndulatingBandofYig,
"Unerring Crossfire":UnerringCrossfire,
"Unholy Skullsplitter":UnholySkullsplitter,
"Upholder Armguards":UpholderArmguards,
"Utility Shoulders":UtilityShoulders,
"Utric's Healing Cloak":UtricsHealingCloak,
"Utric's Just Blade":UtricsJustBlade,
"Utric's Keen Knife":UtricsKeenKnife,
"Utric's Lawful Mace":UtricsLawfulMace,
"Utric's Seal of Law":UtricsSealofLaw,
"Utric's Shimmering Cloak":UtricsShimmeringCloak,
"Vaedus":Vaedus,
"Valka's Illimitable Aegis":ValkasIllimitableAegis,
"Valka's Woe Hymn":ValkasWoeHymn,
"Valorous Carcanet":ValorousCarcanet,
"Vambrace of Crimson Slaughter (nm)":VambraceofCrimsonSlaughternm,
"Vambrace of Crimson Slaughter":VambraceofCrimsonSlaughter,
"Vambrace of Red Ruin (nm)":VambraceofRedRuinnm,
"Vambrace of Red Ruin":VambraceofRedRuin,
"Vambrace of the Sanguine Disciple (nm)":VambraceoftheSanguineDisciplenm,
"Vambrace of the Sanguine Disciple":VambraceoftheSanguineDisciple,
"Vambraces of Baleful Blood":VambracesofBalefulBlood,
"Vambraces of Black Spite":VambracesofBlackSpite,
"Vambraces of Bone and Horn":VambracesofBoneandHorn,
"Vambraces of Heroic Soul":VambracesofHeroicSoul,
"Vambraces of Indomitable Souls":VambracesofIndomitableSouls,
"Vambraces of Reckless Challenge":VambracesofRecklessChallenge,
"Vambraces of the Assailant":VambracesoftheAssailant,
"Vambraces of the Atlantean":VambracesoftheAtlantean,
"Vambraces of the Beyond":VambracesoftheBeyond,
"Vambraces of the Black Dragon":VambracesoftheBlackDragon,
"Vambraces of the Black Pharaoh":VambracesoftheBlackPharaoh,
"Vambraces of the Black Warden":VambracesoftheBlackWarden,
"Vambraces of the Blood Drinker (nm)":VambracesoftheBloodDrinkernm,
"Vambraces of the Blood Drinker":VambracesoftheBloodDrinker,
"Vambraces of the Bloodhunter (nm)":VambracesoftheBloodhunternm,
"Vambraces of the Bloodhunter":VambracesoftheBloodhunter,
"Vambraces of the Chaos Agent":VambracesoftheChaosAgent,
"Vambraces of the Crimson Fort":VambracesoftheCrimsonFort,
"Vambraces of the Dark Messenger":VambracesoftheDarkMessenger,
"Vambraces of the Dauntless":VambracesoftheDauntless,
"Vambraces of the Defiant":VambracesoftheDefiant,
"Vambraces of the Fallen Empire (nm)":VambracesoftheFallenEmpirenm,
"Vambraces of the Fallen Empire":VambracesoftheFallenEmpire,
"Vambraces of the Great Impi":VambracesoftheGreatImpi,
"Vambraces of the Hell Walker (nm)":VambracesoftheHellWalkernm,
"Vambraces of the Hell Walker":VambracesoftheHellWalker,
"Vambraces of the Invincible":VambracesoftheInvincible,
"Vambraces of the Martial Paragon":VambracesoftheMartialParagon,
"Vambraces of the Masquer of the Sands":VambracesoftheMasqueroftheSands,
"Vambraces of the Milites Templi":VambracesoftheMilitesTempli,
"Vambraces of the Ostiary":VambracesoftheOstiary,
"Vambraces of the Painlegion":VambracesofthePainlegion,
"Vambraces of the Proven Champion":VambracesoftheProvenChampion,
"Vambraces of the Scattered Gods":VambracesoftheScatteredGods,
"Vambraces of the Steel Behemoth":VambracesoftheSteelBehemoth,
"Vambraces of the Tireless Defender":VambracesoftheTirelessDefender,
"Vambraces of the Tormentor":VambracesoftheTormentor,
"Vambraces of the Triumphant":VambracesoftheTriumphant,
"Vambraces of the Usurper":VambracesoftheUsurper,
"Vambraces of the Valiant":VambracesoftheValiant,
"Vambraces of the Vanguard":VambracesoftheVanguard,
"Vambraces of the Victorious Elite":VambracesoftheVictoriousElite,
"Vambraces of the Wicked":VambracesoftheWicked,
"Vanir Avenger":VanirAvenger,
"Vanir Bloodied Band":VanirBloodiedBand,
"Vanir Butcher Axe":VanirButcherAxe,
"Vanir Fleshcarver":VanirFleshcarver,
"Vanir Square Shield":VanirSquareShield,
"Vanir Stonecrusher":VanirStonecrusher,
"Vanir Warrior's Cache":VanirWarriorsCache,
"Vashian Keffiyeh":VashianKeffiyeh,
"Vashian Schenti":VashianSchenti,
"Vashian Treads":VashianThreads,
"Vashian Tunic":VashianTunic,
"Venakis":Venakis,
"Vengeance":Vengeance,
"Venomshield Belt":VenomshieldBelt,
"Venturer's Arm-straps of Grinning Skulls":VenturersArmstrapsofGrinningSkulls,
"Venturer's Armbands of the Second Caste":VenturersArmbandsoftheSecondCaste,
"Venturer's Armguards of Stalking Fury":VenturersArmguardsofStalkingFury,
"Venturer's Belt of the Painted Claw":VenturersBeltofthePaintedClaw,
"Venturer's Belt of the Savage Sun":VenturersBeltoftheSavageSun,
"Venturer's Belt of the Yellow Spring":VenturersBeltoftheYellowSpring,
"Venturer's Boots of Crouching Calm":VenturersBootsofCrouchingCalm,
"Venturer's Boots of the Roaring Jungle":VenturersBootsoftheRoaringJungle,
"Venturer's Bracers of Crouching Calm":VenturersBracersofCrouchingCalm,
"Venturer's Bracers of the Untamed":VenturersBracersoftheUntamed,
"Venturer's Chestguard of the Roaring Jungle":VenturersChestguardoftheRoaringJungle,
"Venturer's Gauntlets of the Primeval":VenturersGauntletsofthePrimeval,
"Venturer's Gauntlets of the Savage Sun":VenturersGauntletsoftheSavageSun,
"Venturer's Girdle of the Primeval":VenturersGirdleofthePrimeval,
"Venturer's Gloves of the Painted Claw":VenturersGlovesofthePaintedClaw,
"Venturer's Gloves of the Yellow Spring":VenturersGlovesoftheYellowSpring,
"Venturer's Harness of the Untamed":VenturersHarnessoftheUntamed,
"Venturer's Helm of Crouching Calm":VenturersHelmofCrouchingCalm,
"Venturer's Helm of Pierced Flesh":VenturersHelmofPiercedFlesh,
"Venturer's Helm of the Untamed":VenturersHelmoftheUntamed,
"Venturer's Helm":VenturersHelm,
"Venturer's Leggings of Grinning Skulls":VenturersLeggingsofGrinningSkulls,
"Venturer's Leggings of the Second Caste":VenturersLeggingsoftheSecondCaste,
"Venturer's Legguards of Stalking Fury":VenturersLegguardsofStalkingFury,
"Venturer's Legguards of the Elder Bond":VenturersLegguardsoftheElderBond,
"Venturer's Straps of Pierced Flesh":VenturersStrapsofPiercedFlesh,
"Venturer's Straps of the Elder Bond":VenturersStrapsoftheElderBond,
"Venturer's Treads of Pierced Flesh":VenturersTreadsofPiercedFlesh,
"Venturer's Vambraces of the Roaring Jungle":VenturersVambracesoftheRoaringJungle,
"Venturer's Vest of Pierced Flesh":VenturersVestofPiercedFlesh,
"Vermiculated Fang of All Fiends":VermiculatedFangofallFiends,
"Vermiculated Token of All Fiends":VermiculatedTokenofallFiends,
"Vest of the Blood God (nm)":VestoftheBloodGodnm,
"Vest of the Blood God":VestoftheBloodGod,
"Vest of the Bloodhunter (nm)":VestoftheBloodhunternm,
"Vest of the Bloodhunter":VestoftheBloodhunter,
"Vest of the Ghost of the Veldt":VestoftheGhostoftheVeldt,
"Vest of the Hell Walker (nm)":VestoftheHellWalkernm,
"Vest of the Hell Walker":VestoftheHellWalker,
"Vestment of the Cackling Marionette":VestmentoftheCacklingMarionette,
"Vestment of the Grand Monarch":VestmentoftheGrandMonarch,
"Vestment of the Revelations":VestmentoftheRevelations,
"Vestments of the Great Impi":VestmentsoftheGreatImpi,
"Veteran's Bag":VeteransBag,
"Vicious Cape of Ill Intent":ViciousCapeofIllIntent,
"Vicious Drape":ViciousDrape,
"Vicious Hound Boots":ViciousHoundBoots,
"Vigdis Soothsayer's Ring":VigdisSoothsayersRing,
"Vigdis Wiccan Band":VigdisWiccanBand,
"Vigilant Serpentweave":VigilantSerpentweave,
"Vigortouch Harness":VigortouchHarness,
"Violin Shield of the Twelfth Dynasty":ViolinShieldoftheTwelfthDynasty,
"Viridian Arrows":ViridianArrows,
"Viridian Bolts":ViridianBolts,
"Virtue":Virtue,
"Visage of Elder Shadows":VisageofElderShadows,
"Visage of the Masquer of the Sands":VisageoftheMasqueroftheSands,
"Vise of the Anointed":ViseoftheAnointed,
"Void Warden":VoidWarden,
"Voidcage":Voidcage,
"Vortex Gem":VortexGem,
"Votanthic Raiment":VotanthicRaiment,
"Vows of the Empire":VowsoftheEmpire,
"Vyre":Vyre,
"Walker's Arm-straps of the Ancestors":WalkersArmstrapsoftheAncestors,
"Walker's Armbands of the Greensward":WalkersArmbandsoftheGreensward,
"Walker's Belt of Passing Spirits":WalkersBeltofPassingSpirits,
"Walker's Belt of the Clans":WalkersBeltoftheClans,
"Walker's Belt of the Tribes":WalkersBeltoftheTribes,
"Walker's Boots of the Far Horizon":WalkersBootsoftheFarHorizon,
"Walker's Boots of the Four Winds":WalkersBootsoftheFourWinds,
"Walker's Bracers of the Four Winds":WalkersBracersoftheFourWinds,
"Walker's Fauld of the Ancestors":WalkersFauldoftheAncestors,
"Walker's Fauld of the Seven Suns":WalkersFauldoftheSevenSuns,
"Walker's Gauntlets of the Everlasting Sky":WalkersGauntletsoftheEverlastingSky,
"Walker's Girdle of the Everlasting Sky":WalkersGirdleoftheEverlastingSky,
"Walker's Gloves of Passing Spirits":WalkersGlovesofPassingSpirits,
"Walker's Gloves of the Clans":WalkersGlovesoftheClans,
"Walker's Gloves of the Tribes":WalkersGlovesoftheTribes,
"Walker's Jerkin of the Far Horizon":WalkersJerkinoftheFarHorizon,
"Walker's Leggings of the Greensward":WalkersLeggingsoftheGreensward,
"Walker's Legguards of the Golden Horde":WalkersLegguardsoftheGoldenHorde,
"Walker's Straps of the Golden Horde":WalkersStrapsoftheGoldenHorde,
"Walker's Straps of the Seven Suns":WalkersStrapsoftheSevenSuns,
"Walker's Tunic of the Mound":WalkersTunicoftheMound,
"Walker's Vambraces of the Mound":WalkersVambracesoftheMound,
"Wall of Eternal Winter":WallofEternalWinter,
"Waning Boundary":WaningBoundary,
"War Mammoth":WarMammoth,
"Ward of the Arch Lector":WardoftheArchLector,
"Warglory Armguards":WargloryArmbands,
"Warglory Boots":WargloryBoots,
"Warglory Chestguard":WargloryChestguard,
"Warglory Gauntlets":WargloryGauntlets,
"Warglory Girdle":WargloryGirdle,
"Warglory Helm":WargloryHelm,
"Warglory Legguards":WargloryLegguards,
"Warglory Vambraces":WargloryVambraces,
"Warhaven":Warhaven,
"Warherald Girdle":WarheraldGirdle,
"Warhoof Boots":WarhoofBoots,
"Warlord's Arrows":WarlordsArrows,
"Warlord's Axe":WarlordsAxe,
"Warlord's Band of Might":WarlordsBandofMight,
"Warlord's Band of Power":WarlordsBandofPower,
"Warlord's Blade":WarlordsBlade,
"Warlord's Bolts":WarlordsBolts,
"Warlord's Cinch":WarlordsCinch,
"Warlord's Cloak":WarlordsCloak,
"Ancestral Warlord's Cloak":WarlordsCloak,
"Warlord's Crossbow":WarlordsCrossbow,
"Warlord's Dagger":WarlordsDagger,
"Warlord's Great Shield":WarlordsGreatShield,
"Warlord's Greatbow":WarlordsGreatbow,
"Warlord's Greatsword":WarlordsGreatsword,
"Warlord's Mace":WarlordsMace,
"Warlord's Mark of Loathing":WarlordsMarkofLoathing,
"Warlord's Maxim of Chaos":WarlordsMaximofChaos,
"Warlord's Mystic Blade":WarlordsMysticBlade,
"Warlord's Pendant of Shielding":WarlordsPendantofShielding,
"Warlord's Sanctum":WarlordsSanctum,
"Warlord's Scepter":WarlordsScepter,
"Warlord's Spell Glaive":WarlordsSpellGlaive,
"Warlord's Spellsword":WarlordsSpellsword,
"Warlord's Staff":WarlordsStaff,
"Warlord's War Glaive":WarlordsWarGlaive,
"Warlord's War Hammer":WarlordsWarHammer,
"Warmaster Dreadfists":WarmasterDreadfists,
"Warmonger Ring":WarmongerRing,
"Warmonger's Battlebow":WarmongersBattlebow,
"Warmonger's Club":WarmongersClub,
"Warmonger's Dagger":WarmongersDagger,
"Warmonger's Mask":WarmongersMask,
"Warmonger's Shield":WarmongersShield,
"Waspsting Bolts":WaspstingBolts,
"Watch Captain's Honor Shield":WatchCaptainsHonorShield,
"Watcher of the Den":WatcheroftheDen,
"Watcher's Serpentweave":WatchersSerpentweave,
"Wavebreaker":Wavebreaker,
"West Cleave of the White Tiger":WestCleaveoftheWhiteTiger,
"Westermarck Crossbow":WestermarckCrossbow,
"Westermarck Javelin":WestermarckJavelin,
"Westermarck Mace":WestermarckMace,
"Westermarck Mantle":WestermarckMantle,
"Westermarck Short Bow":WestermarckShortBow,
"Wetland Gauntlets":WetlandGauntlets,
"Whisperer of Evil Luck":WhispererofEvilLuck,
"Whispering Touch":WhisperingTouch,
"Whispersilk Drape":WhispersilkDrape,
"Whisperstride":Whisperstride,
"White Hand Deathgloves":WhiteHandDeathgloves,
"White Hand Fists":WhiteHandFists,
"White Hand Gem of Holy Storm":WhiteHandGemofHolyStorm,
"White Hand Gem of Unholy Strike":WhiteHandGemofUnholyStrike,
"White Hand Warders":WhiteHandWarders,
"White Hand Witchweaves":WhiteHandWitchweaves,
"Whitemoon Chain":WhitemoonChain,
"Wicked Heart":WickedHeart,
"Widowdusk Arm-straps":WidowduskArmstraps,
"Widowdusk Belt":WidowduskBelt,
"Widowdusk Bracers":WidowduskBracers,
"Widowdusk Fauld":WidowduskFauld,
"Widowdusk Hood":WidowduskHood,
"Widowdusk Mitts":WidowduskMitts,
"Widowdusk Padsoles":WidowduskPadsoles,
"Widowdusk Tunic":WidowduskTunic,
"Wildclaw Gauntlets":WildclawGauntlets,
"Wildguard Girdle":WildguardGirdle,
"Wildhound Bracers":WildhoundBracers,
"Wildling Hauberk":WildlingHauberk,
"Wildmight Gloves":WildmightGloves,
"Wildstrider Armbands":WildstriderArmbands,
"Wildstrider Boots":WildstriderBoots,
"Wildstrider Bracers":WildstriderBracers,
"Wildstrider Girdle":WildstriderGirdle,
"Wildstrider Gloves":WildstriderGloves,
"Wildstrider Helm":WildstriderHelm,
"Wildstrider Jerkin":WildstriderJerkin,
"Wildstrider Tasset":WildstriderTasset,
"Wildthorn Band":WildthornBand,
"Will of Atali":WillofAtali,
"Will of Salvation":WillofSalvation,
"Willcaster Circlet":WillcasterCirclet,
"Wind of the Vanir":WindoftheVanir,
"Wind's Grasp":WindsGrasp,
"Windfury":Windfury,
"Windpiercer":Windpiercer,
"Wings of Salvation":WingsofSalvation,
"Witchbone Necklace":WitchboneNecklace,
"Witchborn Tasset":WitchbornTasset,
"Wizenbone":Wizenbone,
"Wol Do":WolDo,
"Wolf Snarl":WolfSnarl,
"Wolf Tamer's Blade":WolfTamersBlade,
"Wolf Tamer's Cloak":WolfTamersCloak,
"Wolf Tamer's Longblade":WolfTamersLongblade,
"Wolf Tamer's Shield":WolfTamersShield,
"Wolf Tooth Pendant":WolfToothPendant,
"Wolf's Armbands of the Covert Trail":WolfsArmbandsoftheCovertTrail,
"Wolf's Armbands of the Wicked Hearth":WolfsArmbandsoftheWickedHearth,
"Wolf's Armbands of World's Edge":WolfsArmbandsofWorldsEdge,
"Wolf's Armguards of the Grasslands":WolfsArmguardsoftheGrasslands,
"Wolf's Belt of the Covert Trail":WolfsBeltoftheCovertTrail,
"Wolf's Belt of the Grasslands":WolfsBeltoftheGrasslands,
"Wolf's Belt of the Wicked Hearth":WolfsBeltoftheWickedHearth,
"Wolf's Belt of World's Edge":WolfsBeltofWorldsEdge,
"Wolf's Boots of the Bloody Fang":WolfsBootsoftheBloodyFang,
"Wolf's Boots of the Khan":WolfsBootsoftheKhan,
"Wolf's Boots of the Ritual Flame":WolfsBootsoftheRitualFlame,
"Wolf's Boots of Woven Clouds":WolfsBootsofWovenClouds,
"Wolf's Chestguard of the Howling Moon":WolfsChestguardoftheHowlingMoon,
"Wolf's Gauntlets of the Grasslands":WolfsGauntletsoftheGrasslands,
"Wolf's Gloves of the Covert Trail":WolfsGlovesoftheCovertTrail,
"Wolf's Gloves of the Wicked Hearth":WolfsGlovesoftheWickedHearth,
"Wolf's Gloves of World's Edge":WolfsGlovesofWorldsEdge,
"Wolf's Helm of the Howling Moon":WolfsHelmoftheHowlingMoon,
"Wolf's Hood of a Hundred Eyes":WolfsHoodofaHundredEyes,
"Wolf's Hood of the Grasping Wild":WolfsHoodoftheGraspingWild,
"Wolf's Jerkin of a Hundred Eyes":WolfsJerkinofaHundredEyes,
"Wolf's Jerkin of the Grasping Wild":WolfsJerkinoftheGraspingWild,
"Wolf's Leggings of the Covert Trail":WolfsLeggingsoftheCovertTrail,
"Wolf's Leggings of the Wicked Hearth":WolfsLeggingsoftheWickedHearth,
"Wolf's Leggings of World's Edge":WolfsLeggingsofWorldsEdge,
"Wolf's Legguards of the Grasslands":WolfsLegguardsoftheGrasslands,
"Wolf's Mask of the Howling Wind":WolfsMaskoftheHowlingWind,
"Wolf's Straps of the Ritual Flame":WolfsStrapsoftheRitualFlame,
"Wolf's Straps of Woven Clouds":WolfsStrapsofWovenClouds,
"Wolf's Tunic of the Howling Wind":WolfsTunicoftheHowlingWind,
"Wolf's Vambraces of the Khan":WolfsVambracesoftheKhan,
"Wolf's Wristbands of the Bloody Fang":WolfsWristbandsoftheBloodyFang,
"Wolfsbane":Wolfsbane,
"Wolfsteel Sabatons":WolfsteelSabatons,
"Wound-hoe of Pict's Ruin":WoundhoeofPictsRuin,
"Wrap of Dragon Flight":WrapofDragonFlight,
"Wrap of the Dragon King":WrapoftheDragonKing,
"Wrap of the Endless Sands":WrapoftheEndlessSands,
"Wrap of the Exuberant":WrapoftheExuberant,
"Wrap of the Hell Walker (nm)":WrapoftheHellWalkernm,
"Wrap of the Hell Walker":WrapoftheHellWalker,
"Wrap of the Masquer of the Sands":WrapoftheMasqueroftheSands,
"Wrap of the Oxmal":WrapoftheOxmal,
"Wrap of the Shivering Stars":WrapoftheShiveringStars,
"Wraps of the Earth Mother":WrapsoftheEarthMother,
"Wrath of the Dark Sun":WrathoftheDarkSun,
"Wrath of Xotli":WrathofXotli,
"Wrathward Helm":WrathwardHelm,
"Wreath of Ether":WreathofEther,
"Wreath of the Unruly":WreathoftheUnruly,
"Wreath of Vapors":WreathofVapors,
"Wrist-straps of the Blood God (nm)":WriststrapsoftheBloodGodnm,
"Wrist-straps of the Blood God":WriststrapsoftheBloodGod,
"Wrist-straps of the Death Master (nm)":WriststrapsoftheDeathMasternm,
"Wrist-straps of the Death Master":WriststrapsoftheDeathMaster,
"Wristband of the Crawling Chaos":WristbandoftheCrawlingChaos,
"Wristband of the Faceless Chaos":WristbandoftheFacelessChaos,
"Wristband of the Faceless Sphinx":WristbandoftheFacelessSphinx,
"Wristband of the Nebulous":WristbandoftheNebulous,
"Wristband of the Sepulcher":WristbandoftheSepulcher,
"Wristband of the Spheres":WristbandoftheSpheres,
"Wristband of the Unutterable":WristbandoftheUnutterable,
"Wristbands of the Whispering Blade":WristbandsoftheWhisperingBlade,
"Wristwraps of Concealing Shadows":WristwrapsofConcealingShadows,
"Wristwraps of Fiendish Invocation":WristwrapsofFiendishInvocation,
"Wristwraps of Intricate Spite":WristwrapsofIntricateSpite,
"Wristwraps of the Darkwretch":WristwrapsoftheDarkwretch,
"Wristwraps of the Doomsayer":WristwrapsoftheDoomsayer,
"Wristwraps of the Firebrand":WristwrapsoftheFirebrand,
"Wristwraps of the Forsaken":WristwrapsoftheForsaken,
"Wristwraps of the Harbinger":WristwrapsoftheHarbinger,
"Wristwraps of the Precursor":WristwrapsofthePrecursor,
"Wristwraps of the Reanimator":WristwrapsoftheReanimator,
"Wristwraps of Vindictive Malice":WristwrapsofVindictiveMalice,
"Y'toth":Ytothdagger,
"Ymirish Frostband":YmirishFrostband,
"Ytoth":Ytoth,
"Yun Mark of Immolation":YunMarkofImmolation,
"Yun's Cold Flame":YunsColdFlame,
"Yun's Crow-Beaked Kisses":YunsCrowBeakedKisses,
"Zeal of Atali":ZealofAtali,
"Zoria's Spire":ZoriasSpire,
"Zugite Heretic Staff":ZugiteHereticStaff,
"Zugite Knight Totem":ZugiteKnightTotem,
"Zugite Sacrificial Poniard":ZugiteSacrificialPoniard,
"Zukala's Reliquary":ZukalasReliquary,
"Zukala's Rites":ZukalasRites,
"Zukas' Prized Helm":ZukasPrizedHelm,
//abilities
"Absolute Farseer Elixir":AbsoluteFarseerElixir,
"Mana Potion Effect 9":AbsoluteFarseerElixir,
"Absolute Moonspill":AbsoluteMoonspill,
"Mana Potion Effect 11":AbsoluteMoonspill,
"Absolute Witchsour":AbsoluteWitchsour,
"Mana Potion Effect 7":AbsoluteWitchsour,
"Battleburn Stout":BattleburnStout,
"Stamina Potion Effect 12":BattleburnStout,
"Bonesoul Ale":BonesoulAle,
"Health Potion Effect 12":BonesoulAle,
"Acute Acumen":BrewofAcuteAcumen,
"Acute Aptitude":BrewofAcuteAptitude,
"Acute Brawn":BrewofAcuteBrawn,
"Acute Foresight":BrewofAcuteForesight,
"Acute Fortitude":BrewofAcuteFortitude,
"Vigorous Acumen":BrewofVigorousAcumen,
"Vigorous Aptitude":BrewofVigorousAptitude,
"Vigorous Brawn":BrewofVigorousBrawn,
"Vigorous Foresight":BrewofVigorousForesight,
"Clarified Bloodroyal Brandy":ClarifiedBloodroyalBrandy,
"Clarified Devilsmead":ClarifiedDevilsmead,
"Clarified Soursap":ClarifiedSoursap,
"Combat Rating Boost (4h)":CombatRatingBoost4h,
"Critical Rating Boost (4h)":CriticalRatingBoost4h,
"Cynosural Ale":CynosuralAle,
"Daggamalt":Daggamalt,
"Health Potion Effect 10":Daggamalt,
"Dire Greatmane Ale":DireGreatmaneAle,
"Stamina Potion Effect 7":DireGreatmaneAle,
"Dire Rain of Khitai":DireRainofKhitai,
"Stamina Potion Effect 9":DireRainofKhitai,
"Dire Sweetpressed Haste":DireSweetpressedHaste,
"Stamina Potion Effect 11":DireSweetpressedHaste,
"Elixir of Brute Force":ElixirofBruteForce,
"Elixir of Guile":ElixirofGuile,
"Elixir of Invigorative Rejuvenation":ElixirofInvigorativeRejuvenation,
"Elixir of Mystical Excellence":ElixirofMysticalExcellence,
"Elixir of Mystical Replenishment":ElixirofMysticalReplenishment,
"Elixir of Precision":ElixirofPrecision,
"Excellent Amrita":ExcellentAmrita,
"Excellent Brawlbracer Ale":ExcellentBrawlbracerAle,
"Excellent Etherdew":ExcellentEtherdew,
"Exceptional Elixir of Resurgence: Resurrection":ExceptionalElixirofResurgence,
"Exceptional Elixir of Resurgence":ExceptionalElixirofResurgence,
"Exhausting Traps":ExhaustingTraps,
"Fatal Concoction":FatalConcoction,
"Golden Wine of Xuthal":GoldenWineofXuthal,
"Group King's Feast":GroupKingsFeast,
"Heal Rating Boost (4h)":HealRatingBoost4h,
"Health Potion":HealthPotion,
"King's Feast":KingsFeast,
"Kingsmight Ale":KingsmightAle,
"Leg of Fena":LegofFena,
"Magic Damage Boost (4h)":MagicDamageBoost4h,
"Ascension (V)":MajorRuneStoneofAscensionV,
"Ascension":MajorRuneStoneofAscension,
"Berserker's Fury (V)":MajorRuneStoneofBerserkersFuryV,
"Berserker's Fury":MajorRuneStoneofBerserkersFury,
"Quilled Darts (V)":MajorRuneStoneofQuilledDartsV,
"Quilled Darts":MajorRuneStoneofQuilledDarts,
"Chaos Agent (V)":MajorRuneStoneoftheChaosAgentV,
"Chaos Agent":MajorRuneStoneoftheChaosAgent,
"Eternal Blaze (V)":MajorRuneStoneoftheEternalBlazeV,
"Eternal Blaze":MajorRuneStoneoftheEternalBlaze,
"Rune of the Exile":MajorRuneStoneoftheExile,
"First Circle (V)":MajorRuneStoneoftheFirstCircleV,
"First Circle":MajorRuneStoneoftheFirstCircle,
"Furious Swipe (V)":MajorRuneStoneoftheFuriousSwipeV,
"Furious Swipe":MajorRuneStoneoftheFuriousSwipe,
"Judgment Bolt (V)":MajorRuneStoneoftheJudgmentBoltV,
"Judgment Bolt":MajorRuneStoneoftheJudgmentBolt,
"Rune of the Pit Fighter":MajorRuneStoneofthePitFighter,
"Proven Champion (V)":MajorRuneStoneoftheProvenChampionV,
"Proven Champion":MajorRuneStoneoftheProvenChampion,
"Rune of the Red Wake":MajorRuneStoneoftheRedWake,
"Rune of the Second Wind":MajorRuneStoneoftheSecondWind,
"Silent Slayer (V)":MajorRuneStoneoftheSilentSlayerV,
"Silent Slayer":MajorRuneStoneoftheSilentSlayer,
"Tireless Defender (V)":MajorRuneStoneoftheTirelessDefenderV,
"Tireless Defender":MajorRuneStoneoftheTirelessDefender,
"Unholy Communion (V)":MajorRuneStoneofUnholyCommunionV,
"Unholy Communion":MajorRuneStoneofUnholyCommunion,
"Mana Potion":ManaPotion,
"Acumen":MinorBrewofAcumen,
"Acute Striking":MinorBrewofAcuteStriking,
"Aptitude":MinorBrewofAptitude,
"Brawn":MinorBrewofBrawn,
"Foresight":MinorBrewofForesight,
"Fortitude":MinorBrewofFortitude,
"Minor Elixir of Resurgence: Resurrection":MinorElixirofResurgence,
" Resurrection":MinorElixirofResurgence,
"Minor Rune of the Claret Trail":MinorRuneStoneoftheClaretTrail,
"Moonspill":Moonspill,
"Mana Potion Effect 10":Moonspill,
"Morph : Wolf Pict Warrior":MorphWolfPictWarrior,
"Morph : Child of the Goat":MorphChildoftheGoat,
"Morph : Choleric Fiend":MorphCholericFiend,
"Morph : Crocodile Pict Chieftain":MorphCrocodilePictChieftain,
"Morph : Decaying Corpse":MorphDecayingCorpse,
"Morph : Grim Curate":MorphGrimCurate,
"Morph : Panther Pict Berserker":MorphPantherPictBerserker,
"Morph : Phlegmatic Fiend":MorphPhlegmaticFiend,
"Morph : Undead":MorphUndead,
"Narcinthe":Narcinthe,
"Pet: Black Lotus":PetBlackLotus,
"Pet: Fleet Cinder Fu Dog":PetFleetCinderFuDog,
"Pet: Golden Lotus":PetGoldenLotus,
"Pet: Grey Lotus":PetGreyLotus,
"Pet: Yellow Lotus":PetYellowLotus,
"Pharmacon of Avoidance":PharmaconofAvoidance,
"Pharmacon of Negation":PharmaconofNegation,
"Polymorph : Lycanthropic Morph (Gray)":PolymorphLycanthropicMorph,
"Polymorph : Lycanthropic Morph (Bloody)":PolymorphLycanthropicMorph,
"Polymorph : Lycanthropic Morph (Red)":PolymorphLycanthropicMorph,
"Lycanthropic Morph (Gray)":LycanthropicMorph,
"Lycanthropic Morph (Bloody)":LycanthropicMorph,
"Lycanthropic Morph (Red)":LycanthropicMorph,
"Potent Bittersharp":PotentBittersharp,
"Potent Daggamalt":PotentDaggamalt,
"Health Potion Effect 11":PotentDaggamalt,
"Health Potion Effect 7":PotentDaggamalt,
"Potent Soursap":PotentSoursap,
"Health Potion Effect 9":PotentSoursap,
"Potion of Constitution (4h)":PotionofConstitution4h,
"Potion of Dexterity (4h)":PotionofDexterity4h,
"Potion of Intellect (4h)":PotionofIntellect4h,
"Potion of Strength (4h)":PotionofStrength4h,
"Potion of Wisdom (4h)":PotionofWisdom4h,
"Purified Daggamalt":PurifiedDaggamalt,
"Purified Moonspill":PurifiedMoonspill,
"Purified Sweetpressed Haste":PurifiedSweetpressedHaste,
"Red Deviled Dates":RedDeviledDates,
"Refined Elixir of Physical Might":RefinedElixirofBruteForce,
"Refined Elixir of Guile":RefinedElixirofGuile,
"Refined Elixir of Invigorative Rejuvenation":RefinedElixirofInvigorativeRejuvenation,
"Refined Elixir of Mystical Excellence":RefinedElixirofMysticalExcellence,
"Refined Elixir of Mystical Replenishment":RefinedElixirofMysticalReplenishment,
"Refined Elixir of Precision":RefinedElixirofPrecision,
"Refined Pharmacon of Avoidance":RefinedPharmaconofAvoidance,
"Refined Pharmacon of Negation":RefinedPharmaconofNegation,
"Refined Philtre of Constitution":RefinedPhiltreofConstitution,
"Refined Philtre of Dexterity":RefinedPhiltreofDexterity,
"Refined Philtre of Intellect":RefinedPhiltreofIntellect,
"Refined Philtre of Strength":RefinedPhiltreofStrength,
"Refined Philtre of Wisdom":RefinedPhiltreofWisdom,
"Rejuvenation of the Ghagha":RejuvenationoftheGhagha,
"Rune of Shared Bloodshed":RuneStoneofSharedBloodshed,
"Rune of the Crimson Path":RuneStoneoftheCrimsonPath,
"Rune of the Eiglophians":RuneStoneoftheEiglophians,
"Rune of the Emerald Lotus":RuneStoneoftheEmeraldLotus,
"Rune of the Last Resort":RuneStoneoftheLastResort,
"Rune of the Royal Stables":RuneStoneoftheRoyalStables,
"Rune of the Styx":RuneStoneoftheStyx,
"Rune of the Warmonks":RuneStoneoftheWarmonks,
"Seal of Yog":SealofYog,
"Self-Resurrection Potion":SelfResurrectionPotion,
"Soulslake Mead":SoulslakeMead,
"Mana Potion Effect 12":SoulslakeMead,
"Stamina Potion":StaminaPotion,
"Sweetpressed Haste":SweetpressedHaste,
"Unlimited Morph: Dusk Fiend":UnlimitedMorphDuskFiend,
"Unlimited Morph: Grim Blade":UnlimitedMorphGrimBlade,
"Unlimited Morph: Hyperborean Warrior":UnlimitedMorphHyperboreanWarrior
}

export function getItem(item: string | undefined) {
  if(item == undefined)
    return NotFound;
  let foundValue = null;
  let temp = Items[item];
  if(temp){
    foundValue = temp;
  }
  if(!foundValue)
    foundValue = NotFound;
  return foundValue;
}